var Xs = Object.defineProperty;
var Qs = (t, e, n) => e in t ? Xs(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var hn = (t, e, n) => Qs(t, typeof e != "symbol" ? e + "" : e, n);
import { jsx as c, jsxs as L, Fragment as St } from "react/jsx-runtime";
import { LanguageCodeEnum as Mr, getLanguageCodeByLocale as fa, LocaleEnum as Or, SharedLocaleProvider as el, isLink as tl, BaseButton as co, FieldLabel as dr, FieldErrorAndDescription as ha, ContactSlugEnum as Qe, FormInput as ar, getContactFieldTitle as rl, FormInputPhone as nl, getContactSlugName as Ia, FormSelect as al, getCountryData as il, PaymentMethodEnum as le, Modal as uo, ModalSizeEnum as ol, toast as xt, Loader as sl, centsToUnits as Me, CurrencyEnum as Ne, cents as me, getPaymentMethodTitle as po } from "@systemeio/ui";
import C, { createContext as pr, useContext as vt, createElement as $t, isValidElement as $r, cloneElement as yr, useState as Te, useRef as Ot, useEffect as Ve, useMemo as tn, Fragment as ll, useDebugValue as mo } from "react";
import { useWatch as Fe, createHttpClient as fo, getErrorMapper as cl, UnprocessableContentError as ul, BadRequest as _t, toPercent as Rr } from "@systemeio/util";
import { twJoin as De, twMerge as fe } from "tailwind-merge";
import ho from "isomorphic-dompurify";
import { getPaymentMethodIcon as dl, PersonIcon as pl, ArrowDownIcon as ml } from "@systemeio/ui/icons";
import { FileTypeEnum as dt, FileSourceEnum as pt } from "@systemeio/file-manager";
const se = (t) => typeof t == "string", er = () => {
  let t, e;
  const n = new Promise((r, a) => {
    t = r, e = a;
  });
  return n.resolve = t, n.reject = e, n;
}, ja = (t) => t == null ? "" : "" + t, fl = (t, e, n) => {
  t.forEach((r) => {
    e[r] && (n[r] = e[r]);
  });
}, hl = /###/g, Fa = (t) => t && t.indexOf("###") > -1 ? t.replace(hl, ".") : t, Va = (t) => !t || se(t), or = (t, e, n) => {
  const r = se(e) ? e.split(".") : e;
  let a = 0;
  for (; a < r.length - 1; ) {
    if (Va(t)) return {};
    const i = Fa(r[a]);
    !t[i] && n && (t[i] = new n()), Object.prototype.hasOwnProperty.call(t, i) ? t = t[i] : t = {}, ++a;
  }
  return Va(t) ? {} : {
    obj: t,
    k: Fa(r[a])
  };
}, Ha = (t, e, n) => {
  const {
    obj: r,
    k: a
  } = or(t, e, Object);
  if (r !== void 0 || e.length === 1) {
    r[a] = n;
    return;
  }
  let i = e[e.length - 1], o = e.slice(0, e.length - 1), s = or(t, o, Object);
  for (; s.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), s = or(t, o, Object), s && s.obj && typeof s.obj[`${s.k}.${i}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${i}`] = n;
}, gl = (t, e, n, r) => {
  const {
    obj: a,
    k: i
  } = or(t, e, Object);
  a[i] = a[i] || [], a[i].push(n);
}, Br = (t, e) => {
  const {
    obj: n,
    k: r
  } = or(t, e);
  if (n)
    return n[r];
}, _l = (t, e, n) => {
  const r = Br(t, n);
  return r !== void 0 ? r : Br(e, n);
}, go = (t, e, n) => {
  for (const r in e)
    r !== "__proto__" && r !== "constructor" && (r in t ? se(t[r]) || t[r] instanceof String || se(e[r]) || e[r] instanceof String ? n && (t[r] = e[r]) : go(t[r], e[r], n) : t[r] = e[r]);
  return t;
}, jt = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var yl = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const vl = (t) => se(t) ? t.replace(/[&<>"'\/]/g, (e) => yl[e]) : t;
class bl {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const n = this.regExpMap.get(e);
    if (n !== void 0)
      return n;
    const r = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, r), this.regExpQueue.push(e), r;
  }
}
const Cl = [" ", ",", "?", "!", ";"], wl = new bl(20), xl = (t, e, n) => {
  e = e || "", n = n || "";
  const r = Cl.filter((o) => e.indexOf(o) < 0 && n.indexOf(o) < 0);
  if (r.length === 0) return !0;
  const a = wl.getRegExp(`(${r.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let i = !a.test(t);
  if (!i) {
    const o = t.indexOf(n);
    o > 0 && !a.test(t.substring(0, o)) && (i = !0);
  }
  return i;
}, Bn = function(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!t) return;
  if (t[e]) return t[e];
  const r = e.split(n);
  let a = t;
  for (let i = 0; i < r.length; ) {
    if (!a || typeof a != "object")
      return;
    let o, s = "";
    for (let l = i; l < r.length; ++l)
      if (l !== i && (s += n), s += r[l], o = a[s], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && l < r.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    a = o;
  }
  return a;
}, Kr = (t) => t && t.replace("_", "-"), kl = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, e) {
    console && console[t] && console[t].apply(console, e);
  }
};
class Ur {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, n);
  }
  init(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = e || kl, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, n, r, a) {
    return a && !this.debug ? null : (se(e[0]) && (e[0] = `${r}${this.prefix} ${e[0]}`), this.logger[n](e));
  }
  create(e) {
    return new Ur(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new Ur(this.logger, e);
  }
}
var ft = new Ur();
class rn {
  constructor() {
    this.observers = {};
  }
  on(e, n) {
    return e.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const a = this.observers[r].get(n) || 0;
      this.observers[r].set(n, a + 1);
    }), this;
  }
  off(e, n) {
    if (this.observers[e]) {
      if (!n) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(n);
    }
  }
  emit(e) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((o) => {
      let [s, l] = o;
      for (let d = 0; d < l; d++)
        s(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [s, l] = o;
      for (let d = 0; d < l; d++)
        s.apply(s, [e, ...r]);
    });
  }
}
class $a extends rn {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const n = this.options.ns.indexOf(e);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(e, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, o = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    e.indexOf(".") > -1 ? s = e.split(".") : (s = [e, n], r && (Array.isArray(r) ? s.push(...r) : se(r) && i ? s.push(...r.split(i)) : s.push(r)));
    const l = Br(this.data, s);
    return !l && !n && !r && e.indexOf(".") > -1 && (e = s[0], n = s[1], r = s.slice(2).join(".")), l || !o || !se(r) ? l : Bn(this.data && this.data[e] && this.data[e][n], r, i);
  }
  addResource(e, n, r, a) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = [e, n];
    r && (s = s.concat(o ? r.split(o) : r)), e.indexOf(".") > -1 && (s = e.split("."), a = n, n = s[1]), this.addNamespaces(n), Ha(this.data, s, a), i.silent || this.emit("added", e, n, r, a);
  }
  addResources(e, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (se(r[i]) || Array.isArray(r[i])) && this.addResource(e, n, i, r[i], {
        silent: !0
      });
    a.silent || this.emit("added", e, n, r);
  }
  addResourceBundle(e, n, r, a, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [e, n];
    e.indexOf(".") > -1 && (s = e.split("."), a = r, r = n, n = s[1]), this.addNamespaces(n);
    let l = Br(this.data, s) || {};
    o.skipCopy || (r = JSON.parse(JSON.stringify(r))), a ? go(l, r, i) : l = {
      ...l,
      ...r
    }, Ha(this.data, s, l), o.silent || this.emit("added", e, n, r);
  }
  removeResourceBundle(e, n) {
    this.hasResourceBundle(e, n) && delete this.data[e][n], this.removeNamespaces(n), this.emit("removed", e, n);
  }
  hasResourceBundle(e, n) {
    return this.getResource(e, n) !== void 0;
  }
  getResourceBundle(e, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, n)
    } : this.getResource(e, n);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const n = this.getDataByLanguage(e);
    return !!(n && Object.keys(n) || []).find((a) => n[a] && Object.keys(n[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var _o = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, e, n, r, a) {
    return t.forEach((i) => {
      this.processors[i] && (e = this.processors[i].process(e, n, r, a));
    }), e;
  }
};
const Ba = {};
class qr extends rn {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), fl(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = ft.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const r = this.resolve(e, n);
    return r && r.res !== void 0;
  }
  extractFromKey(e, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const o = r && e.indexOf(r) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !xl(e, r, a);
    if (o && !s) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: se(i) ? [i] : i
        };
      const d = e.split(r);
      (r !== a || r === a && this.options.ns.indexOf(d[0]) > -1) && (i = d.shift()), e = d.join(a);
    }
    return {
      key: e,
      namespaces: se(i) ? [i] : i
    };
  }
  translate(e, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const a = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: s
    } = this.extractFromKey(e[e.length - 1], n), l = s[s.length - 1], d = n.lng || this.language, u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d && d.toLowerCase() === "cimode") {
      if (u) {
        const S = n.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${l}${S}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: d,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${S}${o}`;
      }
      return a ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: d,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : o;
    }
    const p = this.resolve(e, n);
    let m = p && p.res;
    const _ = p && p.usedKey || o, y = p && p.exactUsedKey || o, f = Object.prototype.toString.apply(m), g = ["[object Number]", "[object Function]", "[object RegExp]"], b = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject, x = !se(m) && typeof m != "boolean" && typeof m != "number";
    if (v && m && x && g.indexOf(f) < 0 && !(se(b) && Array.isArray(m))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const S = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(_, m, {
          ...n,
          ns: s
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return a ? (p.res = S, p.usedParams = this.getUsedParamsDetails(n), p) : S;
      }
      if (i) {
        const S = Array.isArray(m), h = S ? [] : {}, P = S ? y : _;
        for (const F in m)
          if (Object.prototype.hasOwnProperty.call(m, F)) {
            const G = `${P}${i}${F}`;
            h[F] = this.translate(G, {
              ...n,
              joinArrays: !1,
              ns: s
            }), h[F] === G && (h[F] = m[F]);
          }
        m = h;
      }
    } else if (v && se(b) && Array.isArray(m))
      m = m.join(b), m && (m = this.extendTranslation(m, e, n, r));
    else {
      let S = !1, h = !1;
      const P = n.count !== void 0 && !se(n.count), F = qr.hasDefaultValue(n), G = P ? this.pluralResolver.getSuffix(d, n.count, n) : "", W = n.ordinal && P ? this.pluralResolver.getSuffix(d, n.count, {
        ordinal: !1
      }) : "", H = P && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), B = H && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${G}`] || n[`defaultValue${W}`] || n.defaultValue;
      !this.isValidLookup(m) && F && (S = !0, m = B), this.isValidLookup(m) || (h = !0, m = o);
      const Y = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && h ? void 0 : m, ee = F && B !== m && this.options.updateMissing;
      if (h || S || ee) {
        if (this.logger.log(ee ? "updateKey" : "missingKey", d, l, o, ee ? B : m), i) {
          const te = this.resolve(o, {
            ...n,
            keySeparator: !1
          });
          te && te.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let Z = [];
        const pe = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && pe && pe[0])
          for (let te = 0; te < pe.length; te++)
            Z.push(pe[te]);
        else this.options.saveMissingTo === "all" ? Z = this.languageUtils.toResolveHierarchy(n.lng || this.language) : Z.push(n.lng || this.language);
        const ne = (te, ce, A) => {
          const D = F && A !== m ? A : Y;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(te, l, ce, D, ee, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(te, l, ce, D, ee, n), this.emit("missingKey", te, l, ce, m);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && P ? Z.forEach((te) => {
          const ce = this.pluralResolver.getSuffixes(te, n);
          H && n[`defaultValue${this.options.pluralSeparator}zero`] && ce.indexOf(`${this.options.pluralSeparator}zero`) < 0 && ce.push(`${this.options.pluralSeparator}zero`), ce.forEach((A) => {
            ne([te], o + A, n[`defaultValue${A}`] || B);
          });
        }) : ne(Z, o, B));
      }
      m = this.extendTranslation(m, e, n, p, r), h && m === o && this.options.appendNamespaceToMissingKey && (m = `${l}:${o}`), (h || S) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? m = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, S ? m : void 0) : m = this.options.parseMissingKeyHandler(m));
    }
    return a ? (p.res = m, p.usedParams = this.getUsedParamsDetails(n), p) : m;
  }
  extendTranslation(e, n, r, a, i) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const d = se(e) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (d) {
        const m = e.match(this.interpolator.nestingRegexp);
        u = m && m.length;
      }
      let p = r.replace && !se(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (p = {
        ...this.options.interpolation.defaultVariables,
        ...p
      }), e = this.interpolator.interpolate(e, p, r.lng || this.language || a.usedLng, r), d) {
        const m = e.match(this.interpolator.nestingRegexp), _ = m && m.length;
        u < _ && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (r.lng = this.language || a.usedLng), r.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var m = arguments.length, _ = new Array(m), y = 0; y < m; y++)
          _[y] = arguments[y];
        return i && i[0] === _[0] && !r.context ? (o.logger.warn(`It seems you are nesting recursively key: ${_[0]} in key: ${n[0]}`), null) : o.translate(..._, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const s = r.postProcess || this.options.postProcess, l = se(s) ? [s] : s;
    return e != null && l && l.length && r.applyPostProcessor !== !1 && (e = _o.handle(l, e, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), e;
  }
  resolve(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, a, i, o, s;
    return se(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(r)) return;
      const d = this.extractFromKey(l, n), u = d.key;
      a = u;
      let p = d.namespaces;
      this.options.fallbackNS && (p = p.concat(this.options.fallbackNS));
      const m = n.count !== void 0 && !se(n.count), _ = m && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), y = n.context !== void 0 && (se(n.context) || typeof n.context == "number") && n.context !== "", f = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      p.forEach((g) => {
        this.isValidLookup(r) || (s = g, !Ba[`${f[0]}-${g}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (Ba[`${f[0]}-${g}`] = !0, this.logger.warn(`key "${a}" for languages "${f.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), f.forEach((b) => {
          if (this.isValidLookup(r)) return;
          o = b;
          const v = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, b, g, n);
          else {
            let S;
            m && (S = this.pluralResolver.getSuffix(b, n.count, n));
            const h = `${this.options.pluralSeparator}zero`, P = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (m && (v.push(u + S), n.ordinal && S.indexOf(P) === 0 && v.push(u + S.replace(P, this.options.pluralSeparator)), _ && v.push(u + h)), y) {
              const F = `${u}${this.options.contextSeparator}${n.context}`;
              v.push(F), m && (v.push(F + S), n.ordinal && S.indexOf(P) === 0 && v.push(F + S.replace(P, this.options.pluralSeparator)), _ && v.push(F + h));
            }
          }
          let x;
          for (; x = v.pop(); )
            this.isValidLookup(r) || (i = x, r = this.getResource(b, g, x, n));
        }));
      });
    }), {
      res: r,
      usedKey: a,
      exactUsedKey: i,
      usedLng: o,
      usedNS: s
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, n, r, a) : this.resourceStore.getResource(e, n, r, a);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = e.replace && !se(e.replace);
    let a = r ? e.replace : e;
    if (r && typeof e.count < "u" && (a.count = e.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !r) {
      a = {
        ...a
      };
      for (const i of n)
        delete a[i];
    }
    return a;
  }
  static hasDefaultValue(e) {
    const n = "defaultValue";
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && n === r.substring(0, n.length) && e[r] !== void 0)
        return !0;
    return !1;
  }
}
const gn = (t) => t.charAt(0).toUpperCase() + t.slice(1);
class Ka {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ft.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = Kr(e), !e || e.indexOf("-") < 0) return null;
    const n = e.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = Kr(e), !e || e.indexOf("-") < 0) return e;
    const n = e.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(e) {
    if (se(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let a = Intl.getCanonicalLocales(e)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a) return a;
        } catch {
        }
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = e.split("-");
      return this.options.lowerCaseLng ? r = r.map((a) => a.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = gn(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = gn(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = gn(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let n;
    return e.forEach((r) => {
      if (n) return;
      const a = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (n = a);
    }), !n && this.options.supportedLngs && e.forEach((r) => {
      if (n) return;
      const a = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(a)) return n = a;
      n = this.options.supportedLngs.find((i) => {
        if (i === a) return i;
        if (!(i.indexOf("-") < 0 && a.indexOf("-") < 0) && (i.indexOf("-") > 0 && a.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === a || i.indexOf(a) === 0 && a.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(e, n) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(n)), se(e) && (e = [e]), Array.isArray(e)) return e;
    if (!n) return e.default || [];
    let r = e[n];
    return r || (r = e[this.getScriptPartFromCode(n)]), r || (r = e[this.formatLanguageCode(n)]), r || (r = e[this.getLanguagePartFromCode(n)]), r || (r = e.default), r || [];
  }
  toResolveHierarchy(e, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], e), a = [], i = (o) => {
      o && (this.isSupportedCode(o) ? a.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return se(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(e))) : se(e) && i(this.formatLanguageCode(e)), r.forEach((o) => {
      a.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), a;
  }
}
let Sl = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Pl = {
  1: (t) => +(t > 1),
  2: (t) => +(t != 1),
  3: (t) => 0,
  4: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  5: (t) => t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5,
  6: (t) => t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2,
  7: (t) => t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  8: (t) => t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3,
  9: (t) => +(t >= 2),
  10: (t) => t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4,
  11: (t) => t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3,
  12: (t) => +(t % 10 != 1 || t % 100 == 11),
  13: (t) => +(t !== 0),
  14: (t) => t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3,
  15: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  16: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2,
  17: (t) => t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1,
  18: (t) => t == 0 ? 0 : t == 1 ? 1 : 2,
  19: (t) => t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3,
  20: (t) => t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2,
  21: (t) => t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0,
  22: (t) => t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3
};
const El = ["v1", "v2", "v3"], Ll = ["v4"], Ua = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Tl = () => {
  const t = {};
  return Sl.forEach((e) => {
    e.lngs.forEach((n) => {
      t[n] = {
        numbers: e.nr,
        plurals: Pl[e.fc]
      };
    });
  }), t;
};
class Nl {
  constructor(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = n, this.logger = ft.create("pluralResolver"), (!this.options.compatibilityJSON || Ll.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Tl(), this.pluralRulesCache = {};
  }
  addRule(e, n) {
    this.rules[e] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = Kr(e === "dev" ? "en" : e), a = n.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: r,
        type: a
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let o;
      try {
        o = new Intl.PluralRules(r, {
          type: a
        });
      } catch {
        if (!e.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(e);
        o = this.getRule(l, n);
      }
      return this.pluralRulesCache[i] = o, o;
    }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, r).map((a) => `${n}${a}`);
  }
  getSuffixes(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(e, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((a, i) => Ua[a] - Ua[i]).map((a) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : r.numbers.map((a) => this.getSuffix(e, a, n)) : [];
  }
  getSuffix(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(e, r);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(n)}` : this.getSuffixRetroCompatible(a, n) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, n) {
    const r = e.noAbs ? e.plurals(n) : e.plurals(Math.abs(n));
    let a = e.numbers[r];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const i = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !El.includes(this.options.compatibilityJSON);
  }
}
const qa = function(t, e, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = _l(t, e, n);
  return !i && a && se(n) && (i = Bn(t, n, r), i === void 0 && (i = Bn(e, n, r))), i;
}, _n = (t) => t.replace(/\$/g, "$$$$");
class Ml {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ft.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((n) => n), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: a,
      prefix: i,
      prefixEscaped: o,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: d,
      unescapeSuffix: u,
      unescapePrefix: p,
      nestingPrefix: m,
      nestingPrefixEscaped: _,
      nestingSuffix: y,
      nestingSuffixEscaped: f,
      nestingOptionsSeparator: g,
      maxReplaces: b,
      alwaysFormat: v
    } = e.interpolation;
    this.escape = n !== void 0 ? n : vl, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = i ? jt(i) : o || "{{", this.suffix = s ? jt(s) : l || "}}", this.formatSeparator = d || ",", this.unescapePrefix = u ? "" : p || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = m ? jt(m) : _ || jt("$t("), this.nestingSuffix = y ? jt(y) : f || jt(")"), this.nestingOptionsSeparator = g || ",", this.maxReplaces = b || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, n, r, a) {
    let i, o, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, d = (_) => {
      if (_.indexOf(this.formatSeparator) < 0) {
        const b = qa(n, l, _, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(b, void 0, r, {
          ...a,
          ...n,
          interpolationkey: _
        }) : b;
      }
      const y = _.split(this.formatSeparator), f = y.shift().trim(), g = y.join(this.formatSeparator).trim();
      return this.format(qa(n, l, f, this.options.keySeparator, this.options.ignoreJSONStructure), g, r, {
        ...a,
        ...n,
        interpolationkey: f
      });
    };
    this.resetRegExp();
    const u = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, p = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (_) => _n(_)
    }, {
      regex: this.regexp,
      safeValue: (_) => this.escapeValue ? _n(this.escape(_)) : _n(_)
    }].forEach((_) => {
      for (s = 0; i = _.regex.exec(e); ) {
        const y = i[1].trim();
        if (o = d(y), o === void 0)
          if (typeof u == "function") {
            const g = u(e, i, a);
            o = se(g) ? g : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, y))
            o = "";
          else if (p) {
            o = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${y} for interpolating ${e}`), o = "";
        else !se(o) && !this.useRawValueToEscape && (o = ja(o));
        const f = _.safeValue(o);
        if (e = e.replace(i[0], f), p ? (_.regex.lastIndex += o.length, _.regex.lastIndex -= i[0].length) : _.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, i, o;
    const s = (l, d) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const p = l.split(new RegExp(`${u}[ ]*{`));
      let m = `{${p[1]}`;
      l = p[0], m = this.interpolate(m, o);
      const _ = m.match(/'/g), y = m.match(/"/g);
      (_ && _.length % 2 === 0 && !y || y.length % 2 !== 0) && (m = m.replace(/'/g, '"'));
      try {
        o = JSON.parse(m), d && (o = {
          ...d,
          ...o
        });
      } catch (f) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, f), `${l}${u}${m}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(e); ) {
      let l = [];
      o = {
        ...r
      }, o = o.replace && !se(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let d = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const u = a[1].split(this.formatSeparator).map((p) => p.trim());
        a[1] = u.shift(), l = u, d = !0;
      }
      if (i = n(s.call(this, a[1].trim(), o), o), i && a[0] === e && !se(i)) return i;
      se(i) || (i = ja(i)), i || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${e}`), i = ""), d && (i = l.reduce((u, p) => this.format(u, p, r.lng, {
        ...r,
        interpolationkey: a[1].trim()
      }), i.trim())), e = e.replace(a[0], i), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const Ol = (t) => {
  let e = t.toLowerCase().trim();
  const n = {};
  if (t.indexOf("(") > -1) {
    const r = t.split("(");
    e = r[0].toLowerCase().trim();
    const a = r[1].substring(0, r[1].length - 1);
    e === "currency" && a.indexOf(":") < 0 ? n.currency || (n.currency = a.trim()) : e === "relativetime" && a.indexOf(":") < 0 ? n.range || (n.range = a.trim()) : a.split(";").forEach((o) => {
      if (o) {
        const [s, ...l] = o.split(":"), d = l.join(":").trim().replace(/^'+|'+$/g, ""), u = s.trim();
        n[u] || (n[u] = d), d === "false" && (n[u] = !1), d === "true" && (n[u] = !0), isNaN(d) || (n[u] = parseInt(d, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: n
  };
}, Ft = (t) => {
  const e = {};
  return (n, r, a) => {
    let i = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (i = {
      ...i,
      [a.interpolationkey]: void 0
    });
    const o = r + JSON.stringify(i);
    let s = e[o];
    return s || (s = t(Kr(r), a), e[o] = s), s(n);
  };
};
class Rl {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ft.create("formatter"), this.options = e, this.formats = {
      number: Ft((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      }),
      currency: Ft((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (i) => a.format(i);
      }),
      datetime: Ft((n, r) => {
        const a = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      }),
      relativetime: Ft((n, r) => {
        const a = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (i) => a.format(i, r.range || "day");
      }),
      list: Ft((n, r) => {
        const a = new Intl.ListFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      })
    }, this.init(e);
  }
  init(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = n.interpolation.formatSeparator || ",";
  }
  add(e, n) {
    this.formats[e.toLowerCase().trim()] = n;
  }
  addCached(e, n) {
    this.formats[e.toLowerCase().trim()] = Ft(n);
  }
  format(e, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = n.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((s) => s.indexOf(")") > -1)) {
      const s = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, s)].join(this.formatSeparator);
    }
    return i.reduce((s, l) => {
      const {
        formatName: d,
        formatOptions: u
      } = Ol(l);
      if (this.formats[d]) {
        let p = s;
        try {
          const m = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, _ = m.locale || m.lng || a.locale || a.lng || r;
          p = this.formats[d](s, _, {
            ...u,
            ...a,
            ...m
          });
        } catch (m) {
          this.logger.warn(m);
        }
        return p;
      } else
        this.logger.warn(`there was no format function for ${d}`);
      return s;
    }, e);
  }
}
const Al = (t, e) => {
  t.pending[e] !== void 0 && (delete t.pending[e], t.pendingCount--);
};
class zl extends rn {
  constructor(e, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = a, this.logger = ft.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, a.backend, a);
  }
  queueLoad(e, n, r, a) {
    const i = {}, o = {}, s = {}, l = {};
    return e.forEach((d) => {
      let u = !0;
      n.forEach((p) => {
        const m = `${d}|${p}`;
        !r.reload && this.store.hasResourceBundle(d, p) ? this.state[m] = 2 : this.state[m] < 0 || (this.state[m] === 1 ? o[m] === void 0 && (o[m] = !0) : (this.state[m] = 1, u = !1, o[m] === void 0 && (o[m] = !0), i[m] === void 0 && (i[m] = !0), l[p] === void 0 && (l[p] = !0)));
      }), u || (s[d] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, n, r) {
    const a = e.split("|"), i = a[0], o = a[1];
    n && this.emit("failedLoading", i, o, n), !n && r && this.store.addResourceBundle(i, o, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = n ? -1 : 2, n && r && (this.state[e] = 0);
    const s = {};
    this.queue.forEach((l) => {
      gl(l.loaded, [i], o), Al(l, e), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((d) => {
        s[d] || (s[d] = {});
        const u = l.loaded[d];
        u.length && u.forEach((p) => {
          s[d][p] === void 0 && (s[d][p] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: n,
        fcName: r,
        tried: a,
        wait: i,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const s = (d, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const p = this.waitingReads.shift();
        this.read(p.lng, p.ns, p.fcName, p.tried, p.wait, p.callback);
      }
      if (d && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, n, r, a + 1, i * 2, o);
        }, i);
        return;
      }
      o(d, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const d = l(e, n);
        d && typeof d.then == "function" ? d.then((u) => s(null, u)).catch(s) : s(null, d);
      } catch (d) {
        s(d);
      }
      return;
    }
    return l(e, n, s);
  }
  prepareLoading(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    se(e) && (e = this.languageUtils.toResolveHierarchy(e)), se(n) && (n = [n]);
    const i = this.queueLoad(e, n, r, a);
    if (!i.toLoad.length)
      return i.pending.length || a(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(e, n, r) {
    this.prepareLoading(e, n, {}, r);
  }
  reload(e, n, r) {
    this.prepareLoading(e, n, {
      reload: !0
    }, r);
  }
  loadOne(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = e.split("|"), a = r[0], i = r[1];
    this.read(a, i, "read", void 0, void 0, (o, s) => {
      o && this.logger.warn(`${n}loading namespace ${i} for language ${a} failed`, o), !o && s && this.logger.log(`${n}loaded namespace ${i} for language ${a}`, s), this.loaded(e, o, s);
    });
  }
  saveMissing(e, n, r, a, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...o,
          isUpdate: i
        }, d = this.backend.create.bind(this.backend);
        if (d.length < 6)
          try {
            let u;
            d.length === 5 ? u = d(e, n, r, a, l) : u = d(e, n, r, a), u && typeof u.then == "function" ? u.then((p) => s(null, p)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          d(e, n, r, a, s, l);
      }
      !e || !e[0] || this.store.addResource(e[0], n, r, a);
    }
  }
}
const Ga = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (t) => {
    let e = {};
    if (typeof t[1] == "object" && (e = t[1]), se(t[1]) && (e.defaultValue = t[1]), se(t[2]) && (e.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
      const n = t[3] || t[2];
      Object.keys(n).forEach((r) => {
        e[r] = n[r];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (t) => t,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Wa = (t) => (se(t.ns) && (t.ns = [t.ns]), se(t.fallbackLng) && (t.fallbackLng = [t.fallbackLng]), se(t.fallbackNS) && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs && t.supportedLngs.indexOf("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), t), vr = () => {
}, Dl = (t) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((n) => {
    typeof t[n] == "function" && (t[n] = t[n].bind(t));
  });
};
class sr extends rn {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Wa(e), this.services = {}, this.logger = ft, this.modules = {
      external: []
    }, Dl(this), n && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, n), this;
      setTimeout(() => {
        this.init(e, n);
      }, 0);
    }
  }
  init() {
    var e = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (se(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const a = Ga();
    this.options = {
      ...a,
      ...this.options,
      ...Wa(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const i = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? ft.init(i(this.modules.logger), this.options) : ft.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = Rl);
      const p = new Ka(this.options);
      this.store = new $a(this.options.resources, this.options);
      const m = this.services;
      m.logger = ft, m.resourceStore = this.store, m.languageUtils = p, m.pluralResolver = new Nl(p, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (m.formatter = i(u), m.formatter.init(m, this.options), this.options.interpolation.format = m.formatter.format.bind(m.formatter)), m.interpolator = new Ml(this.options), m.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, m.backendConnector = new zl(i(this.modules.backend), m.resourceStore, m, this.options), m.backendConnector.on("*", function(_) {
        for (var y = arguments.length, f = new Array(y > 1 ? y - 1 : 0), g = 1; g < y; g++)
          f[g - 1] = arguments[g];
        e.emit(_, ...f);
      }), this.modules.languageDetector && (m.languageDetector = i(this.modules.languageDetector), m.languageDetector.init && m.languageDetector.init(m, this.options.detection, this.options)), this.modules.i18nFormat && (m.i18nFormat = i(this.modules.i18nFormat), m.i18nFormat.init && m.i18nFormat.init(this)), this.translator = new qr(this.services, this.options), this.translator.on("*", function(_) {
        for (var y = arguments.length, f = new Array(y > 1 ? y - 1 : 0), g = 1; g < y; g++)
          f[g - 1] = arguments[g];
        e.emit(_, ...f);
      }), this.modules.external.forEach((_) => {
        _.init && _.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = vr), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments), e;
      };
    });
    const l = er(), d = () => {
      const u = (p, m) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(m), r(p, m);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? d() : setTimeout(d, 0), l;
  }
  loadResources(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : vr;
    const a = se(e) ? e : this.language;
    if (typeof e == "function" && (r = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (a && a.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return r();
      const i = [], o = (s) => {
        if (!s || s === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((d) => {
          d !== "cimode" && i.indexOf(d) < 0 && i.push(d);
        });
      };
      a ? o(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => o(l)), this.options.preload && this.options.preload.forEach((s) => o(s)), this.services.backendConnector.load(i, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(s);
      });
    } else
      r(null);
  }
  reloadResources(e, n, r) {
    const a = er();
    return typeof e == "function" && (r = e, e = void 0), typeof n == "function" && (r = n, n = void 0), e || (e = this.languages), n || (n = this.options.ns), r || (r = vr), this.services.backendConnector.reload(e, n, (i) => {
      a.resolve(), r(i);
    }), a;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && _o.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(e, n) {
    var r = this;
    this.isLanguageChangingTo = e;
    const a = er();
    this.emit("languageChanging", e);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, d) => {
      d ? (i(d), this.translator.changeLanguage(d), this.isLanguageChangingTo = void 0, this.emit("languageChanged", d), this.logger.log("languageChanged", d)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return r.t(...arguments);
      }), n && n(l, function() {
        return r.t(...arguments);
      });
    }, s = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const d = se(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      d && (this.language || i(d), this.translator.language || this.translator.changeLanguage(d), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(d)), this.loadResources(d, (u) => {
        o(u, d);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(e), a;
  }
  getFixedT(e, n, r) {
    var a = this;
    const i = function(o, s) {
      let l;
      if (typeof s != "object") {
        for (var d = arguments.length, u = new Array(d > 2 ? d - 2 : 0), p = 2; p < d; p++)
          u[p - 2] = arguments[p];
        l = a.options.overloadTranslationOptionHandler([o, s].concat(u));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || i.keyPrefix);
      const m = a.options.keySeparator || ".";
      let _;
      return l.keyPrefix && Array.isArray(o) ? _ = o.map((y) => `${l.keyPrefix}${m}${y}`) : _ = l.keyPrefix ? `${l.keyPrefix}${m}${o}` : o, a.t(_, l);
    };
    return se(e) ? i.lng = e : i.lngs = e, i.ns = n, i.keyPrefix = r, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode") return !0;
    const o = (s, l) => {
      const d = this.services.backendConnector.state[`${s}|${l}`];
      return d === -1 || d === 0 || d === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, o);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(r, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(r, e) && (!a || o(i, e)));
  }
  loadNamespaces(e, n) {
    const r = er();
    return this.options.ns ? (se(e) && (e = [e]), e.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(e, n) {
    const r = er();
    se(e) && (e = [e]);
    const a = this.options.preload || [], i = e.filter((o) => a.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return i.length ? (this.options.preload = a.concat(i), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Ka(Ga());
    return n.indexOf(r.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new sr(e, n);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : vr;
    const r = e.forkResourceStore;
    r && delete e.forkResourceStore;
    const a = {
      ...this.options,
      ...e,
      isClone: !0
    }, i = new sr(a);
    return (e.debug !== void 0 || e.prefix !== void 0) && (i.logger = i.logger.clone(e)), ["store", "services", "language"].forEach((s) => {
      i[s] = this[s];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r && (i.store = new $a(this.store.data, a), i.services.resourceStore = i.store), i.translator = new qr(i.services, a), i.translator.on("*", function(s) {
      for (var l = arguments.length, d = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        d[u - 1] = arguments[u];
      i.emit(s, ...d);
    }), i.init(a, n), i.translator.options = a, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Oe = sr.createInstance();
Oe.createInstance = sr.createInstance;
Oe.createInstance;
Oe.dir;
Oe.init;
Oe.loadResources;
Oe.reloadResources;
Oe.use;
Oe.changeLanguage;
Oe.getFixedT;
Oe.t;
Oe.exists;
Oe.setDefaultNamespace;
Oe.hasLoadedNamespace;
Oe.loadNamespaces;
Oe.loadLanguages;
function Il(t, e) {
  if (t == null) return {};
  var n = {};
  for (var r in t) if ({}.hasOwnProperty.call(t, r)) {
    if (e.indexOf(r) !== -1) continue;
    n[r] = t[r];
  }
  return n;
}
function ga(t, e) {
  if (t == null) return {};
  var n, r, a = Il(t, e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (r = 0; r < i.length; r++) n = i[r], e.indexOf(n) === -1 && {}.propertyIsEnumerable.call(t, n) && (a[n] = t[n]);
  }
  return a;
}
function rt(t) {
  "@babel/helpers - typeof";
  return rt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, rt(t);
}
function jl(t, e) {
  if (rt(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (rt(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function yo(t) {
  var e = jl(t, "string");
  return rt(e) == "symbol" ? e : e + "";
}
function re(t, e, n) {
  return (e = yo(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function mr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var yn, Za;
function Fl() {
  return Za || (Za = 1, yn = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  }), yn;
}
var Vl = Fl();
const Hl = /* @__PURE__ */ mr(Vl);
var $l = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function Ya(t) {
  var e = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, n = t.match(/<\/?([^\s]+?)[/\s>]/);
  if (n && (e.name = n[1], (Hl[n[1]] || t.charAt(t.length - 2) === "/") && (e.voidElement = !0), e.name.startsWith("!--"))) {
    var r = t.indexOf("-->");
    return { type: "comment", comment: r !== -1 ? t.slice(4, r) : "" };
  }
  for (var a = new RegExp($l), i = null; (i = a.exec(t)) !== null; ) if (i[0].trim()) if (i[1]) {
    var o = i[1].trim(), s = [o, ""];
    o.indexOf("=") > -1 && (s = o.split("=")), e.attrs[s[0]] = s[1], a.lastIndex--;
  } else i[2] && (e.attrs[i[2]] = i[3].trim().substring(1, i[3].length - 1));
  return e;
}
var Bl = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, Kl = /^\s*$/, Ul = /* @__PURE__ */ Object.create(null);
function vo(t, e) {
  switch (e.type) {
    case "text":
      return t + e.content;
    case "tag":
      return t += "<" + e.name + (e.attrs ? (function(n) {
        var r = [];
        for (var a in n) r.push(a + '="' + n[a] + '"');
        return r.length ? " " + r.join(" ") : "";
      })(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce(vo, "") + "</" + e.name + ">";
    case "comment":
      return t + "<!--" + e.comment + "-->";
  }
}
var ql = { parse: function(t, e) {
  e || (e = {}), e.components || (e.components = Ul);
  var n, r = [], a = [], i = -1, o = !1;
  if (t.indexOf("<") !== 0) {
    var s = t.indexOf("<");
    r.push({ type: "text", content: s === -1 ? t : t.substring(0, s) });
  }
  return t.replace(Bl, function(l, d) {
    if (o) {
      if (l !== "</" + n.name + ">") return;
      o = !1;
    }
    var u, p = l.charAt(1) !== "/", m = l.startsWith("<!--"), _ = d + l.length, y = t.charAt(_);
    if (m) {
      var f = Ya(l);
      return i < 0 ? (r.push(f), r) : ((u = a[i]).children.push(f), r);
    }
    if (p && (i++, (n = Ya(l)).type === "tag" && e.components[n.name] && (n.type = "component", o = !0), n.voidElement || o || !y || y === "<" || n.children.push({ type: "text", content: t.slice(_, t.indexOf("<", _)) }), i === 0 && r.push(n), (u = a[i - 1]) && u.children.push(n), a[i] = n), (!p || n.voidElement) && (i > -1 && (n.voidElement || n.name === l.slice(2, -1)) && (i--, n = i === -1 ? r : a[i]), !o && y !== "<" && y)) {
      u = i === -1 ? r : a[i].children;
      var g = t.indexOf("<", _), b = t.slice(_, g === -1 ? void 0 : g);
      Kl.test(b) && (b = " "), (g > -1 && i + u.length >= 0 || b !== " ") && u.push({ type: "text", content: b });
    }
  }), r;
}, stringify: function(t) {
  return t.reduce(function(e, n) {
    return e + vo("", n);
  }, "");
} };
function At(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Gl(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, yo(r.key), r);
  }
}
function zt(t, e, n) {
  return e && Gl(t.prototype, e), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
var Wl = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Zl = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Yl = function(e) {
  return Zl[e];
}, Jl = function(e) {
  return e.replace(Wl, Yl);
};
function Ja(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xa(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ja(Object(n), !0).forEach(function(r) {
      re(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ja(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
var Kn = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Jl
}, bo, _a = pr();
function Xl() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  Kn = Xa(Xa({}, Kn), t);
}
function Co() {
  return Kn;
}
var Ql = (function() {
  function t() {
    At(this, t), this.usedNamespaces = {};
  }
  return zt(t, [{
    key: "addUsedNamespaces",
    value: function(n) {
      var r = this;
      n.forEach(function(a) {
        r.usedNamespaces[a] || (r.usedNamespaces[a] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), t;
})();
function ec(t) {
  bo = t;
}
function wo() {
  return bo;
}
var tc = {
  type: "3rdParty",
  init: function(e) {
    Xl(e.options.react), ec(e);
  }
};
function Ar() {
  if (console && console.warn) {
    for (var t, e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    typeof n[0] == "string" && (n[0] = "react-i18next:: ".concat(n[0])), (t = console).warn.apply(t, n);
  }
}
var Qa = {};
function Gr() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  typeof e[0] == "string" && Qa[e[0]] || (typeof e[0] == "string" && (Qa[e[0]] = /* @__PURE__ */ new Date()), Ar.apply(void 0, e));
}
function ei(t, e, n) {
  t.loadNamespaces(e, function() {
    if (t.isInitialized)
      n();
    else {
      var r = function a() {
        setTimeout(function() {
          t.off("initialized", a);
        }, 0), n();
      };
      t.on("initialized", r);
    }
  });
}
function rc(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = e.languages[0], a = e.options ? e.options.fallbackLng : !1, i = e.languages[e.languages.length - 1];
  if (r.toLowerCase() === "cimode") return !0;
  var o = function(l, d) {
    var u = e.services.backendConnector.state["".concat(l, "|").concat(d)];
    return u === -1 || u === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !o(e.isLanguageChangingTo, t) ? !1 : !!(e.hasResourceBundle(r, t) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || o(r, t) && (!a || o(i, t)));
}
function nc(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!e.languages || !e.languages.length)
    return Gr("i18n.languages were undefined or empty", e.languages), !0;
  var r = e.options.ignoreJSONStructure !== void 0;
  return r ? e.hasLoadedNamespace(t, {
    precheck: function(i, o) {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && i.services.backendConnector.backend && i.isLanguageChangingTo && !o(i.isLanguageChangingTo, t)) return !1;
    }
  }) : rc(t, e, n);
}
var ac = ["format"], ic = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
function ti(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ze(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ti(Object(n), !0).forEach(function(r) {
      re(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ti(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function vn(t, e) {
  if (!t) return !1;
  var n = t.props ? t.props.children : t.children;
  return e ? n.length > 0 : !!n;
}
function bn(t) {
  return t ? t.props ? t.props.children : t.children : [];
}
function oc(t) {
  return Object.prototype.toString.call(t) !== "[object Array]" ? !1 : t.every(function(e) {
    return $r(e);
  });
}
function ir(t) {
  return Array.isArray(t) ? t : [t];
}
function sc(t, e) {
  var n = ze({}, e);
  return n.props = Object.assign(t.props, e.props), n;
}
function xo(t, e) {
  if (!t) return "";
  var n = "", r = ir(t), a = e.transSupportBasicHtmlNodes && e.transKeepBasicHtmlNodesFor ? e.transKeepBasicHtmlNodesFor : [];
  return r.forEach(function(i, o) {
    if (typeof i == "string")
      n += "".concat(i);
    else if ($r(i)) {
      var s = Object.keys(i.props).length, l = a.indexOf(i.type) > -1, d = i.props.children;
      if (!d && l && s === 0)
        n += "<".concat(i.type, "/>");
      else if (!d && (!l || s !== 0))
        n += "<".concat(o, "></").concat(o, ">");
      else if (i.props.i18nIsDynamicList)
        n += "<".concat(o, "></").concat(o, ">");
      else if (l && s === 1 && typeof d == "string")
        n += "<".concat(i.type, ">").concat(d, "</").concat(i.type, ">");
      else {
        var u = xo(d, e);
        n += "<".concat(o, ">").concat(u, "</").concat(o, ">");
      }
    } else if (i === null)
      Ar("Trans: the passed in value is invalid - seems you passed in a null child.");
    else if (rt(i) === "object") {
      var p = i.format, m = ga(i, ac), _ = Object.keys(m);
      if (_.length === 1) {
        var y = p ? "".concat(_[0], ", ").concat(p) : _[0];
        n += "{{".concat(y, "}}");
      } else
        Ar("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", i);
    } else
      Ar("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", i);
  }), n;
}
function lc(t, e, n, r, a, i) {
  if (e === "") return [];
  var o = r.transKeepBasicHtmlNodesFor || [], s = e && new RegExp(o.join("|")).test(e);
  if (!t && !s) return [e];
  var l = {};
  function d(g) {
    var b = ir(g);
    b.forEach(function(v) {
      typeof v != "string" && (vn(v) ? d(bn(v)) : rt(v) === "object" && !$r(v) && Object.assign(l, v));
    });
  }
  d(t);
  var u = ql.parse("<0>".concat(e, "</0>")), p = ze(ze({}, l), a);
  function m(g, b, v) {
    var x = bn(g), S = y(x, b.children, v);
    return oc(x) && S.length === 0 ? x : S;
  }
  function _(g, b, v, x, S) {
    g.dummy && (g.children = b), v.push(yr(g, ze(ze({}, g.props), {}, {
      key: x
    }), S ? void 0 : b));
  }
  function y(g, b, v) {
    var x = ir(g), S = ir(b);
    return S.reduce(function(h, P, F) {
      var G = P.children && P.children[0] && P.children[0].content && n.services.interpolator.interpolate(P.children[0].content, p, n.language);
      if (P.type === "tag") {
        var W = x[parseInt(P.name, 10)];
        !W && v.length === 1 && v[0][P.name] && (W = v[0][P.name]), W || (W = {});
        var H = Object.keys(P.attrs).length !== 0 ? sc({
          props: P.attrs
        }, W) : W, B = $r(H), U = B && vn(P, !0) && !P.voidElement, Y = s && rt(H) === "object" && H.dummy && !B, ee = rt(t) === "object" && t !== null && Object.hasOwnProperty.call(t, P.name);
        if (typeof H == "string") {
          var Z = n.services.interpolator.interpolate(H, p, n.language);
          h.push(Z);
        } else if (vn(H) || U) {
          var pe = m(H, P, v);
          _(H, pe, h, F);
        } else if (Y) {
          var ne = y(x, P.children, v);
          h.push(yr(H, ze(ze({}, H.props), {}, {
            key: F
          }), ne));
        } else if (Number.isNaN(parseFloat(P.name)))
          if (ee) {
            var te = m(H, P, v);
            _(H, te, h, F, P.voidElement);
          } else if (r.transSupportBasicHtmlNodes && o.indexOf(P.name) > -1)
            if (P.voidElement)
              h.push($t(P.name, {
                key: "".concat(P.name, "-").concat(F)
              }));
            else {
              var ce = y(x, P.children, v);
              h.push($t(P.name, {
                key: "".concat(P.name, "-").concat(F)
              }, ce));
            }
          else if (P.voidElement)
            h.push("<".concat(P.name, " />"));
          else {
            var A = y(x, P.children, v);
            h.push("<".concat(P.name, ">").concat(A, "</").concat(P.name, ">"));
          }
        else if (rt(H) === "object" && !B) {
          var D = P.children[0] ? G : null;
          D && h.push(D);
        } else P.children.length === 1 && G ? h.push(yr(H, ze(ze({}, H.props), {}, {
          key: F
        }), G)) : h.push(yr(H, ze(ze({}, H.props), {}, {
          key: F
        })));
      } else if (P.type === "text") {
        var N = r.transWrapTextNodes, T = i ? r.unescape(n.services.interpolator.interpolate(P.content, p, n.language)) : n.services.interpolator.interpolate(P.content, p, n.language);
        N ? h.push($t(N, {
          key: "".concat(P.name, "-").concat(F)
        }, T)) : h.push(T);
      }
      return h;
    }, []);
  }
  var f = y([{
    dummy: !0,
    children: t || []
  }], u, ir(t || []));
  return bn(f[0]);
}
function ko(t) {
  var e = t.children, n = t.count, r = t.parent, a = t.i18nKey, i = t.context, o = t.tOptions, s = o === void 0 ? {} : o, l = t.values, d = t.defaults, u = t.components, p = t.ns, m = t.i18n, _ = t.t, y = t.shouldUnescape, f = ga(t, ic), g = vt(_a) || {}, b = g.i18n, v = g.defaultNS, x = m || b || wo();
  if (!x)
    return Gr("You will need to pass in an i18next instance by using i18nextReactModule"), e;
  var S = _ || x.t.bind(x) || function(Z) {
    return Z;
  };
  i && (s.context = i);
  var h = ze(ze({}, Co()), x.options && x.options.react), P = p || S.ns || v || x.options && x.options.defaultNS;
  P = typeof P == "string" ? [P] : P || ["translation"];
  var F = d || xo(e, h) || h.transEmptyNodeValue || a, G = h.hashTransKey, W = a || (G ? G(F) : F), H = l ? s.interpolation : {
    interpolation: ze(ze({}, s.interpolation), {}, {
      prefix: "#$?",
      suffix: "?$#"
    })
  }, B = ze(ze(ze(ze({}, s), {}, {
    count: n
  }, l), H), {}, {
    defaultValue: F,
    ns: P
  }), U = W ? S(W, B) : F, Y = lc(u || e, U, x, h, B, y), ee = r !== void 0 ? r : h.defaultTransParent;
  return ee ? $t(ee, f, Y) : Y;
}
function cc(t) {
  if (Array.isArray(t)) return t;
}
function uc(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, a, i, o, s = [], l = !0, d = !1;
    try {
      if (i = (n = n.call(t)).next, e !== 0) for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== e); l = !0) ;
    } catch (u) {
      d = !0, a = u;
    } finally {
      try {
        if (!l && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (d) throw a;
      }
    }
    return s;
  }
}
function ri(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function dc(t, e) {
  if (t) {
    if (typeof t == "string") return ri(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ri(t, e) : void 0;
  }
}
function pc() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mc(t, e) {
  return cc(t) || uc(t, e) || dc(t, e) || pc();
}
function ni(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Cn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ni(Object(n), !0).forEach(function(r) {
      re(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ni(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
var fc = function(e, n) {
  var r = Ot();
  return Ve(function() {
    r.current = e;
  }, [e, n]), r.current;
};
function He(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.i18n, r = vt(_a) || {}, a = r.i18n, i = r.defaultNS, o = n || a || wo();
  if (o && !o.reportNamespaces && (o.reportNamespaces = new Ql()), !o) {
    Gr("You will need to pass in an i18next instance by using initReactI18next");
    var s = function(W) {
      return Array.isArray(W) ? W[W.length - 1] : W;
    }, l = [s, {}, !1];
    return l.t = s, l.i18n = {}, l.ready = !1, l;
  }
  o.options.react && o.options.react.wait !== void 0 && Gr("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var d = Cn(Cn(Cn({}, Co()), o.options.react), e), u = d.useSuspense, p = d.keyPrefix, m = i || o.options && o.options.defaultNS;
  m = typeof m == "string" ? [m] : m || ["translation"], o.reportNamespaces.addUsedNamespaces && o.reportNamespaces.addUsedNamespaces(m);
  var _ = (o.isInitialized || o.initializedStoreOnce) && m.every(function(G) {
    return nc(G, o, d);
  });
  function y() {
    return o.getFixedT(null, d.nsMode === "fallback" ? m : m[0], p);
  }
  var f = Te(y), g = mc(f, 2), b = g[0], v = g[1], x = m.join(), S = fc(x), h = Ot(!0);
  Ve(function() {
    var G = d.bindI18n, W = d.bindI18nStore;
    h.current = !0, !_ && !u && ei(o, m, function() {
      h.current && v(y);
    }), _ && S && S !== x && h.current && v(y);
    function H() {
      h.current && v(y);
    }
    return G && o && o.on(G, H), W && o && o.store.on(W, H), function() {
      h.current = !1, G && o && G.split(" ").forEach(function(B) {
        return o.off(B, H);
      }), W && o && W.split(" ").forEach(function(B) {
        return o.store.off(B, H);
      });
    };
  }, [o, x]);
  var P = Ot(!0);
  Ve(function() {
    h.current && !P.current && v(y), P.current = !1;
  }, [o, p]);
  var F = [b, o, _];
  if (F.t = b, F.i18n = o, F.ready = _, _ || !_ && !u) return F;
  throw new Promise(function(G) {
    ei(o, m, function() {
      G();
    });
  });
}
function hc(t) {
  var e = t.i18n, n = t.defaultNS, r = t.children, a = tn(function() {
    return {
      i18n: e,
      defaultNS: n
    };
  }, [e, n]);
  return $t(_a.Provider, {
    value: a
  }, r);
}
const gc = { "required-field": "الحقل مطلوب", payment: { price_plan: "عرض", stripe_card: "بطاقة ائتمان أو خصم", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "بطاقات الائتمان (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "بطاقات الائتمان (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "mollie", gocardless: "Gocardless", cash_on_delivery: "الدفع عند الاستلام", xendit_card: "بطاقات الائتمان (Xendit)", paystack_card: "بطاقات الإئتمان (Paystack)", paypal_connect: "ربط paypal", paypal_edit_organization_name: "تعديل اسم المنظمة", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "خطأ", "Payment-method": "طريقة دفع", price_plan: { trial_period: { week_0: "{{count}} أسبوع", week_1: "أسبوع {{count}}", week_2: "أسبوعين {{count}}", week_3: "{{count}} أسابيع", week_4: "{{count}} أسبوع", week_5: "{{count}} أسبوع", day_0: "{{count}} يوم", day_1: "يوم {{count}}", day_2: "يومين {{count}}", day_3: "{{count}} أيام", day_4: "{{count}} يوم", day_5: "{{count}} يوم", month_0: "{{count}} شهر", month_1: "شهر{{count}}", month_2: "شهربن {{count}}", month_3: "{{count}} أشهر", month_4: "{{count}} شهر", month_5: "{{count}} شهر", year_0: "{{count}} سنة", year_1: "سنة {{count}}", year_2: "سنتان {{count}}", year_3: "{{count}} سنوات", year_4: "{{count}} سنة", year_5: "{{count}} سنة" }, interval: { month_0: "{{count}} شهر", month_1: "شهر {{count}}", month_2: "شهرين {{count}}", month_3: "{{count}} أشهر", month_4: "{{count}} شهر", month_5: "{{count}} شهر", day_0: "{{count}} يوم", day_1: "يوم {{count}}", day_2: "يومين {{count}}", day_3: "{{count}} أيام", day_4: "{{count}} يوم", day_5: "{{count}} يوم", week_0: "{{count}} أسبوع", week_1: "أسبوع {{count}}", week_2: "أسبوعين {{count}}", week_3: "{{count}} أسابيع", week_4: "{{count}} أسبوع", week_5: "{{count}} أسبوع", year_0: "{{count}} سنة", year_1: "سنة {{count}}", year_2: "سنتان{{count}}", year_3: "{{count}} سنوات", year_4: "{{count}} سنة", year_5: "{{count}} سنة" } }, components: { offer_price: { price_plans: { trial_period_price: "مجانا", trial_period_new: "{{ trialPeriodPrice }} لمدة {{ trialInterval }} ثم", unlimited_new: "<bold>{{amount}}</bold> لكل {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} مرات" } } }, affiliate_badge: { made_with: "يعمل بواسطة" }, form_select: { empty_list: "يبدو أن هذه القائمة فارغة", select: "حدد" }, contact_slug: { email: "البريد الإلكتروني", first_name: "الاسم", last_name: "اسم العائلة", phone_number: "رقم الهاتف", country: "البلد", street_address: "عنوان الشارع", city: "المدينة", postal_code: "الرمز البريدي", company_name: "اسم الشركة", tax_number: "الرقم الضريبي", state_province: "الولاية/المقاطعة", street_number: "رقم الشارع", neighborhood: "الحي" }, date_picker: { apply: "تطبيق", clear: "إزالة", time: "الوقت", all_time: "كل الوقت", last_3_months: "آخر 3 أشهر", last_pool_period: "فترة التقييم الأخيرة للمجموعة", last_month: "الشهر الفائت", this_month: "هذا الشهر", last_30_days: "آخر 30 يوم", title_dates: "تواريخ", from: "من", to: "إلى" }, copy_clipboard: "تم النسخ في الحافظة", payment_inputs: { empty_card_number: "أدخل رقم البطاقة", invalid_card_number: "رقم البطاقة غير صالح", empty_expiry_date: "أدخل تاريخ الانتهاء", month_out_of_range: "يجب أن يكون شهر الانتهاء بين 01 و 12", year_out_of_range: "لا يمكن أن تكون سنة الانتهاء في الماضي", date_out_of_range: "لا يمكن أن يكون تاريخ الانتهاء في الماضي", invalid_expiry_date: "تاريخ الانتهاء غير صالح", invalid_cvc: "رمز التحقق غير صالح", empty_cvc: "أدخل رمز التحقق", card_number_placeholder: "رقم البطاقة", expiry_data_placeholder: "الشهر/السنة", cvc_placeholder: "رمز التحقق", card_holder_placeholder: "حامل البطاقة", empty_card_holder: "أدخل اسم حامل البطاقة" }, copy_clipboard_error: "فشل في نسخ النص", input: { phone_number: "رقم الهاتف", phone_search: "بحث", search: "بحث" }, "registered-over": "مسجل أكثر من", locale: { french: "فرنسية", german: "ألمانية", italian: "ايطالية", dutch: "هولندية", english: "إنجليزية", portuguese: "البرتغالية", russian: "الروسية", spanish: "الإسبانية", japanese: "اليابانية", arabic: "العربية", turkish: "التركية", chinese: "الصينية", swedish: "السويدية", romanian: "الرومانية", czech: "التشيكية", hungarian: "الهنغارية", slovak: "السلوفاكية", danish: "الدانماركية", indonesian: "الأندونيسية", polish: "البولندية", greek: "اليونانية", serbian: "الصربية", hindi: "الهندية", norwegian: "النرويجية", thai: "التايلندية", slovenian: "السلوفينية", ukrainian: "الأوكرانية", albania: "الألبانية" }, product: "منتج", quantity: "الكمية", order_summary: "ملخص الطلب", vat: "ضريبة المبيعات", total: "المجموع", subtotal: "المجموع الفرعي", shipping: { shipping_method: "طريقة الشحن", not_available: "عذرًا! يبدو أننا لا نقدم الشحن إلى هذا الموقع بعد.", condition_label: { price: "للطلبات التي تتراوح أسعارها بين {{min}} {{currency}} و {{max}} {{currency}}", price_min: "للطلبات التي تتراوح أسعارها عند {{min}} {{currency}} أو أكثر", quantity: "للطلبات التي تحتوي على بين {{min}} إلى {{max}} عنصر", quantity_min: "للطلبات التي تحتوي على {{min}} عنصر أو أكثر", weight: "للطلبات التي يبلغ وزنها الإجمالي بين {{min}} غرام إلى {{max}} غرام", weight_min: "للطلبات التي يبلغ وزنها الإجمالي {{min}} غرام أو أكثر" } }, shipping_fee: "رسوم الشحن", total_amount_with_tax_and_shipping: "المجموع (بما في ذلك الضريبة والشحن)", vat_percent: "ضريبة المبيعات ({{percent}}%)", including_tax: "يشمل {{percent}}٪ ضريبة القيمة المضافة ({{amount}})", total_amount_with_tax: "المجموع (شامل الضرائب)", total_amount_with_shipping: "المجموع (شامل الشحن)" }, _c = {
  public_pages_purchase: gc
}, yc = { "required-field": "Pole je povinné", payment: { price_plan: "Plán", stripe_card: "Kreditní nebo debetní karta", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Kreditní karty (místní)", dlocal_boleto: "Boleto (místní)", dlocal_pix: "Pix (místní)", paypal_soap: "PayPal", mercadopago_card: "Kreditní karty (Mercado Pago)", mercadopago_pix: "PIX (Platební trh)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Dobírka", xendit_card: "Kreditní karty (Xendit)", paystack_card: "Kreditní karty (Paystack)", paypal_connect: "Připojte PayPal", paypal_edit_organization_name: "Upravit název organizace", paypal_rest: "PayPal", secure_and_pay: "Zabezpečte a zaplaťte", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Chyba", "Payment-method": "Způsob platby", price_plan: { trial_period: { week_0: "{{count}} týden", week_1: "{{count}} týdnů", week_2: "{{count}} týdnů", day_0: "{{count}} den", day_1: "{{count}} dny", day_2: "{{count}} dní", month_0: "{{count}} měsíc", month_1: "{{count}} měsíců", month_2: "{{count}} měsíců", year_0: "{{count}} rok", year_1: "{{count}} let", year_2: "{{count}} let" }, interval: { month_0: "měsíc", month_1: "{{count}} měsíců", month_2: "{{count}} měsíců", day_0: "den", day_1: "{{count}} dnů", day_2: "{{count}} dnů", week_0: "týden", week_1: "{{count}} týdnů", week_2: "{{count}} týdnů", year_0: "rok", year_1: "{{count}} let", year_2: "{{count}} let" } }, components: { offer_price: { price_plans: { trial_period_price: "Zdarma", trial_period_new: "{{ trialPeriodPrice }} pro {{ trialInterval }} pak", unlimited_new: "<bold>{{amount}}</bold> každý {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} krát" } } }, affiliate_badge: { made_with: "Poháněno" }, form_select: { empty_list: "Vypadá to, že tento seznam je prázdný", select: "Vybrat" }, contact_slug: { email: "E-mail", first_name: "Jméno", last_name: "Příjmení", phone_number: "Telefonní číslo", country: "Země", street_address: "Ulice", city: "Město", postal_code: "PSČ", company_name: "Název společnosti", tax_number: "DIČ", state_province: "Stát/Provincie", street_number: "Číslo ulice", neighborhood: "Čtvrť" }, date_picker: { apply: "Použít", clear: "Vymazat", time: "Čas", all_time: "Celý čas", last_3_months: "Poslední 3 měsíce", last_pool_period: "Poslední hodnotící období", last_month: "Minulý měsíc", this_month: "Tento měsíc", last_30_days: "Posledních 30 dní", title_dates: "Data", from: "Z", to: "Do" }, copy_clipboard: "Zkopírováno do schránky", payment_inputs: { empty_card_number: "Zadejte číslo karty", invalid_card_number: "Číslo karty je neplatné", empty_expiry_date: "Zadejte datum vypršení platnosti", month_out_of_range: "Měsíc vypršení platnosti musí být mezi 01 a 12", year_out_of_range: "Rok expirace nemůže být v minulosti", date_out_of_range: "Datum expirace nemůže být v minulosti", invalid_expiry_date: "Datum expirace je neplatné", invalid_cvc: "CVC je neplatné", empty_cvc: "Zadejte CVC", card_number_placeholder: "Číslo karty", expiry_data_placeholder: "MM/YY", cvc_placeholder: "CVC", card_holder_placeholder: "Držitel karty", empty_card_holder: "Zadejte jméno držitele karty" }, copy_clipboard_error: "Kopírování textu se nezdařilo", input: { phone_number: "Telefonní číslo", phone_search: "Hledat", search: "Hledat" }, "registered-over": "registrovaných přes", locale: { french: "Francouzština", german: "Němčina", italian: "Italština", dutch: "Holandský", english: "Angličtina", portuguese: "Portugalština", russian: "Ruština", spanish: "Španělština", japanese: "Japonština", arabic: "Arabština", turkish: "Turečtina", chinese: "Čínština", swedish: "Švédnština", romanian: "Rumunština", czech: "Čeština", hungarian: "Maďarský", slovak: "Slovenština", danish: "Dánština", indonesian: "Indonéština", polish: "Polština", greek: "Řečtina", serbian: "Srbština", hindi: "Hindi", norwegian: "Norština", thai: "Thajština", slovenian: "Slovinský", ukrainian: "Ukrajinština", albania: "Albánština" }, product: "Produkt", quantity: "Množství", order_summary: "Shrnutí objednávky", vat: "Daň z prodeje", total: "Celkem", subtotal: "Mezisoučet", shipping: { shipping_method: "Způsob dopravy", not_available: "Omlouváme se! Vypadá to, že zatím nenabízíme dopravu na tuto adresu.", condition_label: { price: "Pro objednávky v cenovém rozmezí {{min}} {{currency}} až {{max}} {{currency}}", price_min: "Pro objednávky v ceně {{min}} {{currency}} nebo více", quantity: "Pro objednávky obsahující mezi {{min}} a {{max}} položkami", quantity_min: "Pro objednávky obsahující {{min}} nebo více položek", weight: "Pro objednávky s celkovou hmotností mezi {{min}}g a {{max}}g", weight_min: "Pro objednávky s celkovou hmotností {{min}}g nebo více" } }, shipping_fee: "Poplatek za dopravu", total_amount_with_tax_and_shipping: "Celkem (včetně daně a dopravy)", vat_percent: "Daň z prodeje ({{percent}}%)", including_tax: "Včetně DPH {{percent}} % ({{amount}})", total_amount_with_tax: "Celkem (včetně daně)", total_amount_with_shipping: "Celkem (včetně dopravy)" }, vc = {
  public_pages_purchase: yc
}, bc = { "required-field": "Feltet er påkrævet", payment: { price_plan: "Plan", stripe_card: "Kredit- eller betalingskort", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Kreditkort (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Kreditkort (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Kontant ved levering", xendit_card: "Kreditkort (Xendit)", paystack_card: "Kreditkort (Paystack)", paypal_connect: "Tilslut PayPal", paypal_edit_organization_name: "Rediger organisationens navn", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Fejl", "Payment-method": "Betalingsmetode", price_plan: { trial_period: { week: "{{count}} uge", week_plural: "{{count}} uger", day: "{{count}} dag", day_plural: "{{count}} dage", month: "{{count}} måned", month_plural: "{{count}} måneder", year: "{{count}} år", year_plural: "{{count}} år" }, interval: { month: "måned", month_plural: "{{count}} måneder", day: "dag", day_plural: "{{count}} dage", week: "uge", week_plural: "{{count}} uger", year: "år", year_plural: "{{count}} år" } }, components: { offer_price: { price_plans: { trial_period_price: "Gratis", trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} derefter", unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gange" } } }, affiliate_badge: { made_with: "Støttet af" }, form_select: { empty_list: "Det ser ud til, at denne liste er tom", select: "Vælge" }, contact_slug: { email: "E-mail", first_name: "Fornavn", last_name: "Efternavn", phone_number: "Telefonnummer", country: "Land", street_address: "Gadeadresse", city: "By", postal_code: "Postnummer", company_name: "Firmanavn", tax_number: "Skattenummer", state_province: "stat/provins", street_number: "Gadenummer", neighborhood: "Kvarter" }, date_picker: { apply: "Anvende", clear: "Slet", time: "Tid", all_time: "Hele tiden", last_3_months: "Sidste 3 måneder", last_pool_period: "Sidste puljeevalueringsperiode", last_month: "Sidste måned", this_month: "Denne måned", last_30_days: "Sidste 30 dage", title_dates: "Datoer", from: "Fra", to: "Til" }, copy_clipboard: "Kopieret til udklipsholder", payment_inputs: { empty_card_number: "Indtast et kortnummer", invalid_card_number: "Kortnummeret er ugyldigt", empty_expiry_date: "Indtast en udløbsdato", month_out_of_range: "Udløbsmåned skal være mellem 01 og 12", year_out_of_range: "Udløbsåret må ikke ligge i fortiden", date_out_of_range: "Udløbsdatoen må ikke ligge i fortiden", invalid_expiry_date: "Udløbsdatoen er ugyldig", invalid_cvc: "CVC er ugyldig", empty_cvc: "Indtast en CVC", card_number_placeholder: "Kortnummer", expiry_data_placeholder: "MM/ÅÅ", cvc_placeholder: "CVC", card_holder_placeholder: "Kortholder", empty_card_holder: "Indtast et kortholdernavn" }, copy_clipboard_error: "Teksten kunne ikke kopieres", input: { phone_number: "Telefonnummer", phone_search: "Søge", search: "Søge" }, "registered-over": "registreret over", locale: { french: "Fransk", german: "Tysk", italian: "Italiensk", dutch: "Hollandsk", english: "Engelsk", portuguese: "Portugisisk", russian: "Russisk", spanish: "Spansk", japanese: "Japansk", arabic: "Arabisk", turkish: "Tyrkisk", chinese: "Kinesisk", swedish: "Svensk", romanian: "Rumænsk", czech: "Tjekkisk", hungarian: "Ungarsk", slovak: "Slovakisk", danish: "Dansk", indonesian: "Indonesisk", polish: "Polsk", greek: "Græsk", serbian: "Serbisk", hindi: "Hindi", norwegian: "Norsk", thai: "Thai", slovenian: "Slovensk", ukrainian: "Ukrainsk", albania: "Albansk" }, product: "Produkt", quantity: "Mængde", order_summary: "Ordreoversigt", vat: "Salgsskat", total: "Total", subtotal: "Subtotal", shipping: { shipping_method: "Forsendelsesmetode", not_available: "Ups! Det ser ud til, at vi endnu ikke tilbyder forsendelse til denne placering.", condition_label: { price: "For ordrer prissat mellem {{min}} {{currency}} og {{max}} {{currency}}", price_min: "For ordrer prissat til {{min}} {{currency}} eller mere", quantity: "For ordrer indeholdende mellem {{min}} og {{max}} varer", quantity_min: "For ordrer indeholdende {{min}} eller flere varer", weight: "For ordrer med en samlet vægt mellem {{min}}g og {{max}}g", weight_min: "For ordrer med en samlet vægt på {{min}}g eller mere" } }, shipping_fee: "Forsendelsesgebyr", total_amount_with_tax_and_shipping: "I alt (inkl. moms og forsendelse)", vat_percent: "Moms ({{percent}} %)", including_tax: "Inkluderer {{percent}} % moms ({{amount}})", total_amount_with_tax: "Total (inkl. skat)", total_amount_with_shipping: "Total (inklusive forsendelse)" }, Cc = {
  public_pages_purchase: bc
}, wc = { "required-field": "Das Feld ist erforderlich", payment: { price_plan: "Plan", stripe_card: "Kredit- oder Debitkarte", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Kreditkarten (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Kreditkarten (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Lieferung per Nachnahme", xendit_card: "Kreditkarten (Xendit)", paystack_card: "Kreditkarten (Paystack)", paypal_connect: "PayPal verbinden", paypal_edit_organization_name: "Organisationsnamen bearbeiten", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Fehler", "Payment-method": "Zahlungsmethode", price_plan: { trial_period: { week: "{{count}} Woche", week_plural: "{{count}} Wochen", day: "{{count}} Tag", day_plural: "{{count}} Tage", month: "{{count}} Monat", month_plural: "{{count}} Monate", year: "{{count}} Jahr", year_plural: "{{count}} Jahre" }, interval: { month: "Monat", month_plural: "{{count}} Monate", day: "Tag", day_plural: "{{count}} Tage", week: "Woche", week_plural: "{{count}} Wochen", year: "Jahr", year_plural: "{{count}} Jahre" } }, components: { offer_price: { price_plans: { trial_period_price: "Kostenlos", trial_period_new: "{{ trialPeriodPrice }} für {{ trialInterval }} dann", unlimited_new: "<bold>{{amount}}</bold> alle {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} mal" } } }, affiliate_badge: { made_with: "Unterstützt von" }, form_select: { empty_list: "Es sieht so aus, als wäre diese Liste leer", select: "Auswählen" }, contact_slug: { email: "E-Mail", first_name: "Vorname", last_name: "Nachname", phone_number: "Telefonnummer", country: "Land", street_address: "Straßenadresse", city: "Stadt", postal_code: "Postleitzahl", company_name: "Firmenname", tax_number: "Steuernummer", state_province: "Bundesland/Provinz", street_number: "Hausnummer", neighborhood: "Nachbarschaft" }, date_picker: { apply: "Anwenden", clear: "Löschen", time: "Zeit", all_time: "Alle Zeiten", last_3_months: "Letzte 3 Monate", last_pool_period: "Letzter Pool-Auswertungszeitraum", last_month: "Letzter Monat", this_month: "Dieser Monat", last_30_days: "Letzte 30 Tage", title_dates: "Termine", from: "Von", to: "Nach" }, copy_clipboard: "In die Zwischenablage kopiert", payment_inputs: { empty_card_number: "Eine Kartennummer eingeben", invalid_card_number: "Kartennummer ist ungültig", empty_expiry_date: "Geben Sie ein Verfallsdatum ein", month_out_of_range: "Der Verfallsmonat muss zwischen 01 und 12 liegen", year_out_of_range: "Das Verfallsjahr darf nicht in der Vergangenheit liegen", date_out_of_range: "Das Verfallsdatum darf nicht in der Vergangenheit liegen", invalid_expiry_date: "Verfallsdatum ist ungültig", invalid_cvc: "CVC ist ungültig", empty_cvc: "Einen CVC eingeben", card_number_placeholder: "Kartennummer", expiry_data_placeholder: "MM/JJ", cvc_placeholder: "CVC", card_holder_placeholder: "Karteninhaber", empty_card_holder: "Name des Karteninhabers eingeben" }, copy_clipboard_error: "Text konnte nicht kopiert werden", input: { phone_number: "Telefonnummer", phone_search: "Suchen", search: "Suchen" }, "registered-over": "registriert über", locale: { french: "Französisch", german: "Deutsch", italian: "Italienisch", dutch: "Niederländisch", english: "Englisch", portuguese: "Portugiesisch", russian: "Russisch", spanish: "Spanisch", japanese: "Japanisch", arabic: "Arabisch", turkish: "Türkisch", chinese: "Chinesisch", swedish: "Schwedisch", romanian: "Rumänisch", czech: "Tschechisch", hungarian: "Ungarisch", slovak: "Slowakisch", danish: "Dänisch", indonesian: "Indonesisch", polish: "Polnisch", greek: "Griechisch", serbian: "Serbisch", hindi: "Hindi", norwegian: "Norwegisch", thai: "Thailändisch", slovenian: "Slowenisch", ukrainian: "Ukrainisch", albania: "Albanisch" }, product: "Produkt", quantity: "Menge", order_summary: "Bestellübersicht", vat: "Mehrwertsteuer", total: "Gesamt", subtotal: "Zwischensumme", shipping: { shipping_method: "Versandmethode", not_available: "Ups! Es scheint, dass wir noch keinen Versand an diesen Standort anbieten.", condition_label: { price: "Für Bestellungen im Wert von {{min}} {{currency}} bis {{max}} {{currency}}", price_min: "Für Bestellungen im Wert von {{min}} {{currency}} oder mehr", quantity: "Für Bestellungen mit {{min}} bis {{max}} Artikeln", quantity_min: "Für Bestellungen mit {{min}} oder mehr Artikeln", weight: "Für Bestellungen mit einem Gesamtgewicht zwischen {{min}}g und {{max}}g", weight_min: "Für Bestellungen mit einem Gesamtgewicht von {{min}}g oder mehr" } }, shipping_fee: "Versandgebühr", total_amount_with_tax_and_shipping: "Gesamt (inklusive Steuern und Versand)", vat_percent: "Umsatzsteuer ({{percent}} %)", including_tax: "Enthält {{percent}} % MwSt. ({{amount}})", total_amount_with_tax: "Gesamtbetrag (inkl. Steuern)", total_amount_with_shipping: "Gesamtbetrag (einschließlich Versand)" }, xc = {
  public_pages_purchase: wc
}, kc = { "required-field": "Το πεδίο είναι υποχρεωτικό", payment: { price_plan: "Πλάνο", stripe_card: "Πιστωτική ή χρεωστική κάρτα", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Τραπεζικές κάρτες (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Τραπεζικές κάρτες (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Με αντικαταβολή", xendit_card: "Τραπεζικές κάρτες (Xendit)", paystack_card: "Τραπεζικές κάρτες (Paystack)", paypal_connect: "Σύνδεση με PayPal", paypal_edit_organization_name: "Επεξεργασία ονόματος οργανισμού", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Σφάλμα", "Payment-method": "Τρόπος πληρωμής", price_plan: { trial_period: { week: "{{count}} εβδομάδα", week_plural: "{{count}} εβδομάδες", day: "{{count}} ημέρα", day_plural: "{{count}} ημέρες", month: "{{count}} μήνας", month_plural: "{{count}} μήνες", year: "{{count}} έτος", year_plural: "{{count}} έτη" }, interval: { month: "μήνας", month_plural: "{{count}} μήνες", day: "ημέρα", day_plural: "{{count}} ημέρες", week: "εβδομάδα", week_plural: "{{count}} εβδομάδες", year: "έτος", year_plural: "{{count}} έτη" } }, components: { offer_price: { price_plans: { trial_period_price: "Δωρεάν", trial_period_new: "{{ trialPeriodPrice }} για {{ trialInterval }} και έπειτα", unlimited_new: "<bold>{{amount}}</bold> κάθε {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} φορές" } } }, affiliate_badge: { made_with: "Powered by" }, form_select: { empty_list: "Φαίνεται ότι αυτή η λίστα είναι κενή", select: "Επιλογή" }, contact_slug: { email: "Email", first_name: "Όνομα", last_name: "Επώνυμο", phone_number: "Τηλέφωνο", country: "Χώρα", street_address: "Διεύθυνση", city: "Πόλη", postal_code: "Ταχυδρομικός κώδικας", company_name: "Επωνυμία εταιρίας", tax_number: "Α.Φ.Μ.", state_province: "Νομός", street_number: "Αριθμός οδού", neighborhood: "Γειτονιά" }, date_picker: { apply: "Υποβολή", clear: "Επαναφορά", time: "Χρόνος", all_time: "Συνολικά", last_3_months: "Τελευταίοι 3 μήνες", last_pool_period: "Τελευταία περίοδος αξιολόγησης email", last_month: "Προηγούμενος μήνας", this_month: "Αυτό το μήνα", last_30_days: "Τελευταίες 30 ημέρες", title_dates: "Ημερομηνίες", from: "Από", to: "Προς" }, copy_clipboard: "Επιτυχής αντιγραφή", payment_inputs: { empty_card_number: "Εισάγετε έναν αριθμό κάρτας", invalid_card_number: "Ο αριθμός κάρτας είναι μη έγκυρος", empty_expiry_date: "Εισάγετε μια ημερομηνία λήξης", month_out_of_range: "Ο μήνας λήξης πρέπει να είναι μεταξύ 01 και 12", year_out_of_range: "Η χρονολογία λήξης δεν μπορεί να είναι στο παρελθόν", date_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν", invalid_expiry_date: "Η ημερομηνία λήξης είναι μη έγκυρη", invalid_cvc: "Το CVC είναι μη έγκυρο", empty_cvc: "Εισάγετε το CVC", card_number_placeholder: "Αριθμός κάρτας", expiry_data_placeholder: "ΜΜ/ΕΕ", cvc_placeholder: "CVC", card_holder_placeholder: "Κάτοχος κάρτας", empty_card_holder: "Εισάγετε το όνομα του κατόχου της κάρτας" }, copy_clipboard_error: "Αποτυχία αντιγραφής κειμένου", input: { phone_number: "Τηλέφωνο", phone_search: "Αναζήτηση", search: "Αναζήτηση" }, "registered-over": "εγγεγραμμένο πάνω από", locale: { french: "Γαλλικά", german: "Γερμανικά", italian: "Ιταλικά", dutch: "Ολλανδικά", english: "Αγγλικά", portuguese: "Πορτογαλικά", russian: "Ρωσικά", spanish: "Ισπανικά", japanese: "Ιαπωνικά", arabic: "Αραβικά", turkish: "Τούρκικα", chinese: "Κινέζικα", swedish: "Σουηδικά", romanian: "Ρουμανικά", czech: "Τσέχικα", hungarian: "Ουγγρικά", slovak: "Σλοβάκικα", danish: "Δανικά", indonesian: "Ινδονησιακά", polish: "Πολωνικά", greek: "Ελληνικά", serbian: "Σερβικά", hindi: "Ινδικά", norwegian: "Νορβηγικά", thai: "Ταϊλανδέζικα", slovenian: "Σλοβενικά", ukrainian: "Ουκρανικά", albania: "Αλβανικά" }, product: "Προϊόν", quantity: "Ποσότητα", order_summary: "Σύνοψη Παραγγελίας", vat: "Φόρος πωλήσεων", total: "Σύνολο", subtotal: "Μερικό σύνολο", shipping: { shipping_method: "Τρόπος αποστολής", not_available: "Ωχ. Φαίνεται ότι δεν προσφέρουμε αποστολή σε αυτήν την τοποθεσία ακόμη", condition_label: { price: "Για παραγγελίες αξίας από {{min}} {{currency}} έως {{max}} {{currency}}", price_min: "Για παραγγελίες αξίας τουλάχιστον {{min}} {{currency}}", quantity: "Για παραγγελίες που περιέχουν από {{min}} έως {{max}} αντικείμενα", quantity_min: "Για παραγγελίες που περιέχουν τουλάχιστον {{min}} αντικείμενα", weight: "Για παραγγελίες με συνολικό βάρος από {{min}}g έως {{max}}g", weight_min: "Για παραγγελίες με συνολικό βάρος τουλάχιστον {{min}}g" } }, shipping_fee: "Χρέωση αποστολής", total_amount_with_tax_and_shipping: "Σύνολο (συμπεριλαμβανομένων φόρων και αποστολής)", vat_percent: "ΦΠΑ ({{percent}}%)", including_tax: "Συμπεριλαμβάνει {{percent}}% ΦΠΑ ({{amount}})", total_amount_with_tax: "Σύνολο (συμπεριλαμβανομένου φόρου)", total_amount_with_shipping: "Σύνολο (συμπεριλαμβανομένων των μεταφορικών)" }, Sc = {
  public_pages_purchase: kc
}, Pc = { "required-field": "Field is required", payment: { price_plan: "Plan", stripe_card: "Credit or debit card", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Credit cards (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Credit cards (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Cash on delivery", xendit_card: "Credit cards (Xendit)", paystack_card: "Credit cards (Paystack)", paypal_connect: "Connect PayPal", paypal_edit_organization_name: "Edit organization name", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Error", "Payment-method": "Payment method", price_plan: { trial_period: { week: "{{count}} week", week_plural: "{{count}} weeks", day: "{{count}} day", day_plural: "{{count}} days", month: "{{count}} month", month_plural: "{{count}} months", year: "{{count}} year", year_plural: "{{count}} years" }, interval: { month: "month", month_plural: "{{count}} months", day: "day", day_plural: "{{count}} days", week: "week", week_plural: "{{count}} weeks", year: "year", year_plural: "{{count}} years" } }, components: { offer_price: { price_plans: { trial_period_price: "Free", trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} then", unlimited_new: "<bold>{{amount}}</bold> every {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} times" } } }, affiliate_badge: { made_with: "Powered by" }, form_select: { empty_list: "It looks like this list is empty", select: "Select" }, contact_slug: { email: "Email", first_name: "First name", last_name: "Last name", phone_number: "Phone number", country: "Country", street_address: "Street address", city: "City", postal_code: "Postal code", company_name: "Company name", tax_number: "Tax number", state_province: "State/Province", street_number: "Street number", neighborhood: "Neighborhood" }, date_picker: { apply: "Apply", clear: "Clear", time: "Time", all_time: "All time", last_3_months: "Last 3 months", last_pool_period: "Last pool evaluation period", last_month: "Last month", this_month: "This month", last_30_days: "Last 30 days", title_dates: "Dates", from: "From", to: "To" }, copy_clipboard: "Copied to clipboard", payment_inputs: { empty_card_number: "Enter a card number", invalid_card_number: "Card number is invalid", empty_expiry_date: "Enter an expiry date", month_out_of_range: "Expiry month must be between 01 and 12", year_out_of_range: "Expiry year cannot be in the past", date_out_of_range: "Expiry date cannot be in the past", invalid_expiry_date: "Expiry date is invalid", invalid_cvc: "CVC is invalid", empty_cvc: "Enter a CVC", card_number_placeholder: "Card number", expiry_data_placeholder: "MM/YY", cvc_placeholder: "CVC", card_holder_placeholder: "Card holder", empty_card_holder: "Enter a card holder name" }, copy_clipboard_error: "Failed to copy text", input: { phone_number: "Phone number", phone_search: "Search", search: "Search" }, "registered-over": "registered over", locale: { french: "French", german: "German", italian: "Italiano", dutch: "Dutch", english: "English", portuguese: "Portuguese", russian: "Russian", spanish: "Spanish", japanese: "Japanese", arabic: "Arabic", turkish: "Turkish", chinese: "Chinese", swedish: "Swedish", romanian: "Romanian", czech: "Czech", hungarian: "Hungarian", slovak: "Slovak", danish: "Danish", indonesian: "Indonesian", polish: "Polish", greek: "Greek", serbian: "Serbian", hindi: "Hindi", norwegian: "Norwegian", thai: "Thai", slovenian: "Slovenian", ukrainian: "Ukrainian", albania: "Albanian" }, product: "Product", quantity: "Quantity", order_summary: "Order summary", vat: "Sales tax", total: "Total", subtotal: "Subtotal", shipping: { shipping_method: "Shipping method", not_available: "Oops! It looks like we don't offer shipping to this location yet", condition_label: { price: "For orders priced between {{min}} {{currency}} to {{max}} {{currency}}", price_min: "For orders priced at {{min}} {{currency}} or more", quantity: "For orders containing between {{min}} to {{max}} items", quantity_min: "For orders containing {{min}} or more items", weight: "For orders with a total weight between {{min}}g to {{max}}g", weight_min: "For orders with a total weight of {{min}}g or more" } }, shipping_fee: "Shipping fee", total_amount_with_tax_and_shipping: "Total (including tax and Shipping)", vat_percent: "Sales tax ({{percent}}%)", including_tax: "Includes {{percent}}% VAT ({{amount}})", total_amount_with_tax: "Total (including tax)", total_amount_with_shipping: "Total (including Shipping)" }, Ec = {
  public_pages_purchase: Pc
}, Lc = { "required-field": "El campo es necesario", payment: { price_plan: "Plan", stripe_card: "Tarjeta de crédito o débito", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Tarjetas de crédito (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Tarjetas de crédito (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Pago contra entrega", xendit_card: "Tarjetas de crédito (Xendit)", paystack_card: "Tarjetas de crédito (Paystack)", paypal_connect: "Conectar PayPal", paypal_edit_organization_name: "Editar el nombre de la organización", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Error", "Payment-method": "Método de pago", price_plan: { trial_period: { week: "{{count}} semana", week_plural: "{{count}} semanas", day: "{{count}} día", day_plural: "{{count}} días", month: "{{count}} mes", month_plural: "{{count}} meses", year: "{{count}} año", year_plural: "{{count}} años" }, interval: { month: "mes", month_plural: "{{count}} meses", day: "día", day_plural: "{{count}} días", week: "semana", week_plural: "{{count}} semanas", year: "año", year_plural: "{{count}} años" } }, components: { offer_price: { price_plans: { trial_period_price: "Gratis", trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} luego", unlimited_new: "<bold>{{amount}}</bold> cada {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} veces" } } }, affiliate_badge: { made_with: "Desarrollado por" }, form_select: { empty_list: "Parece que esta lista está vacía", select: "Seleccionar" }, contact_slug: { email: "Correo", first_name: "Nombre", last_name: "Apellido", phone_number: "Número de teléfono", country: "País", street_address: "Dirección", city: "Ciudad", postal_code: "Código postal", company_name: "Nombre de la empresa", tax_number: "Número de IVA", state_province: "Estado/Provincia", street_number: "Dirección", neighborhood: "Barrio" }, date_picker: { apply: "Aplicar", clear: "Borrar", time: "Hola", all_time: "Desde siempre", last_3_months: "Últimos 3 meses", last_pool_period: "Último periodo de evaluación de la pool", last_month: "Último mes", this_month: "Este mes", last_30_days: "Últimos 30 días", title_dates: "Fechas", from: "Desde", to: "Hasta" }, copy_clipboard: "Copiado en el portapapeles", payment_inputs: { empty_card_number: "Ingresa un número de tarjeta", invalid_card_number: "El número de tarjeta no es válido", empty_expiry_date: "Ingresa la fecha de expiración", month_out_of_range: "El mes de expiración debe estar entre 01 y 12", year_out_of_range: "El año de expiración no puede estar situado en el pasado", date_out_of_range: "La fecha de expiración no puede estar situada en el pasado", invalid_expiry_date: "La fecha de expiracion no es válida", invalid_cvc: "El CVC no es válido", empty_cvc: "Ingresa un CVC", card_number_placeholder: "Número de tarjeta", expiry_data_placeholder: "MM/AA", cvc_placeholder: "CVC", card_holder_placeholder: "Titular de la tarjeta", empty_card_holder: "Ingresa el nombre del titular de la tarjeta" }, copy_clipboard_error: "Error el copiar el texto", input: { phone_number: "Teléfono", phone_search: "Buscar", search: "Buscar" }, "registered-over": "registrado hace más de", locale: { french: "Francés", german: "Alemán", italian: "Italiano", dutch: "Holandés", english: "Inglés", portuguese: "Portugués", russian: "Ruso", spanish: "Español", japanese: "Japonés", arabic: "árabe", turkish: "Turco", chinese: "Chino", swedish: "Sueco", romanian: "Rumano", czech: "Checo", hungarian: "Húngaro", slovak: "Eslovaco", danish: "Danés", indonesian: "Indonesio", polish: "Polaco", greek: "Griego", serbian: "Serbio", hindi: "Hindi", norwegian: "Noruego", thai: "Tailandés", slovenian: "Esloveno", ukrainian: "Ucraniano", albania: "Albanés" }, product: "Producto", quantity: "Cantidad", order_summary: "Resumen del pedido", vat: "IVA", total: "Total", subtotal: "Subtotal", shipping: { shipping_method: "Método de envío", not_available: "¡Vaya! Parece que aún no ofrecemos envíos a esta ubicación", condition_label: { price: "Para pedidos con precio entre {{min}} {{currency}} y {{max}} {{currency}}", price_min: "Para pedidos que cuesten {{min}} {{currency}} o más", quantity: "Para pedidos de entre {{min}} y {{max}} artículos", quantity_min: "Para pedidos con {{min}} o más artículos", weight: "Para pedidos con un peso total entre {{min}}g y {{max}}g", weight_min: "Para pedidos con un peso total de {{min}}g o más" } }, shipping_fee: "Tarifa de envío", total_amount_with_tax_and_shipping: "Total (incluyendo impuestos y envío)", vat_percent: "IVA ({{percent}}%)", including_tax: "Incluye el {{percent}}% de IVA ({{amount}})", total_amount_with_tax: "Total (impuestos incluidos)", total_amount_with_shipping: "Total (incluyendo envío)" }, Tc = {
  public_pages_purchase: Lc
}, Nc = { "required-field": "Le champ est obligatoire", payment: { price_plan: "Plan", stripe_card: "Carte de crédit ou de débit", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "BanContact (Stripe)", dlocal_card: "Cartes de crédit (Dlocal)", dlocal_boleto: "Billet (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Cartes de crédit (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Paiement à la livraison", xendit_card: "Cartes de crédit (Xendit)", paystack_card: "Cartes de crédit (Paystack)", paypal_connect: "Connectez-vous à PayPal", paypal_edit_organization_name: "Modifier le nom de l'organisation", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Erreur", "Payment-method": "Mode de paiement", price_plan: { trial_period: { week: "{{count}} semaine", week_plural: "{{count}} semaines", day: "{{count}} jour", day_plural: "{{count}} jours", month: "{{count}} mois", month_plural: "{{count}} mois", year: "{{count}} an", year_plural: "{{count}} ans" }, interval: { month: "mois", month_plural: "{{count}} mois", day: "jour", day_plural: "{{count}} jours", week: "semaine", week_plural: "{{count}} semaines", year: "an", year_plural: "{{count}} ans" } }, components: { offer_price: { price_plans: { trial_period_price: "Gratuit", trial_period_new: "{{ trialPeriodPrice }} pendant {{ trialInterval }} puis", unlimited_new: "<bold>{{amount}}</bold> tous {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }}  - {{ count }} fois" } } }, affiliate_badge: { made_with: "Développé par" }, form_select: { empty_list: "Cette liste semble vide", select: "Sélectionner" }, contact_slug: { email: "Email", first_name: "Prénom", last_name: "Nom", phone_number: "Numéro de téléphone", country: "Pays", street_address: "Adresse", city: "Ville", postal_code: "Code postal", company_name: "Nom de l'entreprise", tax_number: "Numéro d'identification fiscale", state_province: "Région", street_number: "Numéro de rue", neighborhood: "Quartier" }, date_picker: { apply: "Appliquer", clear: "Effacer", time: "Horaire", all_time: "Depuis le début", last_3_months: "Les 3 derniers mois", last_pool_period: "Dernière période d'évaluation du pool", last_month: "Le mois dernier", this_month: "Ce mois", last_30_days: "Les 30 derniers jours", title_dates: "Dates", from: "De", to: "À" }, copy_clipboard: "Copié dans le presse-papier", payment_inputs: { empty_card_number: "Entrez un numéro de carte", invalid_card_number: "Le numéro de carte est invalide", empty_expiry_date: "Entrez une date d'expiration", month_out_of_range: "Le mois d’expiration doit être entre 01 et 12", year_out_of_range: "L'année d'expiration ne peut pas être dans le passé", date_out_of_range: "La date d’expiration ne peut pas être dans le passé", invalid_expiry_date: "La date d’expiration est invalide", invalid_cvc: "Le code CVC est invalide", empty_cvc: "Saisissez le code CVC", card_number_placeholder: "Numéro de carte", expiry_data_placeholder: "MM/AA", cvc_placeholder: "CVC", card_holder_placeholder: "Titulaire de la carte", empty_card_holder: "Saisir le nom du titulaire de la carte" }, copy_clipboard_error: "Échec de la copie du texte", input: { phone_number: "Numéro de téléphone", phone_search: "Recherche", search: "Recherche" }, "registered-over": "enregistré plus de", locale: { french: "Français", german: "Allemand", italian: "Italiano", dutch: "Néerlandais", english: "Anglais", portuguese: "Portugais", russian: "Russe", spanish: "Espagnol", japanese: "Japonais", arabic: "Аrabe", turkish: "Turc", chinese: "Chinois", swedish: "Suédois", romanian: "Roumain", czech: "Tchèque", hungarian: "Hongrois", slovak: "Slovaque", danish: "Danois", indonesian: "Indonésien", polish: "Polonais", greek: "Grec", serbian: "Serbe", hindi: "Indien", norwegian: "Norvégien", thai: "Thaïlandais", slovenian: "Slovène", ukrainian: "Ukrainien", albania: "Albanais" }, product: "Produit", quantity: "Quantité", order_summary: "Résumé de la commande", vat: "TVA", total: "Total", subtotal: "Sous-total", shipping: { shipping_method: "Méthode d'expédition", not_available: "Oups ! Il semble qu'on ne livre pas encore à cet endroit", condition_label: { price: "Pour les commandes dont le prix est compris entre {{min}} {{currency}} et {{max}} {{currency}}", price_min: "Pour les commandes dont le prix est de {{min}} {{currency}} ou plus", quantity: "Pour les commandes contenant entre {{min}} et {{max}} articles", quantity_min: "Pour les commandes contenant {{min}} articles ou plus", weight: "Pour les commandes avec un poids total compris entre {{min}}g et {{max}}g", weight_min: "Pour les commandes avec un poids total de {{min}}g ou plus" } }, shipping_fee: "Frais d'expédition", total_amount_with_tax_and_shipping: "Total (y compris la TVA et l'expédition)", vat_percent: "TVA ({{percent}}%)", including_tax: "Comprend {{percent}} % de TVA ({{amount}})", total_amount_with_tax: "Total (TVA incluse)", total_amount_with_shipping: "Total (y compris livraison)" }, Mc = {
  public_pages_purchase: Nc
}, Oc = { "required-field": "यह फील्ड भरना अनिवार्य है", payment: { price_plan: "प्लान", stripe_card: "क्रेडिट या डेबिट कार्ड", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "बैनकॉन्टैक्ट (Stripe)", dlocal_card: "क्रेडिट कार्ड्स (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "क्रेडिट कार्ड्स (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "कैश-ऑन-डिलीवरी", xendit_card: "क्रेडिट कार्ड्स (Xendit)", paystack_card: "क्रेडिट कार्ड्स (Paystack)", paypal_connect: "Paypal से जुड़ें", paypal_edit_organization_name: "संगठन का नाम एडिट करें", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "एप्पल पे", xendit: { "3ds": "3D-सिक्योर" } }, error: "एरर", "Payment-method": "पेमेंट मेथड", price_plan: { trial_period: { week: "{{count}} सप्ताह", week_plural: "{{count}} दिन", day: "{{count}} दिन", day_plural: "{{count}} दिन", month: "{{count}} महीना", month_plural: "{{count}} महीने", year: "{{count}} वर्ष", year_plural: "{{count}} वर्ष" }, interval: { month: "महीना", month_plural: "{{count}} महीने", day: "दिन", day_plural: "{{count}} दिन", week: "सप्ताह", week_plural: "{{count}} सप्ताह", year: "वर्ष", year_plural: "{{count}} वर्ष" } }, components: { offer_price: { price_plans: { trial_period_price: "मुफ्त", trial_period_new: "{{ trialPeriodPrice }} के लिए {{ trialInterval }} फिर", unlimited_new: "{{amount}} हर {{interval}} पर", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} बार" } } }, affiliate_badge: { made_with: "द्वारा संचालित" }, form_select: { empty_list: "लगता है यह लिस्ट खाली है", select: "चूनें" }, contact_slug: { email: "ईमेल", first_name: "प्रथम नाम", last_name: "अंतिम नाम", phone_number: "फ़ोन नंबर", country: "देश", street_address: "सड़क का पता", city: "शहर", postal_code: "पोस्टल कोड", company_name: "कंपनी का नाम", tax_number: "टैक्स नंबर", state_province: "राज्य/प्रान्त", street_number: "सड़क संख्या", neighborhood: "पड़ोस" }, date_picker: { apply: "लागू करें", clear: "हटाएं", time: "समय", all_time: "सभी समय", last_3_months: "पिछले 3 महीने", last_pool_period: "पिछले पूल मूल्यांकन अवधि", last_month: "पिछले महीने", this_month: "इस महीने", last_30_days: "पिछले 30 दिन", title_dates: "दिनांक", from: "से", to: "तक" }, copy_clipboard: "क्लिपबोर्ड पर कॉपी किया गया", payment_inputs: { empty_card_number: "कार्ड नंबर दर्ज करें", invalid_card_number: "कार्ड नंबर अमान्य है ", empty_expiry_date: "समाप्ति तिथि दर्ज करें", month_out_of_range: "समाप्ति माह 01 और 12 के बीच होना चाहिए ", year_out_of_range: "समाप्ति वर्ष अतीत में नहीं हो सकता", date_out_of_range: "समाप्ति तिथि अतीत में नहीं हो सकती", invalid_expiry_date: "समाप्ति तिथि अमान्य है", invalid_cvc: "CVC अमान्य है", empty_cvc: "CVC दर्ज करें  ", card_number_placeholder: "कार्ड नंबर", expiry_data_placeholder: "MM/YY", cvc_placeholder: "CVC", card_holder_placeholder: "कार्ड धारक", empty_card_holder: "एक कार्ड धारक का नाम दर्ज करें" }, copy_clipboard_error: "टेक्स्ट कॉपी करने में असफल", input: { phone_number: "फोन नंबर", phone_search: "खोजें", search: "खोजें" }, "registered-over": "पंजीकृत किया गया", locale: { french: "फ्रेंच", german: "जर्मन", italian: "इटैलिनो", dutch: "डच", english: "अंग्रेज़ी", portuguese: "पुर्तगाली", russian: "रूसी", spanish: "स्पैनिश", japanese: "जापानी", arabic: "अरबी", turkish: "तुर्की", chinese: "चीनी", swedish: "स्वीडिश", romanian: "रोमानियाई", czech: "चेक", hungarian: "हंगेरीअन ", slovak: "स्लोवाक", danish: "डैनिश", indonesian: "इन्डोनेशियाई", polish: "पोलिश", greek: "यूनानी", serbian: "सर्बियाई", hindi: "हिंदी ", norwegian: "नार्वेजियन", thai: "थाई", slovenian: "स्लोवेनियाई", ukrainian: "यूक्रेनी", albania: "अल्बानियन" }, product: "प्रोडक्ट", quantity: "क्वान्टिटी", order_summary: "ऑर्डर समरी", vat: "सेल्स टैक्स", total: "टोटल", subtotal: "सब टोटल ", shipping: { shipping_method: "शिपिंग मेथड", not_available: "अरे! ऐसा लगता है कि हम अभी इस स्थान पर शिपिंग की पेशकश नहीं करते है ", condition_label: { price: "{{min}} {{currency}} से {{max}} {{currency}} के बीच प्राइस वाले ऑर्डर्स के लिए", price_min: "{{min}} {{currency}} या अधिक प्राइस वाले ऑर्डर्स के लिए", quantity: "{{min}} से {{max}} आइटम वाले ऑर्डर्स के लिए", quantity_min: "{{min}} या अधिक आइटम वाले ऑर्डर्स के लिए", weight: "{{min}}g से {{max}}g के बीच कुल वजन वाले ऑर्डर्स के लिए", weight_min: "{{min}}g या अधिक कुल वजन वाले ऑर्डर्स के लिए" } }, shipping_fee: "शिपिंग शुल्क", total_amount_with_tax_and_shipping: "कुल (कर और शिपिंग सहित)", vat_percent: "सेल्स टैक्स ({{percent}}%)", including_tax: "शामिल है {{percent}}% VAT ({{amount}})", total_amount_with_tax: "कुल (कर सहित)", total_amount_with_shipping: "कुल (शिपिंग सहित)" }, Rc = {
  public_pages_purchase: Oc
}, Ac = { "required-field": "A mező kitöltése kötelező", payment: { price_plan: "Terv", stripe_card: "Hitel- vagy betéti kártya", stripe_ideal: "iDeal (csík)", stripe_bancotact: "Bancontact (csíkos)", dlocal_card: "Hitelkártyák (Dlocal)", dlocal_boleto: "Boleto (helyi)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Hitelkártyák (Mercado Pago)", mercadopago_pix: "PIX (fizetési piac)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Utánvétes fizetés", xendit_card: "Hitelkártyák (Xendit)", paystack_card: "Hitelkártyák (Paystack)", paypal_connect: "Csatlakoztassa a PayPal-t", paypal_edit_organization_name: "Szerkessze a szervezet nevét", paypal_rest: "PayPal", secure_and_pay: "Biztonságos és fizetés", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Hiba", "Payment-method": "Fizetési mód", price_plan: { trial_period: { week: "{{count}} hét", week_plural: "{{count}} hét", day: "{{count}} nap", day_plural: "{{count}} nap", month: "{{count}} hónap", month_plural: "{{count}} hónap", year: "{{count}} év", year_plural: "{{count}} év" }, interval: { month: "hónap", month_plural: "{{count}} hónap", day: "nap", day_plural: "{{count}} nap", week: "hét", week_plural: "{{count}} hét", year: "év", year_plural: "{{count}} év" } }, components: { offer_price: { price_plans: { trial_period_price: "Ingyenes", trial_period_new: "{{ trialPeriodPrice }} , akkor {{ trialInterval }}", unlimited_new: "<bold>{{amount}}</bold> minden {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} alkalommal" } } }, affiliate_badge: { made_with: "Powered by" }, form_select: { empty_list: "Úgy tűnik, hogy ez a lista üres", select: "Kiválasztás" }, contact_slug: { email: "E-mail", first_name: "Keresztnév", last_name: "Vezetéknév", phone_number: "Telefonszám", country: "Ország", street_address: "Utca cím", city: "Város", postal_code: "Irányítószám", company_name: "Cégnév", tax_number: "Adószám", state_province: "Állam/Mező", street_number: "Utca szám", neighborhood: "Környék" }, date_picker: { apply: "Alkalmaz", clear: "Törlés", time: "Idő", all_time: "Minden idő", last_3_months: "Utolsó 3 hónap", last_pool_period: "Utolsó medenceértékelési időszak", last_month: "Utolsó hónap", this_month: "Ez a hónap", last_30_days: "Utolsó 30 nap", title_dates: "Dátumok", from: "Tól", to: "Ig" }, copy_clipboard: "Másolva a vágólapra", payment_inputs: { empty_card_number: "Adjon meg egy kártyaszámot", invalid_card_number: "A kártyaszám érvénytelen", empty_expiry_date: "Adjon meg egy lejárati dátumot", month_out_of_range: "A lejárati hónapnak 01 és 12 között kell lennie", year_out_of_range: "A lejárati év nem lehet a múltban", date_out_of_range: "A lejárati dátum nem lehet a múltban", invalid_expiry_date: "A lejárati dátum érvénytelen", invalid_cvc: "A CVC érvénytelen", empty_cvc: "Adja meg a CVC-t", card_number_placeholder: "Kártyaszám", expiry_data_placeholder: "HH/YY", cvc_placeholder: "CVC", card_holder_placeholder: "Kártyabirtokos", empty_card_holder: "Adja meg a kártyabirtokos nevét" }, copy_clipboard_error: "A szöveg másolása nem sikerült", input: { phone_number: "Telefonszám", phone_search: "Keresés", search: "Keresés" }, "registered-over": "regisztrált több mint", locale: { french: "Francia", german: "Német", italian: "Olasz", dutch: "Holland", english: "Angol", portuguese: "Portugál", russian: "Orosz", spanish: "Spanyol", japanese: "Japán", arabic: "Arab", turkish: "Török", chinese: "Kínai", swedish: "Svéd", romanian: "Román", czech: "Cseh", hungarian: "Magyar", slovak: "Szlovák", danish: "Dán", indonesian: "Indonéz", polish: "Fényesít", greek: "Görög", serbian: "Szerb", hindi: "Dehogy", norwegian: "Norvég", thai: "Thai", slovenian: "Szlovén", ukrainian: "Ukrán", albania: "Albán" }, product: "Termék", quantity: "Mennyiség", order_summary: "Rendelés összegzése", vat: "Áfa", total: "Összesen", subtotal: "Részösszeg", shipping: { shipping_method: "Szállítási mód", not_available: "Hoppá! Úgy tűnik, hogy még nem kínálunk szállítást erre a helyre.", condition_label: { price: "A {{min}} {{currency}} és {{max}} {{currency}} közötti árú rendelésekhez", price_min: "A {{min}} {{currency}} vagy annál drágább rendelésekhez", quantity: "A {{min}} és {{max}} közötti tételeket tartalmazó rendelésekhez", quantity_min: "A {{min}} vagy annál több tételt tartalmazó rendelésekhez", weight: "A {{min}}g és {{max}}g közötti összsúlyú rendelésekhez", weight_min: "A {{min}}g vagy annál nehezebb rendelésekhez" } }, shipping_fee: "Szállítási díj", total_amount_with_tax_and_shipping: "Összesen (beleértve az adót és a szállítást)", vat_percent: "Áruforgalmi adó ({{percent}}%)", including_tax: "ÁFA {{percent}}%-ot tartalmaz ({{amount}})", total_amount_with_tax: "Összesen (beleértve az adót)", total_amount_with_shipping: "Összesen (beleértve a szállítást)" }, zc = {
  public_pages_purchase: Ac
}, Dc = { "required-field": "Bidang wajib diisi", payment: { price_plan: "Rencana", stripe_card: "Kartu kredit atau debit", stripe_ideal: "iDeal (Garis)", stripe_bancotact: "Bancontact (Garis)", dlocal_card: "Kartu kredit (Dlokal)", dlocal_boleto: "Boleto (Dlokal)", dlocal_pix: "Pix (Dlokal)", paypal_soap: "PayPal", mercadopago_card: "Kartu kredit (Mercado Pago)", mercadopago_pix: "PIX (Pasar Pembayaran)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Pembayaran pisau cukur", flutterwave: "Gelombang bergetar", mollie: "Mollie", gocardless: "Tanpa kartu", cash_on_delivery: "Bayar di tempat", xendit_card: "Kartu kredit (Xendit)", paystack_card: "Kartu kredit (Paystack)", paypal_connect: "Hubungkan PayPal", paypal_edit_organization_name: "Edit nama organisasi", paypal_rest: "PayPal", secure_and_pay: "Amankan dan Bayar", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Kesalahan", "Payment-method": "Metode pembayaran", price_plan: { trial_period: { week: "{{count}} minggu", day: "{{count}} hari", month: "{{count}} bulan", year: "{{count}} tahun" }, interval: { month: "bulan", day: "hari", week: "pekan", year: "tahun" } }, components: { offer_price: { price_plans: { trial_period_price: "Bebas", trial_period_new: "{{ trialPeriodPrice }} untuk {{ trialInterval }} lalu", unlimited_new: "<bold>{{amount}}</bold> setiap {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kali" } } }, affiliate_badge: { made_with: "Ditenagai oleh" }, form_select: { empty_list: "Sepertinya daftar ini kosong", select: "Pilih" }, contact_slug: { email: "Email", first_name: "Nama depan", last_name: "Nama belakang", phone_number: "Nomor telepon", country: "Negara", street_address: "Alamat jalan", city: "Kota", postal_code: "Kode pos", company_name: "Nama perusahaan", tax_number: "Nomor pajak", state_province: "Negara Bagian/Provinsi", street_number: "Nomor jalan", neighborhood: "Lingkungan" }, date_picker: { apply: "Terapkan", clear: "Bersihkan", time: "Waktu", all_time: "Semua waktu", last_3_months: "3 bulan terakhir", last_pool_period: "Periode evaluasi kolam terakhir", last_month: "Bulan lalu", this_month: "Bulan ini", last_30_days: "30 hari terakhir", title_dates: "Tanggal", from: "Dari", to: "Ke" }, copy_clipboard: "Disalin ke clipboard", payment_inputs: { empty_card_number: "Masukkan nomor kartu", invalid_card_number: "Nomor kartu tidak valid", empty_expiry_date: "Masukkan tanggal kedaluwarsa", month_out_of_range: "Bulan kedaluwarsa harus antara 01 dan 12", year_out_of_range: "Tahun kedaluwarsa tidak boleh di masa lalu", date_out_of_range: "Tanggal kedaluwarsa tidak boleh di masa lalu", invalid_expiry_date: "Tanggal kedaluwarsa tidak valid", invalid_cvc: "CVC tidak valid", empty_cvc: "Masukkan CVC", card_number_placeholder: "Nomor kartu", expiry_data_placeholder: "MM/YY", cvc_placeholder: "CVC", card_holder_placeholder: "Pemegang kartu", empty_card_holder: "Masukkan nama pemegang kartu" }, copy_clipboard_error: "Gagal menyalin teks", input: { phone_number: "Nomor telepon", phone_search: "Cari", search: "Cari" }, "registered-over": "terdaftar lebih dari", locale: { french: "Perancis", german: "Jerman", italian: "Italia", dutch: "Belanda", english: "Bahasa inggris", portuguese: "Portugis", russian: "Rusia", spanish: "Orang Spanyol", japanese: "Jepang", arabic: "Arab", turkish: "Turki", chinese: "Cina", swedish: "Orang Swedia", romanian: "Rumania", czech: "Ceko", hungarian: "Hongaria", slovak: "Orang Slovakia", danish: "Orang Denmark", indonesian: "Bahasa Indonesia", polish: "Polandia", greek: "Orang yunani", serbian: "Orang Serbia", hindi: "Tidak", norwegian: "Norwegia", thai: "Thai", slovenian: "Slovenia", ukrainian: "Orang Ukraina", albania: "Bahasa Albania" }, product: "Produk", quantity: "Kuantitas", order_summary: "Ringkasan Pesanan", vat: "Pajak penjualan", total: "Total", subtotal: "Subtotal", shipping: { shipping_method: "Metode Pengiriman", not_available: "Ups! Sepertinya kami belum menawarkan pengiriman ke lokasi ini.", condition_label: { price: "Untuk pesanan yang harganya antara {{min}} {{currency}} hingga {{max}} {{currency}}", price_min: "Untuk pesanan yang harganya {{min}} {{currency}} atau lebih", quantity: "Untuk pesanan yang berisi antara {{min}} hingga {{max}} item", quantity_min: "Untuk pesanan yang berisi {{min}} item atau lebih", weight: "Untuk pesanan dengan total berat antara {{min}}g hingga {{max}}g", weight_min: "Untuk pesanan dengan total berat {{min}}g atau lebih" } }, shipping_fee: "Biaya pengiriman", total_amount_with_tax_and_shipping: "Total (termasuk pajak dan pengiriman)", vat_percent: "Pajak penjualan ({{percent}}%)", including_tax: "Termasuk PPN {{percent}}% ({{amount}})", total_amount_with_tax: "Total (termasuk pajak)", total_amount_with_shipping: "Total (termasuk pengiriman)" }, Ic = {
  public_pages_purchase: Dc
}, jc = { "required-field": "Il campo è obbligatorio", payment: { price_plan: "Piano", stripe_card: "Carta di credito o di debito", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Carte di credito (Dlocal)", dlocal_boleto: "Biglietto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Carte di credito (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Biglietto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Contanti alla consegna", xendit_card: "Carte di credito (Xendit)", paystack_card: "Carte di credito (Paystack)", paypal_connect: "Collegare PayPal", paypal_edit_organization_name: "Modifica il nome dell'organizzazione", paypal_rest: "PayPal", secure_and_pay: "Sicurezza e pagamento", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Errore", "Payment-method": "Metodo di pagamento", price_plan: { trial_period: { week: "{{count}} settimana", week_plural: "{{count}} settimane", day: "{{count}} giorno", day_plural: "{{count}} giorni", month: "{{count}} mese", month_plural: "{{count}} mesi", year: "{{count}} anni", year_plural: "{{count}} anni" }, interval: { month: "mese", month_plural: "{{count}} mesi", day: "giorno", day_plural: "{{count}} giorni", week: "settimana", week_plural: "{{count}} settimane", year: "anno", year_plural: "{{count}} anni" } }, components: { offer_price: { price_plans: { trial_period_price: "Gratuito", trial_period_new: "{{ trialPeriodPrice }} per {{ trialInterval }} poi", unlimited_new: "<bold>{{amount}}</bold> ogni {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} tempi" } } }, affiliate_badge: { made_with: "Realizzato da" }, form_select: { empty_list: "Sembra che questo elenco sia vuoto", select: "Selezionare" }, contact_slug: { email: "Email", first_name: "Nome", last_name: "Cognome", phone_number: "Numero di telefono", country: "Paese", street_address: "Indirizzo", city: "Città", postal_code: "Codice postale", company_name: "Nome azienda", tax_number: "Partita IVA", state_province: "Stato/Provincia", street_number: "Numero civico", neighborhood: "Quartiere" }, date_picker: { apply: "Applicare", clear: "Chiaro", time: "Ora", all_time: "Per tutto il periodo", last_3_months: "Ultimi 3 mesi", last_pool_period: "Ultimo periodo di valutazione del pool", last_month: "Ultimo mese", this_month: "Questo mese", last_30_days: "Ultimi 30 giorni", title_dates: "Date", from: "Da", to: "A" }, copy_clipboard: "Copiato negli appunti", payment_inputs: { empty_card_number: "Inserire un numero di carta", invalid_card_number: "Il numero della carta non è valido", empty_expiry_date: "Inserire una data di scadenza", month_out_of_range: "Il mese di scadenza deve essere compreso tra 01 e 12", year_out_of_range: "L'anno di scadenza non può essere passato", date_out_of_range: "La data di scadenza non può essere passata", invalid_expiry_date: "La data di scadenza non è valida", invalid_cvc: "Il CVC non è valido", empty_cvc: "Inserire una CVC", card_number_placeholder: "Numero della carta", expiry_data_placeholder: "MM/AA", cvc_placeholder: "CVC", card_holder_placeholder: "Portacarte", empty_card_holder: "Inserire il nome del titolare della carta" }, copy_clipboard_error: "Impossibile copiare il testo", input: { phone_number: "Numero di telefono", phone_search: "Ricerca", search: "Ricerca" }, "registered-over": "registrato oltre", locale: { french: "Francese", german: "Tedesco", italian: "Italiano", dutch: "Olandese", english: "Inglese", portuguese: "Portoghese", russian: "Russo", spanish: "Spagnolo", japanese: "Giapponese", arabic: "Аrabo", turkish: "Turco", chinese: "Cinese", swedish: "Svedese", romanian: "Rumeno", czech: "Ceco", hungarian: "Ungherese", slovak: "Slovacco", danish: "Danese", indonesian: "Indonesiano", polish: "Polacco", greek: "Greco", serbian: "Serbo", hindi: "Hindi", norwegian: "Norvegese", thai: "Tailandese", slovenian: "Sloveno", ukrainian: "Ucraino", albania: "Albanese" }, product: "Prodotto", quantity: "Quantità", order_summary: "Riepilogo dell'ordine", vat: "Imposta sulle vendite", total: "Totale", subtotal: "Totale parziale", shipping: { shipping_method: "Metodo di spedizione", not_available: "Ops! Sembra che per ora non offriamo spedizioni in questa località.", condition_label: { price: "Per ordini con un prezzo compreso tra {{min}} {{currency}} e {{max}} {{currency}}", price_min: "Per ordini con un prezzo di {{min}} {{currency}} o più", quantity: "Per ordini contenenti tra {{min}} e {{max}} articoli", quantity_min: "Per ordini contenenti {{min}} articoli o più", weight: "Per ordini con un peso totale compreso tra {{min}}g e {{max}}g", weight_min: "Per ordini con un peso totale di {{min}}g o più" } }, shipping_fee: "Spese di spedizione", total_amount_with_tax_and_shipping: "Totale (incluso l'imposta e la spedizione)", vat_percent: "Imposta sulle vendite ({{percent}}%)", including_tax: "Include {{percent}}% di IVA ({{amount}})", total_amount_with_tax: "Totale (IVA inclusa)", total_amount_with_shipping: "Totale (spedizione inclusa)" }, Fc = {
  public_pages_purchase: jc
}, Vc = { "required-field": "この項目は必須です", payment: { price_plan: "プラン", stripe_card: "クレジットカードまたはデビットカード", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact（Stripe）", dlocal_card: "クレジットカード（Dlocal）", dlocal_boleto: "Borelo（Dlocal）", dlocal_pix: "Pix (Dlocal)", paypal_soap: "Paypal", mercadopago_card: "クレジットカード (Mercado Pago)", mercadopago_pix: "PIX（Mercado Pago）", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay ", flutterwave: "Flutterwave ", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "着払い", xendit_card: "クレジットカード（Xendit）", paystack_card: "クレジットカード（Paystack）", paypal_connect: "PayPalに接続", paypal_edit_organization_name: "組織名を編集", paypal_rest: "ペイパル", secure_and_pay: "Secure and Pay", stripe_applepay: "Appleペイ", xendit: { "3ds": "3Dセキュア" } }, error: "エラー", "Payment-method": "支払い方法", price_plan: { trial_period: { week: `{{count}}週

{{count}}週`, day: `{{count}} 日

{{count}} 日`, month: `{{count}}ヶ月

{{count}}ヶ月`, year: `{{count}}年

{{count}}年` }, interval: { month: `ヶ月

{{count}}ヶ月`, day: `日

{{count}} 日`, week: `週

{{count}}週`, year: `年

{{count}}年` } }, components: { offer_price: { price_plans: { trial_period_price: "無料", trial_period_new: "{{ trialPeriodPrice }}を{{ trialInterval }}間ご利用いただけます。その後は", unlimited_new: "{{interval}}ごとに<bold>{{amount}}</bold>", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 回" } } }, affiliate_badge: { made_with: "提供元" }, form_select: { empty_list: "このリストが空のようです", select: "選択する" }, contact_slug: { email: "Eメール", first_name: "名", last_name: "姓", phone_number: "電話番号", country: "国", street_address: "住所", city: "市区町村", postal_code: "郵便番号", company_name: "法人名", tax_number: "法人番号（税番号）", state_province: "都道府県", street_number: "番地", neighborhood: "地域" }, date_picker: { apply: "適用", clear: "消去", time: "時", all_time: "全期間", last_3_months: "過去3ヶ月", last_pool_period: "前回の集計期間", last_month: "先月", this_month: "今月", last_30_days: "過去30日", title_dates: "日", from: "から", to: "へ" }, copy_clipboard: "クリップボードにコピーされました", payment_inputs: { empty_card_number: "カード番号を入力", invalid_card_number: "カード番号が無効です", empty_expiry_date: "有効期限を入力してください。", month_out_of_range: "有効期限の月は、1月から12月の間である必要があります。", year_out_of_range: "有効期限の年は過去にすることはできません。", date_out_of_range: "有効期限は過去の日付にすることはできません。", invalid_expiry_date: "有効期限が無効です", invalid_cvc: "CVCが無効です", empty_cvc: "CVCを入力", card_number_placeholder: "カード番号", expiry_data_placeholder: "月/年", cvc_placeholder: "CVC", card_holder_placeholder: "カード所有者", empty_card_holder: "カード所有者の名前を入力してください" }, copy_clipboard_error: "テキストのコピーに失敗しました", input: { phone_number: "電話番号", phone_search: "検索", search: "検索" }, "registered-over": "登録された", locale: { french: "フランス語", german: "ドイツ語", italian: "イタリア語", dutch: "オランダ語", english: "英語", portuguese: "ポルトガル語", russian: "ロシア語", spanish: "スペイン語", japanese: "日本語", arabic: "アラブ", turkish: "トルコ語", chinese: "中国語", swedish: "スウェーデン語", romanian: "ルーマニア語", czech: "チェコ語", hungarian: "ハンガリー語", slovak: "スロバキア語", danish: "デンマーク語", indonesian: "インドネシア語", polish: "ポーランド語", greek: "ギリシャ語", serbian: "セルビア語", hindi: "ヒンズー語", norwegian: "ノルウェー語", thai: "タイ語", slovenian: "スロバニア語", ukrainian: "ウクライナ語", albania: "アルバニア語" }, product: "商品", quantity: "数量", order_summary: "ご注文内容", vat: "消費税", total: "合計", subtotal: "小計", shipping: { shipping_method: "配送方法", not_available: "おっと！この地域への配送にはまだ対応していないようです。", condition_label: { price: "{{min}} {{currency}}から{{max}} {{currency}}までの注文の場合", price_min: "{{min}} {{currency}}以上の注文の場合", quantity: "{{min}}から{{max}}個の商品を含む注文の場合", quantity_min: "{{min}}個以上の商品を含む注文の場合", weight: "合計重量が {{min}}g から {{max}}g までの注文の場合", weight_min: "合計重量が {{min}}g 以上の注文の場合" } }, shipping_fee: "送料", total_amount_with_tax_and_shipping: "合計（消費税・送料込み）", vat_percent: "消費税（{{percent}}%）", including_tax: "消費税 {{percent}}% を含む（{{amount}}）", total_amount_with_tax: "合計（税込）", total_amount_with_shipping: "合計（送料込み）" }, Hc = {
  public_pages_purchase: Vc
}, $c = { "required-field": "Veld is vereist", payment: { price_plan: "Plan", stripe_card: "Creditcard of debetkaart", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Creditcards (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlokaal)", paypal_soap: "PayPal", mercadopago_card: "Creditcards (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Contant bij levering", xendit_card: "Creditcards (Xendit)", paystack_card: "Creditcards (Paystack)", paypal_connect: "Verbind PayPal", paypal_edit_organization_name: "Organisatienaam bewerken", paypal_rest: "PayPal", secure_and_pay: "Beveiligd betalen", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Fout", "Payment-method": "Betaalmethode", price_plan: { trial_period: { week: "{{count}} week", week_plural: "{{count}} weken", day: "{{count}} dag", day_plural: "{{count}} dagen", month: "{{count}} maand", month_plural: "{{count}} maanden", year: "{{count}} jaar", year_plural: "{{count}} jaren" }, interval: { month: "maand", month_plural: "{{count}} maanden", day: "dag", day_plural: "{{count}} dagen", week: "week", week_plural: "{{count}} weken", year: "jaar", year_plural: "{{count}} jaren" } }, components: { offer_price: { price_plans: { trial_period_price: "Gratis", trial_period_new: "{{ trialPeriodPrice }} voor {{ trialInterval }} dan", unlimited_new: "<bold>{{amount}}</bold> elke {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} keer" } } }, affiliate_badge: { made_with: "Ondersteund door" }, form_select: { empty_list: "Het lijkt erop dat deze lijst leeg is", select: "Selecteer" }, contact_slug: { email: "E-mail", first_name: "Voornaam", last_name: "Achternaam", phone_number: "Telefoonnummer", country: "Land", street_address: "Straatadres", city: "Plaats", postal_code: "Postcode", company_name: "Bedrijfsnaam", tax_number: "BTW-nummer", state_province: "Staat/Provincie", street_number: "Huisnummer", neighborhood: "Buurt" }, date_picker: { apply: "Toepassen", clear: "Wissen", time: "Tijd", all_time: "Alle tijden", last_3_months: "Laatste 3 maanden", last_pool_period: "Laatste pool-evaluatieperiode", last_month: "Afgelopen maand", this_month: "Deze maand", last_30_days: "Laatste 30 dagen", title_dates: "Datum", from: "Van", to: "Naar" }, copy_clipboard: "Gekopieerd naar klembord", payment_inputs: { empty_card_number: "Voer een kaartnummer in", invalid_card_number: "Kaartnummer is ongeldig", empty_expiry_date: "Voer een vervaldatum in", month_out_of_range: "Vervalmaand moet tussen 01 en 12 liggen", year_out_of_range: "Vervaljaar mag niet in het verleden liggen", date_out_of_range: "Vervaldatum mag niet in het verleden liggen", invalid_expiry_date: "Vervaldatum is ongeldig", invalid_cvc: "CVC is ongeldig", empty_cvc: "Voer een CVC in", card_number_placeholder: "Kaartnummer", expiry_data_placeholder: "MM/JJ", cvc_placeholder: "CVC", card_holder_placeholder: "Kaarthouder", empty_card_holder: "Voer de naam van de kaarthouder in" }, copy_clipboard_error: "Tekst kopiëren mislukt", input: { phone_number: "Telefoonnummer", phone_search: "Zoek", search: "Zoek" }, "registered-over": "geregistreerd over", locale: { french: "Frans", german: "Duits", italian: "Italiaans", dutch: "Nederlands", english: "Engels", portuguese: "Portugees", russian: "Russisch", spanish: "Spaans", japanese: "Japans", arabic: "Arabisch", turkish: "Turks", chinese: "Chinees", swedish: "Zweeds", romanian: "Roemeens", czech: "Tsjechisch", hungarian: "Hongaars", slovak: "Slowaaks", danish: "Deens", indonesian: "Indonesisch", polish: "Pools", greek: "Grieks", serbian: "Servisch", hindi: "Hindi", norwegian: "Noors", thai: "Thais", slovenian: "Sloveens", ukrainian: "Oekraïens", albania: "Albanees" }, product: "Product", quantity: "Aantal", order_summary: "Besteloverzicht", vat: "Verkoopbelasting", total: "Totaal", subtotal: "Subtotaal", shipping: { shipping_method: "Verzendmethode", not_available: "Oeps! Het lijkt erop dat we nog geen verzending naar deze locatie aanbieden", condition_label: { price: "Voor bestellingen geprijsd tussen {{min}} {{currency}} en {{max}} {{currency}}", price_min: "Voor bestellingen geprijsd vanaf {{min}} {{currency}} of meer", quantity: "Voor bestellingen die tussen de {{min}} en {{max}} artikelen bevatten", quantity_min: "Voor bestellingen met {{min}} of meer artikelen", weight: "Voor bestellingen met een totaalgewicht tussen {{min}}g en {{max}}g", weight_min: "Voor bestellingen met een totaalgewicht van {{min}}g of meer" } }, shipping_fee: "Verzendkosten", total_amount_with_tax_and_shipping: "Totaal (inclusief BTW en Verzending)", vat_percent: "BTW ({{percent}}%)", including_tax: "Inclusief {{percent}}% BTW ({{amount}})", total_amount_with_tax: "Totaal (incl. belasting)", total_amount_with_shipping: "Totaal (incl. verzending)" }, Bc = {
  public_pages_purchase: $c
}, Kc = { "required-field": "Felt er obligatorisk", payment: { price_plan: "Plan", stripe_card: "Kreditt- eller debetkort", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Kredittkort (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Kredittkort (Mercado Pago)", mercadopago_pix: "PIX (betalingsmarked)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterbølge", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Kontantbetaling ved levering", xendit_card: "Kredittkort (Xendit)", paystack_card: "Kredittkort (Paystack)", paypal_connect: "Koble til PayPal", paypal_edit_organization_name: "Rediger organisasjonsnavn", paypal_rest: "PayPal", secure_and_pay: "Sikker og betal", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Feil", "Payment-method": "Betalingsmåte", price_plan: { trial_period: { week: "{{count}} uke", week_plural: "{{count}} uker", day: "{{count}} dag", day_plural: "{{count}} dager", month: "{{count}} måned", month_plural: "{{count}} måneder", year: "{{count}} år", year_plural: "{{count}} år" }, interval: { month: "måned", month_plural: "{{count}} måneder", day: "dag", day_plural: "{{count}} dager", week: "uke", week_plural: "{{count}} uker", year: "år", year_plural: "{{count}} år" } }, components: { offer_price: { price_plans: { trial_period_price: "Gratis", trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} da", unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ganger" } } }, affiliate_badge: { made_with: "Drevet av" }, form_select: { empty_list: "Det ser ut som denne listen er tom", select: "Velg" }, contact_slug: { email: "E-post", first_name: "Fornavn", last_name: "Etternavn", phone_number: "Telefonnummer", country: "Land", street_address: "Gateadresse", city: "By", postal_code: "Postnummer", company_name: "Firmanavn", tax_number: "Skattenummer", state_province: "Stat/Provins", street_number: "Gate nummer", neighborhood: "Nabolag" }, date_picker: { apply: "Bruk", clear: "Fjern", time: "Tid", all_time: "All tid", last_3_months: "Siste 3 måneder", last_pool_period: "Siste evalueringsperiode for basseng", last_month: "Siste måned", this_month: "Denne måneden", last_30_days: "Siste 30 dager", title_dates: "Datoer", from: "Fra", to: "Til" }, copy_clipboard: "Kopiert til utklippstavlen", payment_inputs: { empty_card_number: "Skriv inn et kortnummer", invalid_card_number: "Kortnummeret er ugyldig", empty_expiry_date: "Skriv inn en utløpsdato", month_out_of_range: "Utløpsmåned må være mellom 01 og 12", year_out_of_range: "Utløpsår kan ikke være i fortiden", date_out_of_range: "Utløpsdato kan ikke være i fortiden", invalid_expiry_date: "Utløpsdato er ugyldig", invalid_cvc: "CVC er ugyldig", empty_cvc: "Skriv inn en CVC", card_number_placeholder: "Kortnummer", expiry_data_placeholder: "MM/ÅÅ", cvc_placeholder: "CVC", card_holder_placeholder: "Kortholder", empty_card_holder: "Skriv inn navnet til kortholderen" }, copy_clipboard_error: "Kunne ikke kopiere tekst", input: { phone_number: "Telefonnummer", phone_search: "Søk", search: "Søk" }, "registered-over": "registrert over", locale: { french: "Fransk", german: "Tysk", italian: "Italiensk", dutch: "Nederlandsk", english: "Engelsk", portuguese: "Portugisisk", russian: "Russisk", spanish: "Spansk", japanese: "Japansk", arabic: "Arabisk", turkish: "Tyrkisk", chinese: "Kinesisk", swedish: "Svensk", romanian: "Rumensk", czech: "Tsjekkisk", hungarian: "Ungarsk", slovak: "Slovakisk", danish: "Dansk", indonesian: "Indonesisk", polish: "Pusse", greek: "Gresk", serbian: "Serbisk", hindi: "Nei", norwegian: "Norsk", thai: "Thai", slovenian: "Slovensk", ukrainian: "Ukrainsk", albania: "Albansk" }, product: "Produkt", quantity: "Mengde", order_summary: "Ordresammendrag", vat: "Moms", total: "Totalt", subtotal: "Delsum", shipping: { shipping_method: "Fraktmetode", not_available: "Oops! Det ser ut som vi ikke tilbyr frakt til dette stedet ennå.", condition_label: { price: "For bestillinger priset mellom {{min}} {{currency}} og {{max}} {{currency}}", price_min: "For bestillinger priset til {{min}} {{currency}} eller mer", quantity: "For bestillinger som inneholder mellom {{min}} til {{max}} varer", quantity_min: "For bestillinger som inneholder {{min}} eller flere varer", weight: "For bestillinger med en totalvekt mellom {{min}}g og {{max}}g", weight_min: "For bestillinger med en totalvekt på {{min}}g eller mer" } }, shipping_fee: "Fraktgebyr", total_amount_with_tax_and_shipping: "Totalt (inkludert skatt og frakt)", vat_percent: "Merverdiavgift ({{percent}}%)", including_tax: "Inkludert {{percent}}% MVA ({{amount}})", total_amount_with_tax: "Totalbeløp (inkludert skatt)", total_amount_with_shipping: "Totalbeløp (inkludert frakt)" }, Uc = {
  public_pages_purchase: Kc
}, qc = { "required-field": "Pole jest wymagane", payment: { price_plan: "Plan", stripe_card: "Karta kredytowa lub debetowa", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Karty kredytowe (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Karty kredytowe (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Płatność gotówką przy odbiorze", xendit_card: "Karty kredytowe (Xendit)", paystack_card: "Karty kredytowe (Paystack)", paypal_connect: "Połącz PayPala", paypal_edit_organization_name: "Edytuj nazwę organizacji", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Błąd", "Payment-method": "Metoda płatności", price_plan: { trial_period: { week_0: "{{count}} tydzień", week_1: "{{count}} tygodni", week_2: "{{count}} tygodni", day_0: "{{count}} dzień", day_1: "{{count}} dni", day_2: "{{count}} dni", month_0: "{{count}} miesiąc", month_1: "{{count}} miesięcy", month_2: "{{count}} miesięcy", year_0: "{{count}} rok", year_1: "{{count}} lat", year_2: "{{count}} lat" }, interval: { month_0: "miesiąc", month_1: "{{count}} miesięcy", month_2: "{{count}} miesięcy", day_0: "dzień", day_1: "{{count}} dni", day_2: "{{count}} dni", week_0: "tydzień", week_1: "{{count}} tygodni", week_2: "{{count}} tygodni", year_0: "rok", year_1: "{{count}} lat", year_2: "{{count}} lat" } }, components: { offer_price: { price_plans: { trial_period_price: "Bezpłatny", trial_period_new: "{{ trialPeriodPrice }} dla {{ trialInterval }} potem", unlimited_new: "<bold>{{amount}}</bold> każdy {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} razy" } } }, affiliate_badge: { made_with: "Zasilane przez" }, form_select: { empty_list: "Wygląda na to, że ta lista jest pusta", select: "Wybierz" }, contact_slug: { email: "Email", first_name: "Imię", last_name: "Nazwisko", phone_number: "Numer telefonu", country: "Kraj", street_address: "Adres", city: "Miasto", postal_code: "Kod pocztowy", company_name: "Nazwa firmy", tax_number: "Numer identyfikacji podatkowej", state_province: "Stan/Województwo", street_number: "Numer ulicy", neighborhood: "Osiedle" }, date_picker: { apply: "Zastosuj", clear: "Wyczyść", time: "Czas", all_time: "Cały czas", last_3_months: "Ostatnie 3 miesiące", last_pool_period: "Ostatni okres oceny puli", last_month: "Ostatni miesiąc", this_month: "Ten miesiąc", last_30_days: "Ostatnie 30 dni", title_dates: "Daty", from: "Z", to: "Do" }, copy_clipboard: "Skopiowano do schowka", payment_inputs: { empty_card_number: "Wprowadź numer karty", invalid_card_number: "Numer karty jest nieprawidłowy", empty_expiry_date: "Wprowadź datę ważności", month_out_of_range: "Miesiąc ważności musi być między 01 a 12", year_out_of_range: "Rok ważności nie może być w przeszłości", date_out_of_range: "Data ważności nie może być w przeszłości", invalid_expiry_date: "Data ważności jest nieprawidłowa", invalid_cvc: "CVC jest nieprawidłowy", empty_cvc: "Wprowadź CVC", card_number_placeholder: "Numer karty", expiry_data_placeholder: "MM/RR", cvc_placeholder: "CVC", card_holder_placeholder: "Właściciel karty", empty_card_holder: "Wprowadź imię i nazwisko właściciela karty" }, copy_clipboard_error: "Nie udało się skopiować tekstu", input: { phone_number: "Numer telefonu", phone_search: "Szukaj", search: "Szukaj" }, "registered-over": "zarejestrowano ponad", locale: { french: "Francuski", german: "Niemiecki", italian: "Włoski", dutch: "Holenderski", english: "Angielski", portuguese: "Portugalski", russian: "Rosyjski", spanish: "Hiszpański", japanese: "Japoński", arabic: "Arabski", turkish: "Turecki", chinese: "Chiński", swedish: "Szwedzki", romanian: "Rumuński", czech: "Czeski", hungarian: "Węgierski", slovak: "Słowacki", danish: "Duński", indonesian: "Indonezyjski", polish: "Polski", greek: "Grecki", serbian: "Serbski", hindi: "Hinduski", norwegian: "Norweski", thai: "Tajski", slovenian: "Słoweński", ukrainian: "Ukraiński", albania: "Albański" }, product: "Produkt", quantity: "Ilość", order_summary: "Podsumowanie zamówienia", vat: "Podatek od sprzedaży", total: "Razem", subtotal: "Suma częściowa", shipping: { shipping_method: "Metoda wysyłki", not_available: "Ups! Wygląda na to, że nie oferujemy jeszcze wysyłki do tej lokalizacji.", condition_label: { price: "Dla zamówień w cenie od {{min}} {{currency}} do {{max}} {{currency}}", price_min: "Dla zamówień w cenie {{min}} {{currency}} lub więcej", quantity: "Dla zamówień zawierających od {{min}} do {{max}} przedmiotów", quantity_min: "Dla zamówień zawierających {{min}} lub więcej przedmiotów", weight: "Dla zamówień o łącznej wadze od {{min}}g do {{max}}g", weight_min: "Dla zamówień o łącznej wadze {{min}}g lub więcej" } }, shipping_fee: "Opłata za wysyłkę", total_amount_with_tax_and_shipping: "Razem (w tym podatek i wysyłka)", vat_percent: "Podatek od sprzedaży ({{percent}}%)", including_tax: "Zawiera {{percent}}% VAT ({{amount}})", total_amount_with_tax: "Razem (z podatkiem)", total_amount_with_shipping: "Razem (z wysyłką)" }, Gc = {
  public_pages_purchase: qc
}, Wc = { "required-field": "O campo é obrigatório", payment: { price_plan: "Plano", stripe_card: "Cartão de crédito ou débito", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Cartão de crédito (Dlocal)", dlocal_boleto: "Boleto bancário (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Cartão de crédito (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Pagamento na entrega", xendit_card: "Cartão de crédito (Xendit)", paystack_card: "Cartão de crédito (Paystack)", paypal_connect: "Conectar PayPal", paypal_edit_organization_name: "Editar o nome da empresa", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Erro", "Payment-method": "Método de pagamento", price_plan: { trial_period: { week: "{{count}} semana", week_plural: "{{count}} semanas", day: "{{count}} dia", day_plural: "{{count}} dias", month: "{{count}} mês", month_plural: "{{count}} meses", year: "{{count}} ano", year_plural: "{{count}} anos" }, interval: { month: "mês", month_plural: "{{count}} meses", day: "dia", day_plural: "{{count}} dias", week: "semana", week_plural: "{{count}} semanas", year: "ano", year_plural: "{{count}} anos" } }, components: { offer_price: { price_plans: { trial_period_price: "Gratuito", trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} depois", unlimited_new: "<bold>{{amount}}</bold> a cada {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} vezes" } } }, affiliate_badge: { made_with: "Desenvolvido por" }, form_select: { empty_list: "Parece que essa lista está vazia", select: "Selecionar" }, contact_slug: { email: "Email", first_name: "Nome", last_name: "Sobrenome", phone_number: "Número de telefone", country: "País", street_address: "Endereço", city: "Cidade", postal_code: "Código postal", company_name: "Nome da empresa", tax_number: "CNPJ/NIF", state_province: "Estado/Província", street_number: "Número", neighborhood: "Bairro" }, date_picker: { apply: "Aplicar", clear: "Limpar", time: "Horário", all_time: "Desde o início", last_3_months: "Últimos 3 meses", last_pool_period: "Último período de avaliação do grupo", last_month: "Último mês", this_month: "Este mês", last_30_days: "Últimos 30 dias", title_dates: "Datas", from: "De", to: "Até" }, copy_clipboard: "Copiado para a área de transferência", payment_inputs: { empty_card_number: "Insira um número de cartão", invalid_card_number: "O número do cartão é inválido", empty_expiry_date: "Insira uma data de validade", month_out_of_range: "O mês de validade deve estar entre 01 e 12", year_out_of_range: "O ano de validade não pode estar no passado", date_out_of_range: "A data de validade não pode estar no passado", invalid_expiry_date: "A data de validade é inválida", invalid_cvc: "O CVV é inválido", empty_cvc: "Insira o CVV", card_number_placeholder: "Número do cartão", expiry_data_placeholder: "MM/AA", cvc_placeholder: "CVV", card_holder_placeholder: "Titular do cartão", empty_card_holder: "Insira o nome do titular do cartão" }, copy_clipboard_error: "Falha ao copiar o texto", input: { phone_number: "Número de telefone", phone_search: "Pesquisar", search: "Pesquisar" }, "registered-over": "registrado há mais de", locale: { french: "Francês", german: "Alemão", italian: "Italiano", dutch: "Holandês", english: "Inglês", portuguese: "Português", russian: "Russo", spanish: "Espanhol", japanese: "Japonês", arabic: "Árabe", turkish: "Turco", chinese: "Chinês", swedish: "Sueco", romanian: "Romeno", czech: "Tcheco", hungarian: "Húngaro", slovak: "Eslovaco", danish: "Dinamarquês", indonesian: "Indonésio", polish: "Polonês", greek: "Grego", serbian: "Sérvio", hindi: "Hindi", norwegian: "Norueguês", thai: "Tailandês", slovenian: "Esloveno", ukrainian: "Ucraniano", albania: "Albanês" }, product: "Produto", quantity: "Quantidade", order_summary: "Resumo do pedido", vat: "Imposto", total: "Total", subtotal: "Subtotal", shipping: { shipping_method: "Método de envio", not_available: "Ops! Parece que ainda não oferecemos envio para este local", condition_label: { price: "Para pedidos com valor entre {{min}} {{currency}} e {{max}} {{currency}}", price_min: "Para pedidos com valor de {{min}} {{currency}} ou mais", quantity: "Para pedidos contendo entre {{min}} e {{max}} itens", quantity_min: "Para pedidos contendo {{min}} ou mais itens", weight: "Para pedidos com peso total entre {{min}}g e {{max}}g", weight_min: "Para pedidos com peso total de {{min}}g ou mais" } }, shipping_fee: "Taxa de envio", total_amount_with_tax_and_shipping: "Total (incluindo imposto e envio)", vat_percent: "Imposto ({{percent}}%)", including_tax: "Inclui {{percent}}% de imposto (IVA) ({{amount}})", total_amount_with_tax: "Total (incluindo impostos)", total_amount_with_shipping: "Total (incluindo envio)" }, Zc = {
  public_pages_purchase: Wc
}, Yc = { "required-field": "Câmpul este obligatoriu", payment: { price_plan: "Plan", stripe_card: "Card de credit sau debit", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (stripe)", dlocal_card: "Carduri de credit (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Carduri de credit (Mercado Pago)", mercadopago_pix: "PIX (piață de plată)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Plata la livrare", xendit_card: "Carduri de credit (Xendit)", paystack_card: "Carduri de credit (Paystack)", paypal_connect: "Conectați PayPal", paypal_edit_organization_name: "Editați numele organizației", paypal_rest: "PayPal", secure_and_pay: "Securizat și plătiți", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Eroare", "Payment-method": "Modalitate de plată", price_plan: { trial_period: { week_0: "{{count}} săptămână", week_1: "{{count}} săptămâni", week_2: "{{count}} săptămâni", day_0: "{{count}} zi", day_1: "{{count}} zile", day_2: "{{count}} zile", month_0: "{{count}} lună", month_1: "{{count}} luni", month_2: "{{count}} luni", year_0: "{{count}} an", year_1: "{{count}} ani", year_2: "{{count}} ani" }, interval: { month_0: "lună", month_1: "{{count}} luni", month_2: "{{count}} luni", day_0: "zi", day_1: "{{count}} zile", day_2: "{{count}} zile", week_0: "săptămână", week_1: "{{count}} săptămâni", week_2: "{{count}} săptămâni", year_0: "an", year_1: "{{count}} ani", year_2: "{{count}} ani" } }, components: { offer_price: { price_plans: { trial_period_price: "Gratuit", trial_period_new: "{{ trialPeriodPrice }} pentru {{ trialInterval }} atunci", unlimited_new: "<bold>{{amount}}</bold> la fiecare {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - de {{ count }} ori" } } }, affiliate_badge: { made_with: "Realizat de" }, form_select: { empty_list: "Se pare că această listă este goală", select: "Selectați" }, contact_slug: { email: "Email", first_name: "Prenume", last_name: "Nume de familie", phone_number: "Număr de telefon", country: "Țară", street_address: "Adresă", city: "Oraș", postal_code: "Cod poștal", company_name: "Numele companiei", tax_number: "Număr de identificare fiscală", state_province: "Stat/Provincie", street_number: "Numărul străzii", neighborhood: "Cartier" }, date_picker: { apply: "Aplică", clear: "Șterge", time: "Timp", all_time: "Tot timpul", last_3_months: "Ultimele 3 luni", last_pool_period: "Ultima perioadă de evaluare a grupului", last_month: "Luna trecută", this_month: "Luna aceasta", last_30_days: "Ultimele 30 de zile", title_dates: "Date", from: "De la", to: "Către" }, copy_clipboard: "Copiat în clipboard", payment_inputs: { empty_card_number: "Introduceți un număr de card", invalid_card_number: "Numărul cardului este invalid", empty_expiry_date: "Introduceți o dată de expirare", month_out_of_range: "Luna de expirare trebuie să fie între 01 și 12", year_out_of_range: "Anul de expirare nu poate fi în trecut", date_out_of_range: "Data de expirare nu poate fi în trecut", invalid_expiry_date: "Data de expirare este invalidă", invalid_cvc: "CVC este invalid", empty_cvc: "Introduceți un CVC", card_number_placeholder: "Numărul cardului", expiry_data_placeholder: "LL/AA", cvc_placeholder: "CVC", card_holder_placeholder: "Titularul cardului", empty_card_holder: "Introduceți un nume al titularului cardului" }, copy_clipboard_error: "Copierea textului a eșuat", input: { phone_number: "Număr de telefon", phone_search: "Căutare", search: "Caută" }, "registered-over": "înregistrat peste", locale: { french: "Limba franceza", german: "Limba germana", italian: "Italiană", dutch: "Olandeză", english: "Engleză", portuguese: "Portugheză", russian: "Rusă", spanish: "Spaniolă", japanese: "Japonez", arabic: "Arabic", turkish: "Turc", chinese: "Chinez", swedish: "Suedez", romanian: "Română", czech: "Ceh", hungarian: "Maghiară", slovak: "Slovacă", danish: "Danez", indonesian: "Indoneziană", polish: "Lustrui", greek: "Greacă", serbian: "Sârb", hindi: "Nu", norwegian: "Norvegian", thai: "Thailandez", slovenian: "Slovenă", ukrainian: "Ucrainean", albania: "Albanez" }, product: "Produs", quantity: "Cantitate", order_summary: "Rezumatul comenzii", vat: "Taxa pe vânzări", total: "Total", subtotal: "Subtotal", shipping: { shipping_method: "Metoda de livrare", not_available: "Ups! Se pare că nu oferim livrare în această locație încă.", condition_label: { price: "Pentru comenzi cu prețuri între {{min}} {{currency}} și {{max}} {{currency}}", price_min: "Pentru comenzi cu prețuri de {{min}} {{currency}} sau mai mult", quantity: "Pentru comenzi care conțin între {{min}} și {{max}} articole", quantity_min: "Pentru comenzi care conțin {{min}} sau mai multe articole", weight: "Pentru comenzi cu o greutate totală între {{min}}g și {{max}}g", weight_min: "Pentru comenzi cu o greutate totală de {{min}}g sau mai mult" } }, shipping_fee: "Taxa de livrare", total_amount_with_tax_and_shipping: "Total (inclusiv taxe și livrare)", vat_percent: "Taxa pe vânzări ({{percent}}%)", including_tax: "Incluzând TVA de {{percent}}% ({{amount}})", total_amount_with_tax: "Total (inclusiv taxe)", total_amount_with_shipping: "Total (inclusiv transport)" }, Jc = {
  public_pages_purchase: Yc
}, Xc = { "required-field": "Поле обязательно для заполнения", payment: { price_plan: "План", stripe_card: "Кредитная или дебетовая карта", stripe_ideal: "Разрешить платежи через iDeal", stripe_bancotact: "Разрешить платежи через BanContact", dlocal_card: "Кредитные карты (Dlocal)", dlocal_boleto: "Заготовка (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "Разрешить платежи PayPal", mercadopago_card: "Кредитные карты", mercadopago_pix: "PIX (Платный рынок)", mercadopago_boleto: "Билет (Платный рынок)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Оплата наличными при доставке", xendit_card: "Кредитные карты (Xendit)", paystack_card: "Кредитные карты (Paystack)", paypal_connect: "Подключить PayPal", paypal_edit_organization_name: "Изменить название организации", paypal_rest: "PayPal", secure_and_pay: "Secure and Pay", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Ошибка", "Payment-method": "Способ оплаты", price_plan: { trial_period: { week_0: "{{count}} неделя", week_1: "{{count}} недели", week_2: "{{count}} недель", day_0: "день", day_1: "{{count}} дней", day_2: "{{count}} дни", month_0: "месяц", month_1: "{{count}} месяца", month_2: "{{count}} месяцев", year_0: "год", year_1: "{{count}} года", year_2: "{{count}} лет" }, interval: { month_0: "месяц", month_1: "{{count}} месяцы", month_2: "{{count}} месяца", day_0: "день", day_1: "{{count}} дней", day_2: "{{count}} дни", week_0: "неделя", week_1: "{{count}} недели", week_2: "{{count}} неделями", year_0: "год", year_1: "{{count}} годы", year_2: "{{count}} лет" } }, components: { offer_price: { price_plans: { trial_period_price: "Бесплатно", trial_period_new: "{{ trialPeriodPrice }} для {{ trialInterval }} затем", unlimited_new: "<bold>{{amount}}</bold> каждый {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} раз" } } }, affiliate_badge: { made_with: "Создано с " }, form_select: { empty_list: "Похоже, что этот список пуст.", select: "Выбрать" }, contact_slug: { email: "Почта", first_name: "Имя", last_name: "Фамилия", phone_number: "Номер телефона", country: "Страна", street_address: "Адрес", city: "Город", postal_code: "Почтовый индекс", company_name: "Название компании", tax_number: "Налоговый номер", state_province: "Штат/Область", street_number: "Номер улицы", neighborhood: "Соседство" }, date_picker: { apply: "Применить", clear: "Очистить", time: "Время", all_time: "Все время", last_3_months: "Последние 3 месяца", last_pool_period: "Последний период оценки пула", last_month: "Последний месяц", this_month: "В этом месяце", last_30_days: "Последние 30 дней", title_dates: "Даты", from: "От", to: "В" }, copy_clipboard: "Номер карты недействителен", payment_inputs: { empty_card_number: "Введите номер карты", invalid_card_number: "Номер карты недействителен", empty_expiry_date: "Введите дату окончания срока действия", month_out_of_range: "Месяц окончания срока действия должен быть между 01 и 12", year_out_of_range: "Год окончания срока действия не может быть в прошлом", date_out_of_range: "Дата окончания срока действия не может быть в прошлом", invalid_expiry_date: "Срок годности недействителен", invalid_cvc: "CVC код неправильный", empty_cvc: "Введите CVC код", card_number_placeholder: "Номер карты", expiry_data_placeholder: "М/Г", cvc_placeholder: "CVC код", card_holder_placeholder: "Держатель карты", empty_card_holder: "Введите имя держателя карты" }, copy_clipboard_error: "Не удалось скопировать текст", input: { phone_number: "Номер телефона", phone_search: "Поиск", search: "Поиск" }, "registered-over": "зарегистрировано более чем", locale: { french: "Французский", german: "Немецкий", italian: "Итальянский", dutch: "Голландский", english: "Английский", portuguese: "Португальский", russian: "Русский", spanish: "Испанский", japanese: "Японский", arabic: "Арабский", turkish: "Турецкий", chinese: "Китайский", swedish: "Шведский", romanian: "Румынский", czech: "Чешский", hungarian: "Венгерский", slovak: "Словацкий", danish: "Датский", indonesian: "Индонезийский", polish: "Польский", greek: "Греческий", serbian: "Сербский", hindi: "Хинди", norwegian: "Норвежский", thai: "Тайский", slovenian: "Словенский", ukrainian: "Украинский", albania: "Албанский" }, product: "Продукт", quantity: "Количество", order_summary: "Итог заказа", vat: "Налог с продаж", total: "Итого", subtotal: "Промежуточный итог", shipping: { shipping_method: "Способ доставки", not_available: "Упс! Похоже, что мы еще не предлагаем доставку в это место.", condition_label: { price: "Для заказов стоимостью от {{min}} {{currency}} до {{max}} {{currency}}", price_min: "Для заказов стоимостью {{min}} {{currency}} или более", quantity: "Для заказов, содержащих от {{min}} до {{max}} товаров", quantity_min: "Для заказов, содержащих {{min}} или более товаров", weight: "Для заказов с общим весом от {{min}}g до {{max}}g", weight_min: "Для заказов с общим весом {{min}}g или более" } }, shipping_fee: "Стоимость доставки", total_amount_with_tax_and_shipping: "Итого (включая налог и доставку)", vat_percent: "Налог с продаж ({{percent}}%)", including_tax: "Включает {{percent}}% НДС ({{amount}})", total_amount_with_tax: "Общая сумма (с налогом)", total_amount_with_shipping: "Общая сумма (с учетом доставки)" }, Qc = {
  public_pages_purchase: Xc
}, e1 = { "required-field": "Pole je povinné", payment: { price_plan: "Plán", stripe_card: "Kreditná alebo debetná karta", stripe_ideal: "iDeal (pruh)", stripe_bancotact: "Bancontact (pruh)", dlocal_card: "Kreditné karty (miestne)", dlocal_boleto: "Boleto (miestne)", dlocal_pix: "Pix (miestne)", paypal_soap: "PayPal", mercadopago_card: "Kreditné karty (Mercado Pago)", mercadopago_pix: "PIX (Platobný trh)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Platba na dobierku", xendit_card: "Kreditné karty (Xendit)", paystack_card: "Kreditné karty (Paystack)", paypal_connect: "Pripojte PayPal", paypal_edit_organization_name: "Upravte názov organizácie", paypal_rest: "PayPal", secure_and_pay: "Zabezpečiť a zaplatiť", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Chyba", "Payment-method": "Spôsob platby", price_plan: { trial_period: { week_0: "{{count}} týždeň", week_1: "{{count}} týždňov", week_2: "{{count}} týždňov", day_0: "{{count}} deň", day_1: "{{count}} dní", day_2: "{{count}} dní", month_0: "{{count}} mesiac", month_1: "{{count}} mesiacov", month_2: "{{count}} mesiacov", year_0: "{{count}} rok", year_1: "{{count}} rokov", year_2: "{{count}} rokov" }, interval: { month_0: "mesiac", month_1: "{{count}} mesiacov", month_2: "{{count}} mesiacov", day_0: "deň", day_1: "{{count}} dní", day_2: "{{count}} dní", week_0: "týždeň", week_1: "{{count}} týždňov", week_2: "{{count}} týždňov", year_0: "rok", year_1: "{{count}} rokov", year_2: "{{count}} rokov" } }, components: { offer_price: { price_plans: { trial_period_price: "Zadarmo", trial_period_new: "Potom {{ trialPeriodPrice }} za {{ trialInterval }}", unlimited_new: "<bold>{{amount}}</bold> každých {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krát" } } }, affiliate_badge: { made_with: "Poháňané" }, form_select: { empty_list: "Zdá sa, že tento zoznam je prázdny", select: "Vybrať" }, contact_slug: { email: "Email", first_name: "Meno", last_name: "Priezvisko", phone_number: "Telefónne číslo", country: "Krajina", street_address: "Ulica", city: "Mesto", postal_code: "PSČ", company_name: "Názov spoločnosti", tax_number: "Daňové číslo", state_province: "Štát/Provincie", street_number: "Číslo ulice", neighborhood: "Štvrť" }, date_picker: { apply: "Použiť", clear: "Vymazať", time: "Čas", all_time: "Celý čas", last_3_months: "Posledné 3 mesiace", last_pool_period: "Posledné hodnotenie bazéna", last_month: "Minulý mesiac", this_month: "Tento mesiac", last_30_days: "Posledných 30 dní", title_dates: "Dátumy", from: "Z", to: "Do" }, copy_clipboard: "Skopírované do schránky", payment_inputs: { empty_card_number: "Zadajte číslo karty", invalid_card_number: "Číslo karty je neplatné", empty_expiry_date: "Zadajte dátum expirácie", month_out_of_range: "Mesiac expirácie musí byť medzi 01 a 12", year_out_of_range: "Rok expirácie nemôže byť v minulosti", date_out_of_range: "Dátum expirácie nemôže byť v minulosti", invalid_expiry_date: "Dátum expirácie je neplatný", invalid_cvc: "CVC je neplatný", empty_cvc: "Zadajte CVC", card_number_placeholder: "Číslo karty", expiry_data_placeholder: "MM/YY", cvc_placeholder: "CVC", card_holder_placeholder: "Držiteľ karty", empty_card_holder: "Zadajte meno držiteľa karty" }, copy_clipboard_error: "Nepodarilo sa skopírovať text", input: { phone_number: "Telefónne číslo", phone_search: "Hľadať", search: "Hľadať" }, "registered-over": "registrované viac ako", locale: { french: "Francúzsky", german: "Nemecký", italian: "Taliansky", dutch: "Holandský", english: "Angličtina", portuguese: "Portugalčina", russian: "Ruský", spanish: "španielčina", japanese: "Japončina", arabic: "Arabčina", turkish: "Turecký", chinese: "čínsky", swedish: "švédsky", romanian: "Rumunský", czech: "český", hungarian: "Maďarský", slovak: "Slovenský", danish: "Dánčina", indonesian: "Indonézsky", polish: "Poľský", greek: "Grécky", serbian: "Srbský", hindi: "Nie", norwegian: "Nórsky", thai: "Thajčina", slovenian: "Slovensky", ukrainian: "Ukrajinčina", albania: "Albánsky" }, product: "Produkt", quantity: "Množstvo", order_summary: "Zhrnutie objednávky", vat: "Daň z predaja", total: "Celkom", subtotal: "Medzisúčet", shipping: { shipping_method: "Spôsob dopravy", not_available: "Ups! Vyzerá to, že na túto lokalitu zatiaľ nenabízame dopravu.", condition_label: { price: "Pre objednávky v cene medzi {{min}} {{currency}} a {{max}} {{currency}}", price_min: "Pre objednávky v cene {{min}} {{currency}} alebo viac", quantity: "Pre objednávky obsahujúce medzi {{min}} a {{max}} položkami", quantity_min: "Pre objednávky obsahujúce {{min}} alebo viac položiek", weight: "Pre objednávky s celkovou hmotnosťou medzi {{min}}g a {{max}}g", weight_min: "Pre objednávky s celkovou hmotnosťou {{min}}g alebo viac" } }, shipping_fee: "Poplatok za dopravu", total_amount_with_tax_and_shipping: "Celkom (vrátane dane a dopravy)", vat_percent: "Daň z predaja ({{percent}}%)", including_tax: "Vrátane DPH {{percent}}% ({{amount}})", total_amount_with_tax: "Celkom (vrátane dane)", total_amount_with_shipping: "Celkom (vrátane dopravy)" }, t1 = {
  public_pages_purchase: e1
}, r1 = { "required-field": "Polje je obvezno", payment: { price_plan: "Načrtujte", stripe_card: "Kreditna ali debetna kartica", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Kreditne kartice (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Kreditne kartice (Mercado Pago)", mercadopago_pix: "PIX (plačilni trg)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Gotovino po povzetju", xendit_card: "Kreditne kartice (Xendit)", paystack_card: "Kreditne kartice (Paystack)", paypal_connect: "Povežite PayPal", paypal_edit_organization_name: "Uredi ime organizacije", paypal_rest: "PayPal", secure_and_pay: "Zavarujte in plačajte", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Napaka", "Payment-method": "Način plačila", price_plan: { trial_period: { week_0: "{{count}} teden", week_1: "{{count}} tednov", week_2: "{{count}} tednov", week_3: "{{count}} tednov", day_0: "{{count}} dan", day_1: "{{count}} dni", day_2: "{{count}} dni", day_3: "{{count}} dni", month_0: "{{count}} mesec", month_1: "{{count}} mesecev", month_2: "{{count}} mesecev", month_3: "{{count}} mesecev", year_0: "{{count}} leto", year_1: "{{count}} let", year_2: "{{count}} let", year_3: "{{count}} let" }, interval: { month_0: "mesec", month_1: "{{count}} mesecev", month_2: "{{count}} mesecev", month_3: "{{count}} mesecev", day_0: "dan", day_1: "{{count}} dni", day_2: "{{count}} dni", day_3: "{{count}} dni", week_0: "teden", week_1: "{{count}} tednov", week_2: "{{count}} tednov", week_3: "{{count}} tednov", year_0: "leto", year_1: "{{count}} let", year_2: "{{count}} let", year_3: "{{count}} let" } }, components: { offer_price: { price_plans: { trial_period_price: "Brezplačno", trial_period_new: "{{ trialPeriodPrice }} za {{ trialInterval }} potem", unlimited_new: "<bold>{{amount}}</bold> vsak {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krat" } } }, affiliate_badge: { made_with: "Powered by" }, form_select: { empty_list: "Zdi se, da je ta seznam prazen", select: "Izberi" }, contact_slug: { email: "E-pošta", first_name: "Ime", last_name: "Priimek", phone_number: "Telefonska številka", country: "Država", street_address: "Ulična naslov", city: "Mesto", postal_code: "Poštna številka", company_name: "Ime podjetja", tax_number: "Davčna številka", state_province: "Država/Provinca", street_number: "Številka ulice", neighborhood: "Soseska" }, date_picker: { apply: "Uporabi", clear: "Počisti", time: "Čas", all_time: "Vse čase", last_3_months: "Zadnja 3 meseca", last_pool_period: "Zadnje obdobje ocenjevanja bazena", last_month: "Zadnji mesec", this_month: "Ta mesec", last_30_days: "Zadnjih 30 dni", title_dates: "Datumi", from: "Iz", to: "Do" }, copy_clipboard: "Kopirano v odložišče", payment_inputs: { empty_card_number: "Vnesite številko kartice", invalid_card_number: "Številka kartice je neveljavna", empty_expiry_date: "Vnesite datum poteka", month_out_of_range: "Mesec poteka mora biti med 01 in 12", year_out_of_range: "Leto poteka ne more biti v preteklosti", date_out_of_range: "Datum poteka ne more biti v preteklosti", invalid_expiry_date: "Datum poteka je neveljaven", invalid_cvc: "CVC je neveljaven", empty_cvc: "Vnesite CVC", card_number_placeholder: "Številka kartice", expiry_data_placeholder: "MM/YY", cvc_placeholder: "CVC", card_holder_placeholder: "Imetnik kartice", empty_card_holder: "Vnesite ime imetnika kartice" }, copy_clipboard_error: "Kopiranje besedila ni uspelo", input: { phone_number: "Telefonska številka", phone_search: "Iskanje", search: "Iskanje" }, "registered-over": "registrirani več kot", locale: { french: "Francosko", german: "Nemški", italian: "Italijanski", dutch: "Nizozemščina", english: "Angleščina", portuguese: "Portugalščina", russian: "Ruski", spanish: "španski", japanese: "Japonska", arabic: "Arabsko", turkish: "Turško", chinese: "Kitajski", swedish: "švedščina", romanian: "Romunščina", czech: "češki", hungarian: "Madžarski", slovak: "Slovaški", danish: "Danščina", indonesian: "Indonezijski", polish: "Poljski", greek: "Grški", serbian: "Srbsko", hindi: "Ne", norwegian: "Norveški", thai: "Tajska", slovenian: "Slovenščina", ukrainian: "Ukrajinski", albania: "Albanski" }, product: "Izdelek", quantity: "Količina", order_summary: "Povzetek naročila", vat: "Davek na prodajo", total: "Skupaj", subtotal: "Medseštevek", shipping: { shipping_method: "Način dostave", not_available: "Oups! Zdi se, da še ne ponujamo dostave na to lokacijo.", condition_label: { price: "Za naročila v vrednosti med {{min}} {{currency}} in {{max}} {{currency}}", price_min: "Za naročila v vrednosti {{min}} {{currency}} ali več", quantity: "Za naročila, ki vsebujejo med {{min}} in {{max}} artikli", quantity_min: "Za naročila, ki vsebujejo {{min}} ali več artiklov", weight: "Za naročila s skupno težo med {{min}}g in {{max}}g", weight_min: "Za naročila s skupno težo {{min}}g ali več" } }, shipping_fee: "Strošek dostave", total_amount_with_tax_and_shipping: "Skupaj (vključno z davkom in dostavo)", vat_percent: "Davek na prodajo ({{percent}}%)", including_tax: "Vključeno {{percent}}% DDV ({{amount}})", total_amount_with_tax: "Skupaj (vključno z davkom)", total_amount_with_shipping: "Skupaj (vključno s poštnino)" }, n1 = {
  public_pages_purchase: r1
}, a1 = { "required-field": "Fusha kërkohet", payment: { price_plan: "Planifikoni", stripe_card: "Kartë krediti ose debiti", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (shirit)", dlocal_card: "Kartat e kreditit (Dlokale)", dlocal_boleto: "Boleto (lokale)", dlocal_pix: "Pix (vendor)", paypal_soap: "PayPal", mercadopago_card: "Kartat e kreditit (Mercado Pago)", mercadopago_pix: "PIX (Tregu i Pagesave)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Pa kartë", cash_on_delivery: "Para ne dore gjate dorezimit", xendit_card: "Kartat e kreditit (Xendit)", paystack_card: "Kartat e kreditit (Paystack)", paypal_connect: "Lidhni PayPal", paypal_edit_organization_name: "Redakto emrin e organizatës", paypal_rest: "PayPal", secure_and_pay: "Siguro dhe Paguaj", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Gabim", "Payment-method": "Mënyra e pagesës", price_plan: { trial_period: { week: "{{count}} javë", week_plural: "{{count}} javë", day: "{{count}} ditë", day_plural: "{{count}} ditë", month: "{{count}} muaj", month_plural: "{{count}} muaj", year: "{{count}} vit", year_plural: "{{count}} vjet" }, interval: { month: "muaj", month_plural: "{{count}} muaj", day: "ditë", day_plural: "{{count}} ditë", week: "javë", week_plural: "{{count}} javë", year: "vit", year_plural: "{{count}} vjet" } }, components: { offer_price: { price_plans: { trial_period_price: "Falas", trial_period_new: "{{ trialPeriodPrice }} për {{ trialInterval }} pastaj", unlimited_new: "<bold>{{amount}}</bold> çdo {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} herë" } } }, affiliate_badge: { made_with: "E fuqizuar nga" }, form_select: { empty_list: "Duket se kjo listë është bosh", select: "Zgjidhni" }, contact_slug: { email: "Email", first_name: "Emri i parë", last_name: "Mbiemri", phone_number: "Numri i telefonit", country: "Shteti", street_address: "Adresa e rrugës", city: "Qyteti", postal_code: "Kodi postar", company_name: "Emri i kompanisë", tax_number: "Numri i tatimit", state_province: "Shteti/Provinca", street_number: "Numri i rrugës", neighborhood: "Lagja" }, date_picker: { apply: "Apliko", clear: "Pastro", time: "Koha", all_time: "Të gjitha kohët", last_3_months: "3 muajt e fundit", last_pool_period: "Periudha e fundit e vlerësimit të grupit", last_month: "Muaji i kaluar", this_month: "Ky muaj", last_30_days: "30 ditët e fundit", title_dates: "Datat", from: "Nga", to: "Në" }, copy_clipboard: "Kopjuhet në clipboard", payment_inputs: { empty_card_number: "Shkruani një numër kartelash", invalid_card_number: "Numri i kartelës është i pavlefshëm", empty_expiry_date: "Shkruani një datë skadimi", month_out_of_range: "Muaji i skadimit duhet të jetë midis 01 dhe 12", year_out_of_range: "Viti i skadencës nuk mund të jetë në të kaluarën", date_out_of_range: "Data e skadencës nuk mund të jetë në të kaluarën", invalid_expiry_date: "Data e skadencës është e pavlefshme", invalid_cvc: "CVC është i pavlefshëm", empty_cvc: "Shkruani një CVC", card_number_placeholder: "Numri i kartës", expiry_data_placeholder: "MM/YY", cvc_placeholder: "CVC", card_holder_placeholder: "Emri i mbajtësit të kartës", empty_card_holder: "Shkruani emrin e mbajtësit të kartës" }, copy_clipboard_error: "Dështoi të kopjohet teksti", input: { phone_number: "Numri i telefonit", phone_search: "Kërko", search: "Kërko" }, "registered-over": "regjistruar mbi", locale: { french: "Frëngjisht", german: "Gjermane", italian: "Italisht", dutch: "Holandeze", english: "Anglisht", portuguese: "Portugeze", russian: "Rusisht", spanish: "Spanjisht", japanese: "Japoneze", arabic: "Arabisht", turkish: "Turk", chinese: "Kineze", swedish: "Suedeze", romanian: "Rumun", czech: "çeke", hungarian: "Hungareze", slovak: "Sllovake", danish: "Daneze", indonesian: "Indonezisht", polish: "Polonisht", greek: "Greke", serbian: "Serb", hindi: "Jo", norwegian: "Norvegjeze", thai: "Thai", slovenian: "Slloven", ukrainian: "Ukrainase", albania: "Shqiptare" }, product: "Produkt", quantity: "Sasia", order_summary: "Përmbledhja e Porosisë", vat: "Tatimi mbi shitjet", total: "Totali", subtotal: "Nëntotali", shipping: { shipping_method: "Metoda e Dërgesës", not_available: "Ups! Duket se nuk ofrojmë dërgesa në këtë vend akoma.", condition_label: { price: "Për porositë me çmim midis {{min}} {{currency}} dhe {{max}} {{currency}}", price_min: "Për porositë me çmim {{min}} {{currency}} ose më shumë", quantity: "Për porositë që përmbajnë midis {{min}} dhe {{max}} artikuj", quantity_min: "Për porositë që përmbajnë {{min}} ose më shumë artikuj", weight: "Për porositë me një peshë totale midis {{min}}g dhe {{max}}g", weight_min: "Për porositë me një peshë totale prej {{min}}g ose më shumë" } }, shipping_fee: "Tarifa e dërgesës", total_amount_with_tax_and_shipping: "Totali (duke përfshirë taksën dhe dërgesën)", vat_percent: "Tatimi mbi shitjet ({{percent}}%)", including_tax: "Duke përfshirë TVSH-në {{percent}}% ({{amount}})", total_amount_with_tax: "Totali (përfshirë taksën)", total_amount_with_shipping: "Totali (përfshirë Transportin)" }, i1 = {
  public_pages_purchase: a1
}, o1 = { "required-field": "Поље је обавезно", payment: { price_plan: "План", stripe_card: "Kreditna ili debitna kartica", stripe_ideal: "иДеал (Стрипе)", stripe_bancotact: "Банцонтацт (Стрипе)", dlocal_card: "Кредитне картице (Длоцал)", dlocal_boleto: "Болето (Длоцал)", dlocal_pix: "Пик (Длоцал)", paypal_soap: "ПаиПал", mercadopago_card: "Кредитне картице (Мерцадо Паго)", mercadopago_pix: "ПИКС (тржиште плаћања)", mercadopago_boleto: "Болето (Меркадо Паго)", razorpay: "Разорпаи", flutterwave: "Флуттерваве", mollie: "Моллие", gocardless: "Гоцардлесс", cash_on_delivery: "Плаћање поузећем", xendit_card: "Кредитне картице (Ксендит)", paystack_card: "Кредитне картице (Паистацк)", paypal_connect: "Повежите ПаиПал", paypal_edit_organization_name: "Измените назив организације", paypal_rest: "ПаиПал", secure_and_pay: "Осигурајте и платите", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Грешка", "Payment-method": "Начин плаћања", price_plan: { trial_period: { week_0: "{{count}} недеља", week_1: "{{count}} недеља", week_2: "{{count}} недеља", day_0: "{{count}} дан", day_1: "{{count}} дана", day_2: "{{count}} дана", month_0: "{{count}} месец", month_1: "{{count}} месеци", month_2: "{{count}} месеци", year_0: "{{count}} година", year_1: "{{count}} година", year_2: "{{count}} година" }, interval: { month_0: "месец", month_1: "{{count}} месеци", month_2: "{{count}} месеци", day_0: "дан", day_1: "{{count}} дана", day_2: "{{count}} дана", week_0: "недељу дана", week_1: "{{count}} недеља", week_2: "{{count}} недеља", year_0: "године", year_1: "{{count}} година", year_2: "{{count}} година" } }, components: { offer_price: { price_plans: { trial_period_price: "Бесплатно", trial_period_new: "{{ trialPeriodPrice }} за {{ trialInterval }} онда", unlimited_new: "<bold>{{amount}}</bold> сваких {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} пута" } } }, affiliate_badge: { made_with: "Pokreće" }, form_select: { empty_list: "Izgleda da je ova lista prazna", select: "Izaberi" }, contact_slug: { email: "Email", first_name: "Ime", last_name: "Prezime", phone_number: "Broj telefona", country: "Zemlja", street_address: "Adresa", city: "Grad", postal_code: "Poštanski broj", company_name: "Naziv kompanije", tax_number: "Poreski broj", state_province: "Država/Provincija", street_number: "Broj ulice", neighborhood: "Kraj" }, date_picker: { apply: "Primeni", clear: "Obriši", time: "Vreme", all_time: "Sve vreme", last_3_months: "Poslednja 3 meseca", last_pool_period: "Poslednji period evaluacije", last_month: "Prošli mesec", this_month: "Ovaj mesec", last_30_days: "Poslednjih 30 dana", title_dates: "Datumi", from: "Od", to: "Do" }, copy_clipboard: "Kopirano u međuspremnik", payment_inputs: { empty_card_number: "Unesite broj kartice", invalid_card_number: "Broj kartice je nevažeći", empty_expiry_date: "Unesite datum isteka", month_out_of_range: "Mesec isteka mora biti između 01 i 12", year_out_of_range: "Godina isteka ne može biti u prošlosti", date_out_of_range: "Datum isteka ne može biti u prošlosti", invalid_expiry_date: "Datum isteka je nevažeći", invalid_cvc: "CVC je nevažeći", empty_cvc: "Unesite CVC", card_number_placeholder: "Broj kartice", expiry_data_placeholder: "MM/YY", cvc_placeholder: "CVC", card_holder_placeholder: "Ime vlasnika kartice", empty_card_holder: "Unesite ime vlasnika kartice" }, copy_clipboard_error: "Kopiranje teksta nije uspelo", input: { phone_number: "Broj telefona", phone_search: "Pretraži", search: "Pretraži" }, "registered-over": "registrovano više od", locale: { french: "Француски", german: "Немачки", italian: "Италијан", dutch: "холандски", english: "енглески језик", portuguese: "португалски", russian: "Руски", spanish: "Шпански", japanese: "јапански", arabic: "арапски", turkish: "турски", chinese: "кинески", swedish: "Шведски", romanian: "румунски", czech: "чешки", hungarian: "мађарски", slovak: "словачки", danish: "дански", indonesian: "индонезијски", polish: "Пољски", greek: "грчки", serbian: "Српски", hindi: "Јок", norwegian: "норвешки", thai: "тајландски", slovenian: "словеначки", ukrainian: "украјински", albania: "Албанац" }, product: "Proizvod", quantity: "Količina", order_summary: "Pregled narudžbine", vat: "Porez na promet", total: "Ukupno", subtotal: "Međuzbir", shipping: { shipping_method: "Metod isporuke", not_available: "Ups! Izgleda da još ne nudimo isporuku na ovu lokaciju.", condition_label: { price: "Za narudžbine u cenovnom rasponu od {{min}} {{currency}} do {{max}} {{currency}}", price_min: "Za narudžbine od {{min}} {{currency}} ili više", quantity: "Za narudžbine koje sadrže između {{min}} i {{max}} stavki", quantity_min: "Za narudžbine koje sadrže {{min}} ili više stavki", weight: "Za narudžbine sa ukupnom težinom između {{min}}g i {{max}}g", weight_min: "Za narudžbine sa ukupnom težinom od {{min}}g ili više" } }, shipping_fee: "Trošak isporuke", total_amount_with_tax_and_shipping: "Ukupno (uključujući porez i isporuku)", vat_percent: "Porez na promet ({{percent}}%)", including_tax: "Uključujući {{percent}}% PDV ({{amount}})", total_amount_with_tax: "Ukupno (uključujući porez)", total_amount_with_shipping: "Ukupno (uključujući dostavu)" }, s1 = {
  public_pages_purchase: o1
}, l1 = { "required-field": "Fält är obligatoriskt", payment: { price_plan: "Planen", stripe_card: "Kredit- eller betalkort", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Kreditkort (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Kreditkort (Mercado Pago)", mercadopago_pix: "PIX (betalningsmarknad)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Fluttervåg", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Postförskott", xendit_card: "Kreditkort (Xendit)", paystack_card: "Kreditkort (Paystack)", paypal_connect: "Anslut PayPal", paypal_edit_organization_name: "Redigera organisationens namn", paypal_rest: "PayPal", secure_and_pay: "Säkra och betala", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Fel", "Payment-method": "Betalningsmetod", price_plan: { trial_period: { week: "{{count}} vecka", week_plural: "{{count}} veckor", day: "{{count}} dag", day_plural: "{{count}} dagar", month: "{{count}} månad", month_plural: "{{count}} månader", year: "{{count}} år", year_plural: "{{count}} år" }, interval: { month: "månad", month_plural: "{{count}} månader", day: "dag", day_plural: "{{count}} dagar", week: "vecka", week_plural: "{{count}} veckor", year: "år", year_plural: "{{count}} år" } }, components: { offer_price: { price_plans: { trial_period_price: "Gratis", trial_period_new: "{{ trialPeriodPrice }} för {{ trialInterval }} sedan", unlimited_new: "<bold>{{amount}}</bold> varje {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gånger" } } }, affiliate_badge: { made_with: "Drivs av" }, form_select: { empty_list: "Det verkar som att denna lista är tom", select: "Välj" }, contact_slug: { email: "E-post", first_name: "Förnamn", last_name: "Efternamn", phone_number: "Telefonnummer", country: "Land", street_address: "Gatuadress", city: "Stad", postal_code: "Postnummer", company_name: "Företagsnamn", tax_number: "Skattenummer", state_province: "Stat/Provins", street_number: "Gatu nummer", neighborhood: "Grannskap" }, date_picker: { apply: "Tillämpa", clear: "Rensa", time: "Tid", all_time: "All tid", last_3_months: "Senaste 3 månaderna", last_pool_period: "Senaste poolutvärderingsperioden", last_month: "Senaste månaden", this_month: "Denna månad", last_30_days: "Senaste 30 dagarna", title_dates: "Datum", from: "Från", to: "Till" }, copy_clipboard: "Kopierad till urklipp", payment_inputs: { empty_card_number: "Ange ett kortnummer", invalid_card_number: "Kortnumret är ogiltigt", empty_expiry_date: "Ange ett utgångsdatum", month_out_of_range: "Utgångsmånad måste vara mellan 01 och 12", year_out_of_range: "Utgångsår kan inte vara i det förflutna", date_out_of_range: "Utgångsdatum kan inte vara i det förflutna", invalid_expiry_date: "Utgångsdatum är ogiltigt", invalid_cvc: "CVC är ogiltigt", empty_cvc: "Ange en CVC", card_number_placeholder: "Kortnummer", expiry_data_placeholder: "MM/ÅÅ", cvc_placeholder: "CVC", card_holder_placeholder: "Kortinnehavare", empty_card_holder: "Ange ett namn på kortinnehavaren" }, copy_clipboard_error: "Misslyckades med att kopiera text", input: { phone_number: "Telefonnummer", phone_search: "Sök", search: "Sök" }, "registered-over": "registrerade över", locale: { french: "Franska", german: "Tysk", italian: "Italienska", dutch: "Holländska", english: "Engelsk", portuguese: "Portugisiska", russian: "Ryska", spanish: "Spanska", japanese: "Japanska", arabic: "Arabiska", turkish: "Turkiska", chinese: "Kinesiska", swedish: "Svenska", romanian: "Rumänska", czech: "Tjeckiska", hungarian: "Ungerska", slovak: "Slovakiska", danish: "Danska", indonesian: "Indonesiska", polish: "Putsa", greek: "Grekisk", serbian: "Serbiska", hindi: "Nej", norwegian: "Norska", thai: "Thai", slovenian: "Slovenska", ukrainian: "Ukrainska", albania: "Albanska" }, product: "Produkt", quantity: "Antal", order_summary: "Orderöversikt", vat: "Moms", total: "Totalt", subtotal: "Delsumma", shipping: { shipping_method: "Fraktmetod", not_available: "Oj! Det verkar som om vi inte erbjuder frakt till denna plats än.", condition_label: { price: "För beställningar prissatta mellan {{min}} {{currency}} och {{max}} {{currency}}", price_min: "För beställningar prissatta till {{min}} {{currency}} eller mer", quantity: "För beställningar som innehåller mellan {{min}} till {{max}} artiklar", quantity_min: "För beställningar som innehåller {{min}} eller fler artiklar", weight: "För beställningar med en totalvikt mellan {{min}}g och {{max}}g", weight_min: "För beställningar med en totalvikt av {{min}}g eller mer" } }, shipping_fee: "Fraktavgift", total_amount_with_tax_and_shipping: "Totalt (inklusive skatt och frakt)", vat_percent: "Moms ({{percent}}%)", including_tax: "Inklusive {{percent}}% moms ({{amount}})", total_amount_with_tax: "Totalt (inklusive moms)", total_amount_with_shipping: "Totalt (inklusive frakt)" }, c1 = {
  public_pages_purchase: l1
}, u1 = { "required-field": "จำเป็นต้องกรอกข้อมูล", payment: { price_plan: "วางแผน", stripe_card: "บัตรเครดิตหรือเดบิต", stripe_ideal: "ไอดีล (ลายทาง)", stripe_bancotact: "แบนคอนแทค (ลายทาง)", dlocal_card: "บัตรเครดิต (ดีโลคอล)", dlocal_boleto: "โบเลโต (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "เพย์พาล", mercadopago_card: "บัตรเครดิต (เมอร์คาโดปาโก)", mercadopago_pix: "PIX (ตลาดการชำระเงิน)", mercadopago_boleto: "โบเลโต (Mercado Pago)", razorpay: "เรเซอร์เพย์", flutterwave: "กระพือปีก", mollie: "มอลลี่", gocardless: "ไร้บัตร", cash_on_delivery: "เงินสดในการจัดส่ง", xendit_card: "บัตรเครดิต (Xendit)", paystack_card: "บัตรเครดิต (เพย์สแต็ค)", paypal_connect: "เชื่อมต่อเพย์พาล", paypal_edit_organization_name: "แก้ไขชื่อองค์กร", paypal_rest: "เพย์พาล", secure_and_pay: "ปลอดภัยและชำระเงิน", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "ข้อผิดพลาด", "Payment-method": "วิธีการชำระเงิน", price_plan: { trial_period: { week: "{{count}} สัปดาห์", day: "{{count}} วัน", month: "{{count}} เดือน", year: "{{count}} ปี" }, interval: { month: "เดือน", day: "วัน", week: "สัปดาห์", year: "ปี" } }, components: { offer_price: { price_plans: { trial_period_price: "ฟรี", trial_period_new: "{{ trialPeriodPrice }} สำหรับ {{ trialInterval }} จากนั้น", unlimited_new: "<bold>{{amount}}</bold> ทุกๆ {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ครั้ง" } } }, affiliate_badge: { made_with: "ขับเคลื่อนโดย" }, form_select: { empty_list: "ดูเหมือนว่ารายการนี้จะว่างเปล่า", select: "เลือก" }, contact_slug: { email: "อีเมล", first_name: "ชื่อจริง", last_name: "นามสกุล", phone_number: "หมายเลขโทรศัพท์", country: "ประเทศ", street_address: "ที่อยู่ถนน", city: "เมือง", postal_code: "รหัสไปรษณีย์", company_name: "ชื่อบริษัท", tax_number: "หมายเลขภาษี", state_province: "รัฐ/จังหวัด", street_number: "หมายเลขถนน", neighborhood: "ย่าน" }, date_picker: { apply: "สมัคร", clear: "ล้าง", time: "เวลา", all_time: "ทั้งหมด", last_3_months: "3 เดือนที่ผ่านมา", last_pool_period: "ช่วงเวลาประเมินผลล่าสุด", last_month: "เดือนที่แล้ว", this_month: "เดือนนี้", last_30_days: "30 วันที่ผ่านมา", title_dates: "วันที่", from: "จาก", to: "ถึง" }, copy_clipboard: "คัดลอกไปยังคลิปบอร์ด", payment_inputs: { empty_card_number: "กรอกหมายเลขบัตร", invalid_card_number: "หมายเลขบัตรไม่ถูกต้อง", empty_expiry_date: "กรอกวันที่หมดอายุ", month_out_of_range: "เดือนหมดอายุต้องอยู่ระหว่าง 01 ถึง 12", year_out_of_range: "ปีหมดอายุไม่สามารถอยู่ในอดีตได้", date_out_of_range: "วันที่หมดอายุไม่สามารถอยู่ในอดีตได้", invalid_expiry_date: "วันที่หมดอายุไม่ถูกต้อง", invalid_cvc: "CVC ไม่ถูกต้อง", empty_cvc: "กรุณาใส่ CVC", card_number_placeholder: "หมายเลขบัตร", expiry_data_placeholder: "MM/YY", cvc_placeholder: "CVC", card_holder_placeholder: "ชื่อผู้ถือบัตร", empty_card_holder: "กรุณาใส่ชื่อผู้ถือบัตร" }, copy_clipboard_error: "ไม่สามารถคัดลอกข้อความได้", input: { phone_number: "หมายเลขโทรศัพท์", phone_search: "ค้นหา", search: "ค้นหา" }, "registered-over": "ลงทะเบียนมากกว่า", locale: { french: "ภาษาฝรั่งเศส", german: "เยอรมัน", italian: "ภาษาอิตาลี", dutch: "ภาษาดัตช์", english: "ภาษาอังกฤษ", portuguese: "โปรตุเกส", russian: "ภาษารัสเซีย", spanish: "สเปน", japanese: "ญี่ปุ่น", arabic: "ภาษาอาหรับ", turkish: "ภาษาตุรกี", chinese: "ชาวจีน", swedish: "ภาษาสวีเดน", romanian: "โรมาเนีย", czech: "เช็ก", hungarian: "ภาษาฮังการี", slovak: "สโลวัก", danish: "ภาษาเดนมาร์ก", indonesian: "ชาวอินโดนีเซีย", polish: "ขัด", greek: "กรีก", serbian: "เซอร์เบีย", hindi: "ไม่", norwegian: "ภาษานอร์เวย์", thai: "แบบไทย", slovenian: "ภาษาสโลเวเนีย", ukrainian: "ภาษายูเครน", albania: "แอลเบเนีย" }, product: "ผลิตภัณฑ์", quantity: "จำนวน", order_summary: "สรุปคำสั่งซื้อ", vat: "ภาษีขาย", total: "รวม", subtotal: "ยอดรวมย่อย", shipping: { shipping_method: "วิธีการจัดส่ง", not_available: "อุ๊บส์! ดูเหมือนว่าเรายังไม่สามารถจัดส่งไปยังสถานที่นี้ได้", condition_label: { price: "สำหรับคำสั่งซื้อที่มีราคาอยู่ระหว่าง {{min}} {{currency}} ถึง {{max}} {{currency}}", price_min: "สำหรับคำสั่งซื้อที่มีราคา {{min}} {{currency}} ขึ้นไป", quantity: "สำหรับคำสั่งซื้อที่มีจำนวนระหว่าง {{min}} ถึง {{max}} รายการ", quantity_min: "สำหรับคำสั่งซื้อที่มีจำนวน {{min}} รายการขึ้นไป", weight: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวมระหว่าง {{min}}g ถึง {{max}}g", weight_min: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวม {{min}}g ขึ้นไป" } }, shipping_fee: "ค่าจัดส่ง", total_amount_with_tax_and_shipping: "รวม (รวมภาษีและค่าจัดส่ง)", vat_percent: "ภาษีขาย ({{percent}}%)", including_tax: "รวมภาษีมูลค่าเพิ่ม {{percent}}% ({{amount}})", total_amount_with_tax: "รวมทั้งภาษีแล้ว", total_amount_with_shipping: "รวมค่าส่งแล้ว" }, d1 = {
  public_pages_purchase: u1
}, p1 = { "required-field": "Alan gereklidir", payment: { price_plan: "Plan", stripe_card: "Kredi veya banka kartı", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "İletişimi yasakla (Stripe)", dlocal_card: "Kredi kartları (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Kredi kartları (Mercado Pago)", mercadopago_pix: "PIX (Mercado Pago)", mercadopago_boleto: "Boleto (Mercado Pago)", razorpay: "Razorpay", flutterwave: "Çarpıntı dalgası", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "Kapıda ödeme", xendit_card: "Kredi kartları (Xendit)", paystack_card: "Kredi kartları (Paystack)", paypal_connect: "PayPal'ı bağlayın", paypal_edit_organization_name: "Kuruluş adını düzenleyin", paypal_rest: "PayPal", secure_and_pay: "Güvenli ve Ödemeli", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Güvenlik" } }, error: "Hata", "Payment-method": "Ödeme yöntemi", price_plan: { trial_period: { week: "{{count}} hafta", week_plural: "{{count}} hafta", day: "{{count}} gün", day_plural: "{{count}} gün", month: "{{count}} ay", month_plural: "{{count}} ay", year: "{{count}} yıl", year_plural: "{{count}} yıl" }, interval: { month: "ay", month_plural: "{{count}} ay", day: "gün", day_plural: "{{count}} gün", week: "hafta", week_plural: "{{count}} hafta", year: "yıl", year_plural: "{{count}} yıl" } }, components: { offer_price: { price_plans: { trial_period_price: "Ücretsiz", trial_period_new: "{{ trialInterval }} için {{ trialPeriodPrice }} sonra", unlimited_new: "<bold>{{amount}}</bold> her {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kez" } } }, affiliate_badge: { made_with: "Tarafından desteklenmektedir" }, form_select: { empty_list: "Bu liste boş gibi görünüyor", select: "Seçin" }, contact_slug: { email: "E-posta", first_name: "İsim", last_name: "Soyisim", phone_number: "Telefon numarası", country: "Ülke", street_address: "Sokak adresi", city: "Şehir", postal_code: "Posta kodu", company_name: "Şirket adı", tax_number: "Vergi numarası", state_province: "Eyalet/İl", street_number: "Sokak numarası", neighborhood: "Mahalle" }, date_picker: { apply: "Uygula", clear: "Temizle", time: "Zaman", all_time: "Tüm zamanlar", last_3_months: "Son 3 ay", last_pool_period: "Son havuz değerlendirme dönemi", last_month: "Geçen Ay", this_month: "Bu Ay", last_30_days: "Son 30 gün", title_dates: "Tarihler", from: "Tarihinden itibaren", to: "Tarihine kadar" }, copy_clipboard: "Panoya kopyalandı", payment_inputs: { empty_card_number: "Bir kart numarası girin", invalid_card_number: "Kart numarası geçersiz", empty_expiry_date: "Bir son kullanma tarihi girin", month_out_of_range: "Son kullanma ayı 01 ile 12 arasında olmalıdır", year_out_of_range: "Son kullanma yılı geçmiş tarihte olamaz", date_out_of_range: "Son kullanma tarihi geçmiş tarih olamaz", invalid_expiry_date: "Son kullanma tarihi geçersiz", invalid_cvc: "CVC geçersiz", empty_cvc: "CVC girin", card_number_placeholder: "Kart numarası", expiry_data_placeholder: "AA/YY", cvc_placeholder: "CVC", card_holder_placeholder: "Kart sahibi", empty_card_holder: "Bir kart sahibi adı girin" }, copy_clipboard_error: "Metin kopyalanamadı", input: { phone_number: "Telefon numarası", phone_search: "Ara", search: "Ara" }, "registered-over": "kaydedilen", locale: { french: "Fransızca", german: "Almanca", italian: "İtalyan", dutch: "Flemenkçe", english: "İngilizce", portuguese: "Portekizce", russian: "Rusça", spanish: "İspanyol", japanese: "Japonca", arabic: "Arap", turkish: "Türkçe", chinese: "Çince", swedish: "İsveççe", romanian: "Romen", czech: "Çek", hungarian: "Macarca", slovak: "Slovak", danish: "Danimarka", indonesian: "Endonezya dili", polish: "Lehçe", greek: "Yunan", serbian: "Sırpça", hindi: "Hintçe", norwegian: "Norveççe", thai: "Tay dili", slovenian: "Slovence", ukrainian: "Ukrayna", albania: "Arnavut" }, product: "Ürün", quantity: "Miktar", order_summary: "Sipariş Özeti", vat: "Satış vergisi", total: "Toplam", subtotal: "Ara Toplam", shipping: { shipping_method: "Gönderim Yöntemi", not_available: "Aman! Görünüşe göre bu konuma henüz gönderim yapmıyoruz.", condition_label: { price: "{{min}} {{currency}} ile {{max}} {{currency}} arasında fiyatlandırılan siparişler için", price_min: "{{min}} {{currency}} veya daha fazla fiyatlandırılan siparişler için", quantity: "{{min}} ile {{max}} ürün içeren siparişler için", quantity_min: "{{min}} veya daha fazla ürün içeren siparişler için", weight: "Toplam ağırlığı {{min}}g ile {{max}}g arasında olan siparişler için", weight_min: "Toplam ağırlığı {{min}}g veya daha fazla olan siparişler için" } }, shipping_fee: "Gönderim ücreti", total_amount_with_tax_and_shipping: "Toplam (vergi ve gönderim dahil)", vat_percent: "Satış vergisi ({{percent}}%)", including_tax: "KDV dahil {{percent}}% ({{amount}})", total_amount_with_tax: "Toplam (vergiler dahil)", total_amount_with_shipping: "Toplam (kargo dahil)" }, m1 = {
  public_pages_purchase: p1
}, f1 = { "required-field": "Поле обов'язкове", payment: { price_plan: "План", stripe_card: "Кредитна або дебетова карта", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "Кредитні картки (Dlocal)", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Пікс (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "Кредитні картки (Mercado Pago)", mercadopago_pix: "PIX (платіжний ринок)", mercadopago_boleto: "Болето (Меркадо Паго)", razorpay: "Razorpay", flutterwave: "Флаттервейв", mollie: "Моллі", gocardless: "Gocardless", cash_on_delivery: "Накладений платіж", xendit_card: "Кредитні картки (Xendit)", paystack_card: "Кредитні картки (Paystack)", paypal_connect: "Підключіть PayPal", paypal_edit_organization_name: "Редагувати назву організації", paypal_rest: "PayPal", secure_and_pay: "Захистіть і заплатите", stripe_applepay: "Apple Pay", xendit: { "3ds": "3D-Secure" } }, error: "Помилка", "Payment-method": "Спосіб оплати", price_plan: { trial_period: { week_0: "{{count}} тиждень", week_1: "{{count}} тижнів", week_2: "{{count}} тижнів", day_0: "{{count}} день", day_1: "{{count}} днів", day_2: "{{count}} днів", month_0: "{{count}} місяць", month_1: "{{count}} місяців", month_2: "{{count}} місяців", year_0: "{{count}} рік", year_1: "{{count}} років", year_2: "{{count}} років" }, interval: { month_0: "місяць", month_1: "{{count}} місяців", month_2: "{{count}} місяців", day_0: "день", day_1: "{{count}} днів", day_2: "{{count}} днів", week_0: "тиждень", week_1: "{{count}} тижнів", week_2: "{{count}} тижнів", year_0: "рік", year_1: "{{count}} років", year_2: "{{count}} років" } }, components: { offer_price: { price_plans: { trial_period_price: "безкоштовно", trial_period_new: "Тоді {{ trialPeriodPrice }} за {{ trialInterval }} ", unlimited_new: "<bold>{{amount}}</bold> кожні {{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} разів" } } }, affiliate_badge: { made_with: "Підтримується" }, form_select: { empty_list: "Схоже, що цей список порожній", select: "Вибрати" }, contact_slug: { email: "Електронна пошта", first_name: "Ім'я", last_name: "Прізвище", phone_number: "Номер телефону", country: "Країна", street_address: "Вулиця", city: "Місто", postal_code: "Поштовий індекс", company_name: "Назва компанії", tax_number: "Податковий номер", state_province: "Штат/Область", street_number: "Номер вулиці", neighborhood: "Район" }, date_picker: { apply: "Застосувати", clear: "Очистити", time: "Час", all_time: "Весь час", last_3_months: "Останні 3 місяці", last_pool_period: "Останній період оцінки пулу", last_month: "Останній місяць", this_month: "Цей місяць", last_30_days: "Останні 30 днів", title_dates: "Дати", from: "З", to: "До" }, copy_clipboard: "Скопійовано в буфер обміну", payment_inputs: { empty_card_number: "Введіть номер картки", invalid_card_number: "Номер картки недійсний", empty_expiry_date: "Введіть дату закінчення терміну дії", month_out_of_range: "Місяць закінчення терміну дії має бути між 01 і 12", year_out_of_range: "Рік закінчення не може бути в минулому", date_out_of_range: "Дата закінчення не може бути в минулому", invalid_expiry_date: "Дата закінчення недійсна", invalid_cvc: "CVC недійсний", empty_cvc: "Введіть CVC", card_number_placeholder: "Номер картки", expiry_data_placeholder: "ММ/РР", cvc_placeholder: "CVC", card_holder_placeholder: "Власник картки", empty_card_holder: "Введіть ім'я власника картки" }, copy_clipboard_error: "Не вдалося скопіювати текст", input: { phone_number: "Номер телефону", phone_search: "Пошук", search: "Пошук" }, "registered-over": "зареєстровано понад", locale: { french: "французька", german: "Німецький", italian: "італійська", dutch: "голландська", english: "англійська", portuguese: "португальська", russian: "російський", spanish: "Іспанська", japanese: "Японський", arabic: "арабська", turkish: "турецька", chinese: "китайський", swedish: "шведська", romanian: "румунська", czech: "чеська", hungarian: "угорська", slovak: "словацький", danish: "датська", indonesian: "індонезійська", polish: "польський", greek: "грецька", serbian: "сербська", hindi: "ні", norwegian: "норвезька", thai: "тайська", slovenian: "словенська", ukrainian: "Українська", albania: "албанець" }, product: "Продукт", quantity: "Кількість", order_summary: "Підсумок замовлення", vat: "Податок на продаж", total: "Всього", subtotal: "Проміжний підсумок", shipping: { shipping_method: "Спосіб доставки", not_available: "Упс! Схоже, що ми ще не пропонуємо доставку в це місце.", condition_label: { price: "Для замовлень вартістю від {{min}} {{currency}} до {{max}} {{currency}}", price_min: "Для замовлень вартістю від {{min}} {{currency}} або більше", quantity: "Для замовлень, що містять від {{min}} до {{max}} товарів", quantity_min: "Для замовлень, що містять {{min}} або більше товарів", weight: "Для замовлень з загальною вагою від {{min}}g до {{max}}g", weight_min: "Для замовлень з загальною вагою {{min}}g або більше" } }, shipping_fee: "Вартість доставки", total_amount_with_tax_and_shipping: "Всього (включаючи податок і доставку)", vat_percent: "Податок з продажу ({{percent}}%)", including_tax: "З урахуванням ПДВ {{percent}}% ({{amount}})", total_amount_with_tax: "Загалом (з урахуванням податку)", total_amount_with_shipping: "Загалом (з урахуванням доставки)" }, h1 = {
  public_pages_purchase: f1
}, g1 = { "required-field": "字段为必填项", payment: { price_plan: "计划", stripe_card: "信用卡或借记卡", stripe_ideal: "iDeal (Stripe)", stripe_bancotact: "Bancontact (Stripe)", dlocal_card: "信用卡（Dlocal）", dlocal_boleto: "Boleto (Dlocal)", dlocal_pix: "Pix (Dlocal)", paypal_soap: "PayPal", mercadopago_card: "信用卡（Mercado Pago）", mercadopago_pix: "PIX（Mercado Pago）", mercadopago_boleto: "Boleto（Mercado Pago）", razorpay: "Razorpay", flutterwave: "Flutterwave", mollie: "Mollie", gocardless: "Gocardless", cash_on_delivery: "货到付款", xendit_card: "信用卡 (Xendit)", paystack_card: "信用卡（Paystack）", paypal_connect: "连接 PayPal", paypal_edit_organization_name: "编辑组织名称", paypal_rest: "PayPal", secure_and_pay: "安全与支付", stripe_applepay: "苹果支付", xendit: { "3ds": "3D-安全" } }, error: "错误", "Payment-method": "付款方式", price_plan: { trial_period: { week: `周

{{count}} 周`, day: `{{count}} 天

{{count}} 天`, month: `{{count}} 月

{{count}} 月`, year: `{{count}}年

{{count}}年` }, interval: { month: `月

{{count}} 月`, day: `天

{{count}} 天`, week: `周

{{count}}周`, year: `年

{{count}}年` } }, components: { offer_price: { price_plans: { trial_period_price: "免费", trial_period_new: "{{ trialInterval }} {{ trialPeriodPrice }} 然后", unlimited_new: "<bold>{{amount}}</bold>每个{{interval}}", limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 次" } } }, affiliate_badge: { made_with: "技术支持" }, form_select: { empty_list: "看起来这个列表是空的", select: "选择" }, contact_slug: { email: "电子邮件", first_name: "名字", last_name: "姓氏", phone_number: "电话号码", country: "国家", street_address: "街道地址", city: "城市", postal_code: "邮政编码", company_name: "公司名称", tax_number: "税号", state_province: "州/省", street_number: "街道号码", neighborhood: "街道邻里" }, date_picker: { apply: "应用", clear: "清除", time: "时间", all_time: "所有的时间", last_3_months: "过去3个月", last_pool_period: "最后一个池评估期", last_month: "次月", this_month: "这个月", last_30_days: "过去30天", title_dates: "日期", from: "从", to: "到" }, copy_clipboard: "已复制到剪贴板", payment_inputs: { empty_card_number: "输入卡号", invalid_card_number: "卡号无效", empty_expiry_date: "输入到期日期", month_out_of_range: "到期月份必须在01到12之间", year_out_of_range: "到期年不能是过去的年份", date_out_of_range: "过期日期不能是过去时间", invalid_expiry_date: "过期日期无效", invalid_cvc: "CVC无效", empty_cvc: "输入CVC", card_number_placeholder: "卡号", expiry_data_placeholder: "月/年", cvc_placeholder: "CVC", card_holder_placeholder: "持卡人", empty_card_holder: "输入持卡人姓名" }, copy_clipboard_error: "复制文本失败", input: { phone_number: "电话号码", phone_search: "搜索", search: "搜索" }, "registered-over": "注册超过", locale: { french: "法语", german: "德语", italian: "意大利语", dutch: "荷兰语", english: "英语", portuguese: "葡萄牙语", russian: "俄语", spanish: "西班牙语", japanese: "日语", arabic: "阿拉伯语", turkish: "土耳其语", chinese: "中國人", swedish: "瑞典语", romanian: "罗马尼亚语", czech: "捷克语", hungarian: "匈牙利语", slovak: "斯洛伐克语", danish: "丹麦语", indonesian: "印度尼西亚语", polish: "波兰语", greek: "希腊语", serbian: "塞尔维亚语", hindi: "印地语", norwegian: "挪威语", thai: "泰语", slovenian: "斯洛文尼亚语", ukrainian: "乌克兰语", albania: "阿尔巴尼亚语" }, product: "产品", quantity: "数量", order_summary: "订单摘要", vat: "销售税", total: "总计", subtotal: "小计", shipping: { shipping_method: "运输方式", not_available: "哎呀！看起来我们还不提供该地点的运输服务。", condition_label: { price: "对于价格在 {{min}} {{currency}} 到 {{max}} {{currency}} 之间的订单", price_min: "对于价格在 {{min}} {{currency}} 或以上的订单", quantity: "对于包含 {{min}} 到 {{max}} 件商品的订单", quantity_min: "对于包含 {{min}} 件或更多商品的订单", weight: "对于总重量在 {{min}}g 到 {{max}}g 之间的订单", weight_min: "对于总重量在 {{min}}g 或以上的订单" } }, shipping_fee: "运费", total_amount_with_tax_and_shipping: "总计（包括税费和运费）", vat_percent: "销售税 ({{percent}}%)", including_tax: "含{{percent}}%增值税（{{amount}}）", total_amount_with_tax: "总计（含税）", total_amount_with_shipping: "总计（含运费）" }, _1 = {
  public_pages_purchase: g1
}, ai = ["common"], y1 = Object.values(Mr), So = {
  ar: { common: _c },
  cs: { common: vc },
  da: { common: Cc },
  de: { common: xc },
  el: { common: Sc },
  en: { common: Ec },
  es: { common: Tc },
  fr: { common: Mc },
  hi: { common: Rc },
  hu: { common: zc },
  id: { common: Ic },
  it: { common: Fc },
  ja: { common: Hc },
  nl: { common: Bc },
  no: { common: Uc },
  pl: { common: Gc },
  pt: { common: Zc },
  ro: { common: Jc },
  ru: { common: Qc },
  sk: { common: t1 },
  sl: { common: n1 },
  sq: { common: i1 },
  sr: { common: s1 },
  sv: { common: c1 },
  th: { common: d1 },
  tr: { common: m1 },
  uk: { common: h1 },
  zh: { common: _1 }
}, Po = {
  supportedLngs: y1,
  load: "languageOnly",
  debug: !1,
  defaultNS: ai[0],
  react: { useSuspense: !1 },
  ns: ai,
  compatibilityJSON: "v3",
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
  }
};
Oe.isInitialized || Oe.use(tc).init({ ...Po, resources: So });
const v1 = (t) => {
  const e = fa(t);
  return Oe.cloneInstance({
    ...Po,
    lng: e,
    resources: So
  });
}, U3 = ({
  locale: t,
  children: e
}) => /* @__PURE__ */ c(hc, { i18n: v1(t), children: e }), b1 = (t) => {
  const e = (n) => t((r) => ({ ...r, mercadoPago: { ...r.mercadoPago, ...n } }));
  return {
    initialized: !1,
    setInitialized: (n) => e({ initialized: n })
  };
}, ii = (t) => {
  let e;
  const n = /* @__PURE__ */ new Set(), r = (d, u) => {
    const p = typeof d == "function" ? d(e) : d;
    if (!Object.is(p, e)) {
      const m = e;
      e = u ?? (typeof p != "object" || p === null) ? p : Object.assign({}, e, p), n.forEach((_) => _(e, m));
    }
  }, a = () => e, s = { setState: r, getState: a, getInitialState: () => l, subscribe: (d) => (n.add(d), () => n.delete(d)) }, l = e = t(r, a, s);
  return s;
}, C1 = (t) => t ? ii(t) : ii, w1 = (t) => t;
function x1(t, e = w1) {
  const n = C.useSyncExternalStore(
    t.subscribe,
    () => e(t.getState()),
    () => e(t.getInitialState())
  );
  return C.useDebugValue(n), n;
}
const oi = (t) => {
  const e = C1(t), n = (r) => x1(e, r);
  return Object.assign(n, e), n;
}, k1 = (t) => t ? oi(t) : oi, si = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, Un = /* @__PURE__ */ new Map(), br = (t) => {
  const e = Un.get(t);
  return e ? Object.fromEntries(
    Object.entries(e.stores).map(([n, r]) => [n, r.getState()])
  ) : {};
}, S1 = (t, e, n) => {
  if (t === void 0)
    return {
      type: "untracked",
      connection: e.connect(n)
    };
  const r = Un.get(n.name);
  if (r)
    return { type: "tracked", store: t, ...r };
  const a = {
    connection: e.connect(n),
    stores: {}
  };
  return Un.set(n.name, a), { type: "tracked", store: t, ...a };
}, P1 = (t, e = {}) => (n, r, a) => {
  const { enabled: i, anonymousActionType: o, store: s, ...l } = e;
  let d;
  try {
    d = (i ?? (si ? "production" : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!d)
    return t(n, r, a);
  const { connection: u, ...p } = S1(s, d, l);
  let m = !0;
  a.setState = (f, g, b) => {
    const v = n(f, g);
    if (!m) return v;
    const x = b === void 0 ? { type: o || "anonymous" } : typeof b == "string" ? { type: b } : b;
    return s === void 0 ? (u == null || u.send(x, r()), v) : (u == null || u.send(
      {
        ...x,
        type: `${s}/${x.type}`
      },
      {
        ...br(l.name),
        [s]: a.getState()
      }
    ), v);
  };
  const _ = (...f) => {
    const g = m;
    m = !1, n(...f), m = g;
  }, y = t(a.setState, r, a);
  if (p.type === "untracked" ? u == null || u.init(y) : (p.stores[p.store] = a, u == null || u.init(
    Object.fromEntries(
      Object.entries(p.stores).map(([f, g]) => [
        f,
        f === p.store ? y : g.getState()
      ])
    )
  )), a.dispatchFromDevtools && typeof a.dispatch == "function") {
    let f = !1;
    const g = a.dispatch;
    a.dispatch = (...b) => {
      (si ? "production" : void 0) !== "production" && b[0].type === "__setState" && !f && (console.warn(
        '[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.'
      ), f = !0), g(...b);
    };
  }
  return u.subscribe((f) => {
    var g;
    switch (f.type) {
      case "ACTION":
        if (typeof f.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return wn(
          f.payload,
          (b) => {
            if (b.type === "__setState") {
              if (s === void 0) {
                _(b.state);
                return;
              }
              Object.keys(b.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const v = b.state[s];
              if (v == null)
                return;
              JSON.stringify(a.getState()) !== JSON.stringify(v) && _(v);
              return;
            }
            a.dispatchFromDevtools && typeof a.dispatch == "function" && a.dispatch(b);
          }
        );
      case "DISPATCH":
        switch (f.payload.type) {
          case "RESET":
            return _(y), s === void 0 ? u == null ? void 0 : u.init(a.getState()) : u == null ? void 0 : u.init(br(l.name));
          case "COMMIT":
            if (s === void 0) {
              u == null || u.init(a.getState());
              return;
            }
            return u == null ? void 0 : u.init(br(l.name));
          case "ROLLBACK":
            return wn(f.state, (b) => {
              if (s === void 0) {
                _(b), u == null || u.init(a.getState());
                return;
              }
              _(b[s]), u == null || u.init(br(l.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return wn(f.state, (b) => {
              if (s === void 0) {
                _(b);
                return;
              }
              JSON.stringify(a.getState()) !== JSON.stringify(b[s]) && _(b[s]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: b } = f.payload, v = (g = b.computedStates.slice(-1)[0]) == null ? void 0 : g.state;
            if (!v) return;
            _(s === void 0 ? v : v[s]), u == null || u.send(
              null,
              // FIXME no-any
              b
            );
            return;
          }
          case "PAUSE_RECORDING":
            return m = !m;
        }
        return;
    }
  }), y;
}, E1 = P1, wn = (t, e) => {
  let n;
  try {
    n = JSON.parse(t);
  } catch (r) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      r
    );
  }
  n !== void 0 && e(n);
}, L1 = (t) => {
  const e = (n) => t((r) => ({ ...r, xendit: { ...r.xendit, ...n } }));
  return {
    cardHolderName: "",
    setCardHolderName: (n) => e({ cardHolderName: n }),
    cardNumber: "",
    setCardNumber: (n) => e({ cardNumber: n }),
    expiryMonth: "",
    setExpiryMonth: (n) => e({ expiryMonth: n }),
    expiryYear: "",
    setExpiryYear: (n) => e({ expiryYear: n }),
    cvc: "",
    setCvc: (n) => e({ cvc: n }),
    formInvalid: !0,
    setFormInvalid: (n) => e({ formInvalid: n })
  };
}, T1 = (t, e, n, r) => {
  const a = {
    locale: Or.ENGLISH
  };
  return {
    locale: (r == null ? void 0 : r.locale) ?? a.locale,
    setLocale: (i) => t({ locale: i })
  };
}, N1 = (t, e, n, r) => {
  const a = {
    offerId: void 0,
    productId: void 0,
    paymentMethod: void 0,
    availablePaymentMethods: [],
    currency: void 0,
    pricePlan: void 0,
    finalAmount: void 0,
    contactFields: {}
  }, i = (o) => t((s) => ({ ...s, offer: { ...s.offer, ...o } }));
  return {
    offerId: (r == null ? void 0 : r.offerId) ?? a.offerId,
    setOfferId: (o) => i({ offerId: o }),
    productId: (r == null ? void 0 : r.productId) ?? a.productId,
    setProductId: (o) => i({ productId: o }),
    paymentMethod: (r == null ? void 0 : r.paymentMethod) ?? a.paymentMethod,
    setPaymentMethod: (o) => i({ paymentMethod: o }),
    availablePaymentMethods: (r == null ? void 0 : r.availablePaymentMethods) ?? a.availablePaymentMethods,
    setAvailablePaymentMethods: (o) => i({ availablePaymentMethods: o }),
    currency: (r == null ? void 0 : r.currency) ?? a.currency,
    setCurrency: (o) => i({ currency: o }),
    pricePlan: (r == null ? void 0 : r.pricePlan) ?? a.pricePlan,
    setPricePlan: (o) => i({ pricePlan: o }),
    finalAmount: (r == null ? void 0 : r.finalAmount) ?? a.finalAmount,
    setFinalAmount: (o) => i({ finalAmount: o }),
    contactFields: (r == null ? void 0 : r.contactFields) ?? a.contactFields,
    setContactFields: (o) => i({ contactFields: o })
  };
}, M1 = (t, e, n, r) => {
  const a = {
    quantity: 1,
    selectedShipping: null,
    productVariant: null
  }, i = (o) => t((s) => ({
    ...s,
    physicalProduct: { ...s.physicalProduct, ...o }
  }));
  return {
    quantity: (r == null ? void 0 : r.quantity) ?? a.quantity,
    setQuantity: (o) => i({ quantity: o }),
    selectedShipping: (r == null ? void 0 : r.selectedShipping) ?? a.selectedShipping,
    setSelectedShipping: (o) => i({ selectedShipping: o }),
    productVariant: (r == null ? void 0 : r.productVariant) ?? a.productVariant,
    setProductVariant: (o) => i({ productVariant: o })
  };
}, O1 = (t, e, n, r) => {
  const a = {
    stripeAccountId: void 0,
    mercadoPublicKey: null,
    xenditPublicKey: null
  }, i = (o) => t((s) => ({ ...s, publicKeys: { ...s.publicKeys, ...o } }));
  return {
    stripeAccountId: (r == null ? void 0 : r.stripeAccountId) ?? a.stripeAccountId,
    mercadoPublicKey: (r == null ? void 0 : r.mercadoPublicKey) ?? a.mercadoPublicKey,
    xenditPublicKey: (r == null ? void 0 : r.xenditPublicKey) ?? a.xenditPublicKey,
    setStripeAccountId: (o) => i({ stripeAccountId: o }),
    setMercadoPublicKey: (o) => i({ mercadoPublicKey: o }),
    setXenditPublicKey: (o) => i({ xenditPublicKey: o })
  };
}, R1 = (t) => {
  const e = (n) => t((r) => ({ ...r, visitorInfo: { ...r.visitorInfo, ...n } }));
  return {
    visitorInfo: null,
    setVisitorInfo: (n) => e({ visitorInfo: n })
  };
}, Eo = (t) => k1()(
  E1((e, n, r) => {
    const a = T1(e, n, r, t == null ? void 0 : t.base), i = N1(e, n, r, t == null ? void 0 : t.offer), o = R1(e), s = O1(e, n, r, t == null ? void 0 : t.publicKeys), l = M1(
      e,
      n,
      r,
      t == null ? void 0 : t.physicalProduct
    );
    return {
      ...a,
      offer: i,
      publicKeys: s,
      xendit: L1(e),
      physicalProduct: l,
      visitorInfo: o,
      mercadoPago: b1(e)
    };
  })
);
let xn = null;
const A1 = (t) => (xn || (xn = Eo(t)), xn), Lo = pr(null), z1 = () => vt(Lo) ?? A1(), _e = () => z1()(), tt = () => {
  const { offer: t } = _e();
  return t;
}, D1 = () => {
  const { publicKeys: t } = _e();
  return t;
}, To = () => {
  const { xendit: t } = _e();
  return t;
}, No = () => {
  const { visitorInfo: t } = _e();
  return t;
}, fr = () => {
  const { physicalProduct: t } = _e();
  return t;
}, Mo = () => {
  const { mercadoPago: t } = _e();
  return t;
};
function q3({ children: t, initProps: e }) {
  const n = C.useMemo(() => Eo(e), [e]), r = typeof t == "function" ? t({ store: n }) : t;
  return C.createElement(Lo.Provider, { value: n }, r);
}
const Oo = pr(null), G3 = ({
  children: t,
  locale: e
}) => {
  const { setLocale: n } = _e();
  return Fe(e, (r) => {
    const a = fa(r);
    Oe.language !== a && Oe.changeLanguage(a), n(r);
  }), /* @__PURE__ */ c(el, { locale: e, children: /* @__PURE__ */ c(Oo.Provider, { value: { locale: e }, children: t }) });
}, at = () => {
  const t = vt(Oo);
  if (!t)
    throw new Error("useLocaleContext must be used within a LocaleProvider");
  return t;
};
var je = /* @__PURE__ */ ((t) => (t.Arizonia = "arizonia", t.Inter = "inter", t.Kanit = "kanit", t.Lato = "lato", t.Lora = "lora", t.Merriweather = "merriweather", t.Montserrat = "montserrat", t.NotoSans = "notosans", t.Nunito = "nunito", t.OpenSans = "opensans", t.PlayfairDisplay = "playfairdisplay", t.Poppins = "poppins", t.Roboto = "roboto", t.SourceSansPro = "sourcesanspro", t.Ubuntu = "ubuntu", t))(je || {}), de = /* @__PURE__ */ ((t) => (t.default = "default", t.luminous = "luminous", t.night = "night", t.camilla = "camilla", t.creamy = "creamy", t.sepia = "sepia", t.urban = "urban", t.solarized = "solarized", t.cosmopolitan = "cosmopolitan", t.new_york = "new_york", t.cyberpunk = "cyberpunk", t))(de || {});
const ot = {
  primaryFont: je.Inter,
  secondaryFont: je.Inter
}, qn = {
  [de.default]: {
    theme: de.default,
    primaryColor: "#00A0FF",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F1F4F8",
    ...ot
  },
  [de.luminous]: {
    theme: de.luminous,
    primaryColor: "#6620FA",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F8F5FF",
    ...ot
  },
  [de.night]: {
    theme: de.night,
    primaryColor: "#FC3C67",
    secondaryColor: "#0A1733",
    tertiaryColor: "#142D63",
    ...ot
  },
  [de.camilla]: {
    theme: de.camilla,
    primaryColor: "#EEFF34",
    secondaryColor: "#121212",
    tertiaryColor: "#121212",
    ...ot
  },
  [de.creamy]: {
    theme: de.creamy,
    primaryColor: "#E40160",
    secondaryColor: "#FCF1E3",
    tertiaryColor: "#FFFAF4",
    ...ot
  },
  [de.sepia]: {
    theme: de.sepia,
    primaryColor: "#E7961B",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#FFF7EB",
    ...ot
  },
  [de.solarized]: {
    theme: de.solarized,
    primaryColor: "#00A0FF",
    secondaryColor: "#011420",
    tertiaryColor: "#011420",
    ...ot
  },
  [de.new_york]: {
    theme: de.new_york,
    primaryColor: "#FFC634",
    secondaryColor: "#01133A",
    tertiaryColor: "#01133A",
    ...ot
  },
  [de.urban]: {
    theme: de.urban,
    primaryColor: "#F57F29",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F9F9F9",
    ...ot
  },
  [de.cyberpunk]: {
    theme: de.cyberpunk,
    primaryColor: "#AE3ECA",
    secondaryColor: "#131114",
    tertiaryColor: "#1e1533",
    ...ot
  },
  [de.cosmopolitan]: {
    theme: de.cosmopolitan,
    primaryColor: "#D9335a",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F9F9F9",
    ...ot
  }
};
var Lt = /* @__PURE__ */ ((t) => (t.primaryColor = "--THEME-primary", t.secondaryColor = "--THEME-secondary", t.tertiaryColor = "--THEME-tertiary", t.textColorPrimary = "--THEME-text-primary", t.textColorSecondary = "--THEME-text-secondary", t.borderColorTertiary = "--THEME-border-tertiary", t))(Lt || {}), Gn = /* @__PURE__ */ ((t) => (t.primaryFont = "--THEME-font-primary", t.secondaryFont = "--THEME-font-secondary", t))(Gn || {});
const li = "root-design-css", ci = "root-font-css", Ro = "https://d1asgbu35ychbr.cloudfront.net", ya = "https://d3syewzhvzylbl.cloudfront.net", ui = {
  [je.Inter]: [400, 500, 600, 700],
  [je.Roboto]: [400, 500, 700],
  [je.Lato]: [400, 700],
  [je.Montserrat]: [400, 500, 600, 700],
  [je.OpenSans]: [400, 600, 700],
  [je.Poppins]: [400, 500, 600, 700],
  [je.Arizonia]: [400],
  [je.Kanit]: [400, 500, 600, 700],
  [je.Merriweather]: [400, 700],
  [je.NotoSans]: [400, 700],
  [je.Nunito]: [400, 600, 700],
  [je.PlayfairDisplay]: [400, 500, 600, 700],
  [je.SourceSansPro]: [400, 600, 700],
  [je.Ubuntu]: [400, 500, 700],
  [je.Lora]: [400, 500, 600, 700]
}, I1 = (t, e) => {
  const n = [];
  return ui[t].forEach((r) => {
    n.push(di({ fontFamily: t, fontWeight: r }));
  }), ui[e].forEach((r) => {
    n.push(di({ fontFamily: e, fontWeight: r }));
  }), n.join(`
`);
}, di = ({
  fontFamily: t,
  fontWeight: e
}) => `@font-face {
  font-family: '${t}';
  font-style: normal;
  font-weight: ${e};
  font-display: swap;
  src: url('${ya}/fonts/google-fonts/${t}/${j1(
  e
)}.woff2') format('woff2');
  }
  `, j1 = (t) => t === 400 ? "regular" : t, W3 = ({
  fontFamily: t
}) => `@font-face {
  font-family: '${t}';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('${ya}/fonts/google-fonts/${t}/preview/preview.woff2') format('woff2');
  }
  `;
function kn(t) {
  return parseInt(t, 16) || 0;
}
function Sn(t) {
  return kn(t) / 255 <= 0.03928 ? kn(t) / 255 / 12.92 : Math.pow((kn(t) / 255 + 0.055) / 1.055, 2.4);
}
function pi(t) {
  return 0.2126 * Sn(t.substr(1, 2)) + 0.7152 * Sn(t.substr(3, 2)) + 0.0722 * Sn(t.substr(-2));
}
function Wr(t, e) {
  const n = pi(t), r = pi(e);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
const mi = "#ffffff", Wn = "#000000", fi = "#ffffff33", hi = "#00000033";
function zr(t) {
  const e = Wr(t, mi), n = Wr(t, Wn);
  return e > n ? mi : Wn;
}
const F1 = (t) => {
  const e = Wr(t, fi), n = Wr(t, hi);
  return e > n ? fi : hi;
}, Ao = (t) => zr(t) === Wn, nn = (t) => {
  const { primaryColor: e, secondaryColor: n, tertiaryColor: r } = t, a = zr(e), i = zr(n), o = zr(r), s = F1(r);
  return {
    primaryColor: e,
    secondaryColor: n,
    tertiaryColor: r,
    textColorPrimary: a,
    textColorSecondary: i,
    textColorTertiary: o,
    borderColorTertiary: s
  };
}, V1 = (t) => {
  const {
    primaryColor: e,
    secondaryColor: n,
    tertiaryColor: r,
    textColorPrimary: a,
    textColorSecondary: i,
    borderColorTertiary: o
  } = nn(t);
  return `
  :root {
      /* Colors */
      /* Default primary color */
      ${Lt.primaryColor}: ${e}; /* Default primary color */

      /* Default secondary color */
      ${Lt.secondaryColor}: ${n}; /* Default secondary color */

      /* Default background color */
      ${Lt.tertiaryColor}: ${r}; /* Default background color */

      /* Default text primary color */
      ${Lt.textColorPrimary}: ${a}; /* Default text primary color */
      ${Lt.textColorSecondary}: ${i}; /* Default text secondary color */
      ${Lt.borderColorTertiary}: ${o}; /* Default border tertiry color */
      
      /* Fonts */
      ${Gn.primaryFont}: ${t.primaryFont};
      ${Gn.secondaryFont}: ${t.secondaryFont};
  }
  `;
}, H1 = (t, e) => {
  const n = e ?? document, r = V1(t), a = n.createElement("style");
  a.id = li;
  const i = n.getElementById(li);
  i && i.remove(), a.append(r), n.head.append(a);
  const o = I1(t.primaryFont, t.secondaryFont), s = n.createElement("style");
  s.id = ci;
  const l = n.getElementById(ci);
  l && l.remove(), s.append(o), n.head.append(s);
}, zo = pr(null), Z3 = ({
  children: t,
  design: e,
  customRoot: n
}) => {
  const [r, a] = Te(e);
  return Ve(() => {
    a(e);
  }, [e]), Ve(() => {
    H1(r, n);
  }, [r, n]), /* @__PURE__ */ c(zo.Provider, { value: { state: r, setState: a }, children: t });
}, qe = () => {
  const t = vt(zo), e = (t == null ? void 0 : t.state.theme) === de.default, n = (t == null ? void 0 : t.state.primaryColor) === qn[de.default].primaryColor && (t == null ? void 0 : t.state.theme) === de.default;
  if (!t)
    throw new Error("useDesignContext must be used within a DesignProvider");
  return { ...t, isDefaultTheme: e, isDefaultSioColor: n };
}, Do = "w-full h-full flex items-center flex-col gap-5", va = ({ children: t }) => /* @__PURE__ */ c("div", { className: Do, children: t }), $1 = "flex w-full min-h-screen py-5 [&>*]:h-fit [&>*]:m-auto", Y3 = ({ children: t }) => /* @__PURE__ */ c("div", { className: $1, children: t });
var ie = /* @__PURE__ */ ((t) => (t.link_thumbnail = "link_thumbnail", t.optin_thumbnail = "optin_thumbnail", t.profile = "profile", t.product_download_thumbnail = "product_download_thumbnail", t.product_download_cover = "product_download_cover", t.e_course_thumbnail = "e_course_thumbnail", t.e_course_cover = "e_course_cover", t.physical_product_thumbnail = "physical_product_thumbnail", t.physical_product_cover = "physical_product_cover", t))(ie || {}), ht = /* @__PURE__ */ ((t) => (t.link = "link", t.optin = "optin", t.header = "header", t.product = "product", t))(ht || {}), B1 = /* @__PURE__ */ ((t) => (t.button = "button", t.callout = "callout", t.preview = "preview", t))(B1 || {});
function K1({ primaryColor: t, secondaryColor: e, ...n }) {
  return /* @__PURE__ */ L(
    "svg",
    {
      width: "128",
      height: "128",
      viewBox: "0 0 128 128",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ L("g", { clipPath: "url(#clip0_34300_1538)", children: [
          /* @__PURE__ */ c("path", { d: "M128 64.0015C128 80.9749 121.257 97.2532 109.255 109.255C97.2532 121.257 80.975 128 64.0015 128C47.0281 128 30.7498 121.257 18.7478 109.255C6.74573 97.2532 0.00305176 80.9749 0.00305176 64.0015C0.00305176 28.6553 28.6569 0.00299072 64.0015 0.00299072C99.3461 0.00299072 128 28.6538 128 64.0015Z" }),
          /* @__PURE__ */ c(
            "path",
            {
              d: "M64 67.4342C78.44 67.4342 90.146 55.7282 90.146 41.2882C90.146 26.8482 78.44 15.1422 64 15.1422C49.56 15.1422 37.854 26.8482 37.854 41.2882C37.854 55.7282 49.56 67.4342 64 67.4342Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ c(
            "path",
            {
              d: "M108.05 102.978C107.539 103.557 107.014 104.128 106.478 104.685C100.988 110.417 94.3938 114.979 87.0937 118.096C79.7936 121.212 71.9382 122.819 64.0007 122.819C56.0632 122.819 48.2078 121.212 40.9077 118.096C33.6076 114.979 27.0139 110.417 21.5236 104.685C20.9878 104.128 20.4626 103.557 19.9497 102.978C19.9497 92.1073 23.7345 79.2693 34.0171 72.528C38.6639 69.4812 44.7223 69.7017 49.2083 72.9873C52.6517 75.5059 57.0948 77.0692 63.9999 77.0692C70.905 77.0692 75.3497 75.5059 78.7931 72.9873C83.2791 69.7078 89.3375 69.4873 93.9843 72.528C104.267 79.2693 108.05 92.1073 108.05 102.978Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_34300_1538", children: /* @__PURE__ */ c("rect", { width: "128", height: "128", fill: "white" }) }) })
      ]
    }
  );
}
function U1({ primaryColor: t, secondaryColor: e, ...n }) {
  return /* @__PURE__ */ c("svg", { width: "50", height: "50", viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg", ...n, children: /* @__PURE__ */ c("path", { d: "M24.9486 49.5817C20.0334 49.5817 15.1168 49.5844 10.2016 49.5817C5.13151 49.5778 1.10694 46.3184 0.160213 41.4345C0.0493842 40.8593 0.0106611 40.2631 0.00932579 39.6761C-2.12604e-05 29.8939 -0.00402697 20.113 0.00532007 10.3308C0.0106612 4.78766 4.4238 0.434324 10.0521 0.426445C20.016 0.413312 29.9813 0.413312 39.9452 0.426445C45.5748 0.433011 49.9853 4.78372 49.992 10.3282C50.0027 20.1104 50.0027 29.8913 49.992 39.6735C49.9853 45.2376 45.5655 49.5673 39.8945 49.5778C34.9125 49.5883 29.9306 49.5804 24.9472 49.5804L24.9486 49.5817ZM15.6416 34.2052V18.8641C15.8659 18.8641 16.0609 18.8641 16.2558 18.8641C18.2054 18.8641 20.1535 18.8641 22.1031 18.8641C22.2366 18.8641 22.3701 18.8681 22.5023 18.8615C23.1499 18.8313 23.4063 18.5791 23.4183 17.9527C23.425 17.5601 23.4223 17.1661 23.4183 16.7735C23.4117 16.0459 23.1606 15.7885 22.4329 15.7872C19.9346 15.7833 17.4349 15.778 14.9366 15.7885C13.4838 15.7951 12.5023 16.7787 12.501 18.2154C12.497 23.769 12.497 29.3226 12.501 34.8749C12.501 36.3103 13.4904 37.2886 14.9459 37.29C20.6102 37.2952 26.2745 37.2952 31.9388 37.29C33.3022 37.29 34.3277 36.3812 34.3584 35.0535C34.4051 33.0075 34.3798 30.9589 34.3677 28.9103C34.3651 28.3758 34.0633 28.1013 33.5185 28.079C33.1032 28.0619 32.6853 28.0711 32.2687 28.0751C31.5049 28.0816 31.2512 28.3246 31.2485 29.0836C31.2431 30.607 31.2472 32.1303 31.2472 33.6536C31.2472 33.8296 31.2472 34.0056 31.2472 34.2039H15.6403L15.6416 34.2052ZM31.0188 16.3769C29.2829 18.0814 27.6098 19.7243 25.9367 21.3684C23.6987 23.5681 21.4595 25.7677 19.2242 27.9713C18.5872 28.599 18.5886 29.2202 19.2135 29.8545C19.4458 30.0896 19.6835 30.3194 19.9199 30.5505C20.7464 31.3608 21.2912 31.3608 22.1204 30.5452C25.8539 26.8735 29.5887 23.203 33.3182 19.5273C33.4544 19.3933 33.5305 19.199 33.668 18.9784C34.3584 19.6744 34.9018 20.2286 35.4507 20.7749C35.8259 21.1478 36.2692 21.2752 36.7726 21.0625C37.268 20.8523 37.4977 20.4636 37.4977 19.9344C37.4963 17.9527 37.5017 15.9711 37.495 13.9881C37.4923 13.1752 37.017 12.7169 36.1824 12.7143C34.1835 12.7077 32.1845 12.7143 30.1856 12.7103C29.6301 12.7103 29.2148 12.9178 28.9932 13.43C28.7702 13.9487 28.9278 14.3847 29.3257 14.7616C29.8771 15.2829 30.4246 15.8096 31.0175 16.3756L31.0188 16.3769Z" }) });
}
function q1({ primaryColor: t, secondaryColor: e, ...n }) {
  return /* @__PURE__ */ c("svg", { width: "50", height: "47", viewBox: "0 0 50 47", xmlns: "http://www.w3.org/2000/svg", ...n, children: /* @__PURE__ */ c("path", { d: "M49.9985 16.8733V40.7569C49.9694 40.8466 49.933 40.9335 49.9141 41.0262C49.266 44.2437 46.8221 46.2651 43.5451 46.2651C31.1756 46.2695 18.8076 46.2709 6.43808 46.2651C2.72272 46.2637 0.000647304 43.5429 0.000647304 39.8533C-0.00080913 32.5394 0.000647304 25.2255 0.000647304 17.9115C0.000647304 15.2747 1.15997 13.3329 3.4888 12.0717C10.2263 8.42125 16.9652 4.77371 23.691 1.10444C24.5969 0.610663 25.4139 0.60342 26.3126 1.10154C28.7681 2.46267 31.2455 3.78761 33.7142 5.12703C37.9815 7.44095 42.2445 9.76067 46.5162 12.0645C48.1256 12.9318 49.2354 14.1916 49.7568 15.9466C49.8485 16.2536 49.9199 16.5649 50 16.8748L49.9985 16.8733ZM45.8244 18.734C45.8244 18.443 45.8142 18.1519 45.8259 17.8609C45.8666 16.8632 45.4093 16.1797 44.5369 15.7091C38.1577 12.2585 31.7815 8.79919 25.4096 5.33409C25.1256 5.17915 24.9042 5.14006 24.6158 5.32395C24.2211 5.57736 23.7929 5.77863 23.3793 6.00307C17.3744 9.26111 11.371 12.5206 5.36469 15.7743C4.57676 16.2014 4.16896 16.8386 4.17478 17.7349C4.17915 18.414 4.19809 19.0946 4.16605 19.7722C4.14857 20.1371 4.28984 20.3066 4.60298 20.4702C10.8147 23.6848 17.0278 26.8921 23.2162 30.1502C24.4644 30.8076 25.5625 30.796 26.8034 30.1429C32.6757 27.0514 38.5641 23.9889 44.4757 20.9741C45.4792 20.4629 46.1871 19.9692 45.8244 18.734Z" }) });
}
function G1({
  primaryColor: t,
  secondaryColor: e,
  ...n
}) {
  return /* @__PURE__ */ c("svg", { xmlns: "http://www.w3.org/2000/svg", width: "50", height: "50", viewBox: "0 0 50 50", ...n, children: /* @__PURE__ */ c("path", { d: "M8.4003 0.636108C19.4679 0.636108 30.5342 0.636108 41.6018 0.636108C41.709 0.666399 41.8148 0.70986 41.9246 0.726981C45.5946 1.31436 48.1101 3.31224 49.4361 6.72194C49.7053 7.41467 49.8152 8.16799 50 8.89366V41.5393C49.9692 41.646 49.925 41.75 49.9076 41.858C49.1749 46.5439 45.3777 49.7863 40.5557 49.7929C30.1927 49.8061 19.8296 49.8113 9.46648 49.7745C8.41101 49.7705 7.30867 49.6072 6.31214 49.274C2.41978 47.9728 0.0128507 44.5684 0.00615361 40.4897C-0.00456175 33.9956 0.00347216 27.5001 0.00347216 21.006C0.00347216 17.3106 -0.00590117 13.6151 0.00615361 9.92091C0.0195478 5.81189 2.48943 2.41405 6.42063 1.10628C7.06087 0.892922 7.73996 0.790197 8.40164 0.636108H8.4003ZM23.5357 26.5572C23.4822 26.5954 23.4286 26.6322 23.375 26.6704C23.2625 26.5163 23.1687 26.3425 23.0348 26.2095C21.4623 24.6568 19.8898 23.104 18.3053 21.5631C17.7736 21.0456 17.1119 20.9586 16.5212 21.2866C15.9519 21.6026 15.6345 22.2532 15.8381 22.8828C15.9412 23.2002 16.1663 23.507 16.41 23.748C18.8384 26.1555 21.2815 28.5498 23.7206 30.9454C24.6327 31.841 25.3667 31.8436 26.2708 30.9559C28.1808 29.0792 30.0909 27.2025 32.0009 25.3245C32.6103 24.7252 33.2251 24.13 33.8238 23.5202C34.235 23.1014 34.3221 22.5891 34.1346 22.0504C33.9511 21.5236 33.5452 21.2115 32.9907 21.118C32.4281 21.0219 31.9861 21.2629 31.5964 21.6474C30.0359 23.1896 28.4702 24.7252 26.9044 26.2622C26.7852 26.3794 26.6553 26.4874 26.4651 26.6586V26.0462C26.4651 21.28 26.4651 16.5138 26.4651 11.7476C26.4651 11.5711 26.4731 11.3946 26.4557 11.2208C26.3713 10.3397 25.577 9.76419 24.693 9.93672C23.963 10.079 23.5371 10.6637 23.5357 11.5421C23.5344 16.3729 23.5357 21.2023 23.5357 26.033C23.5357 26.2082 23.5357 26.382 23.5357 26.5572ZM25.0533 37.666C20.4819 37.666 15.9104 37.666 11.339 37.666C11.1274 37.666 10.9144 37.6647 10.7054 37.6871C9.89375 37.774 9.33655 38.4799 9.44103 39.2741C9.5522 40.1209 10.1536 40.5436 11.2573 40.545C20.4162 40.545 29.5752 40.545 38.7355 40.545C38.9458 40.545 39.1601 40.5384 39.3663 40.5028C40.1834 40.3659 40.6857 39.6599 40.5491 38.8553C40.4178 38.0848 39.8378 37.6673 38.8654 37.6673C34.2618 37.6647 29.6569 37.6673 25.0533 37.6673V37.666Z" }) });
}
const W1 = ({
  primaryColor: t,
  secondaryColor: e,
  ...n
}) => /* @__PURE__ */ L(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "398",
    height: "240",
    viewBox: "0 0 398 240",
    ...n,
    children: [
      /* @__PURE__ */ c("rect", { x: "0.5", width: "397", height: "240", rx: "47" }),
      /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M121.997 98.5457V101.851C122.145 102.825 122.296 103.798 122.448 104.771C122.809 107.093 123.17 109.416 123.487 111.745C125.072 123.386 126.634 135.037 128.185 146.682C128.373 148.085 128.563 149.489 128.752 150.892C129.513 156.524 130.274 162.158 130.925 167.806C131.791 175.334 138.051 181.27 145.654 181.454C148.495 181.522 151.339 181.509 154.182 181.497C155.301 181.492 156.421 181.487 157.54 181.487C164.734 181.487 171.929 181.486 179.123 181.486C203.116 181.483 227.11 181.481 251.105 181.506C256.414 181.511 260.776 179.674 264.079 175.494C265.962 173.114 266.865 170.356 267.249 167.367C268.597 156.803 269.984 146.243 271.375 135.683C271.767 132.711 272.148 129.736 272.528 126.761C273.557 118.725 274.585 110.687 275.846 102.687C276.787 96.7134 273.348 89.4454 267.4 86.7016C265.129 85.658 262.763 85.1243 260.275 85.1243C249.142 85.1243 238.01 85.1233 226.878 85.1222C197.193 85.1194 167.51 85.1166 137.824 85.1338C129.879 85.1385 124.041 89.9318 122.266 97.7098C122.225 97.8987 122.159 98.0834 122.093 98.2681C122.06 98.3605 122.027 98.4528 121.997 98.5457ZM159.9 135.161C159.86 135.354 159.819 135.547 159.777 135.739H159.775V138.826C159.788 138.854 159.803 138.881 159.819 138.908C159.854 138.97 159.889 139.032 159.897 139.098C160.694 146.032 166.865 151.814 174.696 151.676C179.548 151.591 184.402 151.608 189.257 151.626C191.748 151.635 194.239 151.643 196.73 151.639C197.242 151.639 197.566 151.785 197.889 152.195C200.401 155.391 202.931 158.575 205.48 161.742C205.929 162.298 206.429 162.841 206.999 163.265C209.967 165.48 213.843 164.863 216.305 161.795C216.473 161.586 216.641 161.377 216.809 161.168C218.993 158.447 221.177 155.725 223.306 152.962C223.992 152.076 224.661 151.391 225.882 151.599C226.012 151.622 226.15 151.59 226.289 151.558C226.357 151.542 226.425 151.526 226.492 151.517C233.278 150.589 238.453 145.071 238.924 138.261C239.388 131.535 235.069 125.364 228.533 123.51C227.666 123.264 226.768 123.125 225.861 122.984C225.437 122.918 225.012 122.852 224.587 122.774C224.356 117.688 222.215 113.55 217.813 110.785C213.386 108.003 208.705 107.888 203.946 109.925C199.169 102.446 190.654 99.8649 183.812 102.071C173.554 105.378 169.703 112.863 170.829 123.302C170.787 123.314 170.741 123.326 170.691 123.339C170.607 123.36 170.515 123.384 170.424 123.412C165.063 125.042 161.626 128.539 160.175 133.954C160.068 134.352 159.984 134.756 159.9 135.161ZM205.024 140.871H205.974L205.978 140.874V139.834V123.329C205.978 121.636 206.497 121.119 208.193 121.119C208.503 121.118 208.812 121.118 209.122 121.118C210.667 121.116 212.211 121.114 213.756 121.119C215.264 121.123 215.871 121.721 215.871 123.22C215.873 126.923 215.872 130.625 215.872 134.327C215.872 136.178 215.871 138.029 215.871 139.88V140.874H216.778C217.672 140.874 218.567 140.874 219.461 140.874C220.653 140.874 221.845 140.873 223.038 140.876C223.761 140.876 224.349 141.14 224.682 141.814C225.017 142.492 224.858 143.109 224.403 143.678C223.178 145.217 221.954 146.757 220.729 148.297C217.936 151.811 215.143 155.324 212.341 158.83C211.451 159.944 210.337 159.917 209.439 158.789C207.581 156.458 205.725 154.125 203.869 151.791C201.754 149.133 199.639 146.474 197.521 143.818C197.035 143.21 196.781 142.577 197.133 141.83C197.486 141.082 198.141 140.867 198.919 140.869C200.344 140.875 201.768 140.874 203.193 140.873C203.803 140.872 204.414 140.871 205.024 140.871Z",
          fill: e
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "M260.79 79.7267H137.383C137.289 79.5331 137.171 79.4056 137.175 79.2734C137.213 75.4245 137.104 71.5662 137.346 67.7268C137.686 62.3857 142.247 57.9276 147.589 57.7435C152.997 57.5593 158.415 57.6537 163.828 57.649C171.748 57.6396 179.669 57.6726 187.589 57.6254C188.971 57.6159 189.931 58.0551 190.807 59.1272C193.461 62.3857 196.229 65.5545 198.898 68.8083C199.593 69.6583 200.303 70.0078 201.429 70.0078C217.223 69.9653 233.012 69.9747 248.805 69.9842C254.299 69.9842 258.235 72.5485 260.099 77.2994C260.383 78.0266 260.53 78.8058 260.785 79.7267H260.79Z",
          fill: e
        }
      )
    ]
  }
);
function Z1({ primaryColor: t, secondaryColor: e, ...n }) {
  return /* @__PURE__ */ L(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "59",
      height: "61",
      viewBox: "0 0 59 61",
      style: { maxHeight: 61 },
      ...n,
      children: [
        /* @__PURE__ */ c("path", { d: "M53.6899 23.3603C53.4756 22.7929 53.0763 22.4258 52.5326 22.1498C44.384 18.0012 36.2381 13.8498 28.1034 9.67457C27.3216 9.27386 26.6589 9.28647 25.8855 9.68297C17.8433 13.8078 9.78845 17.9115 1.73363 22.0125C1.00507 22.3838 0.325541 22.7747 0.32414 23.7148C0.322739 24.6535 0.99386 25.05 1.72382 25.4227C9.79405 29.5307 17.8629 33.6443 25.9219 37.7761C26.6575 38.1529 27.3006 38.1782 28.0473 37.7957C36.1834 33.6232 44.3293 29.469 52.478 25.3232C53.0342 25.0402 53.4616 24.6787 53.6899 24.0959V23.3603Z" }),
        /* @__PURE__ */ c("path", { d: "M1.53892 28.9366C1.53892 29.6666 1.53892 30.2761 1.53892 30.8855C1.53892 33.3654 1.54452 35.8454 1.53051 38.3239C1.52911 38.6279 1.46186 38.9474 1.35537 39.2346C0.971479 40.2812 0.52173 41.3054 0.163053 42.3618C-0.395978 44.0095 0.528738 45.7818 2.1666 46.3002C3.84089 46.8298 5.64268 45.9093 6.08683 44.207C6.23394 43.6466 6.14287 43.0091 6.08262 42.4136C6.049 42.0774 5.88647 41.7425 5.72955 41.4343C4.84967 39.7109 4.58487 37.8937 4.68995 35.9687C4.78102 34.3154 4.69976 32.6523 4.71657 30.9934C4.71937 30.674 4.63671 30.496 4.33688 30.3517C3.43038 29.9174 2.54069 29.4466 1.53751 28.9352L1.53892 28.9366Z" }),
        /* @__PURE__ */ c("path", { d: "M39.2665 35.6672C40.9767 33.9985 43.3452 32.9774 45.9084 32.9746C51.028 32.9676 55.2648 37.1624 55.2732 42.2259C55.2802 47.3889 51.0672 51.6314 45.9364 51.6202C42.6898 51.6128 40.0607 50.1878 38.4238 47.9398C35.3523 49.4673 32.049 50.159 28.6344 50.3508C24.277 50.596 20.0584 49.9613 16.0667 48.1665C14.95 47.6649 13.923 46.9363 12.9184 46.2218C12.1451 45.6712 11.8102 44.8739 11.8284 43.861C11.8656 41.7052 11.8588 39.5488 11.852 37.3921C11.8493 36.5436 11.8466 35.695 11.8466 34.8464V34.2089C11.9332 34.252 12.0127 34.2914 12.0873 34.3284C12.2675 34.4178 12.4185 34.4927 12.5682 34.569C13.8658 35.2312 15.1638 35.8927 16.4619 36.5544C19.1738 37.9366 21.886 39.319 24.5951 40.7071C26.2063 41.5324 27.7937 41.5366 29.4078 40.7043C31.7914 39.4761 34.1806 38.259 36.5699 37.0417C37.4688 36.5838 38.3678 36.1258 39.2665 35.6672ZM45.9645 45.4624C46.8836 44.86 47.7816 44.2197 48.6629 43.5626C49.5484 42.9013 49.5428 41.7902 48.6517 41.1261C47.9273 40.5866 47.1833 40.0705 46.4402 39.555C46.2937 39.4534 46.1472 39.3518 46.0009 39.25C45.5091 38.9068 44.9837 38.8493 44.4443 39.1394C43.9105 39.428 43.6555 39.8875 43.6527 40.4886C43.6508 40.8912 43.6514 41.2937 43.6521 41.6963C43.6524 41.8976 43.6527 42.0989 43.6527 42.3002C43.6527 42.5004 43.6513 42.7005 43.6499 42.9005C43.6469 43.3402 43.6439 43.7796 43.6555 44.2197C43.6877 45.4708 44.9206 46.1462 45.9645 45.4624Z" })
      ]
    }
  );
}
const Y1 = ({
  primaryColor: t,
  secondaryColor: e,
  ...n
}) => /* @__PURE__ */ L(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "398",
    height: "240",
    viewBox: "0 0 398 240",
    ...n,
    children: [
      /* @__PURE__ */ c("rect", { x: "0.5", width: "397", height: "240", rx: "47", fill: t }),
      /* @__PURE__ */ L("g", { children: [
        /* @__PURE__ */ c("path", { d: "M 108 120 L 203 157 L 292 120 L 203 84 L 108 120 Z", fill: e }),
        /* @__PURE__ */ c("ellipse", { cx: "35", cy: "40", rx: "7.327", ry: "7.352", fill: e }),
        /* @__PURE__ */ c("ellipse", { fill: e, cx: "65", cy: "40", rx: "7.706", ry: "7.706" }),
        /* @__PURE__ */ c("ellipse", { fill: e, cx: "95", cy: "40", rx: "7.449", ry: "7.449" }),
        /* @__PURE__ */ c("path", { fill: e, d: "M 126 155 L 126 130 L 119 127 L 119 153 L 126 155 Z" }),
        /* @__PURE__ */ c("rect", { fill: e, x: "0", y: "63", width: "398", height: "7" }),
        /* @__PURE__ */ c("path", { fill: e, d: "M 105 0 L 142 65 L 152 65 L 114 0 L 105 0 Z" }),
        /* @__PURE__ */ c(
          "path",
          {
            fill: e,
            d: "M 262 140 L 203 163 L 143 140 L 143 172 C 162 203 264 191 263 169 L 262 140 Z"
          }
        ),
        /* @__PURE__ */ c("ellipse", { fill: e, cx: "122", cy: "159", rx: "6.87", ry: "6.87" })
      ] })
    ]
  }
);
function J1({
  primaryColor: t,
  secondaryColor: e,
  ...n
}) {
  return /* @__PURE__ */ L(
    "svg",
    {
      width: "60",
      height: "60",
      viewBox: "0 0 60 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ L("g", { clipPath: "url(#clip0_111300_11839)", children: [
          /* @__PURE__ */ c("path", { d: "M26.4843 56.3672C29.3967 56.3672 31.7577 54.0062 31.7577 51.0938C31.7577 48.1813 29.3967 45.8203 26.4843 45.8203C23.5718 45.8203 21.2108 48.1813 21.2108 51.0938C21.2108 54.0062 23.5718 56.3672 26.4843 56.3672Z" }),
          /* @__PURE__ */ c("path", { d: "M44.1794 56.3672C47.0919 56.3672 49.4529 54.0062 49.4529 51.0938C49.4529 48.1813 47.0919 45.8203 44.1794 45.8203C41.267 45.8203 38.906 48.1813 38.906 51.0938C38.906 54.0062 41.267 56.3672 44.1794 56.3672Z" }),
          /* @__PURE__ */ c("path", { d: "M1.7578 7.14853H9.08819L17.5746 36.8569L16.909 38.1882C15.1564 41.6897 17.7006 45.8202 21.6262 45.8202H51.2106C52.1822 45.8202 52.9684 45.034 52.9684 44.0624C52.9684 43.0908 52.1822 42.3046 51.2106 42.3046H21.6262C20.3209 42.3046 19.4678 40.9301 20.0538 39.7606L20.5397 38.789H51.2106C51.9951 38.789 52.6852 38.2689 52.9015 37.5135L59.9327 12.9043C60.0838 12.3739 59.9774 11.8039 59.6461 11.3628C59.3131 10.9234 58.793 10.6641 58.242 10.6641H13.7487L12.1042 4.90827C11.8879 4.153 11.1979 3.63281 10.4133 3.63281H1.7578C0.786206 3.63281 0 4.41902 0 5.39061C0 6.36221 0.786206 7.14853 1.7578 7.14853Z" })
        ] }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_111300_11839", children: /* @__PURE__ */ c("rect", { width: "60", height: "60", fill: "white" }) }) })
      ]
    }
  );
}
const X1 = ({
  primaryColor: t,
  secondaryColor: e,
  ...n
}) => /* @__PURE__ */ L(
  "svg",
  {
    width: "397",
    height: "215",
    viewBox: "0 0 397 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ c("rect", { width: "397", height: "215", rx: "47", fill: t }),
      /* @__PURE__ */ L("g", { clipPath: "url(#clip0_125303_20216)", children: [
        /* @__PURE__ */ c(
          "path",
          {
            d: "M165.077 64.627L143.429 76.1167C143.058 76.311 142.708 76.5323 142.377 76.7744L197.734 105.641L220.915 94.1751L165.077 64.627Z",
            fill: "url(#paint0_linear_125303_20216)"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M258.989 83.1848L231.295 96.8826V112.315C231.295 114.255 229.721 115.829 227.78 115.829C225.839 115.829 224.266 114.255 224.266 112.315V100.359L201.207 111.765V167.615C201.279 167.582 201.352 167.551 201.423 167.515L254.435 140.654C257.251 139.246 259 136.417 259 133.267V83.4953C259 83.391 258.993 83.2881 258.989 83.1848Z",
            fill: "url(#paint1_linear_125303_20216)"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M254.435 76.1078L201.445 49.2585L201.423 49.2475C199.064 48.0728 196.26 48.0991 193.923 49.3178L172.58 60.6449L228.682 90.333L255.762 76.9392C255.351 76.626 254.91 76.345 254.435 76.1078Z",
            fill: "url(#paint2_linear_125303_20216)"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            d: "M139.017 82.9492C139.007 83.1102 139 83.2715 139 83.4342V133.328C139 136.413 140.697 139.215 143.429 140.646L193.9 167.433L193.923 167.445C194.007 167.489 194.093 167.527 194.178 167.568V111.713L139.017 82.9492Z",
            fill: "url(#paint3_linear_125303_20216)"
          }
        )
      ] }),
      /* @__PURE__ */ L("defs", { children: [
        /* @__PURE__ */ L(
          "linearGradient",
          {
            id: "paint0_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ c("stop", { stopColor: e }),
              /* @__PURE__ */ c("stop", { offset: "1", stopColor: e, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ L(
          "linearGradient",
          {
            id: "paint1_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ c("stop", { stopColor: e }),
              /* @__PURE__ */ c("stop", { offset: "1", stopColor: e, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ L(
          "linearGradient",
          {
            id: "paint2_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ c("stop", { stopColor: e }),
              /* @__PURE__ */ c("stop", { offset: "1", stopColor: e, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ L(
          "linearGradient",
          {
            id: "paint3_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ c("stop", { stopColor: e }),
              /* @__PURE__ */ c("stop", { offset: "1", stopColor: e, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ c("clipPath", { id: "clip0_125303_20216", children: /* @__PURE__ */ c("rect", { width: "120", height: "120", fill: e, transform: "translate(139 48)" }) })
      ] })
    ]
  }
), Q1 = (t, e) => {
  switch (t) {
    case ie.profile:
      return /* @__PURE__ */ c(K1, { ...e });
    case ie.link_thumbnail:
      return /* @__PURE__ */ c(U1, { ...e });
    case ie.optin_thumbnail:
      return /* @__PURE__ */ c(q1, { ...e });
    case ie.product_download_thumbnail:
      return /* @__PURE__ */ c(G1, { ...e });
    case ie.product_download_cover:
      return /* @__PURE__ */ c(W1, { ...e });
    case ie.e_course_thumbnail:
      return /* @__PURE__ */ c(Z1, { ...e });
    case ie.e_course_cover:
      return /* @__PURE__ */ c(Y1, { ...e });
    case ie.physical_product_thumbnail:
      return /* @__PURE__ */ c(J1, { ...e });
    case ie.physical_product_cover:
      return /* @__PURE__ */ c(X1, { ...e });
  }
}, eu = (t) => {
  switch (t) {
    case ie.link_thumbnail:
    case ie.optin_thumbnail:
    case ie.product_download_thumbnail:
    case ie.e_course_thumbnail:
    case ie.physical_product_thumbnail:
      return 60;
    case ie.profile:
      return 128;
    case ie.product_download_cover:
    case ie.e_course_cover:
    case ie.physical_product_cover:
      return 300;
  }
}, tu = (t) => {
  switch (t) {
    case ie.link_thumbnail:
    case ie.optin_thumbnail:
    case ie.product_download_thumbnail:
    case ie.e_course_thumbnail:
    case ie.physical_product_thumbnail:
      return 60;
    case ie.profile:
      return 128;
    case ie.product_download_cover:
    case ie.e_course_cover:
    case ie.physical_product_cover:
      return 180;
  }
}, Ge = ({
  thumbnail: t,
  imageType: e,
  alt: n,
  className: r,
  width: a = eu(e),
  height: i = tu(e),
  skipTheme: o
}) => {
  const { isDefaultTheme: s, state: l } = qe(), { primaryColor: d, secondaryColor: u } = nn(l), p = !t, m = p ? "" : t.path, _ = p && !s && !o, y = p ? Q1(e, {
    width: a,
    height: i,
    fill: _ ? d : "rgb(var(--text-primary))",
    className: r,
    primaryColor: _ ? d : qn.default.primaryColor,
    secondaryColor: _ ? u : qn.default.secondaryColor
  }) : null;
  return p ? y : /* @__PURE__ */ c("img", { className: r, alt: n, width: a, height: i, src: m });
}, Io = ({ children: t }) => /* @__PURE__ */ c("div", { className: "w-full max-w-xl", children: t }), an = ({ children: t }) => {
  const {
    state: { tertiaryColor: e }
  } = qe();
  return /* @__PURE__ */ c(Io, { children: /* @__PURE__ */ c(
    "div",
    {
      className: De(
        "bg-THEME-secondary mx-5 rounded-lg border p-5 sm:mx-0",
        Ao(e) ? "shadow-around-sm border-transparent" : "border-THEME-border-tertiary"
      ),
      children: t
    }
  ) });
}, ba = ({ title: t, subTitle: e, thumbnail: n, imageType: r }) => {
  const { isDefaultTheme: a } = qe();
  return /* @__PURE__ */ L("div", { className: "flex gap-3", children: [
    /* @__PURE__ */ c(
      Ge,
      {
        className: "h-full shrink-0 rounded-xl",
        thumbnail: n,
        imageType: r,
        alt: t
      }
    ),
    /* @__PURE__ */ L("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ c("h3", { className: De(a ? "text-text-primary" : "text-THEME-primary"), children: t }),
      /* @__PURE__ */ c("span", { className: "whitespace-pre-wrap font-medium", children: e })
    ] })
  ] });
}, it = (t) => {
  const { isDefaultSioColor: e } = qe(), n = tl(t) ? t["aria-disabled"] : t.disabled;
  return /* @__PURE__ */ c(
    co,
    {
      color: e ? "text-background-secondary" : "text-THEME-text-primary",
      hoverColor: e ? "hover:text-background-secondary" : "hover:text-THEME-text-primary",
      backgroundColor: e ? "bg-brand-primary" : "bg-THEME-primary",
      hoverBackgroundColor: e ? "hover:bg-brand-primary" : "hover:bg-THEME-primary",
      ...t,
      className: fe(
        t.className,
        !e && "ring-THEME-primary",
        n && "bg-text-secondary/50"
      ),
      loaderClassName: e ? "text-background-secondary fill-brand-primary" : "text-THEME-text-primary fill-THEME-primary"
    }
  );
}, Ue = ({ currency: t }) => /* @__PURE__ */ L("div", { className: "text-xxs relative rounded-md px-2 py-1 font-bold uppercase", children: [
  /* @__PURE__ */ c("div", { className: "bg-THEME-primary absolute left-0 top-0 h-full w-full rounded-md opacity-30" }),
  t
] }), Ca = ({ className: t, ...e }) => /* @__PURE__ */ c(
  "svg",
  {
    width: 20,
    height: 20,
    className: fe("main-transition-colors fill-green absolute", t),
    ...e,
    children: /* @__PURE__ */ c(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
      }
    )
  }
), Zn = ({
  options: t,
  selected: e,
  onChange: n,
  disabled: r,
  error: a,
  label: i,
  required: o,
  className: s,
  labelClassName: l,
  optionsWrapperClassName: d,
  optionWrapperClassName: u,
  selectedOptionWrapperClassName: p,
  optionClassName: m,
  selectedOptionClassName: _
}) => /* @__PURE__ */ L("div", { className: fe("flex flex-col gap-1", s), children: [
  /* @__PURE__ */ c(dr, { label: i, labelClassName: l, required: o }),
  /* @__PURE__ */ c("ul", { className: fe("flex flex-col gap-5", d), children: t ? t.map((y) => /* @__PURE__ */ L(
    "li",
    {
      className: fe(
        u,
        y.id === e && p,
        "border-text-secondary/30 rounded-lg border"
      ),
      children: [
        /* @__PURE__ */ L(
          "label",
          {
            className: fe(
              "relative flex items-center gap-2",
              !r && "cursor-pointer",
              "p-4"
            ),
            children: [
              /* @__PURE__ */ c(
                "input",
                {
                  className: fe(
                    "border-2 outline-hidden",
                    r ? "border-fill-primary/70" : "border-fill-primary",
                    "h-[20px] w-[20px] rounded-full",
                    y.id === e ? "bg-background-secondary" : "bg-transparent",
                    "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
                  ),
                  disabled: r,
                  checked: y.id === e,
                  value: y.caption,
                  onChange: () => n(y.id),
                  type: "radio"
                }
              ),
              /* @__PURE__ */ c(
                Ca,
                {
                  className: De(
                    y.id !== e && "fill-transparent",
                    r && "opacity-70"
                  )
                }
              ),
              /* @__PURE__ */ L("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: [
                /* @__PURE__ */ c(
                  "span",
                  {
                    className: fe(
                      "main-transition-colors",
                      y.id === e ? "text-text-primary" : "text-text-primary/50",
                      r && "opacity-70",
                      m,
                      y.id === e ? _ : void 0,
                      "text-left"
                    ),
                    children: y.caption
                  }
                ),
                y.additionalInfo
              ] })
            ]
          }
        ),
        y.content && y.id === e && /* @__PURE__ */ c("div", { className: "px-4 pb-4", children: y.content })
      ]
    },
    y.id
  )) : /* @__PURE__ */ L(St, { children: [
    /* @__PURE__ */ c(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "first-skeleton"
    ),
    /* @__PURE__ */ c(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "second-skeleton"
    )
  ] }) }),
  /* @__PURE__ */ c(ha, { error: a })
] }), ru = ({
  thumbnail: t,
  url: e,
  buttonTitle: n,
  subTitle: r,
  title: a
}) => /* @__PURE__ */ c(an, { children: /* @__PURE__ */ L("div", { className: "flex flex-col gap-3", children: [
  /* @__PURE__ */ c(
    ba,
    {
      title: a,
      subTitle: r,
      imageType: ie.link_thumbnail,
      thumbnail: t
    }
  ),
  /* @__PURE__ */ c(it, { href: e, children: n })
] }) }), wa = ({
  value: t,
  error: e,
  field: n,
  onChange: r,
  contactFields: a
}) => {
  var l;
  const { locale: i } = at(), { visitorInfo: o } = No(), s = (l = a[Qe.Country]) != null && l.value ? a[Qe.Country].value : (o == null ? void 0 : o.country) ?? void 0;
  switch (n.slug) {
    case Qe.Country:
      return /* @__PURE__ */ c(
        al,
        {
          label: Ia(n.slug),
          className: "focus:!border-THEME-primary",
          required: n.required,
          data: il(i),
          value: t,
          withoutCloseIcon: !0,
          onChange: (d) => r(d),
          error: e == null ? void 0 : e.join(", ")
        }
      );
    case Qe.PhoneNumber:
      return /* @__PURE__ */ c(
        nl,
        {
          label: Ia(n.slug),
          inputClassName: "focus:!border-THEME-primary",
          required: n.required,
          value: t,
          onChange: r,
          initialCountry: s,
          error: e == null ? void 0 : e.join(", ")
        }
      );
    default:
      return /* @__PURE__ */ c(
        ar,
        {
          label: rl(n),
          inputClassName: "focus:!border-THEME-primary",
          required: n.required,
          value: t,
          onChange: ({ target: { value: d } }) => r(d),
          error: e == null ? void 0 : e.join(", ")
        },
        n.slug
      );
  }
}, Zr = (t) => t.reduce(
  (e, n) => ({ ...e, [n.slug]: { ...n, value: void 0 } }),
  {}
), Kt = fo();
Kt.interceptors.response.use((t) => t, cl(Kt));
Kt.interceptors.response.use((t) => t.data);
const nu = async (t) => Kt.post("/api/public/digital-store/opt-in", t), au = ({
  id: t,
  title: e,
  subTitle: n,
  thumbnail: r,
  fields: a,
  buttonTitle: i,
  thankYouPage: o
}) => {
  const [s, l] = Te(!1), [d, u] = Te({}), [p, m] = Te(
    Zr(a)
  ), { visitorInfo: _ } = No();
  Fe(a, (f) => m(Zr(f))), Fe(_, (f) => {
    if (!f) return;
    const g = Object.prototype.hasOwnProperty.call(p, Qe.Country) && !p[Qe.Country].value;
    f.country && g && m({
      ...p,
      [Qe.Country]: {
        ...p[Qe.Country],
        value: f.country
      }
    });
  });
  const y = async () => {
    var g;
    if (!t) return;
    const f = Object.values(p).map((b) => ({
      slug: b.slug,
      value: b.value ?? ""
    }));
    try {
      u({}), l(!0);
      const b = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await nu({
        itemOptIn: `/api/dashboard/digital-store/item-opt-ins/${t}`,
        values: f,
        timezone: b
      }), o.path && window.location.assign(o.path);
    } catch (b) {
      b instanceof ul && ((g = b.errors.violations) == null || g.forEach((v) => {
        var h;
        const x = /values\[(\d+)]/, S = v.propertyPath.match(x);
        if (S) {
          const P = parseInt(S[1]), F = (h = f.find((G, W) => W === P)) == null ? void 0 : h.slug;
          F && u((G) => ({ ...G, [F]: v.message }));
        }
      }));
    } finally {
      l(!1);
    }
  };
  return /* @__PURE__ */ c(an, { children: /* @__PURE__ */ L(
    "form",
    {
      onSubmit: (f) => {
        f.preventDefault(), y();
      },
      className: "flex flex-col gap-3",
      children: [
        /* @__PURE__ */ c(
          ba,
          {
            title: e,
            subTitle: n,
            imageType: ie.optin_thumbnail,
            thumbnail: r
          }
        ),
        Object.values(p).map((f) => {
          const g = (b) => m({
            ...p,
            [f.slug]: { ...f, value: b }
          });
          return /* @__PURE__ */ c(
            wa,
            {
              contactFields: p,
              field: f,
              value: p[f.slug].value,
              error: d[f.slug] ? [d[f.slug]] : [],
              onChange: g
            },
            f.slug
          );
        }),
        /* @__PURE__ */ c(it, { isFetching: s, type: "submit", children: i })
      ]
    }
  ) });
}, iu = ({ text: t }) => {
  const { isDefaultTheme: e } = qe();
  return /* @__PURE__ */ c(Io, { children: /* @__PURE__ */ c(
    "h2",
    {
      className: De(
        "w-full px-5 py-2.5 text-2xl font-bold sm:px-0",
        e ? "text-text-primary" : "text-THEME-primary"
      ),
      children: t
    }
  ) });
};
var et = /* @__PURE__ */ ((t) => (t.download = "download", t.eCourse = "e-course", t.physicalProduct = "physical", t))(et || {});
const ou = (t) => {
  switch (t) {
    case et.download:
      return ie.product_download_thumbnail;
    case et.eCourse:
      return ie.e_course_thumbnail;
    case et.physicalProduct:
      return ie.physical_product_thumbnail;
  }
}, xa = ({
  productType: t,
  thumbnail: e,
  buttonTitle: n,
  subTitle: r,
  title: a,
  checkoutPage: i
}) => {
  const o = () => {
    i.path && window.location.assign(i.path);
  };
  return /* @__PURE__ */ c(an, { children: /* @__PURE__ */ L("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ c(
      ba,
      {
        title: a,
        subTitle: r,
        imageType: ou(t),
        thumbnail: e
      }
    ),
    /* @__PURE__ */ c(it, { onClick: o, children: n })
  ] }) });
}, su = xa, lu = xa, cu = xa, uu = ({ ...t }) => {
  switch (t.productType) {
    case et.download:
      return /* @__PURE__ */ c(su, { ...t });
    case et.eCourse:
      return /* @__PURE__ */ c(lu, { ...t });
    case et.physicalProduct:
      return /* @__PURE__ */ c(cu, { ...t });
  }
}, du = (t) => {
  switch (t.type) {
    case ht.link:
      return /* @__PURE__ */ c(ru, { ...t });
    case ht.optin:
      return /* @__PURE__ */ c(au, { ...t });
    case ht.header:
      return /* @__PURE__ */ c(iu, { ...t });
    case ht.product:
      return /* @__PURE__ */ c(uu, { ...t });
  }
}, Be = (t, e, n, r) => {
  let a = fa(n);
  switch (a) {
    case Mr.ARABIC:
      a = "ar-AE";
      break;
    case Mr.ALBANIA:
      a = Mr.ENGLISH;
      break;
  }
  return Intl.NumberFormat(a, {
    style: "currency",
    currency: e,
    currencyDisplay: "symbol",
    maximumFractionDigits: r ? 0 : void 0,
    minimumFractionDigits: r ? 0 : 2
    // we need 2 fractional digits for tests
  }).format(t);
};
var Ee = /* @__PURE__ */ ((t) => (t.tiktok = "tiktok", t.youtube = "youtube", t.instagram = "instagram", t.twitter = "twitter", t.facebook = "facebook", t.spotify = "spotify", t.linkedin = "linkedin", t.pinterest = "pinterest", t.snapchat = "snapchat", t.twitch = "twitch", t.discord = "discord", t.telegram = "telegram", t.vimeo = "vimeo", t.etsy = "etsy", t.email = "email", t.website = "website", t.whatsapp = "whatsapp", t))(Ee || {});
const lt = (t) => {
  switch (t.type) {
    case Ee.instagram:
      return "https://www.instagram.com/" + t.url;
    case Ee.twitter:
      return "https://twitter.com/" + t.url;
    case Ee.tiktok:
      return "https://www.tiktok.com/@" + t.url;
    case Ee.telegram:
      return "https://t.me/" + t.url;
    case Ee.email:
      return "mailto:" + t.url;
    default:
      return t.url;
  }
};
function pu(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "27",
      height: "20",
      viewBox: "0 0 27 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ c("path", { d: "M22.2137 1.65786C20.5409 0.890326 18.7478 0.325064 16.8727 0.00143234C16.8388 -0.00512776 16.8049 0.0112724 16.7863 0.0418862C16.5556 0.451893 16.2998 0.987634 16.1215 1.40748C14.1043 1.10572 12.098 1.10572 10.1223 1.40748C9.94412 0.977794 9.67843 0.451893 9.44774 0.0418862C9.42915 0.0112724 9.39526 -0.00403441 9.36136 0.00143234C7.48736 0.323971 5.69427 0.889233 4.02035 1.65786C4.00613 1.66332 3.99301 1.67426 3.98536 1.68738C0.583945 6.76927 -0.348683 11.7265 0.108337 16.6225C0.110524 16.6466 0.123644 16.6696 0.142231 16.6838C2.38688 18.3325 4.56046 19.333 6.69468 19.9955C6.72857 20.0065 6.76465 19.9933 6.78652 19.9649C7.29165 19.2761 7.74102 18.549 8.12697 17.7848C8.14993 17.74 8.12806 17.6864 8.08105 17.6689C7.36709 17.3977 6.68812 17.0675 6.0343 16.6936C5.98291 16.663 5.97854 16.5897 6.02555 16.5537C6.16331 16.4509 6.30107 16.3437 6.43228 16.2355C6.45633 16.2158 6.48913 16.2114 6.51756 16.2246C10.8122 18.1849 15.4612 18.1849 19.7045 16.2246C19.7329 16.2114 19.7657 16.2147 19.7908 16.2355C19.922 16.3437 20.0598 16.452 20.1987 16.5548C20.2468 16.5897 20.2435 16.6641 20.191 16.6947C19.5372 17.0763 18.8582 17.3999 18.1432 17.6689C18.0961 17.6864 18.0765 17.741 18.0983 17.7859C18.4919 18.549 18.9424 19.2761 19.4377 19.9649C19.4585 19.9944 19.4956 20.0065 19.5295 19.9966C21.6736 19.333 23.8483 18.3325 26.0918 16.6849C26.1115 16.6707 26.1235 16.6488 26.1257 16.6247C26.6724 10.9645 25.2095 6.04766 22.2465 1.68957C22.241 1.67426 22.2279 1.66332 22.2137 1.65786ZM8.76877 13.6421C7.47533 13.6421 6.41041 12.4547 6.41041 10.9973C6.41041 9.53982 7.45456 8.35244 8.76877 8.35244C10.0928 8.35244 11.1479 9.54966 11.1271 10.9973C11.1271 12.4558 10.0819 13.6421 8.76877 13.6421ZM17.4882 13.6421C16.1959 13.6421 15.1299 12.4547 15.1299 10.9973C15.1299 9.53982 16.174 8.35244 17.4882 8.35244C18.8123 8.35244 19.8674 9.54966 19.8466 10.9973C19.8466 12.4558 18.8123 13.6421 17.4882 13.6421Z" })
    }
  );
}
function mu(t) {
  return /* @__PURE__ */ L("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", ...t, children: [
    /* @__PURE__ */ c("path", { d: "M23.2,3.71l-1.86,1.65-8.84,7.83c-.29,.26-.72,.26-1.01,0L2.66,5.36,.8,3.71c.46-.44,1.08-.71,1.76-.71H21.44c.68,0,1.3,.27,1.76,.71Z" }),
    /* @__PURE__ */ c("path", { d: "M24,5.56v12.88c0,1.41-1.15,2.56-2.56,2.56H2.56c-1.41,0-2.56-1.15-2.56-2.56V5.56l.15-.07L11.02,15.13c.56,.49,1.39,.49,1.95,0L23.85,5.49l.15,.07Z" })
  ] });
}
function fu(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ c("path", { d: "M17.2792 13.3805H16.5578C16.4251 13.3805 16.3095 13.471 16.2776 13.5998L15.8153 15.4677C15.5602 16.4988 14.6348 17.2231 13.5727 17.2231H8.73963C8.16746 17.2231 7.70363 16.7592 7.70363 16.187V11.0263C7.70363 10.9303 7.78153 10.8524 7.87758 10.8524H11.1943C11.9565 10.8524 12.5744 11.4703 12.5744 12.2324V12.6976C12.5744 12.857 12.7036 12.9862 12.863 12.9862H13.4919C13.6513 12.9862 13.7805 12.857 13.7805 12.6976V6.89647C13.7805 6.73706 13.6513 6.60786 13.4919 6.60786H12.7703C12.6109 6.60786 12.4816 6.73706 12.4816 6.89647V7.69409C12.4816 8.45626 11.8637 9.07417 11.1016 9.07417H7.87758C7.78152 9.07417 7.70363 8.99627 7.70363 8.90018V3.88638C7.70363 3.26725 8.20553 2.76535 8.82469 2.76535H13.5408C14.493 2.76535 15.2649 3.53726 15.2649 4.48944V5.87852C15.2649 6.03794 15.3942 6.16714 15.5535 6.16714H16.2292C16.3791 6.16714 16.504 6.05243 16.5168 5.90308L16.8475 2.03151C16.8834 1.6111 16.5519 1.25 16.1299 1.25H2.37926C2.21985 1.25 2.09064 1.37921 2.09064 1.53862V2.58495C2.09064 2.74437 2.21985 2.87357 2.37926 2.87357H3.52867C4.20761 2.87357 4.75796 3.42396 4.75796 4.10286V16.0015C4.75796 16.6804 4.20761 17.2308 3.52867 17.2308H2.37926C2.21984 17.2308 2.09064 17.36 2.09064 17.5194V18.4613C2.09064 18.6208 2.21985 18.75 2.37926 18.75H16.3012C16.6518 18.75 16.9479 18.4897 16.9928 18.142L17.5655 13.7061C17.5878 13.5335 17.4533 13.3805 17.2792 13.3805Z" })
    }
  );
}
function hu(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ c("path", { d: "M9.999 0C4.477 0 0 4.47698 0 9.99898C0 14.989 3.656 19.125 8.437 19.878V12.89H5.897V9.99898H8.437V7.79598C8.437 5.28798 9.93 3.90498 12.213 3.90498C13.307 3.90498 14.453 4.09998 14.453 4.09998V6.55898H13.189C11.949 6.55898 11.561 7.33098 11.561 8.12198V9.99698H14.332L13.889 12.888H11.561V19.876C16.342 19.127 19.998 14.99 19.998 9.99898C19.998 4.47698 15.521 0 9.999 0Z" })
    }
  );
}
function gu(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 24 24",
      width: "512",
      height: "512",
      fill: "rgb(var(--brand-primary))",
      ...t,
      children: /* @__PURE__ */ L("g", { children: [
        /* @__PURE__ */ c("path", { d: "M12,2.162c3.204,0,3.584,0.012,4.849,0.07c1.308,0.06,2.655,0.358,3.608,1.311c0.962,0.962,1.251,2.296,1.311,3.608   c0.058,1.265,0.07,1.645,0.07,4.849c0,3.204-0.012,3.584-0.07,4.849c-0.059,1.301-0.364,2.661-1.311,3.608   c-0.962,0.962-2.295,1.251-3.608,1.311c-1.265,0.058-1.645,0.07-4.849,0.07s-3.584-0.012-4.849-0.07   c-1.291-0.059-2.669-0.371-3.608-1.311c-0.957-0.957-1.251-2.304-1.311-3.608c-0.058-1.265-0.07-1.645-0.07-4.849   c0-3.204,0.012-3.584,0.07-4.849c0.059-1.296,0.367-2.664,1.311-3.608c0.96-0.96,2.299-1.251,3.608-1.311   C8.416,2.174,8.796,2.162,12,2.162 M12,0C8.741,0,8.332,0.014,7.052,0.072C5.197,0.157,3.355,0.673,2.014,2.014   C0.668,3.36,0.157,5.198,0.072,7.052C0.014,8.332,0,8.741,0,12c0,3.259,0.014,3.668,0.072,4.948c0.085,1.853,0.603,3.7,1.942,5.038   c1.345,1.345,3.186,1.857,5.038,1.942C8.332,23.986,8.741,24,12,24c3.259,0,3.668-0.014,4.948-0.072   c1.854-0.085,3.698-0.602,5.038-1.942c1.347-1.347,1.857-3.184,1.942-5.038C23.986,15.668,24,15.259,24,12   c0-3.259-0.014-3.668-0.072-4.948c-0.085-1.855-0.602-3.698-1.942-5.038c-1.343-1.343-3.189-1.858-5.038-1.942   C15.668,0.014,15.259,0,12,0z" }),
        /* @__PURE__ */ c("path", { d: "M12,5.838c-3.403,0-6.162,2.759-6.162,6.162c0,3.403,2.759,6.162,6.162,6.162s6.162-2.759,6.162-6.162   C18.162,8.597,15.403,5.838,12,5.838z M12,16c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4S14.209,16,12,16z" }),
        /* @__PURE__ */ c("circle", { cx: "18.406", cy: "5.594", r: "1.44" })
      ] })
    }
  );
}
function gi(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "21",
      height: "22",
      viewBox: "0 0 21 22",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ c(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.4388 7.42975C9.94619 7.92232 9.14741 7.92232 8.65484 7.42975C8.16227 6.93718 8.16227 6.1384 8.65484 5.64583L12.223 2.0775C14.1937 0.106979 17.3883 0.106979 19.3589 2.0775C21.3294 4.04818 21.3294 7.24282 19.3589 9.21342L15.7909 12.7814C15.2983 13.274 14.4996 13.274 14.007 12.7814C13.5143 12.2888 13.5143 11.4901 14.007 10.9973L17.575 7.4295C18.5602 6.44416 18.5602 4.84668 17.575 3.8615C16.5897 2.87616 14.9922 2.87616 14.007 3.8615L10.4388 7.42975ZM10.4391 14.5653C10.9316 14.0727 11.7304 14.0727 12.223 14.5653C12.7157 15.058 12.7157 15.8566 12.223 16.3493L8.65483 19.9175C6.68431 21.888 3.48951 21.888 1.51891 19.9175C-0.451614 17.947 -0.451614 14.7522 1.51891 12.7816L5.0869 9.21359C5.57964 8.72102 6.37825 8.72102 6.87099 9.21359C7.36356 9.70632 7.36356 10.5051 6.87099 10.9977L3.30298 14.5657C2.31764 15.5508 2.31764 17.1483 3.30298 18.1337C4.28816 19.1189 5.88565 19.1189 6.87099 18.1337L10.4391 14.5653ZM14.0071 7.42934C14.4996 7.92191 14.4996 8.72069 14.0071 9.21326L8.65483 14.5651C8.16226 15.0578 7.36348 15.0578 6.87091 14.5651C6.37834 14.0725 6.37834 13.2737 6.87091 12.7812L12.2227 7.42934C12.7155 6.93661 13.5141 6.93661 14.0068 7.42934H14.0071Z"
        }
      )
    }
  );
}
function _u(t) {
  return /* @__PURE__ */ L(
    "svg",
    {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ c("path", { d: "M4.66575 6.42578H0.641865C0.463278 6.42578 0.318573 6.57055 0.318573 6.74907V19.6761C0.318573 19.8547 0.463278 19.9994 0.641865 19.9994H4.66575C4.84434 19.9994 4.98904 19.8547 4.98904 19.6761V6.74907C4.98904 6.57055 4.84434 6.42578 4.66575 6.42578Z" }),
        /* @__PURE__ */ c("path", { d: "M2.65526 0C1.19114 0 0 1.18984 0 2.65235C0 4.11551 1.19114 5.3058 2.65526 5.3058C4.11822 5.3058 5.30839 4.11544 5.30839 2.65235C5.30845 1.18984 4.11822 0 2.65526 0Z" }),
        /* @__PURE__ */ c("path", { d: "M14.9008 6.10547C13.2847 6.10547 12.09 6.80022 11.3653 7.58964V6.75005C11.3653 6.57153 11.2206 6.42676 11.042 6.42676H7.18847C7.00988 6.42676 6.86517 6.57153 6.86517 6.75005V19.6771C6.86517 19.8557 7.00988 20.0004 7.18847 20.0004H11.2036C11.3821 20.0004 11.5268 19.8557 11.5268 19.6771V13.2812C11.5268 11.1259 12.1123 10.2863 13.6147 10.2863C15.2509 10.2863 15.3809 11.6323 15.3809 13.3921V19.6771C15.3809 19.8557 15.5256 20.0004 15.7042 20.0004H19.7208C19.8994 20.0004 20.0441 19.8557 20.0441 19.6771V12.5864C20.0441 9.38164 19.433 6.10547 14.9008 6.10547Z" })
      ]
    }
  );
}
function yu(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ c("path", { d: "M10.2719 0C4.79037 0 1.87524 3.51266 1.87524 7.34283C1.87524 9.11916 2.86779 11.3343 4.45661 12.0368C4.69787 12.1455 4.82913 12.0993 4.88288 11.8755C4.93038 11.7055 5.13914 10.8867 5.2404 10.5005C5.27165 10.3767 5.2554 10.2692 5.15539 10.153C4.62787 9.54293 4.2091 8.43163 4.2091 7.38908C4.2091 4.71771 6.33294 2.12385 9.94686 2.12385C13.072 2.12385 15.2583 4.15394 15.2583 7.05782C15.2583 10.3392 13.522 12.6093 11.2657 12.6093C10.0169 12.6093 9.08682 11.6293 9.38183 10.4167C9.7381 8.9729 10.4369 7.42033 10.4369 6.37904C10.4369 5.44524 9.90936 4.67271 8.83181 4.67271C7.5605 4.67271 6.5292 5.93152 6.5292 7.62159C6.5292 8.69539 6.90922 9.42042 6.90922 9.42042C6.90922 9.42042 5.65166 14.5007 5.4179 15.4494C5.02289 17.0558 5.47166 19.6571 5.51041 19.8809C5.53416 20.0046 5.67291 20.0434 5.75042 19.9421C5.87417 19.7796 7.39424 17.6108 7.82051 16.0432C7.97552 15.4719 8.6118 13.1556 8.6118 13.1556C9.03057 13.9119 10.2394 14.5457 11.5269 14.5457C15.3571 14.5457 18.1247 11.1793 18.1247 7.00156C18.111 2.99638 14.6833 0 10.2719 0Z" })
    }
  );
}
function vu(t) {
  return /* @__PURE__ */ L(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ c("g", { clipPath: "url(#clip0_683_607)", children: /* @__PURE__ */ c("path", { d: "M9.99114 1.43967C12.6754 1.44057 14.9113 3.67528 14.9146 6.36602C14.9153 6.99625 14.9348 7.5766 14.9704 8.11121C14.9923 8.44105 15.2666 8.68549 15.5812 8.68549C15.6276 8.68549 15.6748 8.6802 15.7222 8.66909L16.563 8.47197C16.5988 8.46356 16.6347 8.45955 16.6702 8.45955C16.8838 8.45955 17.0804 8.60547 17.1284 8.82159C17.1962 9.12701 17.0251 9.43559 16.7291 9.53936L15.4527 10.0546C15.1305 10.1847 14.9574 10.5354 15.0481 10.8709C16.0722 14.6568 18.9324 14.2631 18.9324 14.7563C18.9324 15.3757 16.7765 15.4631 16.5817 15.658C16.387 15.8528 16.5733 16.7982 16.1381 16.9812C16.0561 17.0157 15.9395 17.0277 15.7974 17.0277C15.4696 17.0277 15.006 16.9638 14.5173 16.9638C14.0935 16.9638 13.6508 17.0119 13.2617 17.1917C12.2293 17.6686 11.2339 18.5594 10 18.5594C8.76613 18.5594 7.77078 17.6686 6.73837 17.1917C6.34912 17.0119 5.90658 16.9638 5.4827 16.9638C4.99412 16.9638 4.53044 17.0277 4.20268 17.0277C4.06061 17.0277 3.94394 17.0157 3.86195 16.9812C3.42675 16.7982 3.61307 15.8528 3.41829 15.658C3.22352 15.4631 1.0676 15.3756 1.0676 14.7563C1.0676 14.263 3.92788 14.6567 4.95193 10.8709C5.04267 10.5354 4.86959 10.1847 4.5473 10.0546L3.27088 9.53932C2.9749 9.43555 2.80378 9.12697 2.8716 8.82155C2.91955 8.60538 3.1162 8.45946 3.32977 8.4595C3.36521 8.4595 3.40117 8.46352 3.43695 8.47193L4.27784 8.66905C4.32524 8.68016 4.37243 8.68545 4.41876 8.68545C4.73332 8.68545 5.0077 8.44097 5.02965 8.11117C5.06522 7.57655 5.08469 6.9962 5.08546 6.36598C5.08871 3.67528 7.30684 1.44061 9.99114 1.43967ZM9.99148 0.37207H9.9911H9.99071C9.1895 0.372327 8.40899 0.533321 7.67098 0.850613C6.96256 1.15514 6.32499 1.58935 5.77599 2.14122C5.22771 2.69236 4.79623 3.33219 4.49354 4.04296C4.17881 4.78204 4.01876 5.56318 4.01777 6.3647C4.0173 6.75821 4.00915 7.14012 3.99343 7.50583L3.68058 7.43247C3.56579 7.40557 3.44776 7.3919 3.32985 7.39186C2.98937 7.39181 2.65351 7.5069 2.38413 7.7159C2.10309 7.93394 1.90601 8.24444 1.82927 8.59022C1.64663 9.41326 2.10108 10.2442 2.88863 10.5363L3.82543 10.9145C3.20511 12.8185 2.06128 13.1833 1.29103 13.4291C1.08665 13.4943 0.91011 13.5506 0.742027 13.634C0.072298 13.9665 0 14.5296 0 14.7563C0 15.1904 0.205492 15.5866 0.578683 15.8719C0.764489 16.0139 0.994664 16.1311 1.28232 16.2301C1.67439 16.3651 2.12889 16.4508 2.49828 16.5194C2.51613 16.6563 2.5423 16.8033 2.58642 16.9515C2.76958 17.5669 3.15609 17.8425 3.4481 17.9653C3.72516 18.0818 4.01145 18.0953 4.20268 18.0953C4.38973 18.0953 4.58745 18.0806 4.79678 18.0651C5.02136 18.0485 5.25359 18.0313 5.4827 18.0313C5.83774 18.0313 6.10203 18.0736 6.29066 18.1608C6.54966 18.2804 6.82433 18.4418 7.11515 18.6125C7.92473 19.088 8.84231 19.6269 10 19.6269C11.1577 19.6269 12.0753 19.088 12.8849 18.6125C13.1757 18.4417 13.4503 18.2804 13.7094 18.1608C13.898 18.0736 14.1623 18.0313 14.5173 18.0313C14.7465 18.0313 14.9787 18.0485 15.2032 18.0651C15.4126 18.0806 15.6103 18.0953 15.7973 18.0953C15.9885 18.0953 16.2748 18.0818 16.5519 17.9653C16.8439 17.8425 17.2304 17.5669 17.4136 16.9515C17.4577 16.8033 17.4839 16.6563 17.5017 16.5194C17.8711 16.4507 18.3257 16.3651 18.7177 16.2301C19.0054 16.1311 19.2355 16.0139 19.4213 15.8719C19.7945 15.5866 20 15.1904 20 14.7563C20 14.5296 19.9277 13.9665 19.2579 13.6341C19.0898 13.5507 18.9133 13.4944 18.7089 13.4292C17.9386 13.1834 16.7948 12.8185 16.1745 10.9145L17.1112 10.5364C17.8988 10.2442 18.3533 9.41326 18.1706 8.59022C18.0939 8.24444 17.8968 7.93394 17.6158 7.7159C17.3464 7.50694 17.0106 7.39186 16.6702 7.39186C16.5523 7.39186 16.4343 7.40552 16.3194 7.43243L16.0065 7.50579C15.9908 7.14012 15.9827 6.75821 15.9822 6.36465C15.9812 5.5625 15.8199 4.78059 15.5026 4.04052C15.1981 3.3301 14.7643 2.69043 14.2132 2.13925C13.6622 1.58811 13.0228 1.15437 12.313 0.8501C11.5735 0.533193 10.7925 0.372369 9.99148 0.37207Z" }) }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_683_607", children: /* @__PURE__ */ c("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function bu(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      height: "512",
      viewBox: "0 0 176 176",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ c("g", { id: "Layer_2", "data-name": "Layer 2", children: /* @__PURE__ */ L("g", { id: "_62.spotify", "data-name": "62.spotify", children: [
        /* @__PURE__ */ c("circle", { id: "background", cx: "88", cy: "88", r: "88" }),
        /* @__PURE__ */ L("g", { id: "icon", fill: "#fff", children: [
          /* @__PURE__ */ c("path", { d: "m119.79 120.53a5.21 5.21 0 0 1 -7.12 1.87c-13.69-8-29.5-9.28-40.36-9a100.22 100.22 0 0 0 -20.93 2.76 5.21 5.21 0 0 1 -2.76-10 108.5 108.5 0 0 1 23.08-3.16 102.33 102.33 0 0 1 22.24 1.61 75.11 75.11 0 0 1 24 8.76 5.2 5.2 0 0 1 1.85 7.16z" }),
          /* @__PURE__ */ c("path", { d: "m129.47 100.42a6.16 6.16 0 0 1 -5.33 3.06 6.08 6.08 0 0 1 -3.11-.85c-16.21-9.47-34.93-11-47.8-10.6a118.31 118.31 0 0 0 -24.79 3.27 6.17 6.17 0 0 1 -3.27-11.89 127.88 127.88 0 0 1 27.34-3.7 119.43 119.43 0 0 1 26.35 1.91 88.81 88.81 0 0 1 28.4 10.38 6.17 6.17 0 0 1 2.21 8.42z" }),
          /* @__PURE__ */ c("path", { d: "m142 78.39a7.55 7.55 0 0 1 -10.35 2.71c-38.54-22.52-88.53-9.13-89-9a7.57 7.57 0 1 1 -4-14.59 157.1 157.1 0 0 1 33.45-4.51 148.15 148.15 0 0 1 32.31 2.34 109.15 109.15 0 0 1 34.84 12.66 7.57 7.57 0 0 1 2.75 10.39z" })
        ] })
      ] }) })
    }
  );
}
function Cu(t) {
  return /* @__PURE__ */ L(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ c("g", { clipPath: "url(#clip0_683_665)", children: /* @__PURE__ */ c("path", { d: "M7.8475 12.6505L7.51667 17.3039C7.99 17.3039 8.195 17.1005 8.44083 16.8564L10.66 14.7355L15.2583 18.103C16.1017 18.573 16.6958 18.3255 16.9233 17.3272L19.9417 3.18385L19.9425 3.18302C20.21 1.93635 19.4917 1.44885 18.67 1.75469L0.928333 8.54719C-0.282501 9.01719 -0.264167 9.69219 0.722499 9.99802L5.25833 11.4089L15.7942 4.81635C16.29 4.48802 16.7408 4.66969 16.37 4.99802L7.8475 12.6505Z" }) }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_683_665", children: /* @__PURE__ */ c("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function wu(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "18",
      height: "20",
      viewBox: "0 0 18 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ c("path", { d: "M16.3909 4.69C15.3941 4.4708 14.4923 3.9414 13.815 3.1779C13.1377 2.4144 12.7197 1.4559 12.6209 0.440001V0H9.17091V13.67C9.17161 14.2766 8.98151 14.868 8.62741 15.3604C8.27331 15.8529 7.77321 16.2215 7.19801 16.414C6.62281 16.6065 6.00161 16.6131 5.42241 16.4329C4.84321 16.2527 4.33541 15.8948 3.97091 15.41C3.64441 14.9808 3.44441 14.4689 3.39371 13.932C3.34291 13.3951 3.44341 12.8548 3.68371 12.372C3.92401 11.8892 4.29471 11.4834 4.75361 11.2003C5.21261 10.9172 5.74171 10.7681 6.28091 10.77C6.57921 10.7683 6.87591 10.8121 7.16091 10.9V7.4C6.82931 7.3589 6.49501 7.3422 6.16091 7.35C4.93021 7.3829 3.73581 7.7739 2.72401 8.4753C1.71221 9.1766 0.926813 10.1578 0.464113 11.2986C0.00141284 12.4395 -0.118588 13.6905 0.118812 14.8986C0.356312 16.1066 0.940813 17.2191 1.80091 18.1C2.68241 18.9962 3.81041 19.6101 5.04161 19.8638C6.27281 20.1175 7.55161 19.9994 8.71561 19.5246C9.87951 19.0498 10.8761 18.2397 11.5785 17.1973C12.281 16.1548 12.6578 14.9271 12.6609 13.67V6.67C14.0524 7.6639 15.7209 8.1956 17.4309 8.19V4.79C17.095 4.7914 16.7599 4.7579 16.4309 4.69H16.3909Z" })
    }
  );
}
function xu(t) {
  return /* @__PURE__ */ L(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ L("g", { clipPath: "url(#clip0_683_603)", children: [
          /* @__PURE__ */ c("path", { d: "M0.8125 3.47917V17.3908H5.60333V20H8.21917L10.8308 17.39H14.7517L19.98 12.175V0H2.11833L0.8125 3.47917ZM3.86083 1.7375H18.2375V11.3033L15.1875 14.3467H10.395L7.78333 16.9525V14.3467H3.86083V1.7375Z" }),
          /* @__PURE__ */ c("path", { d: "M8.65417 5.21875H10.3958V10.4354H8.65417V5.21875Z" }),
          /* @__PURE__ */ c("path", { d: "M13.4442 5.21875H15.1867V10.4354H13.4442V5.21875Z" })
        ] }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_683_603", children: /* @__PURE__ */ c("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function ku(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "23",
      height: "20",
      viewBox: "0 0 23 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ c("path", { d: "M17.4231 0H20.8173L13.4038 8.47115L22.125 20H15.2981L9.94711 13.0096L3.83173 20H0.432692L8.36058 10.9375L0 0H7L11.8317 6.38942L17.4231 0ZM16.2308 17.9712H18.1106L5.97596 1.92308H3.95673L16.2308 17.9712Z" })
    }
  );
}
function Su(t) {
  return /* @__PURE__ */ L(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: [
        /* @__PURE__ */ c("g", { clipPath: "url(#clip0_683_643)", children: /* @__PURE__ */ c("path", { d: "M11.476 5.96933C13.7535 4.60186 14.9809 6.52932 13.8135 8.70802C12.6435 10.8955 11.5698 12.3217 11.0135 12.3217C10.4673 12.3217 10.0348 10.8542 9.3948 8.30678C8.73856 5.66809 8.73856 0.910692 5.99362 1.45068C3.39868 1.96317 0 6.02558 0 6.02558L0.807483 7.08931C0.807483 7.08931 2.48245 5.76809 3.03993 6.42557C3.60492 7.08931 5.74363 15.0591 6.45111 16.5329C7.0686 17.8241 8.78231 19.5278 10.6548 18.3128C12.5447 17.0903 18.7833 11.763 19.9008 5.45934C21.0158 -0.833021 12.381 0.484451 11.476 5.96933Z" }) }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip0_683_643", children: /* @__PURE__ */ c("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function Pu(t) {
  return /* @__PURE__ */ L(
    "svg",
    {
      fill: "#00A0FF",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      ...t,
      children: [
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "clip1", children: /* @__PURE__ */ c("path", { d: "M 0 0 L 23.9375 0 L 23.9375 23.972656 L 0 23.972656 Z M 0 0 " }) }) }),
        /* @__PURE__ */ L("g", { id: "surface1", children: [
          /* @__PURE__ */ c("path", { d: "M 17.453125 14.285156 L 17.445312 14.359375 C 15.253906 13.265625 15.023438 13.121094 14.738281 13.546875 C 14.542969 13.839844 13.972656 14.507812 13.796875 14.707031 C 13.625 14.898438 13.449219 14.914062 13.15625 14.78125 C 12.855469 14.628906 11.894531 14.316406 10.757812 13.296875 C 9.875 12.503906 9.28125 11.53125 9.105469 11.230469 C 8.8125 10.726562 9.421875 10.652344 9.980469 9.597656 C 10.078125 9.390625 10.027344 9.226562 9.953125 9.074219 C 9.878906 8.925781 9.285156 7.457031 9.035156 6.875 C 8.796875 6.289062 8.550781 6.363281 8.367188 6.363281 C 7.792969 6.3125 7.371094 6.320312 7 6.707031 C 5.390625 8.480469 5.796875 10.304688 7.175781 12.25 C 9.878906 15.796875 11.324219 16.449219 13.957031 17.355469 C 14.671875 17.582031 15.320312 17.550781 15.832031 17.476562 C 16.40625 17.386719 17.59375 16.753906 17.84375 16.050781 C 18.097656 15.347656 18.097656 14.765625 18.023438 14.628906 C 17.949219 14.496094 17.753906 14.417969 17.453125 14.285156 Z M 17.453125 14.285156 " }),
          /* @__PURE__ */ c("g", { clipPath: "url(#clip1)", clipRule: "nonzero", children: /* @__PURE__ */ c("path", { d: "M 20.457031 3.445312 C 12.792969 -3.976562 0.105469 1.40625 0.101562 11.875 C 0.101562 13.96875 0.648438 16.007812 1.691406 17.808594 L 0 23.960938 L 6.316406 22.3125 C 14.195312 26.578125 23.921875 20.914062 23.925781 11.878906 C 23.925781 8.710938 22.691406 5.726562 20.441406 3.484375 Z M 21.933594 11.847656 C 21.929688 19.46875 13.574219 24.226562 6.96875 20.339844 L 6.609375 20.125 L 2.871094 21.097656 L 3.875 17.457031 L 3.636719 17.085938 C -0.476562 10.53125 4.246094 1.964844 12.035156 1.964844 C 14.679688 1.964844 17.164062 2.996094 19.035156 4.867188 C 20.902344 6.722656 21.933594 9.210938 21.933594 11.847656 Z M 21.933594 11.847656 " }) })
        ] })
      ]
    }
  );
}
function Eu(t) {
  return /* @__PURE__ */ c(
    "svg",
    {
      width: "21",
      height: "15",
      viewBox: "0 0 21 15",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ c("path", { d: "M19.607 2.20301C19.4931 1.78041 19.2705 1.39501 18.9614 1.08521C18.6523 0.775308 18.2674 0.551908 17.845 0.437008C16.279 0.00700787 10.014 7.59499e-06 10.014 7.59499e-06C10.014 7.59499e-06 3.74998 -0.00699213 2.18298 0.404008C1.76088 0.524208 1.37678 0.750808 1.06758 1.06211C0.758282 1.37351 0.534281 1.75911 0.416981 2.18201C0.00400126 3.74801 1.46519e-06 6.99601 1.46519e-06 6.99601C1.46519e-06 6.99601 -0.00399843 10.26 0.405982 11.81C0.635982 12.667 1.31098 13.344 2.16898 13.575C3.75098 14.005 9.99898 14.012 9.99898 14.012C9.99898 14.012 16.264 14.019 17.83 13.609C18.2525 13.4943 18.6378 13.2714 18.9477 12.9622C19.2576 12.653 19.4814 12.2682 19.597 11.846C20.011 10.281 20.014 7.03401 20.014 7.03401C20.014 7.03401 20.034 3.76901 19.607 2.20301ZM8.00998 10.005L8.01498 4.00501L13.222 7.01001L8.00998 10.005Z" })
    }
  );
}
const Ie = "w-[20px] h-[20px] shrink-0", ct = (t, e) => {
  switch (t) {
    case Ee.instagram:
      return /* @__PURE__ */ c(gu, { className: fe(Ie, e) });
    case Ee.pinterest:
      return /* @__PURE__ */ c(yu, { className: fe(Ie, e) });
    case Ee.telegram:
      return /* @__PURE__ */ c(Cu, { className: fe(Ie, e) });
    case Ee.vimeo:
      return /* @__PURE__ */ c(Su, { className: fe(Ie, e) });
    case Ee.twitter:
      return /* @__PURE__ */ c(ku, { className: fe(Ie, e) });
    case Ee.facebook:
      return /* @__PURE__ */ c(hu, { className: fe(Ie, e) });
    case Ee.spotify:
      return /* @__PURE__ */ c(bu, { className: fe(Ie, e) });
    case Ee.linkedin:
      return /* @__PURE__ */ c(_u, { className: fe(Ie, e) });
    case Ee.youtube:
      return /* @__PURE__ */ c(Eu, { className: fe(Ie, e) });
    case Ee.tiktok:
      return /* @__PURE__ */ c(wu, { className: fe(Ie, e) });
    case Ee.discord:
      return /* @__PURE__ */ c(pu, { className: fe(Ie, e) });
    case Ee.etsy:
      return /* @__PURE__ */ c(fu, { className: fe(Ie, e) });
    case Ee.snapchat:
      return /* @__PURE__ */ c(vu, { className: fe(Ie, e) });
    case Ee.website:
      return /* @__PURE__ */ c(gi, { className: fe(Ie, e) });
    case Ee.twitch:
      return /* @__PURE__ */ c(xu, { className: fe(Ie, e) });
    case Ee.email:
      return /* @__PURE__ */ c(mu, { className: fe(Ie, e) });
    case Ee.whatsapp:
      return /* @__PURE__ */ c(Pu, { className: fe(Ie, e) });
    default:
      return /* @__PURE__ */ c(gi, { className: fe(Ie, e) });
  }
}, Lu = ({ profile: t, socialLinks: e }) => {
  const { locale: n } = _e();
  return /* @__PURE__ */ L(
    "div",
    {
      style: {
        backgroundImage: `url(${Ro}/images/profile-background/luminous-profile-background.png)`
      },
      className: "bg-THEME-secondary shadow-around-sm flex w-full flex-col items-center justify-center gap-5 rounded-none p-10 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ c(
          Ge,
          {
            width: 96,
            height: 96,
            imageType: ie.profile,
            alt: t.sellerName,
            thumbnail: t.sellerPhoto,
            className: "border-THEME-primary rounded-full border-2 object-cover"
          }
        ),
        /* @__PURE__ */ L("div", { className: "flex flex-col items-center justify-center gap-3", children: [
          /* @__PURE__ */ c("h1", { lang: n, className: "text-THEME-primary break-all text-center text-2xl font-bold", children: t.sellerName }),
          /* @__PURE__ */ c("span", { lang: n, className: "hyphens-auto text-center text-[16px] font-normal ", children: t.bio })
        ] }),
        !!e.length && /* @__PURE__ */ c("div", { className: "flex flex-wrap items-center justify-center gap-1.5", children: e.map((r) => /* @__PURE__ */ c(
          "a",
          {
            href: lt(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-1",
            children: ct(r.type, "fill-THEME-text-secondary")
          },
          r.type
        )) })
      ]
    }
  );
}, Tu = ({ profile: t, socialLinks: e }) => {
  const { locale: n } = _e();
  return /* @__PURE__ */ L(
    "div",
    {
      className: "bg-THEME-secondary shadow-around-sm flex w-full flex-col items-center justify-center gap-5 rounded-none px-5 py-10 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ c(
          Ge,
          {
            imageType: ie.profile,
            alt: t.sellerName,
            thumbnail: t.sellerPhoto,
            className: "border-THEME-primary rounded-full border-2 object-cover"
          }
        ),
        /* @__PURE__ */ L("div", { className: "flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ c("h1", { lang: n, className: "text-text-primary break-all text-center text-2xl font-bold", children: t.sellerName }),
          /* @__PURE__ */ c("span", { lang: n, className: "hyphens-auto text-center text-lg font-medium", children: t.bio })
        ] }),
        !!e.length && /* @__PURE__ */ c("div", { className: "flex flex-wrap items-center justify-center gap-1.5", children: e.map((r) => /* @__PURE__ */ c(
          "a",
          {
            href: lt(r),
            target: "_blank",
            rel: "noreferrer",
            className: "border-text-secondary/30 rounded-md border p-1",
            children: ct(r.type, "fill-THEME-primary")
          },
          r.type
        )) })
      ]
    }
  );
}, Nu = ({ profile: t, socialLinks: e }) => {
  const { locale: n } = _e();
  return /* @__PURE__ */ L(
    "div",
    {
      style: {
        backgroundImage: t.sellerPhoto ? `url(${t.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[500px] w-full flex-col items-center justify-end gap-5 overflow-hidden rounded-none bg-cover bg-center px-10 pb-10 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !t.sellerPhoto && /* @__PURE__ */ c(
          Ge,
          {
            width: 500,
            height: 500,
            alt: t.sellerName,
            imageType: ie.profile,
            className: "-z-1 absolute top-0 w-full "
          }
        ),
        /* @__PURE__ */ L("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ c(
            "h1",
            {
              lang: n,
              className: "text-THEME-primary break-all text-center text-[40px] font-bold leading-[50px]",
              children: t.sellerName
            }
          ),
          /* @__PURE__ */ c(
            "span",
            {
              lang: n,
              className: "hyphens-auto text-center text-lg font-normal text-[#FAFAFA]",
              children: t.bio
            }
          )
        ] }),
        !!e.length && /* @__PURE__ */ c("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: e.map((r) => /* @__PURE__ */ c(
          "a",
          {
            href: lt(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-1",
            children: ct(r.type, "fill-THEME-text-secondary")
          },
          r.type
        )) }),
        /* @__PURE__ */ c(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-[300px] w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
}, Mu = ({ profile: t, socialLinks: e }) => {
  const { locale: n } = _e();
  return /* @__PURE__ */ c("div", { className: "flex w-full max-w-xl flex-col gap-5 px-5 py-10 sm:px-0", children: /* @__PURE__ */ L("div", { className: "flex flex-row gap-5", children: [
    /* @__PURE__ */ c("div", { className: "border-3 border-THEME-primary self-start rounded-full", children: /* @__PURE__ */ c(
      Ge,
      {
        width: 99,
        height: 99,
        imageType: ie.profile,
        alt: t.sellerName,
        thumbnail: t.sellerPhoto,
        className: "rounded-full border-2 border-transparent object-cover"
      }
    ) }),
    /* @__PURE__ */ L("div", { className: "flex flex-col justify-between", children: [
      /* @__PURE__ */ c(
        "h1",
        {
          lang: n,
          className: "text-THEME-primary mb-1 break-all text-[22px] font-bold leading-7",
          children: t.sellerName
        }
      ),
      /* @__PURE__ */ c("span", { lang: n, className: "hyphens-auto mb-2.5 text-[14px] font-normal leading-4", children: t.bio }),
      !!e.length && /* @__PURE__ */ c("div", { className: "flex flex-wrap items-start gap-1.5", children: e.map((r) => /* @__PURE__ */ c(
        "a",
        {
          href: lt(r),
          target: "_blank",
          rel: "noreferrer",
          className: "rounded-full bg-[#F1F4F8] p-2",
          children: ct(r.type, "fill-THEME-primary")
        },
        r.type
      )) })
    ] })
  ] }) });
}, Ou = ({ profile: t, socialLinks: e }) => {
  const { locale: n } = _e();
  return /* @__PURE__ */ L(
    "div",
    {
      className: "flex w-full flex-col items-center justify-center gap-5 px-5 py-10 sm:max-w-xl sm:px-0",
      children: [
        /* @__PURE__ */ c(
          Ge,
          {
            width: 200,
            height: 200,
            alt: t.sellerName,
            imageType: ie.profile,
            thumbnail: t.sellerPhoto,
            className: "rounded-full object-cover"
          }
        ),
        /* @__PURE__ */ L(
          "div",
          {
            className: "z-1 flex flex-col items-center justify-center gap-4 text-center font-normal",
            children: [
              /* @__PURE__ */ c("h1", { lang: n, className: "text-THEME-primary break-all text-[48px] leading-[62px]", children: t.sellerName }),
              /* @__PURE__ */ c("span", { lang: n, className: "hyphens-auto text-[18px] leading-[27px] text-[#242424]", children: t.bio }),
              !!e.length && /* @__PURE__ */ c("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: e.map((r) => /* @__PURE__ */ c(
                "a",
                {
                  href: lt(r),
                  target: "_blank",
                  rel: "noreferrer",
                  className: "p-1",
                  children: ct(r.type, "fill-[#242424] ")
                },
                r.type
              )) })
            ]
          }
        )
      ]
    }
  );
}, Ru = ({ profile: t, socialLinks: e }) => {
  const { locale: n } = _e();
  return /* @__PURE__ */ c("div", { className: "flex w-full max-w-xl flex-col gap-5 px-5 py-10 sm:px-0", children: /* @__PURE__ */ L("div", { className: "flex flex-row gap-5", children: [
    /* @__PURE__ */ c("div", { className: "border-3 border-THEME-primary self-start rounded-full", children: /* @__PURE__ */ c(
      Ge,
      {
        width: 99,
        height: 99,
        imageType: ie.profile,
        alt: t.sellerName,
        thumbnail: t.sellerPhoto,
        className: "rounded-full border-2 border-transparent object-cover"
      }
    ) }),
    /* @__PURE__ */ L("div", { className: "flex flex-col justify-center", children: [
      /* @__PURE__ */ c(
        "h1",
        {
          lang: n,
          className: "text-THEME-primary mb-1 break-all text-[22px] font-bold leading-7",
          children: t.sellerName
        }
      ),
      /* @__PURE__ */ c("span", { lang: n, className: "hyphens-auto mb-2.5 text-[14px] font-normal leading-4", children: t.bio }),
      !!e.length && /* @__PURE__ */ c("div", { className: "flex flex-wrap items-start gap-1.5", children: e.map((r) => /* @__PURE__ */ c(
        "a",
        {
          href: lt(r),
          target: "_blank",
          rel: "noreferrer",
          className: "bg-THEME-secondary rounded-full p-2",
          children: ct(r.type, "fill-THEME-primary")
        },
        r.type
      )) })
    ] })
  ] }) });
}, Au = ({ profile: t, socialLinks: e }) => {
  const { locale: n } = _e();
  return /* @__PURE__ */ L(
    "div",
    {
      style: {
        backgroundImage: t.sellerPhoto ? `url(${t.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[500px] w-full flex-col items-center justify-end gap-4 overflow-hidden rounded-none bg-cover bg-center px-10 pb-8 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !t.sellerPhoto && /* @__PURE__ */ c(
          Ge,
          {
            width: 500,
            height: 500,
            alt: t.sellerName,
            imageType: ie.profile,
            className: "-z-1 absolute top-0 w-full"
          }
        ),
        /* @__PURE__ */ L("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ c("h1", { lang: n, className: "break-all text-center text-[28px] font-bold leading-[36px]", children: t.sellerName }),
          /* @__PURE__ */ c(
            "span",
            {
              lang: n,
              className: "hyphens-auto text-center text-base font-normal text-[#F1F4F8]",
              children: t.bio
            }
          )
        ] }),
        !!e.length && /* @__PURE__ */ c("div", { className: "z-1 flex flex-wrap items-center justify-center gap-4", children: e.map((r) => /* @__PURE__ */ c(
          "a",
          {
            href: lt(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-0.5",
            children: ct(r.type, "fill-THEME-primary")
          },
          r.type
        )) }),
        /* @__PURE__ */ c(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-[300px] w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
}, zu = ({ profile: t, socialLinks: e }) => {
  const { locale: n } = _e();
  return /* @__PURE__ */ L(
    "div",
    {
      style: {
        backgroundImage: t.sellerPhoto ? `url(${t.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[520px] w-full flex-col items-center justify-end gap-4 overflow-hidden rounded-none bg-cover bg-center px-10 pb-12 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !t.sellerPhoto && /* @__PURE__ */ c(
          Ge,
          {
            width: 500,
            height: 520,
            alt: t.sellerName,
            imageType: ie.profile,
            className: "-z-1 absolute top-0 w-full"
          }
        ),
        /* @__PURE__ */ L("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ c(
            "h1",
            {
              lang: n,
              className: "mb-2 break-all text-center text-[40px] font-bold leading-[50px]",
              children: t.sellerName
            }
          ),
          /* @__PURE__ */ c(
            "span",
            {
              lang: n,
              className: "hyphens-auto mb-4 text-center text-lg font-normal text-[#FAFAFA]",
              children: t.bio
            }
          )
        ] }),
        !!e.length && /* @__PURE__ */ c("div", { className: "z-1 flex flex-wrap items-center justify-center gap-6", children: e.map((r) => /* @__PURE__ */ c(
          "a",
          {
            href: lt(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-0.5",
            children: ct(r.type, "fill-[#FAFAFA]")
          },
          r.type
        )) }),
        /* @__PURE__ */ c(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-full w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
}, Du = ({ profile: t, socialLinks: e }) => {
  const { locale: n } = _e();
  return /* @__PURE__ */ L(
    "div",
    {
      style: {
        backgroundImage: `linear-gradient(to top, rgba(5, 0, 33, 1) 0%, rgba(6, 1, 36, 0.64) 100%), 
          url(${Ro}/images/profile-background/urban-profile-background.jpeg)`
      },
      className: "flex min-h-[500px] w-full flex-col items-center justify-center gap-20 bg-cover bg-center px-5 py-12 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ c("div", { className: "border-3 border-THEME-secondary rounded-full", children: /* @__PURE__ */ c(
          Ge,
          {
            className: "rounded-full border-0 border-transparent",
            width: 149,
            height: 149,
            alt: t.sellerName,
            imageType: ie.profile,
            thumbnail: t.sellerPhoto
          }
        ) }),
        /* @__PURE__ */ L("div", { className: "flex flex-col items-center", children: [
          /* @__PURE__ */ c(
            "h1",
            {
              lang: n,
              className: "text-THEME-primary mb-2 break-all text-center text-[40px] font-bold leading-[50.4px]",
              children: t.sellerName
            }
          ),
          /* @__PURE__ */ c(
            "span",
            {
              lang: n,
              className: "text-THEME-secondary hyphens-auto mb-4 text-center text-lg font-normal",
              children: t.bio
            }
          ),
          !!e.length && /* @__PURE__ */ c("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: e.map((r) => /* @__PURE__ */ c(
            "a",
            {
              href: lt(r),
              target: "_blank",
              rel: "noreferrer",
              className: "rounded-md p-1",
              children: ct(r.type, "fill-THEME-secondary")
            },
            r.type
          )) })
        ] })
      ]
    }
  );
}, Iu = ({ profile: t, socialLinks: e }) => {
  const { locale: n } = _e();
  return /* @__PURE__ */ c(
    "div",
    {
      className: "mx-5 w-full overflow-hidden py-9 sm:max-w-xl ",
      style: { width: "calc(100% - 2.5rem)" },
      children: /* @__PURE__ */ L("div", { className: "border-THEME-primary/50 relative flex rounded-b-lg border-2 border-t-0", children: [
        /* @__PURE__ */ c("div", { className: "border-THEME-primary absolute -left-[15%] top-[20%] -z-10 h-[60%] w-[130%] rounded-t-full border-[15px] border-b-0 blur-[20px] sm:-left-[15%] sm:top-[25%] sm:h-[65%] sm:w-[130%]" }),
        /* @__PURE__ */ c("div", { className: "from-THEME-primary/30 to -z-1 absolute -inset-x-[1px] -bottom-[0.5px] top-0 rounded-b-lg bg-gradient-to-t to-transparent opacity-70" }),
        /* @__PURE__ */ c("div", { className: "border-THEME-tertiary absolute inset-y-0 -left-[3px] bottom-[3px] z-0 border-l-4" }),
        /* @__PURE__ */ c(
          "div",
          {
            className: "z-1 absolute inset-y-0 -left-[2px] bottom-[3px] border-l-2 opacity-50 md:-left-[1.5px]",
            style: {
              borderImage: "linear-gradient(to bottom, transparent, var(--THEME-primary)) 2"
            }
          }
        ),
        /* @__PURE__ */ c("div", { className: "border-THEME-tertiary absolute inset-y-0 -right-[3px] bottom-[3px] z-0 border-l-4" }),
        /* @__PURE__ */ c(
          "div",
          {
            className: "z-1 absolute inset-y-0 -right-[1.5px] bottom-[3px] border-l-2 opacity-50",
            style: {
              borderImage: "linear-gradient(to bottom, transparent, var(--THEME-primary)) 2"
            }
          }
        ),
        /* @__PURE__ */ L("div", { className: "flex w-full flex-col items-center justify-end gap-10 px-5 py-9", children: [
          /* @__PURE__ */ c("div", { className: "border-THEME-primary rounded-full border-[15px]", children: /* @__PURE__ */ c(
            Ge,
            {
              className: "rounded-full border-0 border-transparent",
              width: 149,
              height: 149,
              alt: t.sellerName,
              imageType: ie.profile,
              thumbnail: t.sellerPhoto
            }
          ) }),
          /* @__PURE__ */ L("div", { className: "flex flex-col items-center", children: [
            /* @__PURE__ */ c(
              "h1",
              {
                lang: n,
                className: "text-THEME-text-primary break-all text-center text-[35px] font-bold leading-[45.57px]",
                children: t.sellerName
              }
            ),
            t.bio && /* @__PURE__ */ c(
              "span",
              {
                lang: n,
                className: "text-THEME-text-primary hyphens-auto mb-4 mt-2 text-center text-lg font-normal",
                children: t.bio
              }
            ),
            !!e.length && /* @__PURE__ */ c("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1", children: e.map((r) => /* @__PURE__ */ c(
              "a",
              {
                href: lt(r),
                target: "_blank",
                rel: "noreferrer",
                className: "rounded-md p-1",
                children: ct(r.type, "fill-THEME-text-primary")
              },
              r.type
            )) })
          ] })
        ] })
      ] })
    }
  );
}, ju = ({ profile: t, socialLinks: e }) => {
  var r;
  const { locale: n } = _e();
  return /* @__PURE__ */ c(
    "div",
    {
      style: {
        backgroundImage: (r = t.sellerPhoto) != null && r.path ? `url(${t.sellerPhoto.path})` : void 0
      },
      className: " bg-center-left w-full overflow-hidden bg-contain bg-no-repeat sm:max-w-xl sm:rounded-lg sm:bg-[length:50%_120%]",
      children: /* @__PURE__ */ L(
        "div",
        {
          className: `
          from-THEME-primary min-[460px]:from-78% from-70% min-[460px]:bg-[length:78%] min-[500px]:from-80% min-[500px]:bg-[length:80%] sm:from-70% flex
          min-h-[215px] bg-gradient-to-l 
          to-[transparent] bg-[length:70%] 
          bg-right bg-no-repeat 
          p-5 sm:bg-[length:73%]
        `,
          children: [
            !t.sellerPhoto && /* @__PURE__ */ c("div", { className: "border-3 border-THEME-primary my-auto rounded-full", children: /* @__PURE__ */ c(
              Ge,
              {
                className: "rounded-full border-0 border-transparent",
                width: 104,
                height: 104,
                alt: t.sellerName,
                imageType: ie.profile,
                thumbnail: t.sellerPhoto
              }
            ) }),
            /* @__PURE__ */ L("div", { className: "my-auto ml-auto flex w-[60%] flex-col", children: [
              /* @__PURE__ */ c(
                "h1",
                {
                  lang: n,
                  className: "text-THEME-text-primary mb-1 break-all text-left text-[22px] font-medium leading-[26.82px]",
                  children: t.sellerName
                }
              ),
              /* @__PURE__ */ c(
                "span",
                {
                  lang: n,
                  className: "text-THEME-text-primary hyphens-auto mb-2.5 text-left text-lg font-normal",
                  children: t.bio
                }
              ),
              !!e.length && /* @__PURE__ */ c("div", { className: "justify-left z-1 flex flex-wrap items-center gap-1.5", children: e.map((a) => /* @__PURE__ */ c(
                "a",
                {
                  href: lt(a),
                  target: "_blank",
                  rel: "noreferrer",
                  className: "bg-THEME-secondary rounded-full p-2",
                  children: ct(a.type, "fill-THEME-primary")
                },
                a.type
              )) })
            ] })
          ]
        }
      )
    }
  );
}, Fu = (t) => {
  const {
    state: { theme: e }
  } = qe();
  switch (e) {
    case de.luminous:
      return /* @__PURE__ */ c(Lu, { ...t });
    case de.camilla:
      return /* @__PURE__ */ c(Nu, { ...t });
    case de.night:
      return /* @__PURE__ */ c(Mu, { ...t });
    case de.creamy:
      return /* @__PURE__ */ c(Ou, { ...t });
    case de.sepia:
      return /* @__PURE__ */ c(Ru, { ...t });
    case de.solarized:
      return /* @__PURE__ */ c(Au, { ...t });
    case de.new_york:
      return /* @__PURE__ */ c(zu, { ...t });
    case de.urban:
      return /* @__PURE__ */ c(Du, { ...t });
    case de.cyberpunk:
      return /* @__PURE__ */ c(Iu, { ...t });
    case de.cosmopolitan:
      return /* @__PURE__ */ c(ju, { ...t });
    case de.default:
    default:
      return /* @__PURE__ */ c(Tu, { ...t });
  }
}, J3 = {
  type: ht.link,
  url: "",
  title: "Check it out!",
  subTitle: `Visit my Affiliate Link \r
and get a DISCOUNT!`,
  buttonTitle: "Click Me!",
  thumbnail: null
}, X3 = {
  type: ht.optin,
  title: "Subscribe to our newsletter",
  subTitle: `Get the latest news and updates \r
from our store!`,
  buttonTitle: "Subscribe",
  fields: [],
  thumbnail: null,
  thankYouPage: {
    title: "Thank you!",
    text: `Thank you for your subscription! \r
And have a good day!`
  }
}, Q3 = {
  type: ht.product,
  productType: et.download,
  title: "Check it out!",
  subTitle: `Check it out! \r
and get a DISCOUNT!`,
  buttonTitle: "Click Me!",
  thumbnail: null,
  checkoutPage: {}
}, e5 = {
  type: ht.product,
  productType: et.eCourse,
  title: "My 12-week Program!",
  subTitle: "A 2-line course summary to close the sale. What will they learn?",
  buttonTitle: "GET MY COURSE",
  thumbnail: null,
  checkoutPage: {}
}, t5 = {
  type: ht.product,
  productType: et.physicalProduct,
  title: "My Physical Product!",
  subTitle: "My Physical Product subtitle",
  buttonTitle: "BUY NOW",
  thumbnail: null,
  checkoutPage: {}
}, on = ({
  affiliateLink: t
}) => {
  const { locale: e } = _e(), n = /* @__PURE__ */ c(
    "img",
    {
      alt: "Systeme.io",
      src: `${ya}/images/affiliate-badge/badge-${e}.svg`
    }
  );
  return /* @__PURE__ */ c("div", { className: "fixed bottom-1 right-1 z-[3]", children: t ? /* @__PURE__ */ c("a", { href: t, target: "_blank", rel: "noopener noreferrer", children: n }) : n });
}, r5 = ({
  profile: t,
  socialLinks: e,
  items: n,
  affiliateLink: r,
  displayAffiliateLink: a
}) => /* @__PURE__ */ c(va, { children: /* @__PURE__ */ L("div", { className: fe(Do, "relative mb-5 sm:mt-5"), children: [
  /* @__PURE__ */ c(Fu, { profile: t, socialLinks: e }),
  n.map((i, o) => /* @__PURE__ */ c(ll, { children: du(i) }, o)),
  a && /* @__PURE__ */ c(on, { affiliateLink: r })
] }) }), n5 = ({
  thankYouPage: { title: t, text: e },
  affiliateLink: n,
  displayAffiliateLink: r
}) => {
  const { isDefaultTheme: a } = qe();
  return /* @__PURE__ */ c(an, { children: /* @__PURE__ */ L("div", { className: "relative flex flex-col justify-center gap-5", children: [
    /* @__PURE__ */ c(
      "h1",
      {
        className: De(
          "self-center text-center text-4xl",
          a ? "text-text-primary" : "text-THEME-primary"
        ),
        children: t
      }
    ),
    /* @__PURE__ */ c("p", { className: "whitespace-pre-wrap text-center text-lg", children: e }),
    r && /* @__PURE__ */ c(on, { affiliateLink: n })
  ] }) });
}, jo = ({ children: t }) => {
  const {
    state: { tertiaryColor: e }
  } = qe();
  return /* @__PURE__ */ c(
    "div",
    {
      className: De(
        "bg-THEME-secondary relative w-full rounded-none border pb-5 sm:mb-5 sm:mt-5 sm:max-w-xl sm:rounded-lg sm:pb-0",
        Ao(e) ? "sm:shadow-around-sm border-transparent" : "sm:border-THEME-border-tertiary border-transparent"
      ),
      children: t
    }
  );
}, Fo = ({ paymentMethod: t }) => /* @__PURE__ */ c("div", { className: "[&>svg]:fill-THEME-primary/70", children: dl(t, { className: "w-5 h-5" }) }), Vu = "pk_test_O3PjYFYA7hqkDM12lU32xgRT";
function Dr(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Dr = function(e) {
    return typeof e;
  } : Dr = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Dr(t);
}
var Vo = "https://js.stripe.com/v3", Hu = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, _i = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used", $u = function() {
  for (var e = document.querySelectorAll('script[src^="'.concat(Vo, '"]')), n = 0; n < e.length; n++) {
    var r = e[n];
    if (Hu.test(r.src))
      return r;
  }
  return null;
}, yi = function(e) {
  var n = e && !e.advancedFraudSignals ? "?advancedFraudSignals=false" : "", r = document.createElement("script");
  r.src = "".concat(Vo).concat(n);
  var a = document.head || document.body;
  if (!a)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return a.appendChild(r), r;
}, Bu = function(e, n) {
  !e || !e._registerWrapper || e._registerWrapper({
    name: "stripe-js",
    version: "4.6.0",
    startTime: n
  });
}, tr = null, Cr = null, wr = null, Ku = function(e) {
  return function() {
    e(new Error("Failed to load Stripe.js"));
  };
}, Uu = function(e, n) {
  return function() {
    window.Stripe ? e(window.Stripe) : n(new Error("Stripe.js not available"));
  };
}, qu = function(e) {
  return tr !== null ? tr : (tr = new Promise(function(n, r) {
    if (typeof window > "u" || typeof document > "u") {
      n(null);
      return;
    }
    if (window.Stripe && e && console.warn(_i), window.Stripe) {
      n(window.Stripe);
      return;
    }
    try {
      var a = $u();
      if (a && e)
        console.warn(_i);
      else if (!a)
        a = yi(e);
      else if (a && wr !== null && Cr !== null) {
        var i;
        a.removeEventListener("load", wr), a.removeEventListener("error", Cr), (i = a.parentNode) === null || i === void 0 || i.removeChild(a), a = yi(e);
      }
      wr = Uu(n, r), Cr = Ku(r), a.addEventListener("load", wr), a.addEventListener("error", Cr);
    } catch (o) {
      r(o);
      return;
    }
  }), tr.catch(function(n) {
    return tr = null, Promise.reject(n);
  }));
}, Gu = function(e, n, r) {
  if (e === null)
    return null;
  var a = e.apply(void 0, n);
  return Bu(a, r), a;
}, vi = function(e) {
  var n = `invalid load parameters; expected object of shape

    {advancedFraudSignals: boolean}

but received

    `.concat(JSON.stringify(e), `
`);
  if (e === null || Dr(e) !== "object")
    throw new Error(n);
  if (Object.keys(e).length === 1 && typeof e.advancedFraudSignals == "boolean")
    return e;
  throw new Error(n);
}, Ir, Yn = !1, Ho = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  Yn = !0;
  var a = Date.now();
  return qu(Ir).then(function(i) {
    return Gu(i, n, a);
  });
};
Ho.setLoadParameters = function(t) {
  if (Yn && Ir) {
    var e = vi(t), n = Object.keys(e), r = n.reduce(function(a, i) {
      var o;
      return a && t[i] === ((o = Ir) === null || o === void 0 ? void 0 : o[i]);
    }, !0);
    if (r)
      return;
  }
  if (Yn)
    throw new Error("You cannot change load parameters after calling loadStripe");
  Ir = vi(t);
};
const $o = pr(void 0);
function Wu() {
  const t = vt($o);
  if (!t) throw new Error("useStripeProvider must be used within a StripeContext.Provider");
  return t;
}
function a5({
  children: t,
  publishableKey: e,
  stripeAccountId: n,
  forceLoad: r
}) {
  const [a, i] = Te(null), { paymentMethod: o } = tt(), s = tn(
    () => o === le.stripe_ideal || o === le.stripe_card || o === le.stripe_bancontact || r,
    [r, o]
  );
  return Ve(() => {
    s && n && i(
      Ho(e || Vu, {
        stripeAccount: n
      })
    );
  }, [e, s, n]), /* @__PURE__ */ c(
    $o.Provider,
    {
      value: {
        stripePromise: a
      },
      children: t
    }
  );
}
const $e = {
  offer: [],
  customer: { fields: {} },
  page: [],
  digitalProduct: [],
  purchaseProductModel: [],
  pricePlan: [],
  thankYouPageUrl: [],
  failedReturnUrl: [],
  paymentMethod: [],
  common: []
}, Pt = async (t, e) => Kt.post("/api/purchase-service/buy-offer", t, {
  headers: {
    "accept-language": e
  }
});
function Zu({
  isFetching: t,
  buttonTitle: e,
  setErrors: n,
  setIsFetching: r,
  preSubmit: a,
  handleBadRequest: i,
  hasErrors: o,
  buttonDisabled: s
}) {
  const { locale: l } = _e(), d = async (u) => {
    u.preventDefault();
    try {
      r(!0), n($e);
      const p = a();
      if (!p) throw new Error();
      const { redirect: m } = await Pt(p, l);
      m && (window.location.href = m);
    } catch (p) {
      p instanceof _t && i(p);
    } finally {
      r(!1);
    }
  };
  return /* @__PURE__ */ c(
    it,
    {
      disabled: s,
      className: De("main-transition-colors", o && "bg-danger focus:bg-danger"),
      onClick: d,
      isFetching: t,
      type: "submit",
      children: e
    }
  );
}
const Yu = (t, e) => Pt(t, e), Ju = ({ threeDsInfo: t, opened: e, onComplete: n }) => {
  const r = Ot(null);
  return Ve(() => {
    if (!e) return;
    const a = (i) => {
      i.origin === "https://api.mercadopago.com" && i.data.status === "COMPLETE" && n();
    };
    return window.addEventListener("message", a), () => window.removeEventListener("message", a);
  }, [e, n]), Ve(() => {
    e && r.current && r.current.requestSubmit();
  }, [e]), /* @__PURE__ */ c(
    uo,
    {
      id: "three-ds-modal",
      size: ol.small,
      title: "",
      isFetching: !0,
      opened: e,
      onClose: () => {
      },
      closeIconClassName: "hidden",
      closeIconWrapperClassName: "hidden",
      contentClassName: "flex justify-center min-h-[500px]",
      children: /* @__PURE__ */ c("iframe", { name: "mercado-3ds-iframe", id: "mercado-3ds-iframe", title: "Mercado Pago 3DS iframe", children: /* @__PURE__ */ c(
        "form",
        {
          name: "mercado-3ds-form",
          target: "mercado-3ds-iframe",
          method: "post",
          action: t.external_resource_url,
          ref: r,
          children: /* @__PURE__ */ c("input", { type: "hidden", name: "creq", value: t.creq })
        }
      ) })
    }
  );
};
function Xu({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o
}) {
  const { locale: s } = _e(), [l, d] = Te(!1), [u, p] = Te(), [m, _] = Te(), y = (g) => {
    window.location.assign(g);
  };
  return /* @__PURE__ */ L(St, { children: [
    /* @__PURE__ */ c(
      it,
      {
        disabled: n,
        type: "submit",
        onClick: async (g) => {
          g.preventDefault(), a(!0), r($e);
          try {
            const b = i();
            if (!b) throw new Error("Request data is undefined");
            const v = await window.cardPaymentBrickController.getFormData(), x = await Yu(
              {
                ...b,
                options: {
                  token: v.token,
                  mercadoPagoPaymentMethod: v.payment_method_id,
                  installments: v.installments
                }
              },
              s
            );
            if (x.threeDsInfo) {
              _(x.threeDsInfo), p(x.redirect), d(!0);
              return;
            }
            y(x.redirect);
          } catch (b) {
            b instanceof _t && o(b);
          } finally {
            a(!1);
          }
        },
        isFetching: t,
        children: e
      }
    ),
    m && /* @__PURE__ */ c(
      Ju,
      {
        opened: l,
        onComplete: () => {
          d(!1), u && y(u);
        },
        threeDsInfo: m
      }
    )
  ] });
}
const Qu = fo();
async function ed(t) {
  const e = await Qu.get(t, {
    maxRedirects: 0
    // Prevent axios from automatically following redirects
  });
  if (e.status === 200) {
    window.location.assign(e.data.options.paypalLink);
    return;
  }
  if (e.status >= 300 && e.status < 400) {
    const n = e.headers.location;
    if (n) {
      window.location.assign(n);
      return;
    }
  }
  throw new Error("No redirect URL found");
}
function td({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o,
  hasErrors: s
}) {
  const { locale: l } = _e(), d = async (u) => {
    u.preventDefault();
    try {
      a(!0), r($e);
      const p = i();
      if (!p) throw new Error();
      const { redirect: m } = await Pt(p, l);
      await ed(m);
    } catch (p) {
      p instanceof _t && o(p), console.error(p);
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ c(
    it,
    {
      disabled: n,
      className: De("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: d,
      isFetching: t,
      type: "submit",
      children: e
    }
  );
}
function Bo(t, e, n) {
  const r = document.createElement("script");
  r.onload = n, r.id = e, r.src = t, document.head.appendChild(r);
}
function rd(t, e) {
  return new Promise((n, r) => {
    const a = e || document, i = a.createElement("script");
    i.src = t, i.onload = (o) => n(o), i.onerror = (o) => r(o), a.head.appendChild(i);
  });
}
const nd = () => {
  const t = typeof window < "u" && !!window.paypal, [e, n] = Te(!t);
  return Ve(() => {
    t || Bo(
      "https://www.paypalobjects.com/api/checkout.min.js",
      "paypal-js",
      () => n(!1)
    );
  }, [t]), {
    isScriptLoading: e
  };
};
function ad({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o
}) {
  const { locale: s } = _e(), { isScriptLoading: l } = nd();
  return /* @__PURE__ */ c(
    it,
    {
      onClick: async (u) => {
        var p, m, _, y;
        u.preventDefault(), a(!0), r($e);
        try {
          const f = i();
          if (!f) throw new Error("Request data is undefined");
          (p = window.paypal) == null || p.checkout.initXO();
          const { redirect: g, approvalUrl: b } = await Pt(f, s);
          if (!b) {
            (m = window.paypal) == null || m.checkout.closeFlow(), g && window.location.assign(g);
            return;
          }
          (_ = window.paypal) == null || _.checkout.startFlow(b);
        } catch (f) {
          f instanceof _t && o(f), (y = window.paypal) == null || y.checkout.closeFlow();
        } finally {
          a(!1);
        }
      },
      isFetching: t,
      disabled: l || n,
      type: "submit",
      children: e
    }
  );
}
const id = (t, e) => Pt(t, e), od = "https://checkout.razorpay.com/v1/checkout.js";
class sd {
  constructor(e) {
    hn(this, "options");
    hn(this, "razorpayInstance");
    this.options = e, typeof window < "u" && "Razorpay" in window && (this.razorpayInstance = new window.Razorpay(this.options));
  }
  on(e, n) {
    this.razorpayInstance.on(e, n);
  }
  open() {
    this.razorpayInstance.open();
  }
}
function ld() {
  const [t, e] = Te(!1), [n, r] = Te(!1), { currency: a, pricePlan: i, finalAmount: o } = tt(), {
    state: { primaryColor: s }
  } = qe(), l = function(d) {
    const u = {
      key: d.keyId,
      amount: o,
      currency: a == null ? void 0 : a.toUpperCase(),
      name: d.vendorName,
      description: i == null ? void 0 : i.name,
      prefill: {
        name: d.prefill.name,
        email: d.prefill.email,
        contact: d.prefill.phone
      },
      theme: {
        color: s
      },
      handler: async () => {
        window.location.assign(d.redirectUrl);
      }
    };
    if (d.rpOrderId)
      u.order_id = d.rpOrderId;
    else if (d.rpSubscriptionId)
      u.subscription_id = d.rpSubscriptionId;
    else
      throw Error("RP order id and subscription id is missing");
    return u;
  };
  return Ve(() => {
    const d = async () => {
      try {
        e(!0), await rd(od, document), r(!0);
      } catch (u) {
        xt.error(u.message);
      } finally {
        e(!1);
      }
    };
    "Razorpay" in window ? r(!0) : d();
  }, []), { Razorpay: sd, generateOptions: l, isRazorpayReady: n, isRazorpayFetching: t };
}
function cd({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  handleBadRequest: i,
  preSubmit: o
}) {
  const { locale: s } = _e(), { generateOptions: l, isRazorpayReady: d, Razorpay: u, isRazorpayFetching: p } = ld();
  return /* @__PURE__ */ c(
    it,
    {
      disabled: n,
      type: "submit",
      onClick: async (_) => {
        _.preventDefault(), a(!0), r($e);
        try {
          const y = o();
          if (!y) throw new Error("Request data is undefined");
          const f = await id(y, s), g = l(f);
          if (d)
            new u(g).open();
          else
            throw new Error("form submitted before razorpay was ready");
        } catch (y) {
          y instanceof _t && i(y);
        } finally {
          a(!1);
        }
      },
      isFetching: t || p,
      children: e
    }
  );
}
var xr = { exports: {} }, kr = { exports: {} }, ye = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bi;
function ud() {
  if (bi) return ye;
  bi = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, _ = t ? Symbol.for("react.memo") : 60115, y = t ? Symbol.for("react.lazy") : 60116, f = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
  function x(h) {
    if (typeof h == "object" && h !== null) {
      var P = h.$$typeof;
      switch (P) {
        case e:
          switch (h = h.type, h) {
            case l:
            case d:
            case r:
            case i:
            case a:
            case p:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case s:
                case u:
                case y:
                case _:
                case o:
                  return h;
                default:
                  return P;
              }
          }
        case n:
          return P;
      }
    }
  }
  function S(h) {
    return x(h) === d;
  }
  return ye.AsyncMode = l, ye.ConcurrentMode = d, ye.ContextConsumer = s, ye.ContextProvider = o, ye.Element = e, ye.ForwardRef = u, ye.Fragment = r, ye.Lazy = y, ye.Memo = _, ye.Portal = n, ye.Profiler = i, ye.StrictMode = a, ye.Suspense = p, ye.isAsyncMode = function(h) {
    return S(h) || x(h) === l;
  }, ye.isConcurrentMode = S, ye.isContextConsumer = function(h) {
    return x(h) === s;
  }, ye.isContextProvider = function(h) {
    return x(h) === o;
  }, ye.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, ye.isForwardRef = function(h) {
    return x(h) === u;
  }, ye.isFragment = function(h) {
    return x(h) === r;
  }, ye.isLazy = function(h) {
    return x(h) === y;
  }, ye.isMemo = function(h) {
    return x(h) === _;
  }, ye.isPortal = function(h) {
    return x(h) === n;
  }, ye.isProfiler = function(h) {
    return x(h) === i;
  }, ye.isStrictMode = function(h) {
    return x(h) === a;
  }, ye.isSuspense = function(h) {
    return x(h) === p;
  }, ye.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === r || h === d || h === i || h === a || h === p || h === m || typeof h == "object" && h !== null && (h.$$typeof === y || h.$$typeof === _ || h.$$typeof === o || h.$$typeof === s || h.$$typeof === u || h.$$typeof === g || h.$$typeof === b || h.$$typeof === v || h.$$typeof === f);
  }, ye.typeOf = x, ye;
}
var ve = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ci;
function dd() {
  return Ci || (Ci = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, _ = t ? Symbol.for("react.memo") : 60115, y = t ? Symbol.for("react.lazy") : 60116, f = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
    function x(k) {
      return typeof k == "string" || typeof k == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      k === r || k === d || k === i || k === a || k === p || k === m || typeof k == "object" && k !== null && (k.$$typeof === y || k.$$typeof === _ || k.$$typeof === o || k.$$typeof === s || k.$$typeof === u || k.$$typeof === g || k.$$typeof === b || k.$$typeof === v || k.$$typeof === f);
    }
    function S(k) {
      if (typeof k == "object" && k !== null) {
        var ue = k.$$typeof;
        switch (ue) {
          case e:
            var E = k.type;
            switch (E) {
              case l:
              case d:
              case r:
              case i:
              case a:
              case p:
                return E;
              default:
                var R = E && E.$$typeof;
                switch (R) {
                  case s:
                  case u:
                  case y:
                  case _:
                  case o:
                    return R;
                  default:
                    return ue;
                }
            }
          case n:
            return ue;
        }
      }
    }
    var h = l, P = d, F = s, G = o, W = e, H = u, B = r, U = y, Y = _, ee = n, Z = i, pe = a, ne = p, te = !1;
    function ce(k) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(k) || S(k) === l;
    }
    function A(k) {
      return S(k) === d;
    }
    function D(k) {
      return S(k) === s;
    }
    function N(k) {
      return S(k) === o;
    }
    function T(k) {
      return typeof k == "object" && k !== null && k.$$typeof === e;
    }
    function M(k) {
      return S(k) === u;
    }
    function V(k) {
      return S(k) === r;
    }
    function w(k) {
      return S(k) === y;
    }
    function $(k) {
      return S(k) === _;
    }
    function O(k) {
      return S(k) === n;
    }
    function J(k) {
      return S(k) === i;
    }
    function K(k) {
      return S(k) === a;
    }
    function oe(k) {
      return S(k) === p;
    }
    ve.AsyncMode = h, ve.ConcurrentMode = P, ve.ContextConsumer = F, ve.ContextProvider = G, ve.Element = W, ve.ForwardRef = H, ve.Fragment = B, ve.Lazy = U, ve.Memo = Y, ve.Portal = ee, ve.Profiler = Z, ve.StrictMode = pe, ve.Suspense = ne, ve.isAsyncMode = ce, ve.isConcurrentMode = A, ve.isContextConsumer = D, ve.isContextProvider = N, ve.isElement = T, ve.isForwardRef = M, ve.isFragment = V, ve.isLazy = w, ve.isMemo = $, ve.isPortal = O, ve.isProfiler = J, ve.isStrictMode = K, ve.isSuspense = oe, ve.isValidElementType = x, ve.typeOf = S;
  })()), ve;
}
var wi;
function Ko() {
  return wi || (wi = 1, process.env.NODE_ENV === "production" ? kr.exports = ud() : kr.exports = dd()), kr.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Pn, xi;
function pd() {
  if (xi) return Pn;
  xi = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        d[u] = u;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Pn = a() ? Object.assign : function(i, o) {
    for (var s, l = r(i), d, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var p in s)
        e.call(s, p) && (l[p] = s[p]);
      if (t) {
        d = t(s);
        for (var m = 0; m < d.length; m++)
          n.call(s, d[m]) && (l[d[m]] = s[d[m]]);
      }
    }
    return l;
  }, Pn;
}
var En, ki;
function ka() {
  if (ki) return En;
  ki = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return En = t, En;
}
var Ln, Si;
function Uo() {
  return Si || (Si = 1, Ln = Function.call.bind(Object.prototype.hasOwnProperty)), Ln;
}
var Tn, Pi;
function md() {
  if (Pi) return Tn;
  Pi = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ ka(), n = {}, r = /* @__PURE__ */ Uo();
    t = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, l, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var p;
          try {
            if (typeof i[u] != "function") {
              var m = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            p = i[u](o, u, l, s, null, e);
          } catch (y) {
            p = y;
          }
          if (p && !(p instanceof Error) && t(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in n)) {
            n[p.message] = !0;
            var _ = d ? d() : "";
            t(
              "Failed " + s + " type: " + p.message + (_ ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Tn = a, Tn;
}
var Nn, Ei;
function fd() {
  if (Ei) return Nn;
  Ei = 1;
  var t = Ko(), e = pd(), n = /* @__PURE__ */ ka(), r = /* @__PURE__ */ Uo(), a = /* @__PURE__ */ md(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Nn = function(s, l) {
    var d = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function p(A) {
      var D = A && (d && A[d] || A[u]);
      if (typeof D == "function")
        return D;
    }
    var m = "<<anonymous>>", _ = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: v(),
      arrayOf: x,
      element: S(),
      elementType: h(),
      instanceOf: P,
      node: H(),
      objectOf: G,
      oneOf: F,
      oneOfType: W,
      shape: U,
      exact: Y
    };
    function y(A, D) {
      return A === D ? A !== 0 || 1 / A === 1 / D : A !== A && D !== D;
    }
    function f(A, D) {
      this.message = A, this.data = D && typeof D == "object" ? D : {}, this.stack = "";
    }
    f.prototype = Error.prototype;
    function g(A) {
      if (process.env.NODE_ENV !== "production")
        var D = {}, N = 0;
      function T(V, w, $, O, J, K, oe) {
        if (O = O || m, K = K || $, oe !== n) {
          if (l) {
            var k = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw k.name = "Invariant Violation", k;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ue = O + ":" + $;
            !D[ue] && // Avoid spamming the console because they are often not actionable except for lib authors
            N < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + K + "` prop on `" + O + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), D[ue] = !0, N++);
          }
        }
        return w[$] == null ? V ? w[$] === null ? new f("The " + J + " `" + K + "` is marked as required " + ("in `" + O + "`, but its value is `null`.")) : new f("The " + J + " `" + K + "` is marked as required in " + ("`" + O + "`, but its value is `undefined`.")) : null : A(w, $, O, J, K);
      }
      var M = T.bind(null, !1);
      return M.isRequired = T.bind(null, !0), M;
    }
    function b(A) {
      function D(N, T, M, V, w, $) {
        var O = N[T], J = pe(O);
        if (J !== A) {
          var K = ne(O);
          return new f(
            "Invalid " + V + " `" + w + "` of type " + ("`" + K + "` supplied to `" + M + "`, expected ") + ("`" + A + "`."),
            { expectedType: A }
          );
        }
        return null;
      }
      return g(D);
    }
    function v() {
      return g(o);
    }
    function x(A) {
      function D(N, T, M, V, w) {
        if (typeof A != "function")
          return new f("Property `" + w + "` of component `" + M + "` has invalid PropType notation inside arrayOf.");
        var $ = N[T];
        if (!Array.isArray($)) {
          var O = pe($);
          return new f("Invalid " + V + " `" + w + "` of type " + ("`" + O + "` supplied to `" + M + "`, expected an array."));
        }
        for (var J = 0; J < $.length; J++) {
          var K = A($, J, M, V, w + "[" + J + "]", n);
          if (K instanceof Error)
            return K;
        }
        return null;
      }
      return g(D);
    }
    function S() {
      function A(D, N, T, M, V) {
        var w = D[N];
        if (!s(w)) {
          var $ = pe(w);
          return new f("Invalid " + M + " `" + V + "` of type " + ("`" + $ + "` supplied to `" + T + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(A);
    }
    function h() {
      function A(D, N, T, M, V) {
        var w = D[N];
        if (!t.isValidElementType(w)) {
          var $ = pe(w);
          return new f("Invalid " + M + " `" + V + "` of type " + ("`" + $ + "` supplied to `" + T + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(A);
    }
    function P(A) {
      function D(N, T, M, V, w) {
        if (!(N[T] instanceof A)) {
          var $ = A.name || m, O = ce(N[T]);
          return new f("Invalid " + V + " `" + w + "` of type " + ("`" + O + "` supplied to `" + M + "`, expected ") + ("instance of `" + $ + "`."));
        }
        return null;
      }
      return g(D);
    }
    function F(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function D(N, T, M, V, w) {
        for (var $ = N[T], O = 0; O < A.length; O++)
          if (y($, A[O]))
            return null;
        var J = JSON.stringify(A, function(oe, k) {
          var ue = ne(k);
          return ue === "symbol" ? String(k) : k;
        });
        return new f("Invalid " + V + " `" + w + "` of value `" + String($) + "` " + ("supplied to `" + M + "`, expected one of " + J + "."));
      }
      return g(D);
    }
    function G(A) {
      function D(N, T, M, V, w) {
        if (typeof A != "function")
          return new f("Property `" + w + "` of component `" + M + "` has invalid PropType notation inside objectOf.");
        var $ = N[T], O = pe($);
        if (O !== "object")
          return new f("Invalid " + V + " `" + w + "` of type " + ("`" + O + "` supplied to `" + M + "`, expected an object."));
        for (var J in $)
          if (r($, J)) {
            var K = A($, J, M, V, w + "." + J, n);
            if (K instanceof Error)
              return K;
          }
        return null;
      }
      return g(D);
    }
    function W(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var D = 0; D < A.length; D++) {
        var N = A[D];
        if (typeof N != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + te(N) + " at index " + D + "."
          ), o;
      }
      function T(M, V, w, $, O) {
        for (var J = [], K = 0; K < A.length; K++) {
          var oe = A[K], k = oe(M, V, w, $, O, n);
          if (k == null)
            return null;
          k.data && r(k.data, "expectedType") && J.push(k.data.expectedType);
        }
        var ue = J.length > 0 ? ", expected one of type [" + J.join(", ") + "]" : "";
        return new f("Invalid " + $ + " `" + O + "` supplied to " + ("`" + w + "`" + ue + "."));
      }
      return g(T);
    }
    function H() {
      function A(D, N, T, M, V) {
        return ee(D[N]) ? null : new f("Invalid " + M + " `" + V + "` supplied to " + ("`" + T + "`, expected a ReactNode."));
      }
      return g(A);
    }
    function B(A, D, N, T, M) {
      return new f(
        (A || "React class") + ": " + D + " type `" + N + "." + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + M + "`."
      );
    }
    function U(A) {
      function D(N, T, M, V, w) {
        var $ = N[T], O = pe($);
        if (O !== "object")
          return new f("Invalid " + V + " `" + w + "` of type `" + O + "` " + ("supplied to `" + M + "`, expected `object`."));
        for (var J in A) {
          var K = A[J];
          if (typeof K != "function")
            return B(M, V, w, J, ne(K));
          var oe = K($, J, M, V, w + "." + J, n);
          if (oe)
            return oe;
        }
        return null;
      }
      return g(D);
    }
    function Y(A) {
      function D(N, T, M, V, w) {
        var $ = N[T], O = pe($);
        if (O !== "object")
          return new f("Invalid " + V + " `" + w + "` of type `" + O + "` " + ("supplied to `" + M + "`, expected `object`."));
        var J = e({}, N[T], A);
        for (var K in J) {
          var oe = A[K];
          if (r(A, K) && typeof oe != "function")
            return B(M, V, w, K, ne(oe));
          if (!oe)
            return new f(
              "Invalid " + V + " `" + w + "` key `" + K + "` supplied to `" + M + "`.\nBad object: " + JSON.stringify(N[T], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
            );
          var k = oe($, K, M, V, w + "." + K, n);
          if (k)
            return k;
        }
        return null;
      }
      return g(D);
    }
    function ee(A) {
      switch (typeof A) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !A;
        case "object":
          if (Array.isArray(A))
            return A.every(ee);
          if (A === null || s(A))
            return !0;
          var D = p(A);
          if (D) {
            var N = D.call(A), T;
            if (D !== A.entries) {
              for (; !(T = N.next()).done; )
                if (!ee(T.value))
                  return !1;
            } else
              for (; !(T = N.next()).done; ) {
                var M = T.value;
                if (M && !ee(M[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Z(A, D) {
      return A === "symbol" ? !0 : D ? D["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && D instanceof Symbol : !1;
    }
    function pe(A) {
      var D = typeof A;
      return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : Z(D, A) ? "symbol" : D;
    }
    function ne(A) {
      if (typeof A > "u" || A === null)
        return "" + A;
      var D = pe(A);
      if (D === "object") {
        if (A instanceof Date)
          return "date";
        if (A instanceof RegExp)
          return "regexp";
      }
      return D;
    }
    function te(A) {
      var D = ne(A);
      switch (D) {
        case "array":
        case "object":
          return "an " + D;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + D;
        default:
          return D;
      }
    }
    function ce(A) {
      return !A.constructor || !A.constructor.name ? m : A.constructor.name;
    }
    return _.checkPropTypes = a, _.resetWarningCache = a.resetWarningCache, _.PropTypes = _, _;
  }, Nn;
}
var Mn, Li;
function hd() {
  if (Li) return Mn;
  Li = 1;
  var t = /* @__PURE__ */ ka();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, Mn = function() {
    function r(o, s, l, d, u, p) {
      if (p !== t) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, Mn;
}
var Ti;
function gd() {
  if (Ti) return xr.exports;
  if (Ti = 1, process.env.NODE_ENV !== "production") {
    var t = Ko(), e = !0;
    xr.exports = /* @__PURE__ */ fd()(t.isElement, e);
  } else
    xr.exports = /* @__PURE__ */ hd()();
  return xr.exports;
}
var _d = /* @__PURE__ */ gd();
const Le = /* @__PURE__ */ mr(_d);
function Ni(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Mi(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ni(Object(n), !0).forEach(function(r) {
      qo(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ni(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function jr(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? jr = function(e) {
    return typeof e;
  } : jr = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, jr(t);
}
function qo(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Go(t, e) {
  return yd(t) || vd(t, e) || bd(t, e) || Cd();
}
function yd(t) {
  if (Array.isArray(t)) return t;
}
function vd(t, e) {
  var n = t && (typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"]);
  if (n != null) {
    var r = [], a = !0, i = !1, o, s;
    try {
      for (n = n.call(t); !(a = (o = n.next()).done) && (r.push(o.value), !(e && r.length === e)); a = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (i) throw s;
      }
    }
    return r;
  }
}
function bd(t, e) {
  if (t) {
    if (typeof t == "string") return Oi(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Oi(t, e);
  }
}
function Oi(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function Cd() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Ye = function(e, n, r) {
  var a = !!r, i = C.useRef(r);
  C.useEffect(function() {
    i.current = r;
  }, [r]), C.useEffect(function() {
    if (!a || !e)
      return function() {
      };
    var o = function() {
      i.current && i.current.apply(i, arguments);
    };
    return e.on(n, o), function() {
      e.off(n, o);
    };
  }, [a, n, e, i]);
}, Jn = function(e) {
  var n = C.useRef(e);
  return C.useEffect(function() {
    n.current = e;
  }, [e]), n.current;
}, Ut = function(e) {
  return e !== null && jr(e) === "object";
}, wd = function(e) {
  return Ut(e) && typeof e.then == "function";
}, xd = function(e) {
  return Ut(e) && typeof e.elements == "function" && typeof e.createToken == "function" && typeof e.createPaymentMethod == "function" && typeof e.confirmCardPayment == "function";
}, Ri = "[object Object]", kd = function t(e, n) {
  if (!Ut(e) || !Ut(n))
    return e === n;
  var r = Array.isArray(e), a = Array.isArray(n);
  if (r !== a) return !1;
  var i = Object.prototype.toString.call(e) === Ri, o = Object.prototype.toString.call(n) === Ri;
  if (i !== o) return !1;
  if (!i && !r) return e === n;
  var s = Object.keys(e), l = Object.keys(n);
  if (s.length !== l.length) return !1;
  for (var d = {}, u = 0; u < s.length; u += 1)
    d[s[u]] = !0;
  for (var p = 0; p < l.length; p += 1)
    d[l[p]] = !0;
  var m = Object.keys(d);
  if (m.length !== s.length)
    return !1;
  var _ = e, y = n, f = function(b) {
    return t(_[b], y[b]);
  };
  return m.every(f);
}, Wo = function(e, n, r) {
  return Ut(e) ? Object.keys(e).reduce(function(a, i) {
    var o = !Ut(n) || !kd(e[i], n[i]);
    return r.includes(i) ? (o && console.warn("Unsupported prop change: options.".concat(i, " is not a mutable property.")), a) : o ? Mi(Mi({}, a || {}), {}, qo({}, i, e[i])) : a;
  }, null) : null;
}, Zo = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.", Ai = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Zo;
  if (e === null || xd(e))
    return e;
  throw new Error(n);
}, Sd = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Zo;
  if (wd(e))
    return {
      tag: "async",
      stripePromise: Promise.resolve(e).then(function(a) {
        return Ai(a, n);
      })
    };
  var r = Ai(e, n);
  return r === null ? {
    tag: "empty"
  } : {
    tag: "sync",
    stripe: r
  };
}, Pd = function(e) {
  !e || !e._registerWrapper || !e.registerAppInfo || (e._registerWrapper({
    name: "react-stripe-js",
    version: "2.8.1"
  }), e.registerAppInfo({
    name: "react-stripe-js",
    version: "2.8.1",
    url: "https://stripe.com/docs/stripe-js/react"
  }));
}, sn = /* @__PURE__ */ C.createContext(null);
sn.displayName = "ElementsContext";
var Yo = function(e, n) {
  if (!e)
    throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(n, " in an <Elements> provider."));
  return e;
}, Jo = function(e) {
  var n = e.stripe, r = e.options, a = e.children, i = C.useMemo(function() {
    return Sd(n);
  }, [n]), o = C.useState(function() {
    return {
      stripe: i.tag === "sync" ? i.stripe : null,
      elements: i.tag === "sync" ? i.stripe.elements(r) : null
    };
  }), s = Go(o, 2), l = s[0], d = s[1];
  C.useEffect(function() {
    var m = !0, _ = function(f) {
      d(function(g) {
        return g.stripe ? g : {
          stripe: f,
          elements: f.elements(r)
        };
      });
    };
    return i.tag === "async" && !l.stripe ? i.stripePromise.then(function(y) {
      y && m && _(y);
    }) : i.tag === "sync" && !l.stripe && _(i.stripe), function() {
      m = !1;
    };
  }, [i, l, r]);
  var u = Jn(n);
  C.useEffect(function() {
    u !== null && u !== n && console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
  }, [u, n]);
  var p = Jn(r);
  return C.useEffect(function() {
    if (l.elements) {
      var m = Wo(r, p, ["clientSecret", "fonts"]);
      m && l.elements.update(m);
    }
  }, [r, p, l.elements]), C.useEffect(function() {
    Pd(l.stripe);
  }, [l.stripe]), /* @__PURE__ */ C.createElement(sn.Provider, {
    value: l
  }, a);
};
Jo.propTypes = {
  stripe: Le.any,
  options: Le.object
};
var Ed = function(e) {
  var n = C.useContext(sn);
  return Yo(n, e);
}, ln = function() {
  var e = Ed("calls useElements()"), n = e.elements;
  return n;
};
Le.func.isRequired;
var Xo = /* @__PURE__ */ C.createContext(null);
Xo.displayName = "CustomCheckoutSdkContext";
var Ld = function(e, n) {
  if (!e)
    throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(n, " in an <CustomCheckoutProvider> provider."));
  return e;
}, Td = /* @__PURE__ */ C.createContext(null);
Td.displayName = "CustomCheckoutContext";
Le.any, Le.shape({
  clientSecret: Le.string.isRequired,
  elementsOptions: Le.object
}).isRequired;
var Xn = function(e) {
  var n = C.useContext(Xo), r = C.useContext(sn);
  if (n && r)
    throw new Error("You cannot wrap the part of your app that ".concat(e, " in both <CustomCheckoutProvider> and <Elements> providers."));
  return n ? Ld(n, e) : Yo(r, e);
}, Nd = function(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}, Re = function(e, n) {
  var r = "".concat(Nd(e), "Element"), a = function(l) {
    var d = l.id, u = l.className, p = l.options, m = p === void 0 ? {} : p, _ = l.onBlur, y = l.onFocus, f = l.onReady, g = l.onChange, b = l.onEscape, v = l.onClick, x = l.onLoadError, S = l.onLoaderStart, h = l.onNetworksChange, P = l.onConfirm, F = l.onCancel, G = l.onShippingAddressChange, W = l.onShippingRateChange, H = Xn("mounts <".concat(r, ">")), B = "elements" in H ? H.elements : null, U = "customCheckoutSdk" in H ? H.customCheckoutSdk : null, Y = C.useState(null), ee = Go(Y, 2), Z = ee[0], pe = ee[1], ne = C.useRef(null), te = C.useRef(null);
    Ye(Z, "blur", _), Ye(Z, "focus", y), Ye(Z, "escape", b), Ye(Z, "click", v), Ye(Z, "loaderror", x), Ye(Z, "loaderstart", S), Ye(Z, "networkschange", h), Ye(Z, "confirm", P), Ye(Z, "cancel", F), Ye(Z, "shippingaddresschange", G), Ye(Z, "shippingratechange", W), Ye(Z, "change", g);
    var ce;
    f && (e === "expressCheckout" ? ce = f : ce = function() {
      f(Z);
    }), Ye(Z, "ready", ce), C.useLayoutEffect(function() {
      if (ne.current === null && te.current !== null && (B || U)) {
        var D = null;
        U ? D = U.createElement(e, m) : B && (D = B.create(e, m)), ne.current = D, pe(D), D && D.mount(te.current);
      }
    }, [B, U, m]);
    var A = Jn(m);
    return C.useEffect(function() {
      if (ne.current) {
        var D = Wo(m, A, ["paymentRequest"]);
        D && "update" in ne.current && ne.current.update(D);
      }
    }, [m, A]), C.useLayoutEffect(function() {
      return function() {
        if (ne.current && typeof ne.current.destroy == "function")
          try {
            ne.current.destroy(), ne.current = null;
          } catch {
          }
      };
    }, []), /* @__PURE__ */ C.createElement("div", {
      id: d,
      className: u,
      ref: te
    });
  }, i = function(l) {
    Xn("mounts <".concat(r, ">"));
    var d = l.id, u = l.className;
    return /* @__PURE__ */ C.createElement("div", {
      id: d,
      className: u
    });
  }, o = n ? i : a;
  return o.propTypes = {
    id: Le.string,
    className: Le.string,
    onChange: Le.func,
    onBlur: Le.func,
    onFocus: Le.func,
    onReady: Le.func,
    onEscape: Le.func,
    onClick: Le.func,
    onLoadError: Le.func,
    onLoaderStart: Le.func,
    onNetworksChange: Le.func,
    onConfirm: Le.func,
    onCancel: Le.func,
    onShippingAddressChange: Le.func,
    onShippingRateChange: Le.func,
    options: Le.object
  }, o.displayName = r, o.__elementType = e, o;
}, Ae = typeof window > "u", Md = /* @__PURE__ */ C.createContext(null);
Md.displayName = "EmbeddedCheckoutProviderContext";
var Wt = function() {
  var e = Xn("calls useStripe()"), n = e.stripe;
  return n;
};
Re("auBankAccount", Ae);
Re("card", Ae);
Re("cardNumber", Ae);
Re("cardExpiry", Ae);
Re("cardCvc", Ae);
Re("fpxBank", Ae);
Re("iban", Ae);
Re("idealBank", Ae);
Re("p24Bank", Ae);
Re("epsBank", Ae);
var Qo = Re("payment", Ae), Od = Re("expressCheckout", Ae);
Re("currencySelector", Ae);
Re("paymentRequestButton", Ae);
Re("linkAuthentication", Ae);
Re("address", Ae);
Re("shippingAddress", Ae);
Re("paymentMethodMessaging", Ae);
Re("affirmMessage", Ae);
Re("afterpayClearpayMessage", Ae);
const es = (t, e) => Pt(t, e), ts = (t, e) => Pt(t, e), cn = () => Kt.get("api/payment/confirm");
var un = /* @__PURE__ */ ((t) => (t.payment = "payment", t.setup = "setup", t))(un || {});
const Rd = (t, e) => e === un.setup ? t.confirmBancontactSetup : t.confirmBancontactPayment;
function Ad({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o,
  hasErrors: s
}) {
  const { locale: l } = _e(), d = Wt(), u = ln(), p = async (m) => {
    if (m.preventDefault(), !(!d || !u))
      try {
        a(!0), r($e);
        const _ = i();
        if (!_) throw new Error("Request data is undefined");
        const { redirect: y, intentSecret: f, intentType: g } = await ts(_, l);
        if (!f) return window.location.href = y;
        const b = Rd(d, g), { error: v } = await b(f, {
          payment_method: {
            billing_details: {
              name: _.customer.fields.first_name,
              email: _.customer.fields.email
            }
          },
          return_url: y
        });
        v ? r((x) => ({ ...x, common: [...x.common, v.message] })) : (await cn(), window.location.assign(y));
      } catch (_) {
        _ instanceof _t && o(_);
      } finally {
        a(!1);
      }
  };
  return /* @__PURE__ */ c(
    it,
    {
      disabled: n,
      className: De("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: p,
      isFetching: t,
      type: "submit",
      children: e
    }
  );
}
const rs = (t, e) => e === un.setup ? t.confirmCardSetup : t.confirmCardPayment;
function zd({
  setIsFetching: t,
  handleBadRequest: e,
  setErrors: n,
  preSubmit: r
}) {
  const a = Wt(), i = ln(), { locale: o } = _e();
  return /* @__PURE__ */ c(
    Od,
    {
      options: {
        paymentMethods: {
          applePay: "always",
          googlePay: "never",
          amazonPay: "never",
          link: "never",
          paypal: "never"
        }
      },
      onConfirm: async (l) => {
        if (!(!a || !i))
          try {
            const d = r();
            if (!d) throw new Error("Request data is undefined");
            const { error: u } = await i.submit();
            if (u) {
              l.paymentFailed();
              return;
            }
            const { error: p, paymentMethod: m } = await a.createPaymentMethod({
              elements: i
            });
            if (p || !m) {
              l.paymentFailed();
              return;
            }
            const { redirect: _, intentSecret: y, intentType: f } = await es(
              {
                ...d,
                paymentMethod: le.stripe_applepay,
                options: { stripePaymentMethodId: m.id }
              },
              o
            );
            if (!y) return window.location.href = _;
            const g = rs(a, f), { error: b } = await g(y, {
              payment_method: m.id
            });
            b ? n((v) => ({
              ...v,
              common: [...v.common, b.message]
            })) : (await cn(), window.location.assign(_));
          } catch (d) {
            l.paymentFailed({ reason: "fail" }), d instanceof _t && e(d);
          } finally {
            t(!1);
          }
      }
    }
  );
}
function Dd(t) {
  const e = Wt(), { availablePaymentMethods: n } = tt();
  if (!e) return null;
  const r = n.includes(le.stripe_applepay);
  return /* @__PURE__ */ L("div", { children: [
    r && /* @__PURE__ */ c(zd, { ...t }),
    /* @__PURE__ */ c(
      Qo,
      {
        options: {
          fields: {
            billingDetails: {
              address: "never"
            }
          }
        }
      }
    )
  ] });
}
function Id({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o,
  hasErrors: s
}) {
  const { locale: l } = _e(), d = Wt(), u = ln(), p = async (m) => {
    if (m.preventDefault(), !(!d || !u))
      try {
        const { error: _ } = await u.submit();
        if (_)
          throw new Error("Stripe elements validation failed");
        const y = i();
        if (!y) throw new Error("Request data is undefined");
        a(!0), r($e);
        const { paymentMethod: f, error: g } = await d.createPaymentMethod({
          elements: u,
          params: {
            billing_details: {
              address: {
                country: null,
                line1: null,
                line2: null,
                city: null,
                state: null,
                postal_code: null
              }
            }
          }
        });
        if (g) {
          r((P) => ({
            ...P,
            common: [...P.common, g.message]
          }));
          return;
        }
        if (!f)
          throw Error("undefined payment method");
        const { redirect: b, intentSecret: v, intentType: x } = await es(
          { ...y, options: { stripePaymentMethodId: f.id } },
          l
        );
        if (!v) return window.location.href = b;
        const S = rs(d, x), { error: h } = await S(v, {
          payment_method: f.id
        });
        h ? r((P) => ({ ...P, common: [...P.common, h.message] })) : (await cn(), window.location.assign(b));
      } catch (_) {
        _ instanceof _t && o(_);
      } finally {
        a(!1);
      }
  };
  return /* @__PURE__ */ c(
    it,
    {
      disabled: n,
      className: De("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: p,
      isFetching: t,
      type: "submit",
      children: e
    }
  );
}
function jd({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o,
  hasErrors: s
}) {
  const { locale: l } = _e(), d = Wt(), u = ln(), p = async (m) => {
    if (m.preventDefault(), !(!d || !u))
      try {
        a(!0), r($e);
        const { error: _ } = await u.submit();
        if (_)
          throw new Error("Stripe elements validation failed");
        const y = i();
        if (!y) throw new Error("Request data is undefined");
        const { redirect: f, intentSecret: g, intentType: b } = await ts(y, l);
        if (!g) return window.location.href = f;
        const v = b === un.setup ? d.confirmSetup : d.confirmPayment, { error: x } = await v({
          elements: u,
          clientSecret: g,
          confirmParams: {
            payment_method_data: {
              billing_details: {
                name: [y.customer.fields.first_name, y.customer.fields.last_name].filter(Boolean).join(" "),
                email: y.customer.fields.email
              }
            },
            return_url: f
          }
        });
        x ? r((S) => ({ ...S, common: [...S.common, x.message] })) : (await cn(), window.location.assign(f));
      } catch (_) {
        _ instanceof _t && o(_);
      } finally {
        a(!1);
      }
  };
  return /* @__PURE__ */ c(
    it,
    {
      disabled: n,
      className: De("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: p,
      isFetching: t,
      type: "submit",
      children: e
    }
  );
}
function Fd() {
  return Wt() ? /* @__PURE__ */ c("div", { children: /* @__PURE__ */ c(
    Qo,
    {
      options: {
        fields: {
          billingDetails: {
            name: "never",
            email: "never"
          }
        }
      }
    }
  ) }) : null;
}
const Vd = (t) => {
  const [e, n] = t.split(" ");
  return { firstName: e, lastName: n };
}, Hd = (t, e) => Pt(t, e), $d = () => {
  const { t } = He(), e = typeof window < "u" && !!window.Xendit, [n, r] = Te(!e), { xenditPublicKey: a } = D1();
  return Ve(() => {
    e || Bo("https://js.xendit.co/v1/xendit.min.js", "xendit-js", () => {
      window.Xendit && a ? window.Xendit.setPublishableKey(a) : xt.error(t("public_pages_purchase.error")), r(!1);
    });
  }, [e]), {
    isScriptLoading: n
  };
}, rr = "xendit-3ds-frame", Bd = (t) => {
  const [e, n] = Te(!1), [r, a] = Te(!1), { t: i } = He();
  return { threeDsModal: /* @__PURE__ */ L(
    uo,
    {
      opened: e,
      onClose: () => {
        n(!1), t();
      },
      title: i("public_pages_purchase.payment.xendit.3ds"),
      children: [
        r && /* @__PURE__ */ c(sl, { className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }),
        /* @__PURE__ */ c(
          "iframe",
          {
            className: fe("h-[650px] w-full", r && "invisible"),
            id: rr,
            title: rr,
            name: rr
          }
        )
      ]
    }
  ), openLinkInIframe: (d) => {
    n(!0);
    const u = 10;
    let p = 0;
    a(!0);
    const m = setInterval(() => {
      p++, document.getElementById(rr) ? (clearInterval(m), a(!1), window.open(d, rr)) : p >= u && (clearInterval(m), xt.error(i("public_pages_purchase.error")), n(!1), a(!1), t());
    }, 500);
  }, closeThreeDsModal: () => {
    n(!1);
  } };
};
var Vt = /* @__PURE__ */ ((t) => (t.verified = "VERIFIED", t.in_review = "IN_REVIEW", t.failed = "FAILED", t.approved = "APPROVED", t.card_enrolled = "CARD_ENROLLED", t.fraud = "FRAUD", t))(Vt || {});
function Kd({
  isFetching: t,
  buttonTitle: e,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o,
  hasErrors: s
}) {
  const { t: l } = He(), { locale: d } = _e(), { currency: u, finalAmount: p } = tt(), { cardNumber: m, cardHolderName: _, cvc: y, expiryMonth: f, expiryYear: g, formInvalid: b } = To(), { isScriptLoading: v } = $d(), { openLinkInIframe: x, threeDsModal: S, closeThreeDsModal: h } = Bd(
    () => a(!1)
  ), P = async (W, H) => {
    if (W) {
      xt.error(W.message), a(!1);
      return;
    } else if (H.status === Vt.in_review)
      x(H.payer_authentication_url);
    else if (H.status === Vt.verified) {
      setTimeout(() => {
        h();
      }, 1e3);
      try {
        const B = i();
        if (!B) throw new Error("Request data is undefined");
        const { redirect: U } = await Hd(
          {
            ...B,
            options: { token: H.credit_card_token_id }
          },
          d
        );
        if (U) {
          window.location.assign(U);
          return;
        } else
          xt.error(l("public_pages_purchase.error"));
      } catch (B) {
        B instanceof _t && o(B);
      } finally {
        a(!1);
      }
    }
  }, F = async (W, H) => {
    if (W) {
      xt.error(W.message), a(!1);
      return;
    }
    if (!window.Xendit || !p) {
      xt.error(l("public_pages_purchase.error")), a(!1);
      return;
    }
    H.status === Vt.verified ? window.Xendit.card.createAuthentication(
      {
        amount: p,
        token_id: H.id
      },
      P
    ) : H.status === Vt.in_review ? x(H.payer_authentication_url) : H.status === Vt.failed && (xt.error(l("public_pages_purchase.error")), a(!1));
  }, G = async (W) => {
    W.preventDefault();
    try {
      const H = i();
      if (!H || !p || !u) throw new Error("Request data is undefined");
      if (a(!0), r($e), window.Xendit) {
        const B = `20${g}`, { firstName: U, lastName: Y } = Vd(_), ee = H.customer.fields[Qe.Email] ?? "", Z = H.customer.fields[Qe.PhoneNumber] ?? "", pe = Z ? `+${Z}` : "";
        window.Xendit.card.createToken(
          {
            amount: p,
            card_number: m,
            card_exp_month: f,
            card_exp_year: B,
            card_cvn: y,
            card_holder_first_name: U,
            card_holder_last_name: Y,
            card_holder_email: ee,
            card_holder_phone_number: pe,
            is_multiple_use: !0,
            should_authenticate: !0,
            currency: u
          },
          F
        );
      }
    } catch {
      a(!1);
    }
  };
  return /* @__PURE__ */ L(St, { children: [
    S,
    /* @__PURE__ */ c(
      it,
      {
        className: De(
          "main-transition-colors",
          (s || b) && "bg-danger focus:bg-danger"
        ),
        onClick: G,
        isFetching: t,
        disabled: v || b || n,
        type: "submit",
        children: e
      }
    )
  ] });
}
const Ud = (t, e) => {
  switch (t) {
    case le.stripe_card:
      return /* @__PURE__ */ c(Id, { ...e });
    case le.stripe_ideal:
      return /* @__PURE__ */ c(jd, { ...e });
    case le.stripe_bancontact:
      return /* @__PURE__ */ c(Ad, { ...e });
    case le.paypal_rest:
      return /* @__PURE__ */ c(td, { ...e });
    case le.paypal_soap:
      return /* @__PURE__ */ c(ad, { ...e });
    case le.mercadopago_ar_card:
    case le.mercadopago_br_card:
    case le.mercadopago_cl_card:
    case le.mercadopago_co_card:
    case le.mercadopago_mx_card:
      return /* @__PURE__ */ c(Xu, { ...e });
    case le.razorpay:
      return /* @__PURE__ */ c(cd, { ...e });
    case le.xendit_id_card:
    case le.xendit_ph_card:
      return /* @__PURE__ */ c(Kd, { ...e });
    default:
      return /* @__PURE__ */ c(Zu, { ...e });
  }
};
var nr = {}, zi;
function qd() {
  if (zi) return nr;
  zi = 1, Object.defineProperty(nr, "__esModule", { value: !0 }), nr.loadMercadoPago = void 0;
  const t = "https://sdk.mercadopago.com/js/v2", e = /^https:\/\/sdk\.mercadopago\.com\/js\/v2\/?(\?.*)?$/, n = "MercadoPago has already been initialized in your window, please remove the duplicate import", r = "MercadoPago.js not available", a = "Failed to load MercadoPago.js", i = () => {
    for (var d = document.querySelectorAll(`script[src^="${t}"`), u = 0; u < d.length; u++) {
      var p = d[u];
      if (e.test(p.src))
        return p;
    }
    return null;
  }, o = () => {
    const d = document.createElement("script");
    d.src = t;
    const u = document.head || document.body;
    if (!u)
      throw new Error("Expected document.body or document.head not to be null. MercadoPago requires a <body> or a <head> element, please add on your project.");
    return u.appendChild(d), d;
  };
  let s = null;
  const l = () => (s !== null || (s = new Promise((d, u) => {
    if (typeof window > "u") {
      d(null);
      return;
    }
    if (window.MercadoPago) {
      console.warn(n), d(window.MercadoPago);
      return;
    }
    try {
      let p = i();
      p ? console.warn(n) : p || (p = o()), p.addEventListener("load", () => {
        window.MercadoPago ? d(window.MercadoPago) : u(new Error(r));
      }), p.addEventListener("error", () => {
        u(new Error(a));
      });
    } catch (p) {
      u(p);
      return;
    }
  })), s);
  return nr.loadMercadoPago = l, nr;
}
var Gd = qd(), Wd = function(t, e, n, r) {
  function a(i) {
    return i instanceof n ? i : new n(function(o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function(i, o) {
    function s(u) {
      try {
        d(r.next(u));
      } catch (p) {
        o(p);
      }
    }
    function l(u) {
      try {
        d(r.throw(u));
      } catch (p) {
        o(p);
      }
    }
    function d(u) {
      u.done ? i(u.value) : a(u.value).then(s, l);
    }
    d((r = r.apply(t, e || [])).next());
  });
};
class mt {
  static getInstance() {
    return Wd(this, void 0, void 0, function* () {
      if (this.publicKey)
        return this.loadedInstanceMercadoPago || (yield Gd.loadMercadoPago(), this.loadedInstanceMercadoPago = !0), this.instanceMercadoPago || (this.instanceMercadoPago = new window.MercadoPago(this.publicKey, this.options)), this.instanceMercadoPago;
      console.error("Expected the PUBLIC_KEY to render the MercadoPago SDK React");
    });
  }
}
mt.publicKey = null;
mt.options = {};
mt.instanceMercadoPago = void 0;
mt.loadedInstanceMercadoPago = !1;
function Zd(t, e) {
  return Object.keys(t).length === Object.keys(e).length && Object.keys(t).every((r) => Object.prototype.hasOwnProperty.call(e, r) && t[r] === e[r]);
}
const Yd = (t, e) => {
  const n = Object.assign(Object.assign({}, e), { frontEndStack: "react" }), r = !Zd(mt.options, n);
  (t !== mt.publicKey || r) && (mt.publicKey = t, mt.options = n, mt.instanceMercadoPago = void 0);
}, Jd = 200;
var Xd = function(t, e, n, r) {
  function a(i) {
    return i instanceof n ? i : new n(function(o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function(i, o) {
    function s(u) {
      try {
        d(r.next(u));
      } catch (p) {
        o(p);
      }
    }
    function l(u) {
      try {
        d(r.throw(u));
      } catch (p) {
        o(p);
      }
    }
    function d(u) {
      u.done ? i(u.value) : a(u.value).then(s, l);
    }
    d((r = r.apply(t, e || [])).next());
  });
};
const Qd = () => Xd(void 0, void 0, void 0, function* () {
}), e0 = () => {
}, t0 = (t) => {
  console.error(t);
}, r0 = (t) => {
  console.log(t);
};
var n0 = function(t, e, n, r) {
  function a(i) {
    return i instanceof n ? i : new n(function(o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function(i, o) {
    function s(u) {
      try {
        d(r.next(u));
      } catch (p) {
        o(p);
      }
    }
    function l(u) {
      try {
        d(r.throw(u));
      } catch (p) {
        o(p);
      }
    }
    function d(u) {
      u.done ? i(u.value) : a(u.value).then(s, l);
    }
    d((r = r.apply(t, e || [])).next());
  });
};
const a0 = ({ settings: t, name: e, containerId: n, controller: r }) => n0(void 0, void 0, void 0, function* () {
  const a = yield mt.getInstance(), i = a == null ? void 0 : a.bricks();
  window[r] = yield i == null ? void 0 : i.create(e, n, t);
}), i0 = ({ onReady: t = e0, onError: e = t0, onSubmit: n = Qd, onBinChange: r = r0, initialization: a, customization: i, locale: o, id: s = "cardPaymentBrick_container" }) => (Ve(() => {
  const l = {
    settings: {
      initialization: a,
      customization: i,
      callbacks: {
        onReady: t,
        onSubmit: n,
        onError: e,
        onBinChange: r
      },
      locale: o
    },
    name: "cardPayment",
    containerId: s,
    controller: "cardPaymentBrickController"
  }, d = setTimeout(() => {
    a0(l);
  }, Jd);
  return () => {
    var u;
    clearTimeout(d), (u = window.cardPaymentBrickController) === null || u === void 0 || u.unmount();
  };
}, [a, i, r, t, e, n]), C.createElement("div", { id: s })), o0 = () => ({ update: (e) => {
  window.cardPaymentBrickController ? window.cardPaymentBrickController.update(e) : console.warn("[Checkout Bricks] Card Payment Brick is not initialized yet, please try again after a few seconds.");
} });
function s0() {
  var y;
  const { state: t } = qe(), { initialized: e } = Mo(), [n, r] = Te(!1), { primaryColor: a, secondaryColor: i, textColorPrimary: o, textColorTertiary: s, tertiaryColor: l } = nn(t), { finalAmount: d, contactFields: u } = tt(), p = (y = u == null ? void 0 : u[Qe.Email]) == null ? void 0 : y.value, { update: m } = o0();
  return Ve(() => {
    d && e && n && m({ amount: Me(d) });
  }, [d, e, n]), tn(() => !d || !e ? null : /* @__PURE__ */ c(
    i0,
    {
      initialization: { amount: Me(d), payer: { email: p } },
      customization: {
        visual: {
          hidePaymentButton: !0,
          style: {
            customVariables: {
              textPrimaryColor: s,
              inputBackgroundColor: l,
              formBackgroundColor: i,
              baseColor: a,
              baseColorFirstVariant: a,
              baseColorSecondVariant: i,
              outlinePrimaryColor: "var(--THEME-border-tertiary)",
              outlineSecondaryColor: "var(--THEME-border-tertiary)",
              buttonTextColor: o
            }
          }
        }
      },
      onSubmit: async (f) => {
      },
      onError: (f) => console.log("MP error", f),
      onReady: () => {
        r(!0);
      }
    }
  ), [e]);
}
var l0 = 3, c0 = 5, st = /(\d{1,4})/g, Sa = [{
  displayName: "Visa",
  type: "visa",
  format: st,
  startPattern: /^4/,
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  code: {
    name: "CVV",
    length: 3
  }
}, {
  displayName: "Mastercard",
  type: "mastercard",
  format: st,
  startPattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVC",
    length: 3
  }
}, {
  displayName: "American Express",
  type: "amex",
  format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
  startPattern: /^3[47]/,
  gaps: [4, 10],
  lengths: [15],
  code: {
    name: "CID",
    length: 4
  }
}, {
  displayName: "Diners Club",
  type: "dinersclub",
  format: st,
  startPattern: /^(36|38|30[0-5])/,
  gaps: [4, 10],
  lengths: [14, 16, 19],
  code: {
    name: "CVV",
    length: 3
  }
}, {
  displayName: "Discover",
  type: "discover",
  format: st,
  startPattern: /^(6011|65|64[4-9]|622)/,
  gaps: [4, 8, 12],
  lengths: [16, 19],
  code: {
    name: "CID",
    length: 3
  }
}, {
  displayName: "JCB",
  type: "jcb",
  format: st,
  startPattern: /^35/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: "CVV",
    length: 3
  }
}, {
  displayName: "UnionPay",
  type: "unionpay",
  format: st,
  startPattern: /^62/,
  gaps: [4, 8, 12],
  lengths: [14, 15, 16, 17, 18, 19],
  code: {
    name: "CVN",
    length: 3
  }
}, {
  displayName: "Maestro",
  type: "maestro",
  format: st,
  startPattern: /^(5018|5020|5038|6304|6703|6708|6759|676[1-3])/,
  gaps: [4, 8, 12],
  lengths: [12, 13, 14, 15, 16, 17, 18, 19],
  code: {
    name: "CVC",
    length: 3
  }
}, {
  displayName: "Elo",
  type: "elo",
  format: st,
  startPattern: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|4(0[5-9]|3[0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8])|9([2-6][0-9]|7[0-8])|541|700|720|901)|651652|655000|655021)/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVE",
    length: 3
  }
}, {
  displayName: "Hipercard",
  type: "hipercard",
  format: st,
  startPattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVC",
    length: 3
  }
}, {
  displayName: "Troy",
  type: "troy",
  format: st,
  startPattern: /^9792/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVV",
    length: 3
  }
}], dn = function(e) {
  return Sa.filter(function(n) {
    return n.startPattern.test(e);
  })[0];
}, u0 = function(e) {
  return Sa.filter(function(n) {
    return n.type === e;
  })[0];
}, d0 = /* @__PURE__ */ Object.freeze({
  DEFAULT_CVC_LENGTH: l0,
  DEFAULT_ZIP_LENGTH: c0,
  DEFAULT_CARD_FORMAT: st,
  CARD_TYPES: Sa,
  getCardTypeByValue: dn,
  getCardTypeByType: u0
}), p0 = /(0[1-9]|1[0-2])/, ns = "Enter a card number", as = "Enter an expiry date", is = "Enter a CVC", os = "Enter a ZIP code", ss = "Card number is invalid", ls = "Expiry date is invalid", Qn = "CVC is invalid", cs = "Expiry month must be between 01 and 12", us = "Expiry year cannot be in the past", ds = "Expiry date cannot be in the past", m0 = function(e) {
  var n = dn(e);
  return n && e.length >= n.lengths[n.lengths.length - 1];
}, f0 = function(e) {
  return /^\d*$/.test(e.key);
}, ps = function(e) {
  return e.split("").reverse().map(function(n) {
    return parseInt(n, 10);
  }).map(function(n, r) {
    return r % 2 ? n * 2 : n;
  }).map(function(n) {
    return n > 9 ? n % 10 + 1 : n;
  }).reduce(function(n, r) {
    return n += r;
  }) % 10 === 0;
}, h0 = function(e, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = r.errorMessages, i = a === void 0 ? {} : a;
  if (!e)
    return i.emptyCardNumber || ns;
  var o = e.replace(/\s/g, ""), s = dn(o);
  if (s && s.lengths) {
    var l = s.lengths.includes(o.length);
    if (l) {
      var d = ps(o);
      if (d)
        return n ? n({
          cardNumber: o,
          cardType: s,
          errorMessages: i
        }) : void 0;
    }
  }
  return i.invalidCardNumber || ss;
}, g0 = function(e, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = r.errorMessages, i = a === void 0 ? {} : a;
  if (!e)
    return i.emptyExpiryDate || as;
  var o = e.replace(" / ", "").replace("/", "");
  if (o.length === 4) {
    var s = o.slice(0, 2), l = "20".concat(o.slice(2, 4));
    return p0.test(s) ? parseInt(l) < (/* @__PURE__ */ new Date()).getFullYear() ? i.yearOutOfRange || us : parseInt(l) === (/* @__PURE__ */ new Date()).getFullYear() && parseInt(s) < (/* @__PURE__ */ new Date()).getMonth() + 1 ? i.dateOutOfRange || ds : n ? n({
      expiryDate: {
        month: s,
        year: l
      },
      errorMessages: i
    }) : void 0 : i.monthOutOfRange || cs;
  }
  return i.invalidExpiryDate || ls;
}, _0 = function(e, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = r.cardType, i = r.errorMessages, o = i === void 0 ? {} : i;
  if (!e)
    return o.emptyCVC || is;
  if (e.length < 3 || a && e.length !== a.code.length)
    return o.invalidCVC || Qn;
  if (n)
    return n({
      cvc: e,
      cardType: a,
      errorMessages: o
    });
}, y0 = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.errorMessages, a = r === void 0 ? {} : r;
  if (!e)
    return a.emptyZIP || os;
}, v0 = /* @__PURE__ */ Object.freeze({
  EMPTY_CARD_NUMBER: ns,
  EMPTY_EXPIRY_DATE: as,
  EMPTY_CVC: is,
  EMPTY_ZIP: os,
  INVALID_CARD_NUMBER: ss,
  INVALID_EXPIRY_DATE: ls,
  INVALID_CVC: Qn,
  MONTH_OUT_OF_RANGE: cs,
  YEAR_OUT_OF_RANGE: us,
  DATE_OUT_OF_RANGE: ds,
  hasCardNumberReachedMaxLength: m0,
  isNumeric: f0,
  validateLuhn: ps,
  getCardNumberError: h0,
  getExpiryDateError: g0,
  getCVCError: _0,
  getZIPError: y0
});
function wt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Et(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      wt(t, a, n[a]);
    });
  }
  return t;
}
function b0(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
function Sr(t, e) {
  if (t == null) return {};
  var n = b0(t, e), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      r = i[a], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function hr(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
function Tt(t, e) {
  return ms(t) || x0(t, e) || fs();
}
function C0(t) {
  return ms(t) || w0(t) || fs();
}
function ms(t) {
  if (Array.isArray(t)) return t;
}
function w0(t) {
  if (Symbol.iterator in Object(t) || Object.prototype.toString.call(t) === "[object Arguments]") return Array.from(t);
}
function x0(t, e) {
  var n = [], r = !0, a = !1, i = void 0;
  try {
    for (var o = t[Symbol.iterator](), s; !(r = (s = o.next()).done) && (n.push(s.value), !(e && n.length === e)); r = !0)
      ;
  } catch (l) {
    a = !0, i = l;
  } finally {
    try {
      !r && o.return != null && o.return();
    } finally {
      if (a) throw i;
    }
  }
  return n;
}
function fs() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var k0 = function(e) {
  var n = dn(e);
  if (!n) return (e.match(/\d+/g) || []).join("");
  var r = n.format;
  if (r && r.global)
    return (e.match(r) || []).join(" ");
  if (r) {
    var a = r.exec(e.split(" ").join(""));
    if (a)
      return a.splice(1, 3).filter(function(i) {
        return i;
      }).join(" ");
  }
  return e;
}, S0 = function(e) {
  var n = e.nativeEvent && e.nativeEvent.data, r = e.target.value.split(" / ").join("/");
  if (!r) return null;
  var a = r;
  if (/^[2-9]$/.test(a) && (a = "0".concat(a)), r.length === 2 && +r > 12) {
    var i = r.split(""), o = C0(i), s = o[0], l = o.slice(1);
    a = "0".concat(s, "/").concat(l.join(""));
  }
  if (/^1[/-]$/.test(a))
    return "01 / ";
  if (a = a.match(/(\d{1,2})/g) || [], a.length === 1) {
    if (!n && r.includes("/"))
      return a[0];
    if (/\d{2}/.test(a))
      return "".concat(a[0], " / ");
  }
  if (a.length > 2) {
    var d = a.join("").match(/^(\d{2}).*(\d{2})$/) || [], u = Tt(d, 3), p = u[1], m = p === void 0 ? null : p, _ = u[2], y = _ === void 0 ? null : _;
    return [m, y].join(" / ");
  }
  return a.join(" / ");
}, P0 = /* @__PURE__ */ Object.freeze({
  formatCardNumber: k0,
  formatExpiry: S0
}), E0 = "Backspace", L0 = "Enter", ke = {
  cardTypes: d0,
  formatter: P0,
  validator: v0,
  BACKSPACE_KEY_CODE: E0,
  ENTER_KEY_CODE: L0
};
function T0() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.autoFocus, n = e === void 0 ? !0 : e, r = t.errorMessages, a = t.onBlur, i = t.onChange, o = t.onError, s = t.onTouch, l = t.cardNumberValidator, d = t.cvcValidator, u = t.expiryValidator, p = C.useRef(), m = C.useRef(), _ = C.useRef(), y = C.useRef(), f = C.useState({
    cardNumber: !1,
    expiryDate: !1,
    cvc: !1,
    zip: !1
  }), g = Tt(f, 2), b = g[0], v = g[1], x = C.useState(!1), S = Tt(x, 2), h = S[0], P = S[1], F = C.useState({
    cardNumber: void 0,
    expiryDate: void 0,
    cvc: void 0,
    zip: void 0
  }), G = Tt(F, 2), W = G[0], H = G[1], B = C.useState(), U = Tt(B, 2), Y = U[0], ee = U[1], Z = C.useState(), pe = Tt(Z, 2), ne = pe[0], te = pe[1], ce = C.useState(), A = Tt(ce, 2), D = A[0], N = A[1], T = C.useCallback(function(I, j) {
    H(function(Q) {
      if (Q[I] === j) return Q;
      var ge = j, Ze = Et({}, Q, wt({}, I, j));
      return j ? ee(j) : (ge = Object.values(Ze).find(Boolean), ee(ge)), o && o(ge, Ze), Ze;
    });
  }, []), M = C.useCallback(function(I, j) {
    requestAnimationFrame(function() {
      document.activeElement.tagName !== "INPUT" ? P(!0) : j === !1 && P(!1);
    }), v(function(Q) {
      if (Q[I] === j) return Q;
      var ge = Et({}, Q, wt({}, I, j));
      return s && s(wt({}, I, j), ge), ge;
    });
  }, []), V = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onBlur && I.onBlur(j), a && a(j), N(void 0), M("cardNumber", !0);
    };
  }, [a, M]), w = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      var Q = j.target.value || "", ge = Q.replace(/\s/g, ""), Ze = p.current.selectionStart, Ct = ke.cardTypes.getCardTypeByValue(ge);
      te(Ct), M("cardNumber", !1), p.current.value = ke.formatter.formatCardNumber(ge), I.onChange && I.onChange(j), i && i(j), requestAnimationFrame(function() {
        document.activeElement === p.current && (p.current.value[Ze - 1] === " " && (Ze = Ze + 1), p.current.setSelectionRange(Ze, Ze));
      });
      var fn = ke.validator.getCardNumberError(ge, l, {
        errorMessages: r
      });
      !fn && n && m.current && m.current.focus(), T("cardNumber", fn), I.onError && I.onError(fn);
    };
  }, [n, l, r, i, T, M]), $ = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onFocus && I.onFocus(j), N("cardNumber");
    };
  }, []), O = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      var Q = j.target.value || "", ge = Q.replace(/\s/g, "");
      I.onKeyPress && I.onKeyPress(j), j.key !== ke.ENTER_KEY_CODE && (ke.validator.isNumeric(j) || j.preventDefault(), ke.validator.hasCardNumberReachedMaxLength(ge) && j.preventDefault());
    };
  }, []), J = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, j = I.refKey, Q = Sr(I, ["refKey"]);
    return Et(wt({
      "aria-label": "Card number",
      autoComplete: "cc-number",
      id: "cardNumber",
      name: "cardNumber",
      placeholder: "Card number",
      type: "tel"
    }, j || "ref", p), Q, {
      onBlur: V(Q),
      onChange: w(Q),
      onFocus: $(Q),
      onKeyPress: O(Q)
    });
  }, [V, w, $, O]), K = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onBlur && I.onBlur(j), a && a(j), N(void 0), M("expiryDate", !0);
    };
  }, [a, M]), oe = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      M("expiryDate", !1), m.current.value = ke.formatter.formatExpiry(j), I.onChange && I.onChange(j), i && i(j);
      var Q = ke.validator.getExpiryDateError(m.current.value, u, {
        errorMessages: r
      });
      !Q && n && _.current && _.current.focus(), T("expiryDate", Q), I.onError && I.onError(Q);
    };
  }, [n, r, u, i, T, M]), k = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onFocus && I.onFocus(j), N("expiryDate");
    };
  }, []), ue = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onKeyDown && I.onKeyDown(j), j.key === ke.BACKSPACE_KEY_CODE && !j.target.value && n && p.current && p.current.focus();
    };
  }, [n]), E = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      var Q = j.target.value || "", ge = Q.replace(" / ", "");
      I.onKeyPress && I.onKeyPress(j), j.key !== ke.ENTER_KEY_CODE && (ke.validator.isNumeric(j) || j.preventDefault(), ge.length >= 4 && j.preventDefault());
    };
  }, []), R = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, j = I.refKey, Q = Sr(I, ["refKey"]);
    return Et(wt({
      "aria-label": "Expiry date in format MM YY",
      autoComplete: "cc-exp",
      id: "expiryDate",
      name: "expiryDate",
      placeholder: "MM/YY",
      type: "tel"
    }, j || "ref", m), Q, {
      onBlur: K(Q),
      onChange: oe(Q),
      onFocus: k(Q),
      onKeyDown: ue(Q),
      onKeyPress: E(Q)
    });
  }, [K, oe, k, ue, E]), q = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onBlur && I.onBlur(j), a && a(j), N(void 0), M("cvc", !0);
    };
  }, [a, M]), X = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Q = j.cardType;
    return function(ge) {
      var Ze = ge.target.value;
      M("cvc", !1), I.onChange && I.onChange(ge), i && i(ge);
      var Ct = ke.validator.getCVCError(Ze, d, {
        cardType: Q,
        errorMessages: r
      });
      !Ct && n && y.current && y.current.focus(), T("cvc", Ct), I.onError && I.onError(Ct);
    };
  }, [n, d, r, i, T, M]), he = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onFocus && I.onFocus(j), N("cvc");
    };
  }, []), We = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onKeyDown && I.onKeyDown(j), j.key === ke.BACKSPACE_KEY_CODE && !j.target.value && n && m.current && m.current.focus();
    };
  }, [n]), Pe = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, j = arguments.length > 1 ? arguments[1] : void 0, Q = j.cardType;
    return function(ge) {
      var Ze = ge.target.value || "", Ct = Ze.replace(" / ", "");
      I.onKeyPress && I.onKeyPress(ge), ge.key !== ke.ENTER_KEY_CODE && (ke.validator.isNumeric(ge) || ge.preventDefault(), Q && Ct.length >= Q.code.length && ge.preventDefault(), Ct.length >= 4 && ge.preventDefault());
    };
  }, []), Dt = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, j = I.refKey, Q = Sr(I, ["refKey"]);
    return Et(wt({
      "aria-label": "CVC",
      autoComplete: "cc-csc",
      id: "cvc",
      name: "cvc",
      placeholder: ne ? ne.code.name : "CVC",
      type: "tel"
    }, j || "ref", _), Q, {
      onBlur: q(Q),
      onChange: X(Q, {
        cardType: ne
      }),
      onFocus: he(Q),
      onKeyDown: We(Q),
      onKeyPress: Pe(Q, {
        cardType: ne
      })
    });
  }, [ne, q, X, he, We, Pe]), bt = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onBlur && I.onBlur(j), a && a(j), N(void 0), M("zip", !0);
    };
  }, [a, M]), Ke = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      var Q = j.target.value;
      M("zip", !1), I.onChange && I.onChange(j), i && i(j);
      var ge = ke.validator.getZIPError(Q, {
        errorMessages: r
      });
      T("zip", ge), I.onError && I.onError(ge);
    };
  }, [r, i, T, M]), ae = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onFocus && I.onFocus(j), N("zip");
    };
  }, []), Se = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onKeyDown && I.onKeyDown(j), j.key === ke.BACKSPACE_KEY_CODE && !j.target.value && n && _.current && _.current.focus();
    };
  }, [n]), It = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(j) {
      I.onKeyPress && I.onKeyPress(j), j.key !== ke.ENTER_KEY_CODE && (ke.validator.isNumeric(j) || j.preventDefault());
    };
  }, []), Qt = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, j = I.refKey, Q = Sr(I, ["refKey"]);
    return Et(wt({
      autoComplete: "off",
      id: "zip",
      maxLength: "6",
      name: "zip",
      placeholder: "ZIP",
      type: "tel"
    }, j || "ref", y), Q, {
      onBlur: bt(Q),
      onChange: Ke(Q),
      onFocus: ae(Q),
      onKeyDown: Se(Q),
      onKeyPress: It(Q)
    });
  }, [bt, Ke, ae, Se, It]), ut = C.useCallback(function() {
    var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, j = I.images || {};
    return Et({
      "aria-label": ne ? ne.displayName : "Placeholder card",
      children: j[ne ? ne.type : "placeholder"] || j.placeholder,
      width: "1.5em",
      height: "1em",
      viewBox: "0 0 24 16"
    }, I);
  }, [ne]);
  return C.useLayoutEffect(function() {
    if (y.current) {
      var I = ke.validator.getZIPError(y.current.value, {
        errorMessages: r
      });
      T("zip", I);
    }
    if (_.current) {
      var j = ke.validator.getCVCError(_.current.value, d, {
        errorMessages: r
      });
      T("cvc", j);
    }
    if (m.current) {
      var Q = ke.validator.getExpiryDateError(m.current.value, u, {
        errorMessages: r
      });
      T("expiryDate", Q);
    }
    if (p.current) {
      var ge = ke.validator.getCardNumberError(p.current.value, l, {
        errorMessages: r
      });
      T("cardNumber", ge);
    }
  }, [l, d, r, u, T]), C.useLayoutEffect(function() {
    p.current && (p.current.value = ke.formatter.formatCardNumber(p.current.value)), m.current && (m.current.value = ke.formatter.formatExpiry({
      target: m.current
    }));
  }, []), C.useLayoutEffect(function() {
    if (p.current) {
      var I = ke.cardTypes.getCardTypeByValue(p.current.value);
      te(I);
    }
  }, []), {
    getCardImageProps: ut,
    getCardNumberProps: J,
    getExpiryDateProps: R,
    getCVCProps: Dt,
    getZIPProps: Qt,
    wrapperProps: {
      error: Y,
      focused: D,
      isTouched: h
    },
    meta: {
      cardType: ne,
      erroredInputs: W,
      error: Y,
      focused: D,
      isTouched: h,
      touchedInputs: b
    }
  };
}
var Pr = { exports: {} }, be = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Di;
function N0() {
  if (Di) return be;
  Di = 1;
  var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), y;
  y = Symbol.for("react.module.reference");
  function f(g) {
    if (typeof g == "object" && g !== null) {
      var b = g.$$typeof;
      switch (b) {
        case t:
          switch (g = g.type, g) {
            case n:
            case a:
            case r:
            case d:
            case u:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case s:
                case o:
                case l:
                case m:
                case p:
                case i:
                  return g;
                default:
                  return b;
              }
          }
        case e:
          return b;
      }
    }
  }
  return be.ContextConsumer = o, be.ContextProvider = i, be.Element = t, be.ForwardRef = l, be.Fragment = n, be.Lazy = m, be.Memo = p, be.Portal = e, be.Profiler = a, be.StrictMode = r, be.Suspense = d, be.SuspenseList = u, be.isAsyncMode = function() {
    return !1;
  }, be.isConcurrentMode = function() {
    return !1;
  }, be.isContextConsumer = function(g) {
    return f(g) === o;
  }, be.isContextProvider = function(g) {
    return f(g) === i;
  }, be.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === t;
  }, be.isForwardRef = function(g) {
    return f(g) === l;
  }, be.isFragment = function(g) {
    return f(g) === n;
  }, be.isLazy = function(g) {
    return f(g) === m;
  }, be.isMemo = function(g) {
    return f(g) === p;
  }, be.isPortal = function(g) {
    return f(g) === e;
  }, be.isProfiler = function(g) {
    return f(g) === a;
  }, be.isStrictMode = function(g) {
    return f(g) === r;
  }, be.isSuspense = function(g) {
    return f(g) === d;
  }, be.isSuspenseList = function(g) {
    return f(g) === u;
  }, be.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === a || g === r || g === d || g === u || g === _ || typeof g == "object" && g !== null && (g.$$typeof === m || g.$$typeof === p || g.$$typeof === i || g.$$typeof === o || g.$$typeof === l || g.$$typeof === y || g.getModuleId !== void 0);
  }, be.typeOf = f, be;
}
var Ce = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ii;
function M0() {
  return Ii || (Ii = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), _ = Symbol.for("react.offscreen"), y = !1, f = !1, g = !1, b = !1, v = !1, x;
    x = Symbol.for("react.module.reference");
    function S(E) {
      return !!(typeof E == "string" || typeof E == "function" || E === n || E === a || v || E === r || E === d || E === u || b || E === _ || y || f || g || typeof E == "object" && E !== null && (E.$$typeof === m || E.$$typeof === p || E.$$typeof === i || E.$$typeof === o || E.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      E.$$typeof === x || E.getModuleId !== void 0));
    }
    function h(E) {
      if (typeof E == "object" && E !== null) {
        var R = E.$$typeof;
        switch (R) {
          case t:
            var q = E.type;
            switch (q) {
              case n:
              case a:
              case r:
              case d:
              case u:
                return q;
              default:
                var X = q && q.$$typeof;
                switch (X) {
                  case s:
                  case o:
                  case l:
                  case m:
                  case p:
                  case i:
                    return X;
                  default:
                    return R;
                }
            }
          case e:
            return R;
        }
      }
    }
    var P = o, F = i, G = t, W = l, H = n, B = m, U = p, Y = e, ee = a, Z = r, pe = d, ne = u, te = !1, ce = !1;
    function A(E) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function D(E) {
      return ce || (ce = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function N(E) {
      return h(E) === o;
    }
    function T(E) {
      return h(E) === i;
    }
    function M(E) {
      return typeof E == "object" && E !== null && E.$$typeof === t;
    }
    function V(E) {
      return h(E) === l;
    }
    function w(E) {
      return h(E) === n;
    }
    function $(E) {
      return h(E) === m;
    }
    function O(E) {
      return h(E) === p;
    }
    function J(E) {
      return h(E) === e;
    }
    function K(E) {
      return h(E) === a;
    }
    function oe(E) {
      return h(E) === r;
    }
    function k(E) {
      return h(E) === d;
    }
    function ue(E) {
      return h(E) === u;
    }
    Ce.ContextConsumer = P, Ce.ContextProvider = F, Ce.Element = G, Ce.ForwardRef = W, Ce.Fragment = H, Ce.Lazy = B, Ce.Memo = U, Ce.Portal = Y, Ce.Profiler = ee, Ce.StrictMode = Z, Ce.Suspense = pe, Ce.SuspenseList = ne, Ce.isAsyncMode = A, Ce.isConcurrentMode = D, Ce.isContextConsumer = N, Ce.isContextProvider = T, Ce.isElement = M, Ce.isForwardRef = V, Ce.isFragment = w, Ce.isLazy = $, Ce.isMemo = O, Ce.isPortal = J, Ce.isProfiler = K, Ce.isStrictMode = oe, Ce.isSuspense = k, Ce.isSuspenseList = ue, Ce.isValidElementType = S, Ce.typeOf = h;
  })()), Ce;
}
var ji;
function O0() {
  return ji || (ji = 1, process.env.NODE_ENV === "production" ? Pr.exports = N0() : Pr.exports = M0()), Pr.exports;
}
var Pa = O0();
function R0(t) {
  function e(N, T, M, V, w) {
    for (var $ = 0, O = 0, J = 0, K = 0, oe, k, ue = 0, E = 0, R, q = R = oe = 0, X = 0, he = 0, We = 0, Pe = 0, Dt = M.length, bt = Dt - 1, Ke, ae = "", Se = "", It = "", Qt = "", ut; X < Dt; ) {
      if (k = M.charCodeAt(X), X === bt && O + K + J + $ !== 0 && (O !== 0 && (k = O === 47 ? 10 : 47), K = J = $ = 0, Dt++, bt++), O + K + J + $ === 0) {
        if (X === bt && (0 < he && (ae = ae.replace(m, "")), 0 < ae.trim().length)) {
          switch (k) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              ae += M.charAt(X);
          }
          k = 59;
        }
        switch (k) {
          case 123:
            for (ae = ae.trim(), oe = ae.charCodeAt(0), R = 1, Pe = ++X; X < Dt; ) {
              switch (k = M.charCodeAt(X)) {
                case 123:
                  R++;
                  break;
                case 125:
                  R--;
                  break;
                case 47:
                  switch (k = M.charCodeAt(X + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (q = X + 1; q < bt; ++q)
                          switch (M.charCodeAt(q)) {
                            case 47:
                              if (k === 42 && M.charCodeAt(q - 1) === 42 && X + 2 !== q) {
                                X = q + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (k === 47) {
                                X = q + 1;
                                break e;
                              }
                          }
                        X = q;
                      }
                  }
                  break;
                case 91:
                  k++;
                case 40:
                  k++;
                case 34:
                case 39:
                  for (; X++ < bt && M.charCodeAt(X) !== k; )
                    ;
              }
              if (R === 0) break;
              X++;
            }
            switch (R = M.substring(Pe, X), oe === 0 && (oe = (ae = ae.replace(p, "").trim()).charCodeAt(0)), oe) {
              case 64:
                switch (0 < he && (ae = ae.replace(m, "")), k = ae.charCodeAt(1), k) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    he = T;
                    break;
                  default:
                    he = pe;
                }
                if (R = e(T, he, R, k, w + 1), Pe = R.length, 0 < te && (he = n(pe, ae, We), ut = s(3, R, he, T, Y, U, Pe, k, w, V), ae = he.join(""), ut !== void 0 && (Pe = (R = ut.trim()).length) === 0 && (k = 0, R = "")), 0 < Pe) switch (k) {
                  case 115:
                    ae = ae.replace(P, o);
                  case 100:
                  case 109:
                  case 45:
                    R = ae + "{" + R + "}";
                    break;
                  case 107:
                    ae = ae.replace(v, "$1 $2"), R = ae + "{" + R + "}", R = Z === 1 || Z === 2 && i("@" + R, 3) ? "@-webkit-" + R + "@" + R : "@" + R;
                    break;
                  default:
                    R = ae + R, V === 112 && (R = (Se += R, ""));
                }
                else R = "";
                break;
              default:
                R = e(T, n(T, ae, We), R, V, w + 1);
            }
            It += R, R = We = he = q = oe = 0, ae = "", k = M.charCodeAt(++X);
            break;
          case 125:
          case 59:
            if (ae = (0 < he ? ae.replace(m, "") : ae).trim(), 1 < (Pe = ae.length)) switch (q === 0 && (oe = ae.charCodeAt(0), oe === 45 || 96 < oe && 123 > oe) && (Pe = (ae = ae.replace(" ", ":")).length), 0 < te && (ut = s(1, ae, T, N, Y, U, Se.length, V, w, V)) !== void 0 && (Pe = (ae = ut.trim()).length) === 0 && (ae = "\0\0"), oe = ae.charCodeAt(0), k = ae.charCodeAt(1), oe) {
              case 0:
                break;
              case 64:
                if (k === 105 || k === 99) {
                  Qt += ae + M.charAt(X);
                  break;
                }
              default:
                ae.charCodeAt(Pe - 1) !== 58 && (Se += a(ae, oe, k, ae.charCodeAt(2)));
            }
            We = he = q = oe = 0, ae = "", k = M.charCodeAt(++X);
        }
      }
      switch (k) {
        case 13:
        case 10:
          O === 47 ? O = 0 : 1 + oe === 0 && V !== 107 && 0 < ae.length && (he = 1, ae += "\0"), 0 < te * A && s(0, ae, T, N, Y, U, Se.length, V, w, V), U = 1, Y++;
          break;
        case 59:
        case 125:
          if (O + K + J + $ === 0) {
            U++;
            break;
          }
        default:
          switch (U++, Ke = M.charAt(X), k) {
            case 9:
            case 32:
              if (K + $ + O === 0) switch (ue) {
                case 44:
                case 58:
                case 9:
                case 32:
                  Ke = "";
                  break;
                default:
                  k !== 32 && (Ke = " ");
              }
              break;
            case 0:
              Ke = "\\0";
              break;
            case 12:
              Ke = "\\f";
              break;
            case 11:
              Ke = "\\v";
              break;
            case 38:
              K + O + $ === 0 && (he = We = 1, Ke = "\f" + Ke);
              break;
            case 108:
              if (K + O + $ + ee === 0 && 0 < q) switch (X - q) {
                case 2:
                  ue === 112 && M.charCodeAt(X - 3) === 58 && (ee = ue);
                case 8:
                  E === 111 && (ee = E);
              }
              break;
            case 58:
              K + O + $ === 0 && (q = X);
              break;
            case 44:
              O + J + K + $ === 0 && (he = 1, Ke += "\r");
              break;
            case 34:
            case 39:
              O === 0 && (K = K === k ? 0 : K === 0 ? k : K);
              break;
            case 91:
              K + O + J === 0 && $++;
              break;
            case 93:
              K + O + J === 0 && $--;
              break;
            case 41:
              K + O + $ === 0 && J--;
              break;
            case 40:
              if (K + O + $ === 0) {
                if (oe === 0) switch (2 * ue + 3 * E) {
                  case 533:
                    break;
                  default:
                    oe = 1;
                }
                J++;
              }
              break;
            case 64:
              O + J + K + $ + q + R === 0 && (R = 1);
              break;
            case 42:
            case 47:
              if (!(0 < K + $ + J)) switch (O) {
                case 0:
                  switch (2 * k + 3 * M.charCodeAt(X + 1)) {
                    case 235:
                      O = 47;
                      break;
                    case 220:
                      Pe = X, O = 42;
                  }
                  break;
                case 42:
                  k === 47 && ue === 42 && Pe + 2 !== X && (M.charCodeAt(Pe + 2) === 33 && (Se += M.substring(Pe, X + 1)), Ke = "", O = 0);
              }
          }
          O === 0 && (ae += Ke);
      }
      E = ue, ue = k, X++;
    }
    if (Pe = Se.length, 0 < Pe) {
      if (he = T, 0 < te && (ut = s(2, Se, he, N, Y, U, Pe, V, w, V), ut !== void 0 && (Se = ut).length === 0)) return Qt + Se + It;
      if (Se = he.join(",") + "{" + Se + "}", Z * ee !== 0) {
        switch (Z !== 2 || i(Se, 2) || (ee = 0), ee) {
          case 111:
            Se = Se.replace(S, ":-moz-$1") + Se;
            break;
          case 112:
            Se = Se.replace(x, "::-webkit-input-$1") + Se.replace(x, "::-moz-$1") + Se.replace(x, ":-ms-input-$1") + Se;
        }
        ee = 0;
      }
    }
    return Qt + Se + It;
  }
  function n(N, T, M) {
    var V = T.trim().split(g);
    T = V;
    var w = V.length, $ = N.length;
    switch ($) {
      case 0:
      case 1:
        var O = 0;
        for (N = $ === 0 ? "" : N[0] + " "; O < w; ++O)
          T[O] = r(N, T[O], M).trim();
        break;
      default:
        var J = O = 0;
        for (T = []; O < w; ++O)
          for (var K = 0; K < $; ++K)
            T[J++] = r(N[K] + " ", V[O], M).trim();
    }
    return T;
  }
  function r(N, T, M) {
    var V = T.charCodeAt(0);
    switch (33 > V && (V = (T = T.trim()).charCodeAt(0)), V) {
      case 38:
        return T.replace(b, "$1" + N.trim());
      case 58:
        return N.trim() + T.replace(b, "$1" + N.trim());
      default:
        if (0 < 1 * M && 0 < T.indexOf("\f")) return T.replace(b, (N.charCodeAt(0) === 58 ? "" : "$1") + N.trim());
    }
    return N + T;
  }
  function a(N, T, M, V) {
    var w = N + ";", $ = 2 * T + 3 * M + 4 * V;
    if ($ === 944) {
      N = w.indexOf(":", 9) + 1;
      var O = w.substring(N, w.length - 1).trim();
      return O = w.substring(0, N).trim() + O + ";", Z === 1 || Z === 2 && i(O, 1) ? "-webkit-" + O + O : O;
    }
    if (Z === 0 || Z === 2 && !i(w, 1)) return w;
    switch ($) {
      case 1015:
        return w.charCodeAt(10) === 97 ? "-webkit-" + w + w : w;
      case 951:
        return w.charCodeAt(3) === 116 ? "-webkit-" + w + w : w;
      case 963:
        return w.charCodeAt(5) === 110 ? "-webkit-" + w + w : w;
      case 1009:
        if (w.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + w + w;
      case 978:
        return "-webkit-" + w + "-moz-" + w + w;
      case 1019:
      case 983:
        return "-webkit-" + w + "-moz-" + w + "-ms-" + w + w;
      case 883:
        if (w.charCodeAt(8) === 45) return "-webkit-" + w + w;
        if (0 < w.indexOf("image-set(", 11)) return w.replace(B, "$1-webkit-$2") + w;
        break;
      case 932:
        if (w.charCodeAt(4) === 45) switch (w.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + w.replace("-grow", "") + "-webkit-" + w + "-ms-" + w.replace("grow", "positive") + w;
          case 115:
            return "-webkit-" + w + "-ms-" + w.replace("shrink", "negative") + w;
          case 98:
            return "-webkit-" + w + "-ms-" + w.replace("basis", "preferred-size") + w;
        }
        return "-webkit-" + w + "-ms-" + w + w;
      case 964:
        return "-webkit-" + w + "-ms-flex-" + w + w;
      case 1023:
        if (w.charCodeAt(8) !== 99) break;
        return O = w.substring(w.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + O + "-webkit-" + w + "-ms-flex-pack" + O + w;
      case 1005:
        return y.test(w) ? w.replace(_, ":-webkit-") + w.replace(_, ":-moz-") + w : w;
      case 1e3:
        switch (O = w.substring(13).trim(), T = O.indexOf("-") + 1, O.charCodeAt(0) + O.charCodeAt(T)) {
          case 226:
            O = w.replace(h, "tb");
            break;
          case 232:
            O = w.replace(h, "tb-rl");
            break;
          case 220:
            O = w.replace(h, "lr");
            break;
          default:
            return w;
        }
        return "-webkit-" + w + "-ms-" + O + w;
      case 1017:
        if (w.indexOf("sticky", 9) === -1) break;
      case 975:
        switch (T = (w = N).length - 10, O = (w.charCodeAt(T) === 33 ? w.substring(0, T) : w).substring(N.indexOf(":", 7) + 1).trim(), $ = O.charCodeAt(0) + (O.charCodeAt(7) | 0)) {
          case 203:
            if (111 > O.charCodeAt(8)) break;
          case 115:
            w = w.replace(O, "-webkit-" + O) + ";" + w;
            break;
          case 207:
          case 102:
            w = w.replace(O, "-webkit-" + (102 < $ ? "inline-" : "") + "box") + ";" + w.replace(O, "-webkit-" + O) + ";" + w.replace(O, "-ms-" + O + "box") + ";" + w;
        }
        return w + ";";
      case 938:
        if (w.charCodeAt(5) === 45) switch (w.charCodeAt(6)) {
          case 105:
            return O = w.replace("-items", ""), "-webkit-" + w + "-webkit-box-" + O + "-ms-flex-" + O + w;
          case 115:
            return "-webkit-" + w + "-ms-flex-item-" + w.replace(G, "") + w;
          default:
            return "-webkit-" + w + "-ms-flex-line-pack" + w.replace("align-content", "").replace(G, "") + w;
        }
        break;
      case 973:
      case 989:
        if (w.charCodeAt(3) !== 45 || w.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (H.test(N) === !0) return (O = N.substring(N.indexOf(":") + 1)).charCodeAt(0) === 115 ? a(N.replace("stretch", "fill-available"), T, M, V).replace(":fill-available", ":stretch") : w.replace(O, "-webkit-" + O) + w.replace(O, "-moz-" + O.replace("fill-", "")) + w;
        break;
      case 962:
        if (w = "-webkit-" + w + (w.charCodeAt(5) === 102 ? "-ms-" + w : "") + w, M + V === 211 && w.charCodeAt(13) === 105 && 0 < w.indexOf("transform", 10)) return w.substring(0, w.indexOf(";", 27) + 1).replace(f, "$1-webkit-$2") + w;
    }
    return w;
  }
  function i(N, T) {
    var M = N.indexOf(T === 1 ? ":" : "{"), V = N.substring(0, T !== 3 ? M : 10);
    return M = N.substring(M + 1, N.length - 1), ce(T !== 2 ? V : V.replace(W, "$1"), M, T);
  }
  function o(N, T) {
    var M = a(T, T.charCodeAt(0), T.charCodeAt(1), T.charCodeAt(2));
    return M !== T + ";" ? M.replace(F, " or ($1)").substring(4) : "(" + T + ")";
  }
  function s(N, T, M, V, w, $, O, J, K, oe) {
    for (var k = 0, ue = T, E; k < te; ++k)
      switch (E = ne[k].call(u, N, ue, M, V, w, $, O, J, K, oe)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          ue = E;
      }
    if (ue !== T) return ue;
  }
  function l(N) {
    switch (N) {
      case void 0:
      case null:
        te = ne.length = 0;
        break;
      default:
        if (typeof N == "function") ne[te++] = N;
        else if (typeof N == "object") for (var T = 0, M = N.length; T < M; ++T)
          l(N[T]);
        else A = !!N | 0;
    }
    return l;
  }
  function d(N) {
    return N = N.prefix, N !== void 0 && (ce = null, N ? typeof N != "function" ? Z = 1 : (Z = 2, ce = N) : Z = 0), d;
  }
  function u(N, T) {
    var M = N;
    if (33 > M.charCodeAt(0) && (M = M.trim()), D = M, M = [D], 0 < te) {
      var V = s(-1, T, M, M, Y, U, 0, 0, 0, 0);
      V !== void 0 && typeof V == "string" && (T = V);
    }
    var w = e(pe, M, T, 0, 0);
    return 0 < te && (V = s(-2, w, M, M, Y, U, w.length, 0, 0, 0), V !== void 0 && (w = V)), D = "", ee = 0, U = Y = 1, w;
  }
  var p = /^\0+/g, m = /[\0\r\f]/g, _ = /: */g, y = /zoo|gra/, f = /([,: ])(transform)/g, g = /,\r+?/g, b = /([\t\r\n ])*\f?&/g, v = /@(k\w+)\s*(\S*)\s*/, x = /::(place)/g, S = /:(read-only)/g, h = /[svh]\w+-[tblr]{2}/, P = /\(\s*(.*)\s*\)/g, F = /([\s\S]*?);/g, G = /-self|flex-/g, W = /[^]*?(:[rp][el]a[\w-]+)[^]*/, H = /stretch|:\s*\w+\-(?:conte|avail)/, B = /([^-])(image-set\()/, U = 1, Y = 1, ee = 0, Z = 1, pe = [], ne = [], te = 0, ce = null, A = 0, D = "";
  return u.use = l, u.set = d, t !== void 0 && d(t), u;
}
var A0 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function z0(t) {
  var e = {};
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var D0 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Fi = z0(
  function(t) {
    return D0.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Er = { exports: {} }, we = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vi;
function I0() {
  if (Vi) return we;
  Vi = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, _ = t ? Symbol.for("react.memo") : 60115, y = t ? Symbol.for("react.lazy") : 60116, f = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
  function x(h) {
    if (typeof h == "object" && h !== null) {
      var P = h.$$typeof;
      switch (P) {
        case e:
          switch (h = h.type, h) {
            case l:
            case d:
            case r:
            case i:
            case a:
            case p:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case s:
                case u:
                case y:
                case _:
                case o:
                  return h;
                default:
                  return P;
              }
          }
        case n:
          return P;
      }
    }
  }
  function S(h) {
    return x(h) === d;
  }
  return we.AsyncMode = l, we.ConcurrentMode = d, we.ContextConsumer = s, we.ContextProvider = o, we.Element = e, we.ForwardRef = u, we.Fragment = r, we.Lazy = y, we.Memo = _, we.Portal = n, we.Profiler = i, we.StrictMode = a, we.Suspense = p, we.isAsyncMode = function(h) {
    return S(h) || x(h) === l;
  }, we.isConcurrentMode = S, we.isContextConsumer = function(h) {
    return x(h) === s;
  }, we.isContextProvider = function(h) {
    return x(h) === o;
  }, we.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, we.isForwardRef = function(h) {
    return x(h) === u;
  }, we.isFragment = function(h) {
    return x(h) === r;
  }, we.isLazy = function(h) {
    return x(h) === y;
  }, we.isMemo = function(h) {
    return x(h) === _;
  }, we.isPortal = function(h) {
    return x(h) === n;
  }, we.isProfiler = function(h) {
    return x(h) === i;
  }, we.isStrictMode = function(h) {
    return x(h) === a;
  }, we.isSuspense = function(h) {
    return x(h) === p;
  }, we.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === r || h === d || h === i || h === a || h === p || h === m || typeof h == "object" && h !== null && (h.$$typeof === y || h.$$typeof === _ || h.$$typeof === o || h.$$typeof === s || h.$$typeof === u || h.$$typeof === g || h.$$typeof === b || h.$$typeof === v || h.$$typeof === f);
  }, we.typeOf = x, we;
}
var xe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hi;
function j0() {
  return Hi || (Hi = 1, process.env.NODE_ENV !== "production" && (function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, o = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, _ = t ? Symbol.for("react.memo") : 60115, y = t ? Symbol.for("react.lazy") : 60116, f = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
    function x(k) {
      return typeof k == "string" || typeof k == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      k === r || k === d || k === i || k === a || k === p || k === m || typeof k == "object" && k !== null && (k.$$typeof === y || k.$$typeof === _ || k.$$typeof === o || k.$$typeof === s || k.$$typeof === u || k.$$typeof === g || k.$$typeof === b || k.$$typeof === v || k.$$typeof === f);
    }
    function S(k) {
      if (typeof k == "object" && k !== null) {
        var ue = k.$$typeof;
        switch (ue) {
          case e:
            var E = k.type;
            switch (E) {
              case l:
              case d:
              case r:
              case i:
              case a:
              case p:
                return E;
              default:
                var R = E && E.$$typeof;
                switch (R) {
                  case s:
                  case u:
                  case y:
                  case _:
                  case o:
                    return R;
                  default:
                    return ue;
                }
            }
          case n:
            return ue;
        }
      }
    }
    var h = l, P = d, F = s, G = o, W = e, H = u, B = r, U = y, Y = _, ee = n, Z = i, pe = a, ne = p, te = !1;
    function ce(k) {
      return te || (te = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(k) || S(k) === l;
    }
    function A(k) {
      return S(k) === d;
    }
    function D(k) {
      return S(k) === s;
    }
    function N(k) {
      return S(k) === o;
    }
    function T(k) {
      return typeof k == "object" && k !== null && k.$$typeof === e;
    }
    function M(k) {
      return S(k) === u;
    }
    function V(k) {
      return S(k) === r;
    }
    function w(k) {
      return S(k) === y;
    }
    function $(k) {
      return S(k) === _;
    }
    function O(k) {
      return S(k) === n;
    }
    function J(k) {
      return S(k) === i;
    }
    function K(k) {
      return S(k) === a;
    }
    function oe(k) {
      return S(k) === p;
    }
    xe.AsyncMode = h, xe.ConcurrentMode = P, xe.ContextConsumer = F, xe.ContextProvider = G, xe.Element = W, xe.ForwardRef = H, xe.Fragment = B, xe.Lazy = U, xe.Memo = Y, xe.Portal = ee, xe.Profiler = Z, xe.StrictMode = pe, xe.Suspense = ne, xe.isAsyncMode = ce, xe.isConcurrentMode = A, xe.isContextConsumer = D, xe.isContextProvider = N, xe.isElement = T, xe.isForwardRef = M, xe.isFragment = V, xe.isLazy = w, xe.isMemo = $, xe.isPortal = O, xe.isProfiler = J, xe.isStrictMode = K, xe.isSuspense = oe, xe.isValidElementType = x, xe.typeOf = S;
  })()), xe;
}
var $i;
function F0() {
  return $i || ($i = 1, process.env.NODE_ENV === "production" ? Er.exports = I0() : Er.exports = j0()), Er.exports;
}
var On, Bi;
function V0() {
  if (Bi) return On;
  Bi = 1;
  var t = F0(), e = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, a = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[t.ForwardRef] = r, i[t.Memo] = a;
  function o(y) {
    return t.isMemo(y) ? a : i[y.$$typeof] || e;
  }
  var s = Object.defineProperty, l = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, u = Object.getOwnPropertyDescriptor, p = Object.getPrototypeOf, m = Object.prototype;
  function _(y, f, g) {
    if (typeof f != "string") {
      if (m) {
        var b = p(f);
        b && b !== m && _(y, b, g);
      }
      var v = l(f);
      d && (v = v.concat(d(f)));
      for (var x = o(y), S = o(f), h = 0; h < v.length; ++h) {
        var P = v[h];
        if (!n[P] && !(g && g[P]) && !(S && S[P]) && !(x && x[P])) {
          var F = u(f, P);
          try {
            s(y, P, F);
          } catch {
          }
        }
      }
    }
    return y;
  }
  return On = _, On;
}
var H0 = V0();
const $0 = /* @__PURE__ */ mr(H0);
function gt() {
  return gt = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, gt.apply(this, arguments);
}
function B0(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(e.indexOf(a) >= 0) && (n[a] = t[a]);
  return n;
}
var Ki = (function(t, e) {
  for (var n = [t[0]], r = 0, a = e.length; r < a; r += 1)
    n.push(e[r], t[r + 1]);
  return n;
}), Ea = (function(t) {
  return t !== null && typeof t == "object" && (t.toString ? t.toString() : Object.prototype.toString.call(t)) === "[object Object]" && !Pa.typeOf(t);
}), Yr = Object.freeze([]), Rt = Object.freeze({});
function gr(t) {
  return typeof t == "function";
}
function La(t) {
  return (process.env.NODE_ENV !== "production" ? typeof t == "string" && t : !1) || // $FlowFixMe
  t.displayName || // $FlowFixMe
  t.name || "Component";
}
function K0(t) {
  return typeof t == "function" && !(t.prototype && t.prototype.isReactComponent);
}
function Ta(t) {
  return t && typeof t.styledComponentId == "string";
}
var Zt = typeof process < "u" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", hs = "active", gs = "data-styled-version", _s = "5.1.1", Na = `/*!sc*/
`, Ma = typeof window < "u" && "HTMLElement" in window, U0 = typeof SC_DISABLE_SPEEDY == "boolean" && SC_DISABLE_SPEEDY || typeof process < "u" && (process.env.REACT_APP_SC_DISABLE_SPEEDY || process.env.SC_DISABLE_SPEEDY) || process.env.NODE_ENV !== "production", q0 = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, G0 = {
  1: `Cannot create styled-component for component: %s.

`,
  2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`,
  3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`,
  4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`,
  5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`,
  6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`,
  7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
  8: `ThemeProvider: Please make your "theme" prop an object.

`,
  9: "Missing document `<head>`\n\n",
  10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`,
  11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`,
  12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`,
  14: `ThemeProvider: "theme" prop is required.

`,
  15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
  16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`,
  17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`
}, W0 = process.env.NODE_ENV !== "production" ? G0 : {};
function Z0() {
  for (var t = arguments.length <= 0 ? void 0 : arguments[0], e = [], n = 1, r = arguments.length; n < r; n += 1)
    e.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
  return e.forEach(function(a) {
    t = t.replace(/%[a-z]/, a);
  }), t;
}
function Yt(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + t + " for more information." + (n.length > 0 ? " Additional arguments: " + n.join(", ") : "")) : new Error(Z0.apply(void 0, [W0[t]].concat(n)).trim());
}
var Y0 = 1, J0 = function(e) {
  for (var n = e.childNodes, r = n.length; r >= 0; r--) {
    var a = n[r];
    if (a && a.nodeType === Y0 && a.hasAttribute(Zt))
      return a;
  }
}, ys = function(e) {
  var n = document.head, r = e || n, a = document.createElement("style"), i = J0(r), o = i !== void 0 ? i.nextSibling : null;
  a.setAttribute(Zt, hs), a.setAttribute(gs, _s);
  var s = q0();
  return s && a.setAttribute("nonce", s), r.insertBefore(a, o), a;
}, X0 = function(e) {
  if (e.sheet)
    return e.sheet;
  for (var n = document, r = n.styleSheets, a = 0, i = r.length; a < i; a++) {
    var o = r[a];
    if (o.ownerNode === e)
      return o;
  }
  Yt(17);
}, Q0 = function(e) {
  var n = e.isServer, r = e.useCSSOMInjection, a = e.target;
  return n ? new rp(a) : r ? new ep(a) : new tp(a);
}, ep = /* @__PURE__ */ (function() {
  function t(n) {
    var r = this.element = ys(n);
    r.appendChild(document.createTextNode("")), this.sheet = X0(r), this.length = 0;
  }
  var e = t.prototype;
  return e.insertRule = function(r, a) {
    try {
      return this.sheet.insertRule(a, r), this.length++, !0;
    } catch {
      return !1;
    }
  }, e.deleteRule = function(r) {
    this.sheet.deleteRule(r), this.length--;
  }, e.getRule = function(r) {
    var a = this.sheet.cssRules[r];
    return a !== void 0 && typeof a.cssText == "string" ? a.cssText : "";
  }, t;
})(), tp = /* @__PURE__ */ (function() {
  function t(n) {
    var r = this.element = ys(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var e = t.prototype;
  return e.insertRule = function(r, a) {
    if (r <= this.length && r >= 0) {
      var i = document.createTextNode(a), o = this.nodes[r];
      return this.element.insertBefore(i, o || null), this.length++, !0;
    } else
      return !1;
  }, e.deleteRule = function(r) {
    this.element.removeChild(this.nodes[r]), this.length--;
  }, e.getRule = function(r) {
    return r < this.length ? this.nodes[r].textContent : "";
  }, t;
})(), rp = /* @__PURE__ */ (function() {
  function t(n) {
    this.rules = [], this.length = 0;
  }
  var e = t.prototype;
  return e.insertRule = function(r, a) {
    return r <= this.length ? (this.rules.splice(r, 0, a), this.length++, !0) : !1;
  }, e.deleteRule = function(r) {
    this.rules.splice(r, 1), this.length--;
  }, e.getRule = function(r) {
    return r < this.length ? this.rules[r] : "";
  }, t;
})(), np = function(e) {
  return new ap(e);
}, Ui = 512, ap = /* @__PURE__ */ (function() {
  function t(n) {
    this.groupSizes = new Uint32Array(Ui), this.length = Ui, this.tag = n;
  }
  var e = t.prototype;
  return e.indexOfGroup = function(r) {
    for (var a = 0, i = 0; i < r; i++)
      a += this.groupSizes[i];
    return a;
  }, e.insertRules = function(r, a) {
    if (r >= this.groupSizes.length) {
      for (var i = this.groupSizes, o = i.length, s = o; r >= s; )
        s <<= 1, s < 0 && Yt(16, "" + r);
      this.groupSizes = new Uint32Array(s), this.groupSizes.set(i), this.length = s;
      for (var l = o; l < s; l++)
        this.groupSizes[l] = 0;
    }
    for (var d = this.indexOfGroup(r + 1), u = 0, p = a.length; u < p; u++)
      this.tag.insertRule(d, a[u]) && (this.groupSizes[r]++, d++);
  }, e.clearGroup = function(r) {
    if (r < this.length) {
      var a = this.groupSizes[r], i = this.indexOfGroup(r), o = i + a;
      this.groupSizes[r] = 0;
      for (var s = i; s < o; s++)
        this.tag.deleteRule(i);
    }
  }, e.getGroup = function(r) {
    var a = "";
    if (r >= this.length || this.groupSizes[r] === 0)
      return a;
    for (var i = this.groupSizes[r], o = this.indexOfGroup(r), s = o + i, l = o; l < s; l++)
      a += "" + this.tag.getRule(l) + Na;
    return a;
  }, t;
})(), ip = 1 << 30, Fr = /* @__PURE__ */ new Map(), Oa = /* @__PURE__ */ new Map(), ea = 1, Lr = function(e) {
  if (Fr.has(e))
    return Fr.get(e);
  var n = ea++;
  return process.env.NODE_ENV !== "production" && ((n | 0) < 0 || n > ip) && Yt(16, "" + n), Fr.set(e, n), Oa.set(n, e), n;
}, op = function(e) {
  return Oa.get(e);
}, sp = function(e, n) {
  n >= ea && (ea = n + 1), Fr.set(e, n), Oa.set(n, e);
}, lp = "style[" + Zt + "][" + gs + '="' + _s + '"]', cp = new RegExp("^" + Zt + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), up = function(e) {
  for (var n = e.getTag(), r = n.length, a = "", i = 0; i < r; i++) {
    var o = op(i);
    if (o !== void 0) {
      var s = e.names.get(o), l = n.getGroup(i);
      if (!(s === void 0 || l.length === 0)) {
        var d = Zt + ".g" + i + '[id="' + o + '"]', u = "";
        s !== void 0 && s.forEach(function(p) {
          p.length > 0 && (u += p + ",");
        }), a += "" + l + d + '{content:"' + u + '"}' + Na;
      }
    }
  }
  return a;
}, dp = function(e, n, r) {
  for (var a = r.split(","), i, o = 0, s = a.length; o < s; o++)
    (i = a[o]) && e.registerName(n, i);
}, pp = function(e, n) {
  for (var r = n.innerHTML.split(Na), a = [], i = 0, o = r.length; i < o; i++) {
    var s = r[i].trim();
    if (s) {
      var l = s.match(cp);
      if (l) {
        var d = parseInt(l[1], 10) | 0, u = l[2];
        d !== 0 && (sp(u, d), dp(e, u, l[3]), e.getTag().insertRules(d, a)), a.length = 0;
      } else
        a.push(s);
    }
  }
}, mp = function(e) {
  for (var n = document.querySelectorAll(lp), r = 0, a = n.length; r < a; r++) {
    var i = n[r];
    i && i.getAttribute(Zt) !== hs && (pp(e, i), i.parentNode && i.parentNode.removeChild(i));
  }
}, qi = Ma, Gi = {
  isServer: !Ma,
  useCSSOMInjection: !U0
}, vs = /* @__PURE__ */ (function() {
  t.registerId = function(r) {
    return Lr(r);
  };
  function t(n, r, a) {
    n === void 0 && (n = Gi), r === void 0 && (r = {}), this.options = gt({}, Gi, {}, n), this.gs = r, this.names = new Map(a), !this.options.isServer && Ma && qi && (qi = !1, mp(this));
  }
  var e = t.prototype;
  return e.reconstructWithOptions = function(r) {
    return new t(gt({}, this.options, {}, r), this.gs, this.names);
  }, e.allocateGSInstance = function(r) {
    return this.gs[r] = (this.gs[r] || 0) + 1;
  }, e.getTag = function() {
    return this.tag || (this.tag = np(Q0(this.options)));
  }, e.hasNameForId = function(r, a) {
    return this.names.has(r) && this.names.get(r).has(a);
  }, e.registerName = function(r, a) {
    if (Lr(r), this.names.has(r))
      this.names.get(r).add(a);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(a), this.names.set(r, i);
    }
  }, e.insertRules = function(r, a, i) {
    this.registerName(r, a), this.getTag().insertRules(Lr(r), i);
  }, e.clearNames = function(r) {
    this.names.has(r) && this.names.get(r).clear();
  }, e.clearRules = function(r) {
    this.getTag().clearGroup(Lr(r)), this.clearNames(r);
  }, e.clearTag = function() {
    this.tag = void 0;
  }, e.toString = function() {
    return up(this);
  }, t;
})(), bs = 5381, Ht = function(e, n) {
  for (var r = n.length; r; )
    e = e * 33 ^ n.charCodeAt(--r);
  return e;
}, Cs = function(e) {
  return Ht(bs, e);
};
function fp(t) {
  var e = "/*|*/", n = e + "}";
  function r(a) {
    if (a)
      try {
        t(a + "}");
      } catch {
      }
  }
  return function(i, o, s, l, d, u, p, m, _, y) {
    switch (i) {
      // property
      case 1:
        if (_ === 0 && o.charCodeAt(0) === 64) return t(o + ";"), "";
        break;
      // selector
      case 2:
        if (m === 0) return o + e;
        break;
      // at-rule
      case 3:
        switch (m) {
          // @font-face, @page
          case 102:
          case 112:
            return t(s[0] + o), "";
          default:
            return o + (y === 0 ? e : "");
        }
      case -2:
        o.split(n).forEach(r);
    }
  };
}
var hp = /^\s*\/\/.*$/gm;
function gp(t) {
  var e = Rt, n = e.options, r = n === void 0 ? Rt : n, a = e.plugins, i = a === void 0 ? Yr : a, o = new R0(r), s = [], l = function(b) {
    if (b === -2) {
      var v = s;
      return s = [], v;
    }
  }, d = fp(function(g) {
    s.push(g);
  }), u, p, m, _ = function(b, v, x) {
    return (
      // the first self-ref is always untouched
      v > 0 && // there should be at least two self-refs to do a replacement (.b > .b)
      x.slice(0, v).indexOf(p) !== -1 && // no consecutive self refs (.b.b); that is a precedence boost and treated differently
      x.slice(v - p.length, v) !== p ? "." + u : b
    );
  }, y = function(b, v, x) {
    b === 2 && x.length && x[0].lastIndexOf(p) > 0 && (x[0] = x[0].replace(m, _));
  };
  o.use([].concat(i, [y, d, l]));
  function f(g, b, v, x) {
    x === void 0 && (x = "&");
    var S = g.replace(hp, ""), h = b && v ? v + " " + b + " { " + S + " }" : S;
    return u = x, p = b, m = new RegExp("\\" + p + "\\b", "g"), o(v || !b ? "" : b, h);
  }
  return f.hash = i.length ? i.reduce(function(g, b) {
    return b.name || Yt(15), Ht(g, b.name);
  }, bs).toString() : "", f;
}
var ws = C.createContext();
ws.Consumer;
var xs = C.createContext();
xs.Consumer;
var _p = new vs(), ks = gp();
function yp() {
  return vt(ws) || _p;
}
function vp() {
  return vt(xs) || ks;
}
var bp = /* @__PURE__ */ (function() {
  function t(n, r) {
    var a = this;
    this.inject = function(i) {
      i.hasNameForId(a.id, a.name) || i.insertRules(a.id, a.name, ks.apply(void 0, a.stringifyArgs));
    }, this.toString = function() {
      return Yt(12, String(a.name));
    }, this.name = n, this.id = "sc-keyframes-" + n, this.stringifyArgs = r;
  }
  var e = t.prototype;
  return e.getName = function() {
    return this.name;
  }, t;
})(), Cp = /([A-Z])/g, wp = /^ms-/;
function Wi(t) {
  return t.replace(Cp, "-$1").toLowerCase().replace(wp, "-ms-");
}
function xp(t, e) {
  return e == null || typeof e == "boolean" || e === "" ? "" : typeof e == "number" && e !== 0 && !(t in A0) ? e + "px" : String(e).trim();
}
var Ss = function(e) {
  return e == null || e === !1 || e === "";
}, kp = function t(e, n) {
  var r = [], a = Object.keys(e);
  return a.forEach(function(i) {
    if (!Ss(e[i])) {
      if (Ea(e[i]))
        return r.push.apply(r, t(e[i], i)), r;
      if (gr(e[i]))
        return r.push(Wi(i) + ":", e[i], ";"), r;
      r.push(Wi(i) + ": " + xp(i, e[i]) + ";");
    }
    return r;
  }), n ? [n + " {"].concat(r, ["}"]) : r;
};
function qt(t, e, n) {
  if (Array.isArray(t)) {
    for (var r = [], a = 0, i = t.length, o; a < i; a += 1)
      o = qt(t[a], e, n), o !== "" && (Array.isArray(o) ? r.push.apply(r, o) : r.push(o));
    return r;
  }
  if (Ss(t))
    return "";
  if (Ta(t))
    return "." + t.styledComponentId;
  if (gr(t))
    if (K0(t) && e) {
      var s = t(e);
      return process.env.NODE_ENV !== "production" && Pa.isElement(s) && console.warn(La(t) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), qt(s, e, n);
    } else return t;
  return t instanceof bp ? n ? (t.inject(n), t.getName()) : t : Ea(t) ? kp(t) : t.toString();
}
function ta(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  return gr(t) || Ea(t) ? qt(Ki(Yr, [t].concat(n))) : n.length === 0 && t.length === 1 && typeof t[0] == "string" ? t : qt(Ki(t, n));
}
function ra(t, e, n) {
  if (n === void 0 && (n = Rt), !Pa.isValidElementType(e))
    return Yt(1, String(e));
  var r = function() {
    return t(e, n, ta.apply(void 0, arguments));
  };
  return r.withConfig = function(a) {
    return ra(t, e, gt({}, n, {}, a));
  }, r.attrs = function(a) {
    return ra(t, e, gt({}, n, {
      attrs: Array.prototype.concat(n.attrs, a).filter(Boolean)
    }));
  }, r;
}
var na = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, Sp = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function Pp(t, e, n) {
  var r = t[n];
  na(e) && na(r) ? Ps(r, e) : t[n] = e;
}
function Ps(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  for (var a = 0, i = n; a < i.length; a++) {
    var o = i[a];
    if (na(o))
      for (var s in o)
        Sp(s) && Pp(t, o[s], s);
  }
  return t;
}
var Ep = /(a)(d)/gi, Tr = 52, Zi = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function aa(t) {
  var e = "", n;
  for (n = Math.abs(t); n > Tr; n = n / Tr | 0)
    e = Zi(n % Tr) + e;
  return (Zi(n % Tr) + e).replace(Ep, "$1-$2");
}
function Lp(t) {
  for (var e = 0; e < t.length; e += 1) {
    var n = t[e];
    if (gr(n) && !Ta(n))
      return !1;
  }
  return !0;
}
var Tp = /* @__PURE__ */ (function() {
  function t(n, r) {
    this.rules = n, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && Lp(n), this.componentId = r, this.baseHash = Cs(r), vs.registerId(r);
  }
  var e = t.prototype;
  return e.generateAndInjectStyles = function(r, a, i) {
    var o = this.componentId;
    if (this.isStatic && !i.hash) {
      if (this.staticRulesId && a.hasNameForId(o, this.staticRulesId))
        return this.staticRulesId;
      var s = qt(this.rules, r, a).join(""), l = aa(Ht(this.baseHash, s.length) >>> 0);
      if (!a.hasNameForId(o, l)) {
        var d = i(s, "." + l, void 0, o);
        a.insertRules(o, l, d);
      }
      return this.staticRulesId = l, l;
    } else {
      for (var u = this.rules.length, p = Ht(this.baseHash, i.hash), m = "", _ = 0; _ < u; _++) {
        var y = this.rules[_];
        if (typeof y == "string")
          m += y, process.env.NODE_ENV !== "production" && (p = Ht(p, y + _));
        else {
          var f = qt(y, r, a), g = Array.isArray(f) ? f.join("") : f;
          p = Ht(p, g + _), m += g;
        }
      }
      var b = aa(p >>> 0);
      if (!a.hasNameForId(o, b)) {
        var v = i(m, "." + b, void 0, o);
        a.insertRules(o, b, v);
      }
      return b;
    }
  }, t;
})(), Yi = 200, Np = (function(t, e) {
  var n = {}, r = !1;
  return function(a) {
    if (!r && (n[a] = !0, Object.keys(n).length >= Yi)) {
      var i = e ? ' with the id of "' + e + '"' : "";
      console.warn("Over " + Yi + " classes were generated for component " + t + i + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), r = !0, n = {};
    }
  };
}), Mp = /invalid hook call/i, Rn = /* @__PURE__ */ new Set(), Op = function(e, n) {
  if (process.env.NODE_ENV !== "production") {
    var r = n ? ' with the id of "' + n + '"' : "", a = "The component " + e + r + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`;
    try {
      Ot(), Rn.has(a) || (console.warn(a), Rn.add(a));
    } catch (i) {
      Mp.test(i.message) && Rn.delete(a);
    }
  }
}, Rp = (function(t, e, n) {
  return n === void 0 && (n = Rt), t.theme !== n.theme && t.theme || e || n.theme;
}), Ap = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, zp = /(^-|-$)/g;
function ia(t) {
  return t.replace(Ap, "-").replace(zp, "");
}
function Jr(t) {
  return typeof t == "string" && (process.env.NODE_ENV !== "production" ? t.charAt(0) === t.charAt(0).toLowerCase() : !0);
}
function Dp(t) {
  return Jr(t) ? "styled." + t : "Styled(" + La(t) + ")";
}
var Ip = (function(t) {
  return aa(Cs(t) >>> 0);
});
function jp(t, e) {
  return t && e ? t + " " + e : t || e;
}
var Es = C.createContext();
Es.Consumer;
var An = {};
function Fp(t, e) {
  var n = typeof t != "string" ? "sc" : ia(t);
  An[n] = (An[n] || 0) + 1;
  var r = n + "-" + Ip(n + An[n]);
  return e ? e + "-" + r : r;
}
function Vp(t, e, n) {
  t === void 0 && (t = Rt);
  var r = gt({}, e, {
    theme: t
  }), a = {};
  return n.forEach(function(i) {
    var o = i, s;
    gr(o) && (o = o(r));
    for (s in o)
      r[s] = a[s] = s === "className" ? jp(a[s], o[s]) : o[s];
  }), [r, a];
}
function Hp(t, e, n, r) {
  var a = yp(), i = vp(), o = t.isStatic && !e, s = o ? t.generateAndInjectStyles(Rt, a, i) : t.generateAndInjectStyles(n, a, i);
  return mo(s), process.env.NODE_ENV !== "production" && !o && r && r(s), s;
}
function $p(t, e, n) {
  var r = t.attrs, a = t.componentStyle, i = t.defaultProps, o = t.foldedComponentIds, s = t.shouldForwardProp, l = t.styledComponentId, d = t.target;
  mo(l);
  var u = Rp(e, vt(Es), i), p = Vp(u || Rt, e, r), m = p[0], _ = p[1], y = Hp(a, r.length > 0, m, process.env.NODE_ENV !== "production" ? t.warnTooManyClasses : void 0), f = n, g = _.$as || e.$as || _.as || e.as || d, b = Jr(g), v = _ !== e ? gt({}, e, {}, _) : e, x = s || b && Fi, S = {};
  for (var h in v)
    h[0] === "$" || h === "as" || (h === "forwardedAs" ? S.as = v[h] : (!x || x(h, Fi)) && (S[h] = v[h]));
  return e.style && _.style !== e.style && (S.style = gt({}, e.style, {}, _.style)), S.className = Array.prototype.concat(o, l, y !== l ? y : null, e.className, _.className).filter(Boolean).join(" "), S.ref = f, $t(g, S);
}
function Ls(t, e, n) {
  var r = Ta(t), a = !Jr(t), i = e.displayName, o = i === void 0 ? Dp(t) : i, s = e.componentId, l = s === void 0 ? Fp(e.displayName, e.parentComponentId) : s, d = e.attrs, u = d === void 0 ? Yr : d, p = e.displayName && e.componentId ? ia(e.displayName) + "-" + e.componentId : e.componentId || l, m = (
    // $FlowFixMe
    r && t.attrs ? Array.prototype.concat(t.attrs, u).filter(Boolean) : u
  ), _ = e.shouldForwardProp;
  r && t.shouldForwardProp && (_ ? _ = function(v, x) {
    return (
      // $FlowFixMe
      t.shouldForwardProp(v, x) && e.shouldForwardProp(v, x)
    );
  } : _ = t.shouldForwardProp);
  var y = new Tp(r ? (
    // fold the underlying StyledComponent rules up (implicit extend)
    // $FlowFixMe
    t.componentStyle.rules.concat(n)
  ) : n, p), f, g = function(v, x) {
    return $p(f, v, x);
  };
  return g.displayName = o, f = C.forwardRef(g), f.attrs = m, f.componentStyle = y, f.displayName = o, f.shouldForwardProp = _, f.foldedComponentIds = r ? (
    // $FlowFixMe
    Array.prototype.concat(t.foldedComponentIds, t.styledComponentId)
  ) : Yr, f.styledComponentId = p, f.target = r ? (
    // $FlowFixMe
    t.target
  ) : t, f.withComponent = function(v) {
    var x = e.componentId, S = B0(e, ["componentId"]), h = x && x + "-" + (Jr(v) ? v : ia(La(v))), P = gt({}, S, {
      attrs: m,
      componentId: h
    });
    return Ls(v, P, n);
  }, Object.defineProperty(f, "defaultProps", {
    get: function() {
      return this._foldedDefaultProps;
    },
    set: function(v) {
      this._foldedDefaultProps = r ? Ps({}, t.defaultProps, v) : v;
    }
  }), process.env.NODE_ENV !== "production" && (Op(o, p), f.warnTooManyClasses = Np(o, p)), f.toString = function() {
    return "." + f.styledComponentId;
  }, a && $0(f, t, {
    // all SC-specific things should not be hoisted
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    self: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), f;
}
var Bp = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], lr = function(e) {
  return ra(Ls, e);
};
Bp.forEach(function(t) {
  lr[t] = lr(t);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles not rendering properly, errors happening during rehydration process, missing theme prop, and makes your application bigger without a good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
function Ts() {
  var t = hr([`
  color: #c9444d;
  font-size: 0.75rem;
  margin-top: 0.25rem;

  & {
    `, `;
  }
`]);
  return Ts = function() {
    return t;
  }, t;
}
function Ns() {
  var t = hr([`
        border-color: #444bc9;
        box-shadow: #444bc9 0px 0px 0px 1px;
        `, `;
      `]);
  return Ns = function() {
    return t;
  }, t;
}
function Ms() {
  var t = hr([`
        border-color: #c9444d;
        box-shadow: #c9444d 0px 0px 0px 1px;
        `, `;
      `]);
  return Ms = function() {
    return t;
  }, t;
}
function Os() {
  var t = hr([`
  align-items: center;
  background-color: white;
  border: 1px solid #bdbdbd;
  box-shadow: inset 0px 1px 2px #e5e5e5;
  border-radius: 0.2em;
  display: flex;
  height: 2.5em;
  padding: 0.4em 0.6em;

  & {
    `, `;
  }

  & {
    `, `;
  }

  & input {
    border: unset;
    margin: unset;
    padding: unset;
    outline: unset;
    font-size: inherit;

    & {
      `, `;
    }

    `, `;
  }

  & svg {
    margin-right: 0.6em;
    & {
      `, `;
    }
  }

  & input#cardNumber {
    width: 11em;
    & {
      `, `;
    }
  }

  & input#expiryDate {
    width: 4em;
    & {
      `, `;
    }
  }

  & input#cvc {
    width: 2.5em;
    & {
      `, `;
    }
  }

  & input#zip {
    width: 4em;
    & {
      `, `;
    }
  }

  `, `;
`]);
  return Os = function() {
    return t;
  }, t;
}
function Rs() {
  var t = hr([`
  display: inline-flex;
  flex-direction: column;

  & {
    `, `;
  }

  `, `;
`]);
  return Rs = function() {
    return t;
  }, t;
}
lr.div(Rs(), function(t) {
  return t.hasErrored && t.styles.fieldWrapper ? t.styles.fieldWrapper.errored : void 0;
}, function(t) {
  return t.styles.fieldWrapper ? t.styles.fieldWrapper.base : void 0;
});
lr.div(Os(), function(t) {
  return t.hasErrored && ta(Ms(), function(e) {
    return e.styles.inputWrapper && e.styles.inputWrapper.errored;
  });
}, function(t) {
  return t.focused && ta(Ns(), function(e) {
    return e.styles.inputWrapper && e.styles.inputWrapper.focused;
  });
}, function(t) {
  return t.hasErrored && t.styles.input ? t.styles.input.errored : void 0;
}, function(t) {
  return t.styles.input && t.styles.input.base;
}, function(t) {
  return t.styles.cardImage;
}, function(t) {
  return t.styles.input && t.styles.input.cardNumber;
}, function(t) {
  return t.styles.input && t.styles.input.expiryDate;
}, function(t) {
  return t.styles.input && t.styles.input.cvc;
}, function(t) {
  return t.styles.input && t.styles.input.zip;
}, function(t) {
  return t.styles.inputWrapper ? t.styles.inputWrapper.base : void 0;
});
lr.div(Ts(), function(t) {
  return t.styles.errorText ? t.styles.errorText.base : void 0;
});
var Kp = C.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, C.createElement("g", {
  id: "New-Icons",
  transform: "translate(-80.000000, -280.000000)",
  fillRule: "nonzero"
}, C.createElement("g", {
  id: "Card-Brands",
  transform: "translate(40.000000, 200.000000)"
}, C.createElement("g", {
  id: "Color",
  transform: "translate(0.000000, 80.000000)"
}, C.createElement("g", {
  id: "Visa",
  transform: "translate(40.000000, 0.000000)"
}, C.createElement("rect", {
  strokeOpacity: "0.2",
  stroke: "#000000",
  strokeWidth: "0.5",
  fill: "#FFFFFF",
  x: "0.25",
  y: "0.25",
  width: "23.5",
  height: "15.5",
  rx: "2"
}), C.createElement("path", {
  d: "M2.78773262,5.91443732 C2.26459089,5.62750595 1.6675389,5.39673777 1,5.23659312 L1.0280005,5.1118821 L3.76497922,5.1118821 C4.13596254,5.12488556 4.43699113,5.23650585 4.53494636,5.63071135 L5.12976697,8.46659052 L5.31198338,9.32072617 L6.97796639,5.1118821 L8.77678896,5.1118821 L6.10288111,11.2775284 L4.30396552,11.2775284 L2.78773262,5.91443732 L2.78773262,5.91443732 Z M10.0999752,11.2840738 L8.39882877,11.2840738 L9.46284763,5.1118821 L11.163901,5.1118821 L10.0999752,11.2840738 Z M16.2667821,5.26277458 L16.0354292,6.59558538 L15.881566,6.53004446 C15.5737466,6.40524617 15.1674138,6.28053516 14.6143808,6.29371316 C13.942741,6.29371316 13.6415263,6.56277129 13.6345494,6.82545859 C13.6345494,7.11441463 13.998928,7.3048411 14.5939153,7.58725177 C15.5740257,8.02718756 16.0286384,8.56556562 16.0218476,9.26818871 C16.0080799,10.5486366 14.8460128,11.376058 13.0610509,11.376058 C12.2978746,11.3694253 11.5627918,11.2180965 11.163808,11.0475679 L11.4018587,9.66204513 L11.6258627,9.76066195 C12.1788958,9.99070971 12.5428092,10.0889775 13.221984,10.0889775 C13.7117601,10.0889775 14.2368857,9.89837643 14.2435835,9.48488392 C14.2435835,9.21565125 14.0198586,9.01850486 13.3617074,8.7164581 C12.717789,8.42086943 11.8568435,7.92848346 11.8707973,7.04197926 C11.8780532,5.84042483 13.0610509,5 14.7409877,5 C15.3990458,5 15.9312413,5.13788902 16.2667821,5.26277458 Z M18.5277524,9.0974856 L19.941731,9.0974856 C19.8717762,8.78889347 19.549631,7.31147374 19.549631,7.31147374 L19.4307452,6.77964104 C19.3467437,7.00942698 19.1998574,7.38373457 19.2069273,7.37055657 C19.2069273,7.37055657 18.6678479,8.74290137 18.5277524,9.0974856 Z M20.6276036,5.1118821 L22,11.2839865 L20.4249023,11.2839865 C20.4249023,11.2839865 20.2707601,10.5748181 20.221922,10.3581228 L18.0377903,10.3581228 C17.9746264,10.5221933 17.6807607,11.2839865 17.6807607,11.2839865 L15.8957988,11.2839865 L18.4226343,5.62399144 C18.5977072,5.22341512 18.9059917,5.1118821 19.3117663,5.1118821 L20.6276036,5.1118821 L20.6276036,5.1118821 Z",
  id: "Shape",
  fill: "#171E6C"
})))))), Up = C.createElement("g", {
  fill: "none"
}, C.createElement("path", {
  d: "m4.54588254.00006676h5.79377466c.8087588 0 1.3117793.72566459 1.1231113 1.61890981l-2.69741608 12.74856503c-.19036262.8901361-1.00010994 1.6164225-1.80943362 1.6164225h-5.79320976c-.80762905 0-1.31177937-.7262864-1.12311135-1.6164225l2.69854581-12.74856503c.18866803-.89324522.9979917-1.61890981 1.80773904-1.61890981",
  fill: "#dd2423"
}), C.createElement("path", {
  d: "m9.85756516.00006676h6.66269264c.8086174 0 .4439911.72566459.2537697 1.61890981l-2.6969924 12.74856503c-.1892329.8901361-.1302036 1.6164225-.9405158 1.6164225h-6.66269248c-.81031221 0-1.31177939-.7262864-1.12141672-1.6164225l2.69685116-12.74856503c.19149238-.89324522.99912144-1.61890981 1.8083039-1.61890981",
  fill: "#16315e"
}), C.createElement("path", {
  d: "m16.2559813.00006676h5.7937745c.8098886 0 1.3129092.72566459 1.1226878 1.61890981l-2.6969924 12.74856503c-.1903626.8901361-1.0006749 1.6164225-1.8104222 1.6164225h-5.7910915c-.8103122 0-1.3129091-.7262864-1.1231113-1.6164225l2.697416-12.74856503c.1886681-.89324522.9974268-1.61890981 1.8077391-1.61890981",
  fill: "#036862"
}), C.createElement("path", {
  d: "m6.05901135 4.08561434c-.59580116.00668457-.77175951 0-.8279645-.01461278-.02160646.11301588-.42365577 2.15460824-.42478553 2.15631824-.08656699.4130443-.14955043.7074763-.36349659.89759795-.12144798.1105286-.26323144.1638497-.42760986.1638497-.26421996 0-.41814822-.1444178-.44399122-.41832975l-.00494264-.09405035s.08049458-.55326485.08049458-.55637395c0 0 .42196112-1.86048711.49751306-2.10641713.00395412-.01399096.00508387-.02129736.00607239-.02798193-.82132725.00792821-.9669236 0-.97695012-.01461278-.00550753.02005371-.025843.13540142-.025843.13540142l-.43085788 2.09693437-.03699927.1778407-.07159782.5817131c0 .1725552.03078565.31339755.09207452.4324762.19629382.37760055.75622549.4341862 1.07297875.4341862.40812169 0 .79096525-.09544945 1.04967767-.26971465.44907509-.2921002.56656897-.74867195.67135315-1.15440985l.04857917-.20815445s.43467082-1.93230737.5085281-2.18367833c.00282441-.01399096.00395413-.02129736.00776704-.02798193zm1.47893982 1.55881086c-.10478422 0-.29627659.0279819-.46828081.12078865-.0624186.0352883-.12144796.07601755-.18372539.11659135l.056205-.22338905-.03078563-.03762015c-.36476761.08130305-.44639193.0921849-.78333945.14441785l-.02824374.0206755c-.03911752.3570805-.07385733.6255515-.21888878 1.32743145-.05521646.25867735-.11255121.519842-.17002718.7778975l.01553403.03280105c.34527946-.0200537.45006363-.0200537.75015309-.0146128l.02428961-.0290701c.03812903-.21499445.04307165-.2653619.12752039-.70079175.03968242-.20644445.1224365-.66006255.16324868-.8215804.07498704-.038242.14898558-.07586215.21959486-.07586215.16819135 0 .14771465.1615179.14121858.22587635-.00720213.1080413-.06849101.4609245-.13133325.76390655l-.04194194.19556255c-.02923223.14441785-.06128888.2847938-.09052111.427968l.01270966.02860375c.34033679-.0200537.44413246-.0200537.73476028-.0146128l.0341749-.0290701c.0525333-.3357831.06792611-.42563615.16113038-.9145426l.04688457-.22463265c.09108601-.43962715.13684082-.6625498.06792616-.8441214-.07286879-.2034908-.24769738-.2526146-.40826291-.2526146zm1.65214439.4602871c-.18090101.038242-.29627659.0637366-.41094606.08021485-.11368097.02005375-.22453757.038242-.39936616.06498025l-.01383941.0138355-.01270966.01103735c-.01821719.14332965-.0309269.26722735-.05507525.41288885-.02047669.150636-.05196844.3217921-.10323077.56772215-.03968243.18825615-.06015913.25385825-.08275412.32008215-.0220301.06622385-.04631967.1305823-.09094476.31572935l.01045019.0171001.00875554.01570095c.1633899-.00855005.27029237-.0146128.38016043-.01570095.10972684-.00435275.22340776 0 .39936611.00108815l.01539286-.0138355.01652257-.0152346c.02541932-.1669588.02923224-.21188535.04476626-.29334385.01539282-.0873658.04194194-.20830985.10704369-.53134565.03078568-.1517242.06510179-.30298205.09701718-.4578154.03318641-.1542115.06792612-.30609115.10097127-.45781535l-.00494263-.0183437zm.00385525-.620608c-.1643784-.10679765-.45288796-.07290845-.64706354.0746185-.19361063.14457325-.21564072.34977405-.05182718.4579708.16155403.10384405.45119334.0729085.64367421-.0758621.19318708-.14768235.21733543-.3510177.05521651-.4567272zm.99410809 2.473369c.3325698 0 .6734715-.1008904.9300657-.400297.1974235-.2428209.2879446-.60409865.3192952-.7528692.1021011-.4931037.0225949-.7233328-.0772466-.8635533-.1516687-.21375085-.4197016-.28230655-.697761-.28230655-.1672028 0-.5654392.01818825-.87654364.33391765-.22340786.22774175-.32663863.5367866-.38891601.83308405-.06284224.3018939-.13514621.84536505.31887154 1.0476122.14008884.0662239.34203141.08441215.47223481.08441215zm-.0259841-1.10948335c.0766817-.3734032.1672028-.6868008.3982364-.6868008.1810422 0 .1941755.23318275.1136809.6078296-.0144042.0831685-.0804945.3923688-.1698859.5240393-.0624186.09715945-.1362759.15607695-.2179003.15607695-.0242896 0-.1687562 0-.1710157-.23613635-.0011297-.11659135.0204767-.23567.0468846-.3650087zm2.1066988 1.06146325.0259841-.0290701c.0368581-.21499445.0429305-.2655174.1245549-.70079175.0408121-.20644445.1252608-.66006255.1649433-.82158045.0751282-.0383974.1478558-.07601755.2207245-.07601755.1670616 0 .1467262.1615179.140089.2258763-.0060725.1081968-.0673613.4609245-.1313334.76390655l-.0396824.1955626c-.030362.14457325-.0634071.2847938-.0926394.42812345l.0127097.02860375c.3414665-.02005375.441308-.02005375.7336305-.0146128l.0353047-.0290701c.0512623-.33593855.0651017-.42579165.1611304-.9145426l.0457548-.2247881c.0915096-.43962715.1378292-.66239435.0700444-.84396595-.0749871-.2034908-.2509454-.2526146-.4092515-.2526146-.1049254 0-.2974063.02782645-.468422.12078865-.0611476.0352883-.1224365.0758621-.1825956.11659135l.0523921-.22338905-.0281025-.0377756c-.3646263.0814585-.4479453.09234035-.7844692.1445733l-.025843.0206755c-.0408122.35708045-.0739986.62539605-.21903 1.32743145-.0552164.25867735-.1125512.51984195-.1698859.7778975l.0153928.03280105c.3458442-.02005375.4490751-.02005375.7485997-.0146128zm2.5088186.01453505c.0214652-.1153477.1489856-.7990394.1501153-.7990394 0 0 .1085971-.50165375.1152345-.519842 0 0 .0341748-.0522329.0683497-.07290845h.0502738c.4743532 0 1.0099953 0 1.4298381-.3399804.2856852-.2331827.4809905-.57751585.5681223-.99600105.022595-.1026004.0392588-.22463269.0392588-.34666496 0-.16027425-.0292322-.3188385-.1136809-.44273624-.2140874-.32972035-.6404262-.3357831-1.132573-.33827039-.0015534 0-.2426136.00248729-.2426136.00248729-.629976.00855003-.8826161.00606275-.9864117-.00792821-.0087556.05052291-.0252782.14037599-.0252782.14037599s-.2256673 1.15130077-.2256673 1.15316622c0 0-.5400198 2.4477966-.5654392 2.5631443.5500464-.00730635.7755725-.00730635.8704714.0041973zm.4181482-2.0451678s.2399304-1.14896892.2388007-1.14461618l.0077669-.05891749.0033893-.04492654.0958874.01088185s.4948299.046792.5064099.04803565c.1953052.0831685.2757998.29754113.2195948.57736036-.0512623.2557237-.2019425.4707182-.3955532.5745622-.1594358.0879876-.3547411.095294-.5559775.095294h-.1302035zm1.4938667.99045135c-.0634072.2975411-.136276.8410123.3154822 1.0347094.1440429.0674675.2731167.0875212.4043088.08021485.1385355-.00823915.2669031-.08472305.3858092-.1947853-.0107326.04523745-.0214652.0904749-.0321978.1358678l.0204766.0290701c.324944-.01507915.4257741-.01507915.7778319-.0121255l.0319154-.0267383c.0514036-.332674.0998416-.65570975.2334344-1.2921431.0651017-.30484755.1300622-.6067414.1968587-.9103453l-.0104501-.03342285c-.3634967.0741521-.4606551.09000855-.8103124.1445733l-.026549.0237846c-.0035305.0309356-.0072021.0606275-.0105914.09031945-.0543692-.0966931-.1331691-.17923975-.2547583-.2306954-.1554817-.0673121-.5206729.01943185-.8346018.33407305-.2205834.2246327-.3264973.53243385-.3866564.8276432zm.7634275.01818825c.0778115-.3667187.1672028-.67700715.3988014-.67700715.1464436 0 .2235489.14877055.2078737.40247335-.0124272.06327025-.025843.1299605-.0418008.20535625-.0231597.10897405-.0482967.21701535-.0727275.32521215-.0248545.07399665-.0538043.143796-.0855784.1902771-.0595943.09296215-.2013777.150636-.2830021.150636-.0231599 0-.1660731 0-.1710157-.23193905-.0011298-.11550315.0204767-.23442635.0474494-.36500865zm3.9866711-1.21085565-.0281024-.0352883c-.3596838.08021485-.4247856.09296215-.755237.142086l-.0242897.02673825c-.0011296.00435275-.0021182.01103735-.0038128.0171001l-.0011298-.00606275c-.2460027.6247742-.2388006.4899946-.4390485.98185465-.0011298-.02238555-.0011298-.0363765-.0022595-.06016115l-.0501327-1.0662668-.0314917-.0352883c-.3767711.08021485-.3856679.09296215-.7336305.142086l-.0271139.02673825c-.003813.01274735-.003813.0267383-.0060724.0419729l.0022594.00544095c.0434954.2446864.0330452.19012165.0766818.5762722.0203354.1894998.0474494.3800878.0677848.5672558.0343162.3132421.0535219.4674536.0954638.94547815-.2349878.4268798-.2906279.5883977-.51686.9630446l.0015534.0037309-.1592946.27733195c-.0182171.0292256-.0347397.0492793-.0578996.05782935-.0254193.0138355-.0584644.01632275-.1043605.01632275h-.0882616l-.131192.4803564.4500635.00855005c.26422-.00124365.4302931-.1372669.5196844-.32008215l.283002-.53383295h-.004519l.0297972-.03762015c.1903626-.4511308 1.6384179-3.1855867 1.6384179-3.1855867zm-4.7501128 6.3087581h-.1909276l.7066579-2.57293795h.2344228l.0744221-.265051.0072022.29474295c-.0087556.1821934.121448.3437113.4634794.31697305h.3955532l.1361347-.49543555h-.1488443c-.0855785 0-.1252609-.02378465-.1203182-.0747739l-.0072022-.299873h-.7325008v.00155455c-.2368235.00544095-.9440462.0250283-1.0872418.0670012-.1732752.0491238-.3558709.1936971-.3558709.1936971l.071739-.26536195h-.6851925l-.1427719.52652655-.7161194 2.61226815h-.1389591l-.136276.4918601h1.3647364l-.0457548.1640051h.6724828l.0446251-.1640051h.1886681zm-.5599316-2.0501423c-.1097268.03342285-.313929.1347796-.313929.1347796l.1816071-.65757525h.5443977l-.1313333.47911275s-.1681914.01088185-.2807425.0436829zm.0104502.9394154s-.1710158.0236292-.283567.0516111c-.1108566.0369984-.3187303.1535897-.3187303.1535897l.1875382-.6843135h.5472221zm-.3050322 1.1167897h-.5460922l.158306-.5775158h.5443976zm1.315112-1.5959024h.7871525l-.1131162.4032506h-.7976024l-.1197535.4408708h.6979023l-.5284398.8190931c-.0369994.0601612-.0701858.0814585-.1070437.0984031-.0369994.0206755-.0855785.0449265-.1417835.0449265h-.1936107l-.133028.4828437h.5064098c.2632315 0 .4187131-.131826.5335239-.3048476l.3623669-.5459584.0778115.5543531c.0165225.1038439.0843074.1646269.1302034.1882561.0506975.0279819.1030897.0760176.1770882.0831685.0793648.0037309.1366995.0066846.1748285.0066846h.2488272l.1494092-.5403621h-.0981469c-.0563463 0-.1533633-.0104155-.1698859-.0298474-.0165226-.0236292-.0165226-.0600057-.0254194-.1153477l-.0789412-.5555967h-.3232494l.1417836-.1857688h.796049l.1224365-.4408708h-.7370197l.1148107-.4032506h.7347603l.1362759-.497301h-2.1905826zm-6.6483163 1.7081877.1837253-.6728098h.7550958l.1379705-.5004101h-.7558018l.1153756-.4141325h.7385731l.1368408-.4845537h-1.84798632l-.13401641.4845537h.41984283l-.1119863.4141325h-.42097264l-.13952389.5089601h.41970155l-.24487301.8901361c-.03304514.117835.01553408.1627615.04631971.2174817.03149175.0533211.06340718.0886094.13514621.1086631.07399857.0181883.12469597.0290701.19361067.0290701h.8512656l.1516688-.554353-.3773361.0570521c-.0728688 0-.2746701-.0096382-.25264-.0837903zm.0866093-3.22084395-.1913512.38070965c-.0409534.08316845-.0778114.1347796-.1109978.1585642-.0292322.02005375-.0871318.0284483-.1710157.0284483h-.0998415l-.13345158.48704095h.33158128c.1594357 0 .2818722-.0643584.3403368-.09653765.0628422-.0369983.0793647-.0158564.1279439-.0674675l.1119864-.1067977h1.0354146l.1374057-.50709465h-.7579202l.1323219-.2768656zm1.5286064 3.23062205c-.0176524-.027982-.0049427-.0772612.0220301-.1798616l.283002-1.0311339h1.0067472c.1467262-.0023318.25264-.0041973.3215547-.0096382.0739985-.0085501.1544932-.0376202.2421899-.0898531.0905212-.0547202.1368408-.1123941.1759583-.178618.0436366-.0660684.113681-.2106417.1738401-.4335643l.3557296-1.3048905-1.044735.0066846s-.3216959.0522329-.4633381.10990675c-.1429132.06435845-.3471154.2440646-.3471154.2440646l.0943341-.3577023h-.645369l-.9035164 3.29860265c-.0320566.1280949-.0535218.2210571-.0584645.2768655-.0016946.0601612.0689147.1197005.1146695.164627.0540867.0449266.1340164.0376202.2106981.0449266.0806358.0066846.1953053.0108818.3536113.0108818h.4959597l.1522336-.5658567-.4439912.0461702c-.0474494 0-.0817655-.027982-.0960286-.0516111zm.4876277-1.9074346h1.0574447l-.06722.2319391c-.0094616.0054409-.0320566-.0115037-.1396652.0024873h-.9156612zm.2118279-.77789745h1.0663414l-.0766816.27935285s-.5025969-.0054409-.5830915.01088185c-.3541763.06746755-.5610614.27577745-.5610614.27577745zm.802065 1.78653705c-.0087555.0346665-.0225949.0558084-.0419418.0716648-.0214654.0152346-.0562051.0206755-.1080323.0206755h-.1506803l.0088968-.2824619h-.626728l-.0254193 1.380908c-.0009886.0996467.007767.1573206.0739985.2034908.0662315.0576738.2702923.0649802.5449624.0649802h.392729l.1417834-.5168883-.3418902.0206755-.1136809.0073064c-.0155341-.0073064-.030362-.013991-.0468846-.0321792-.0144043-.015701-.0386939-.0060627-.0347398-.1057095l.0026831-.3539713.3585541-.0163228c.1936107 0 .2763648-.0693331.346974-.1354015.0673612-.0632702.0893913-.1360232.1148107-.2344264l.0601592-.3133975h-.4927118z",
  fill: "#fefefe"
})), qp = C.createElement("g", null, C.createElement("path", {
  transform: "scale(0.6)",
  d: "m33.6 24h-31.2c-1.325 0-2.4-1.075-2.4-2.4v-19.2c0-1.325 1.075-2.4 2.4-2.4h31.2c1.325 0 2.4 1.075 2.4 2.4v19.2c0 1.325-1.075 2.4-2.4 2.4zm-8.689-15.321c-.07-.002-.151-.004-.233-.004-.213 0-.424.01-.632.028l.027-.002c-.01.03.542 1.996 1.066 3.83l.064.224c1.114 3.896 1.114 3.896.937 4.274-.153.313-.392.565-.686.729l-.008.004-.231.116-.994.019c-.96.02-.998.024-1.12.111-.228.164-.315.425-.489 1.467-.09.55-.16.982-.16 1.006.148.031.318.049.492.049.084 0 .167-.004.249-.012l-.01.001c.214 0 .48 0 .812-.006.17.016.367.025.566.025.484 0 .956-.054 1.409-.157l-.043.008c1.072-.313 1.958-.975 2.55-1.852l.01-.016c.197-.286 5.257-9.732 5.257-9.814-.167-.024-.359-.038-.555-.038-.09 0-.178.003-.267.009l.012-.001h-.594l-1.4.011-.266.132c-.149.071-.277.163-.385.274-.067.08-.528 1.088-1.12 2.445-.344.887-.691 1.622-1.083 2.33l.049-.096c-.022-.046-.218-1.266-.378-2.282-.187-1.218-.366-2.27-.4-2.346-.065-.168-.191-.3-.349-.372l-.004-.002c-.151-.08-.223-.08-1.539-.095h-.553zm-3.77.131c-.043 0-.052.027-.062.071-.027.123-.418 2.354-.418 2.386.042.047.092.087.148.117l.003.001c.41.281.69.725.746 1.237l.001.008c.003.04.005.087.005.134 0 .787-.538 1.448-1.266 1.637l-.012.003c-.136.032-.19.067-.203.131-.035.168-.418 2.357-.418 2.39 0 .006.023.015.179.015.07 0 .16 0 .25-.007 1.958-.11 3.55-1.545 3.9-3.417l.004-.026c.026-.2.041-.431.041-.665 0-.321-.028-.636-.082-.942l.005.032c-.291-1.35-1.207-2.439-2.423-2.964l-.027-.01c-.108-.056-.232-.101-.364-.129l-.01-.002zm-16.966-.136c-.167 0-.603 0-.612.008s-.025.13-.058.32l-.137.758c-.104.588-.179 1.074-.167 1.082s.32.012.621.012h.596l-.012.091c0 .026-.037.211-.085.489l-.185 1.058c-.172.615-.271 1.322-.271 2.051 0 .156.005.31.013.464l-.001-.021c.182 1.082 1.114 1.766 2.624 1.925.198.021.466.031.701.031.038.003.081.004.125.004.138 0 .273-.016.403-.046l-.012.002c.022-.027.413-2.182.418-2.306 0-.052-.069-.068-.386-.088-.778-.043-1.126-.297-1.126-.823 0-.16.367-2.381.457-2.763.013-.059.032-.075.433-.075h.606c.053.003.116.004.179.004.174 0 .344-.012.512-.034l-.019.002c.025-.042.378-2 .378-2.099 0-.037-.198-.047-.847-.047h-.846l.107-.609c.195-1.063.149-1.32-.278-1.527-.214-.107-.231-.107-1.152-.123l-.953-.012-.024.111c-.012.064-.096.525-.183 1.03s-.171.96-.183 1.022l-.024.112zm6-.008-.025.111c-.04.186-1.415 8.014-1.415 8.053.294.026.637.042.983.042.135 0 .27-.002.404-.007l-.019.001h1.369l.04-.21c.025-.111.16-.871.302-1.686.14-.8.297-1.6.342-1.75.238-.867.892-1.541 1.727-1.805l.018-.005c.2-.061.43-.096.668-.096.056 0 .111.002.165.006h-.007c.499 0 .53-.005.545-.08.045-.195.452-2.57.445-2.593-.066-.021-.141-.034-.22-.034-.024 0-.048.001-.072.003h.003c-.006 0-.014 0-.021 0-.16 0-.317.013-.47.038l.017-.002c-.622.133-1.164.417-1.603.813l.003-.003c-.292.27-.546.576-.756.912l-.011.019c-.022.056-.054.104-.094.144.015-.157.037-.297.066-.435l-.004.024c.166-.885.076-1.192-.4-1.371-.269-.047-.578-.074-.894-.074-.058 0-.115.001-.173.003h.008zm9.704-.026h-.141c-.236 0-.467.022-.691.064l.023-.004c-1.274.263-2.314 1.086-2.869 2.195l-.011.024c-.272.488-.432 1.07-.432 1.689 0 .051.001.101.003.151v-.007c-.001.041-.002.09-.002.139 0 .262.024.518.069.767l-.004-.026c.249 1.142.939 2.09 1.879 2.674l.018.01c.276.177.595.325.933.427l.027.007c.025-.018.139-.633.247-1.233l.218-1.213-.103-.08c-.27-.187-.487-.434-.635-.721l-.005-.011c-.099-.162-.157-.359-.157-.569 0-.052.004-.103.01-.153l-.001.006c-.006-.044-.009-.095-.009-.147 0-.2.051-.387.14-.551l-.003.006c.228-.47.651-.815 1.161-.931l.011-.002c.08-.008.151-.031.151-.052 0-.054.4-2.314.422-2.394-.015-.056-.07-.064-.249-.064z"
})), Gp = C.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, C.createElement("g", null, C.createElement("rect", {
  id: "Rectangle",
  fill: "#D8D8D8",
  x: "0",
  y: "0",
  width: "24",
  height: "16",
  rx: "1"
}), C.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "0.923076923",
  y: "10.3529412",
  width: "4.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}), C.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: "16.6153846",
  y: "3.76470588",
  width: "4.61538462",
  height: "2.82352941",
  rx: "1"
}), C.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "6.46153846",
  y: "10.3529412",
  width: "4.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}), C.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "11.9230769",
  y: "10.3529412",
  width: "5.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}), C.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "18.4615385",
  y: "10.3529412",
  width: "4.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}))), Wp = C.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, C.createElement("rect", {
  fill: "#252525",
  height: "16",
  rx: "2",
  width: "24"
}), C.createElement("circle", {
  cx: "9",
  cy: "8",
  fill: "#eb001b",
  r: "5"
}), C.createElement("circle", {
  cx: "15",
  cy: "8",
  fill: "#f79e1b",
  r: "5"
}), C.createElement("path", {
  d: "m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z",
  fill: "#ff5f00"
})), Zp = C.createElement("g", {
  fill: "none"
}, C.createElement("path", {
  d: "m.20535714 16h4.51785715c1.0278125 0 2.25892857-1.1946667 2.25892857-2.1333333v-13.8666667h-4.51785715c-1.0278125 0-2.25892857 1.19466667-2.25892857 3.2z",
  fill: "#047ab1"
}), C.createElement("path", {
  d: "m2.76924107 10.816c-.86733559.0001606-1.73039558-.1147397-2.56388393-.3413333v-1.17333337c.64678874.37770431 1.38610045.59084099 2.14598215.61866667.8696875 0 1.35535714-.576 1.35535714-1.36533333v-3.22133334h2.14598214v3.22133334c0 1.25866666-.70026786 2.26133333-3.0834375 2.26133333z",
  fill: "#fff"
}), C.createElement("path", {
  d: "m8.11160714 16h4.51785716c1.0278125 0 2.2589286-1.1946667 2.2589286-2.1333333v-13.8666667h-4.5178572c-1.02781249 0-2.25892856 1.19466667-2.25892856 3.2z",
  fill: "#d42d06"
}), C.createElement("path", {
  d: "m8.11160714 6.08c.65508929-.59733333 1.78455357-.97066667 3.61428576-.88533333.9939285.04266666 2.0330357.32 2.0330357.32v1.184c-.5943231-.3394747-1.2623758-.54734656-1.9539732-.608-1.3892411-.11733334-2.23633933.61866666-2.23633933 1.90933333s.84709823 2.0266667 2.23633933 1.92c.6920185-.06606555 1.3596342-.27744592 1.9539732-.61866667v1.17333337s-1.0391072.288-2.0330357.3306666c-1.82973219.0853334-2.95919647-.288-3.61428576-.8853333z",
  fill: "#fff"
}), C.createElement("path", {
  d: "m16.0178571 16h4.5178572c1.0278125 0 2.2589286-1.1946667 2.2589286-2.1333333v-13.8666667h-4.5178572c-1.0278125 0-2.2589286 1.19466667-2.2589286 3.2z",
  fill: "#67b637"
}), C.createElement("path", {
  d: "m21.6651786 9.28c0 .8533333-.7002679 1.3866667-1.6377232 1.3866667h-4.0095983v-5.33333337h3.6481697l.2597768.01066667c.8245089.04266667 1.4344196.50133333 1.4344196 1.29066667 0 .61866666-.4179018 1.152-1.1746428 1.28v.032c.8358035.05333333 1.4795982.55466666 1.4795982 1.33333333zm-2.880134-3.104c-.0486104-.00686658-.0976798-.01043129-.1468303-.01066667h-1.3553572v1.344h1.5021875c.2823661-.064.5195536-.30933333.5195536-.672 0-.36266666-.2371875-.608-.5195536-.66133333zm.1694197 2.176c-.059755-.00886168-.1202559-.01243275-.1807143-.01066667h-1.4908929v1.46133334h1.4908929l.1807143-.02133334c.2823661-.064.5195536-.34133333.5195536-.71466666 0-.37333334-.2258929-.64-.5195536-.71466667z",
  fill: "#fff"
})), Yp = C.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, C.createElement("rect", {
  fill: "#016fd0",
  height: "16",
  rx: "2",
  width: "24"
}), C.createElement("path", {
  d: "m13.7640663 13.3938564v-5.70139231l10.1475359.00910497v1.57489503l-1.1728619 1.25339231 1.1728619 1.2648839v1.6083094h-1.8726188l-.9951823-1.0981657-.9881105 1.1023204z",
  fill: "#fffffe"
}), C.createElement("path", {
  d: "m14.4418122 12.7687956v-4.448884h3.7722872v1.02488398h-2.550895v.69569062h2.4900774v1.0078232h-2.4900774v.6833149h2.550895v1.0371713z",
  fill: "#016fd0"
}), C.createElement("path", {
  d: "m18.1952707 12.7687956 2.087337-2.2270055-2.0874254-2.2217901h1.6156464l1.2754917 1.41003315 1.2791161-1.41003315h1.5461657v.03500552l-2.0428729 2.18678458 2.0428729 2.1638895v.063116h-1.5617237l-1.2981216-1.4241768-1.2847735 1.4241768z",
  fill: "#016fd0"
}), C.createElement("path", {
  d: "m14.2373481 2.6319558h2.4460552l.8591381 1.95085083v-1.95085083h3.0198453l.5207514 1.46156906.5225194-1.46156906h2.3059447v5.70139227h-12.1865193z",
  fill: "#fffffe"
}), C.createElement("g", {
  fill: "#016fd0"
}, C.createElement("path", {
  d: "m14.7004641 3.25135912-1.9740111 4.44517127h1.3539006l.3724199-.89016575h2.0179447l.3721547.89016575h1.3875801l-1.96579-4.44517127zm.1696353 2.55743646.592-1.41507182.5915581 1.41507182z"
}), C.createElement("path", {
  d: "m18.2119779 7.69573481v-4.44508288l1.903116.00654144.9792707 2.73272928.9856354-2.73927072h1.8316022v4.44508288l-1.1786077.01043094v-3.05334807l-1.1125746 3.04291713h-1.0758011l-1.1356464-3.05334807v3.05334807z"
}))), Jp = C.createElement("g", {
  id: "319",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, C.createElement("g", {
  id: "New-Icons",
  transform: "translate(-320.000000, -280.000000)",
  fillRule: "nonzero"
}, C.createElement("g", {
  id: "Card-Brands",
  transform: "translate(40.000000, 200.000000)"
}, C.createElement("g", {
  id: "Color",
  transform: "translate(0.000000, 80.000000)"
}, C.createElement("g", {
  id: "Diners-Club",
  transform: "translate(280.000000, 0.000000)"
}, C.createElement("path", {
  d: "M21.9972414,15.749927 L21.999381,15.7499362 C22.9544683,15.7581106 23.73806,14.9772525 23.75,14.0041555 L23.7500083,2.00630219 C23.7461702,1.53568921 23.5588633,1.08617106 23.2297297,0.756801782 C22.9014319,0.428268884 22.4589161,0.246148853 21.9972414,0.250070854 L2.00063,0.250061791 C1.54108393,0.246148853 1.09856813,0.428268884 0.77027028,0.756801782 C0.441136651,1.08617106 0.253829819,1.53568921 0.25,2.00426336 L0.249991686,13.9936957 C0.253829819,14.4643086 0.441136651,14.9138268 0.77027028,15.2431961 C1.09856813,15.571729 1.54108393,15.753849 2.00275862,15.749927 L21.9972414,15.749927 Z M21.996203,16.249927 C21.9958359,16.249924 21.9954688,16.249921 21.9951018,16.2499178 L21.9972414,16.249927 L21.996203,16.249927 Z",
  id: "shape",
  strokeOpacity: "0.2",
  stroke: "#000000",
  strokeWidth: "0.5",
  fill: "#FFFFFF"
}), C.createElement("path", {
  d: "M10.0021142,2.05179033 L10.0021142,2.03579033 L14.0021142,2.03579033 L14.0021142,2.05179033 C17.1375481,2.28122918 19.5642283,4.89197286 19.5642283,8.03579033 C19.5642283,11.1796078 17.1375481,13.7903515 14.0021142,14.0197903 L14.0021142,14.0357903 L10.0021142,14.0357903 L10.0021142,14.0197903 C6.86668021,13.7903515 4.44,11.1796078 4.44,8.03579033 C4.44,4.89197286 6.86668021,2.28122918 10.0021142,2.05179033 Z",
  id: "shape",
  fill: "#0165AC"
}), C.createElement("path", {
  d: "M11.6021142,11.4277903 C13.0374002,10.9175027 13.9961556,9.55908923 13.9961556,8.03579033 C13.9961556,6.51249143 13.0374002,5.15407792 11.6021142,4.64379033 L11.6021142,11.4277903 L11.6021142,11.4277903 Z M9.20211417,4.64379033 C7.76682809,5.15407792 6.80807271,6.51249143 6.80807271,8.03579033 C6.80807271,9.55908923 7.76682809,10.9175027 9.20211417,11.4277903 L9.20211417,4.64379033 L9.20211417,4.64379033 Z M10.4021142,13.2357903 C7.53023347,13.2357903 5.20211417,10.907671 5.20211417,8.03579033 C5.20211417,5.16390963 7.53023347,2.83579033 10.4021142,2.83579033 C13.2739949,2.83579033 15.6021142,5.16390963 15.6021142,8.03579033 C15.6021142,10.907671 13.2739949,13.2357903 10.4021142,13.2357903 Z",
  id: "shape",
  fill: "#FFFFFF"
})))))), Xp = C.createElement("g", {
  id: "319",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, C.createElement("g", {
  id: "New-Icons",
  transform: "translate(-280.000000, -280.000000)",
  fillRule: "nonzero"
}, C.createElement("g", {
  id: "Card-Brands",
  transform: "translate(40.000000, 200.000000)"
}, C.createElement("g", {
  id: "Color",
  transform: "translate(0.000000, 80.000000)"
}, C.createElement("g", {
  id: "Discover",
  transform: "translate(240.000000, 0.000000)"
}, C.createElement("path", {
  d: "M21.9972414,15.749927 L21.999381,15.7499362 C22.9544683,15.7581106 23.73806,14.9772525 23.75,14.0041555 L23.7500083,2.00630219 C23.7461702,1.53568921 23.5588633,1.08617106 23.2297297,0.756801782 C22.9014319,0.428268884 22.4589161,0.246148853 21.9972414,0.250070854 L2.00063,0.250061791 C1.54108393,0.246148853 1.09856813,0.428268884 0.77027028,0.756801782 C0.441136651,1.08617106 0.253829819,1.53568921 0.25,2.00426336 L0.249991686,13.9936957 C0.253829819,14.4643086 0.441136651,14.9138268 0.77027028,15.2431961 C1.09856813,15.571729 1.54108393,15.753849 2.00275862,15.749927 L21.9972414,15.749927 Z M21.996203,16.249927 C21.9958359,16.249924 21.9954688,16.249921 21.9951018,16.2499178 L21.9972414,16.249927 L21.996203,16.249927 Z",
  id: "shape",
  strokeOpacity: "0.2",
  stroke: "#000000",
  strokeWidth: "0.5",
  fill: "#FFFFFF"
}), C.createElement("path", {
  d: "M12.6124138,15.9999283 L21.9972414,15.9999283 C22.5240217,16.0043364 23.0309756,15.7992919 23.4065697,15.4299059 C23.7821638,15.06052 23.9956285,14.5570537 24,14.0302731 L24,11.6716524 C20.4561668,13.7059622 16.6127929,15.1667795 12.6124138,15.9999283 L12.6124138,15.9999283 Z",
  id: "shape",
  fill: "#F27712"
}), C.createElement("path", {
  d: "M23.1724138,9.29647999 L22.32,9.29647999 L21.36,8.03027309 L21.2689655,8.03027309 L21.2689655,9.29647999 L20.5737931,9.29647999 L20.5737931,6.1516524 L21.6,6.1516524 C22.4027586,6.1516524 22.8662069,6.48268688 22.8662069,7.07854895 C22.8662069,7.56682481 22.5765517,7.88130757 22.0551724,7.98061792 L23.1724138,9.29647999 Z M22.1462069,7.10337654 C22.1462069,6.79716964 21.9144828,6.63992826 21.4841379,6.63992826 L21.2689655,6.63992826 L21.2689655,7.5916524 L21.4675862,7.5916524 C21.9144828,7.5916524 22.1462069,7.42613516 22.1462069,7.10337654 L22.1462069,7.10337654 Z M18.1406897,6.1516524 L20.1103448,6.1516524 L20.1103448,6.68130757 L18.8358621,6.68130757 L18.8358621,7.38475585 L20.0606897,7.38475585 L20.0606897,7.92268688 L18.8358621,7.92268688 L18.8358621,8.77510068 L20.1103448,8.77510068 L20.1103448,9.30475585 L18.1406897,9.30475585 L18.1406897,6.1516524 Z M15.9062069,9.37923861 L14.4,6.14337654 L15.1613793,6.14337654 L16.1131034,8.26199723 L17.0731034,6.14337654 L17.817931,6.14337654 L16.2951724,9.37923861 L15.9227586,9.37923861 L15.9062069,9.37923861 Z M9.60827586,9.37096274 C8.54896552,9.37096274 7.72137931,8.65096274 7.72137931,7.71579033 C7.72137931,6.8054455 8.56551724,6.06889378 9.62482759,6.06889378 C9.92275862,6.06889378 10.1710345,6.12682481 10.4772414,6.25923861 L10.4772414,6.98751447 C10.2453534,6.75969251 9.93335245,6.63192067 9.60827586,6.6316524 C8.9462069,6.6316524 8.44137931,7.1116524 8.44137931,7.71579033 C8.44137931,8.35303171 8.93793103,8.80820412 9.64137931,8.80820412 C9.95586207,8.80820412 10.1958621,8.70889378 10.4772414,8.46061792 L10.4772414,9.18889378 C10.1627586,9.32130757 9.89793103,9.37096274 9.60827586,9.37096274 L9.60827586,9.37096274 Z M7.5062069,8.33647999 C7.5062069,8.94889378 7.00137931,9.37096274 6.27310345,9.37096274 C5.74344828,9.37096274 5.36275862,9.18889378 5.04,8.77510068 L5.49517241,8.38613516 C5.65241379,8.66751447 5.91724138,8.80820412 6.24827586,8.80820412 C6.56275862,8.80820412 6.7862069,8.6178593 6.7862069,8.36958343 C6.7862069,8.22889378 6.72,8.12130757 6.57931034,8.03854895 C6.42504922,7.96369158 6.26441119,7.90275992 6.09931034,7.85647999 C5.44551724,7.64958343 5.22206897,7.42613516 5.22206897,6.98751447 C5.22206897,6.47441102 5.70206897,6.0854455 6.33103448,6.0854455 C6.72827586,6.0854455 7.08413793,6.20958343 7.38206897,6.44130757 L7.01793103,6.85510068 C6.87360928,6.69688076 6.66932728,6.60675635 6.45517241,6.60682481 C6.15724138,6.60682481 5.94206897,6.75579033 5.94206897,6.95441102 C5.94206897,7.11992826 6.0662069,7.21096274 6.48,7.3516524 C7.27448276,7.59992826 7.5062069,7.8316524 7.5062069,8.34475585 L7.5062069,8.33647999 Z M4.08827586,6.1516524 L4.78344828,6.1516524 L4.78344828,9.30475585 L4.08827586,9.30475585 L4.08827586,6.1516524 Z M1.8537931,9.30475585 L0.827586207,9.30475585 L0.827586207,6.1516524 L1.8537931,6.1516524 C2.97931034,6.1516524 3.75724138,6.79716964 3.75724138,7.72406619 C3.75724138,8.19579033 3.52551724,8.64268688 3.12,8.94061792 C2.77241379,9.18889378 2.38344828,9.30475585 1.84551724,9.30475585 L1.8537931,9.30475585 Z M2.66482759,6.9378593 C2.43310345,6.75579033 2.16827586,6.68958343 1.71310345,6.68958343 L1.52275862,6.68958343 L1.52275862,8.77510068 L1.71310345,8.77510068 C2.16,8.77510068 2.44137931,8.69234206 2.66482759,8.52682481 C2.90482759,8.32820412 3.04551724,8.03027309 3.04551724,7.72406619 C3.04551724,7.4178593 2.90482759,7.12820412 2.66482759,6.9378593 Z",
  id: "shape",
  fill: "#000000"
}), C.createElement("path", {
  d: "M12.4137931,6.06889378 C11.5034483,6.06889378 10.7586207,6.79716964 10.7586207,7.69923861 C10.7586207,8.65923861 11.4703448,9.37923861 12.4137931,9.37923861 C13.3406897,9.37923861 14.0689655,8.65096274 14.0689655,7.72406619 C14.0689655,6.79716964 13.3489655,6.06889378 12.4137931,6.06889378 Z",
  id: "shape",
  fill: "#F27712"
})))))), Qp = C.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, C.createElement("g", {
  id: "Group-2"
}, C.createElement("rect", {
  id: "Rectangle",
  fill: "#B3131B",
  x: "0",
  y: "0",
  width: "24",
  height: "16",
  rx: "2"
}), C.createElement("g", {
  id: "Hipercard_logo",
  transform: "translate(2.000000, 6.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, C.createElement("path", {
  d: "M4.45845797,4.72911206 L4.71934477,4.72911206 L4.72670967,4.71021617 C4.73076043,4.69982332 4.73407456,4.67539055 4.73407456,4.65592007 C4.73407456,4.63644958 4.74267391,4.56566228 4.75318417,4.49861521 C4.76369454,4.43156695 4.78836018,4.27726169 4.80799675,4.15571305 C4.82763331,4.0341644 4.85703646,3.85139347 4.87333717,3.74955542 C4.88963776,3.64771736 4.90953167,3.51735868 4.91754595,3.45986946 C4.92556023,3.40238023 4.93534271,3.3553436 4.93928464,3.3553436 C4.94322668,3.3553436 4.96009268,3.38074637 4.9767648,3.41179473 L5.0070776,3.46824705 L5.07434118,3.5349692 L5.14160488,3.60169134 L5.22440039,3.63432372 L5.30719578,3.66695609 L5.40587279,3.67955056 L5.5045498,3.69214384 L5.62980554,3.68457856 L5.75506139,3.67701327 L5.8906751,3.64246001 L6.02628894,3.60790675 L6.09908975,3.57519075 C6.13913019,3.55719677 6.21011098,3.51796553 6.25682484,3.48801021 L6.34175912,3.43354447 L6.42095111,3.35561954 C6.46450662,3.31276155 6.5259323,3.24403729 6.55745263,3.20290069 C6.58897283,3.16176409 6.61476215,3.12510239 6.61476215,3.12143264 C6.61476215,3.11776169 6.63024834,3.09228724 6.64917582,3.06482382 C6.66810343,3.0373592 6.70683989,2.96113177 6.73525696,2.8954298 C6.76367415,2.82972783 6.80808531,2.71146429 6.83394853,2.63262192 L6.88097263,2.48927217 L6.90527961,2.36510142 C6.91864839,2.29680721 6.93584673,2.18391928 6.94349809,2.11423935 L6.95740984,1.98754804 L6.9493753,1.88003572 L6.94134076,1.77252341 L6.91602234,1.66501109 L6.89070392,1.55749878 L6.84971924,1.47700311 L6.80873457,1.39650745 L6.72956721,1.31388424 L6.65039973,1.23125983 L6.55674682,1.18360201 L6.4630938,1.13594299 L6.35995932,1.11163207 L6.25682484,1.08732115 L6.15369036,1.07986696 L6.05055588,1.07241397 L5.93566831,1.0854122 L5.82078075,1.09840925 L5.7270093,1.12198192 L5.63323773,1.1455534 L5.55177641,1.18267501 C5.50697261,1.2030916 5.44177912,1.23776791 5.40690207,1.25973387 C5.3720249,1.28169983 5.33604735,1.30697239 5.32695174,1.31589472 C5.31785613,1.32481824 5.29608043,1.34134766 5.27856116,1.3526257 L5.24670802,1.37313308 L5.26898276,1.26820942 C5.28123392,1.21050159 5.29147275,1.15656744 5.2917358,1.14835469 L5.29221386,1.13342243 L5.06976516,1.13342243 L4.84731634,1.13342243 L4.80831003,1.37532513 C4.78685648,1.50837162 4.75298372,1.71398893 4.73303727,1.83225247 C4.7130907,1.95051602 4.68301183,2.12791134 4.66619545,2.22646429 C4.64937895,2.32501725 4.61938307,2.49972476 4.59953794,2.61470321 C4.5796928,2.72968165 4.54689191,2.91245259 4.52664697,3.02086084 C4.50640216,3.12926909 4.47674372,3.28784975 4.46073931,3.37326231 C4.44473502,3.45867488 4.41461296,3.61994335 4.39380151,3.7316367 C4.37299019,3.84333005 4.33954562,4.02072536 4.31948026,4.12584852 C4.29941502,4.23097167 4.26676167,4.39761576 4.24691738,4.49616871 C4.2270731,4.59472167 4.20785211,4.68745104 4.20420394,4.70223398 L4.19757093,4.72911206 L4.45845773,4.72911206 L4.45845797,4.72911206 Z M5.58158434,3.34795511 L5.48028286,3.35395071 L5.41406652,3.34244331 L5.34785018,3.33093472 L5.28059837,3.30070464 L5.21334656,3.27047457 L5.16636177,3.22630134 L5.11937709,3.18212931 L5.09225746,3.12240025 C5.07734166,3.08954926 5.0581828,3.0337432 5.04968233,2.99838718 L5.03422684,2.93410437 L5.04041916,2.8311458 L5.04661147,2.72818843 L5.07787505,2.56691995 C5.09507,2.47822229 5.12594421,2.31157821 5.14648436,2.19659976 C5.1670245,2.08162131 5.19812318,1.9131519 5.21559259,1.82222277 L5.24735509,1.6568975 L5.3169102,1.5999088 C5.35516545,1.56856538 5.41576424,1.52655673 5.45157423,1.50655705 L5.51668327,1.470194 L5.60161755,1.44430981 L5.68655183,1.41842563 L5.79575304,1.41211346 L5.90495426,1.40580129 L5.99387134,1.42445946 L6.08278843,1.44311762 L6.1455397,1.47157016 L6.20829096,1.50002269 L6.2609103,1.55210763 L6.31352963,1.60419138 L6.34191746,1.65934519 C6.3575308,1.68968039 6.37946059,1.74905705 6.39065044,1.79129506 L6.41099548,1.86808991 L6.40476348,2.09506035 L6.39853137,2.32203079 L6.36736983,2.45618705 C6.35023095,2.52997394 6.31760514,2.64286188 6.29486799,2.70704912 L6.25352781,2.82375493 L6.20290006,2.91822719 C6.17505485,2.9701879 6.1321162,3.04040419 6.10748089,3.07426459 C6.08284558,3.10812381 6.04357913,3.15198525 6.0202222,3.17173287 C5.99686528,3.19148049 5.95774892,3.22234369 5.93329695,3.24031617 L5.8888387,3.27299275 L5.7858622,3.30747553 L5.6828857,3.34195951 L5.58158434,3.34795511 Z M8.10111202,3.67635864 L8.23458018,3.67786023 L8.36804833,3.665875 C8.44145581,3.6592833 8.56157715,3.64555995 8.63498463,3.63537973 C8.70839211,3.62519831 8.83520336,3.60240928 8.91678734,3.58473665 L9.06512179,3.5526048 L9.07250973,3.498771 C9.07657311,3.4691621 9.093232,3.38101873 9.10952955,3.3028967 L9.1391613,3.16085621 L9.1326233,3.1544198 L9.12608543,3.1479822 L9.0807372,3.1695444 C9.05579576,3.181403 8.97811171,3.20969069 8.90810597,3.23240685 L8.78082285,3.27370711 L8.6472364,3.29918394 L8.51364995,3.32466077 L8.30131425,3.32506693 L8.08897856,3.32547309 L8.01617775,3.30258252 C7.9761373,3.28999283 7.91724557,3.26695772 7.88530737,3.25139472 L7.82723768,3.22309628 L7.7793106,3.18046765 L7.73138352,3.13783782 L7.69398963,3.07349051 L7.65659562,3.00914319 L7.63315109,2.92843011 L7.60970656,2.84771703 L7.60953911,2.69835615 L7.60937167,2.54899526 L7.63018579,2.41575047 L7.65099978,2.28250449 L7.83358895,2.27410658 L8.01617823,2.26570748 L8.69111697,2.26997453 L9.3660557,2.27424157 L9.38643459,2.18913124 C9.39764288,2.14232038 9.41477886,2.04555929 9.42451439,1.97410661 L9.44221542,1.84419231 L9.44258913,1.73490963 L9.44296284,1.62562694 L9.42374501,1.54404301 L9.40452717,1.46245909 L9.37275132,1.40843654 C9.35527451,1.37872491 9.32448062,1.33566504 9.3043205,1.31274938 C9.28416037,1.28983373 9.24816377,1.25752509 9.22432794,1.24095266 C9.20049222,1.22438023 9.15368992,1.19652977 9.12032288,1.17906499 L9.05965554,1.14730824 L8.95365525,1.12215633 L8.84765497,1.09700442 L8.71705262,1.08471099 L8.58645027,1.07241636 L8.46511559,1.08019547 L8.34378091,1.08797458 L8.19817929,1.11550012 L8.05257767,1.14302686 L7.96157665,1.17884877 C7.9115261,1.198551 7.83508525,1.23447922 7.7917081,1.2586898 C7.74833095,1.28290038 7.68827028,1.32231081 7.65823994,1.34626814 C7.62820961,1.37022427 7.57621515,1.4167998 7.54269681,1.44976786 C7.50917834,1.48273591 7.45959784,1.54196325 7.43251788,1.58138443 C7.40543792,1.62080561 7.36392374,1.69068862 7.34026433,1.73668 C7.31660479,1.78267138 7.28577559,1.84717876 7.27175488,1.88002975 C7.25773417,1.91288073 7.23225571,1.98007593 7.21513599,2.02935241 C7.1980164,2.07862889 7.17110667,2.17270216 7.15533656,2.23840413 C7.13956645,2.3041061 7.11795686,2.41225991 7.10731533,2.47874552 L7.08796742,2.59963476 L7.08814699,2.77739681 L7.08832657,2.95515887 L7.10676835,3.03280665 C7.11691132,3.07551293 7.13630473,3.14002032 7.14986473,3.1761564 C7.16342485,3.21229249 7.18849963,3.26604864 7.20558671,3.29561453 C7.22267367,3.32518042 7.2591652,3.37278329 7.28667905,3.40139948 C7.31419278,3.43001568 7.36400431,3.47343751 7.39737135,3.49789178 C7.43073838,3.52234606 7.49013972,3.55674044 7.52937438,3.57432587 L7.60070995,3.60629765 L7.70017273,3.62996947 C7.75487732,3.64298921 7.83743756,3.65841484 7.88363999,3.66425037 C7.92984242,3.6700847 8.02770503,3.67553319 8.10111251,3.67635864 L8.10111202,3.67635864 Z M8.32965888,1.99352094 C7.99374575,1.99352094 7.71890777,1.99115328 7.71890777,1.98826001 C7.71890777,1.98536673 7.73323995,1.94370571 7.75075703,1.89567996 C7.76827412,1.84765421 7.79903902,1.77617166 7.81912342,1.73682932 L7.85564031,1.66529779 L7.93590903,1.58670271 L8.01617775,1.50810762 L8.09504529,1.47097884 C8.13842244,1.45055747 8.19575308,1.42832273 8.22244671,1.42156738 C8.24914034,1.41481202 8.32558119,1.40585027 8.39231526,1.40165251 L8.51364995,1.39401794 L8.60682685,1.40580726 L8.70000364,1.41759659 L8.76771701,1.44811814 L8.8354305,1.4786385 L8.87257529,1.51806804 C8.89300502,1.53975447 8.9173507,1.5716916 8.92667697,1.58903811 L8.94363374,1.62057745 L8.95483159,1.69057752 L8.96602945,1.76057759 L8.95321966,1.87704927 L8.94040987,1.99352094 L8.32965888,1.99352094 Z M11.959629,3.67642315 L12.0931723,3.67788054 L12.2447655,3.66019237 C12.328143,3.6504637 12.4391291,3.63434164 12.4914025,3.62436569 C12.5436771,3.61438974 12.628308,3.59458597 12.6794712,3.58035851 C12.7306357,3.56612985 12.7769248,3.55074723 12.7823351,3.54617318 C12.7877455,3.54159912 12.8022037,3.48738425 12.8144634,3.42569488 C12.826723,3.3640055 12.8421665,3.28127956 12.8487817,3.24185837 C12.8553968,3.20243719 12.858816,3.16807267 12.8563809,3.16549477 C12.8539445,3.16291567 12.8449948,3.16624735 12.8364917,3.1728952 C12.8279885,3.17954304 12.7684545,3.20420995 12.7041944,3.22770736 L12.5873588,3.27043156 L12.420981,3.302168 L12.2546045,3.33390325 L12.1131465,3.32915121 L11.9716884,3.32439797 L11.8913406,3.29696441 L11.8109916,3.26953085 L11.7489046,3.21605781 L11.6868164,3.16258596 L11.6456318,3.08873695 L11.6044472,3.01488793 L11.5848322,2.91609248 L11.5652172,2.81729702 L11.5653386,2.68912203 L11.5654599,2.56094705 L11.5892961,2.40565148 L11.6131335,2.25035592 L11.6383541,2.16673523 C11.6522263,2.12074385 11.6679222,2.06698769 11.6732342,2.0472771 C11.678545,2.02756651 11.7007978,1.97112254 11.722683,1.92184607 C11.7445681,1.87256959 11.7836087,1.79641025 11.8094409,1.75260257 L11.8564059,1.67295267 L11.9140896,1.61410998 L11.9717721,1.5552673 L12.0328581,1.51796531 L12.0939452,1.48066331 L12.172393,1.45687442 C12.2155396,1.44379137 12.2917924,1.42680322 12.3418429,1.41912326 L12.4328439,1.40516219 L12.5663121,1.41175628 L12.6997802,1.41835037 L12.8575153,1.44943457 L13.0152504,1.48051877 L13.0794061,1.50407591 C13.1146915,1.51703353 13.145104,1.52763425 13.1469871,1.52763425 C13.1488715,1.52763425 13.1573345,1.48328542 13.1657928,1.42908129 C13.1742522,1.37487717 13.1893087,1.28569809 13.1992508,1.23090743 C13.209193,1.17611557 13.2149333,1.12892841 13.2120067,1.12604708 C13.2090789,1.12316575 13.1616662,1.11575337 13.1066446,1.109575 C13.0516217,1.10339663 12.9020779,1.09242679 12.7743246,1.08519718 L12.5420452,1.0720532 L12.3782433,1.08442906 L12.2144415,1.09680493 L12.0931068,1.12190786 L11.9717721,1.14701198 L11.8936314,1.17778201 C11.8506546,1.19470683 11.787705,1.2252463 11.7537446,1.24564856 C11.7197843,1.26605201 11.6765552,1.29349632 11.6576803,1.30663671 C11.6388043,1.3197771 11.5815404,1.37104495 11.5304257,1.42056632 L11.4374894,1.5106043 L11.3856128,1.58542809 C11.3570809,1.62658022 11.3077232,1.71239058 11.2759299,1.77611671 L11.2181236,1.89198153 L11.1738182,2.01741257 C11.1494494,2.08639964 11.1154271,2.19928757 11.098211,2.26827464 L11.0669102,2.39370567 L11.0555485,2.50719089 L11.0441879,2.62067611 L11.0443092,2.76999877 L11.0444306,2.91932143 L11.0558894,3.0061878 L11.0673483,3.09305536 L11.1036916,3.18241243 L11.1400338,3.27176949 L11.1820095,3.33637364 L11.2239841,3.4009766 L11.2907327,3.46565123 L11.3574813,3.53032586 L11.4280836,3.56706401 L11.4986858,3.60380216 L11.591451,3.6291691 C11.642471,3.64312061 11.7161818,3.65913278 11.7552528,3.6647509 C11.7943226,3.67037021 11.8863841,3.67562278 11.9598316,3.67642315 L11.959629,3.67642315 Z M13.9555105,3.67201037 L14.1193123,3.66738973 L14.2224468,3.64140161 L14.3255813,3.6154123 L14.3923154,3.5843508 C14.4290191,3.56726709 14.4890798,3.53354287 14.5257835,3.50940874 C14.5624872,3.48527462 14.6192998,3.43939314 14.6520322,3.40745004 C14.6847659,3.37550574 14.7333071,3.32100536 14.7599012,3.28633861 C14.7864953,3.25167066 14.8098571,3.22488337 14.8118155,3.22681143 C14.8137726,3.22873948 14.8076537,3.2839817 14.7982163,3.34957257 C14.7887801,3.41516345 14.7809516,3.50242641 14.7808217,3.54349015 L14.7805912,3.61815148 L15.003278,3.61815148 L15.2259647,3.61815148 L15.2327728,3.44792364 L15.2395797,3.27769581 L15.2713548,3.05669828 C15.2888318,2.93514963 15.3170592,2.75506651 15.3340824,2.65651355 C15.3511044,2.55796059 15.3806943,2.39131651 15.3998373,2.28619336 C15.4189803,2.1810702 15.4493055,2.01711392 15.4672278,1.92184607 L15.4998135,1.74863178 L15.5009055,1.59901287 L15.5019975,1.44939515 L15.4676343,1.38024561 L15.4332723,1.31109728 L15.3866749,1.26705665 L15.3400776,1.22301602 L15.2635748,1.18484915 L15.1870721,1.14668347 L15.0730551,1.12171553 L14.9590393,1.09674639 L14.8020602,1.08498574 L14.645081,1.07322389 L14.4428707,1.08554122 C14.3316553,1.09231569 14.1751408,1.10569261 14.0950599,1.11526718 L13.9494583,1.13267701 L13.8502272,1.13304733 L13.750996,1.13341765 L13.7365584,1.20210607 C13.7286171,1.2398847 13.7065499,1.32964076 13.687521,1.40156411 C13.6684909,1.47348627 13.6546854,1.53406946 13.6568415,1.53619223 C13.6589976,1.538315 13.7120682,1.52645639 13.7747764,1.50983976 C13.8374846,1.49322194 13.9706919,1.4658947 14.070793,1.44911203 L14.252795,1.41859765 L14.4165969,1.411951 L14.5803987,1.40530435 L14.6859089,1.42351335 L14.7914191,1.44172116 L14.8618442,1.47594352 L14.9322693,1.51016469 L14.971703,1.56803021 L15.0111368,1.62589572 L15.0105787,1.7171259 L15.0100205,1.80835607 L14.989117,1.90846915 L14.9682134,2.00858342 L14.5316331,2.01013398 L14.0950539,2.01168455 L13.9521677,2.05025639 C13.8735792,2.07147095 13.786558,2.09963679 13.7587857,2.11284647 C13.7310146,2.12605735 13.7032351,2.13686592 13.6970543,2.13686592 C13.6908735,2.13686592 13.6441232,2.16238934 13.5931651,2.19358344 L13.5005139,2.25030097 L13.4275457,2.32200093 C13.387413,2.36143645 13.3361406,2.42057897 13.3136063,2.45342996 C13.2910733,2.48628094 13.2544617,2.55490844 13.232249,2.60593498 L13.1918603,2.69871094 L13.173324,2.80304089 L13.1547877,2.90737084 L13.1547877,3.01681838 L13.1547877,3.12626711 L13.1724965,3.21739215 L13.1902065,3.3085184 L13.2230615,3.3679524 C13.2411331,3.40064092 13.2742951,3.44852332 13.2967566,3.47435973 L13.3375954,3.52133305 L13.4101681,3.56473577 L13.4827396,3.60813849 L13.5658078,3.63128231 C13.6114963,3.64401177 13.6810332,3.65942187 13.720336,3.66552618 L13.7917948,3.67662623 L13.9555966,3.67200559 L13.9555105,3.67201037 Z M14.1071788,3.33797677 L14.0101111,3.34295937 L13.9458219,3.32683969 C13.9104626,3.31797351 13.8568096,3.2982008 13.8265924,3.2829006 L13.771652,3.25508 L13.7416666,3.21999634 C13.7251748,3.20069908 13.6999809,3.16278307 13.6856804,3.13573655 L13.6596808,3.08656281 L13.6545823,2.97172771 L13.649485,2.85689381 L13.6700525,2.78723658 C13.6813657,2.74892516 13.7079052,2.68244671 13.7290308,2.6395051 L13.7674417,2.56143085 L13.840996,2.48951348 L13.9145503,2.4175973 L13.9926644,2.38056886 L14.0707784,2.34354042 L14.1678462,2.3208398 L14.2649139,2.29813917 L14.5682506,2.29813917 L14.8715874,2.29813917 L14.8907789,2.30595173 L14.9099692,2.31376429 L14.8938183,2.40749114 C14.8849342,2.4590409 14.8637479,2.55228633 14.8467356,2.61470321 C14.8297232,2.67712008 14.7996905,2.76887348 14.7799954,2.81860031 C14.7603004,2.86832714 14.7441859,2.91229012 14.7441859,2.91629675 C14.7441859,2.92030338 14.7242458,2.95653742 14.6998745,2.99681631 L14.6555643,3.07005131 L14.5828035,3.14102257 C14.5427861,3.18005671 14.5056371,3.21199384 14.5002523,3.21199384 C14.4948674,3.21199384 14.4703372,3.22543885 14.4457427,3.24187151 L14.4010235,3.27174799 L14.3026357,3.30237108 L14.2042466,3.33299417 L14.1071788,3.33797677 Z M18.0566228,3.67628099 L18.1718907,3.67771091 L18.281092,3.66026166 C18.3411526,3.65066439 18.4175935,3.63520412 18.4509605,3.6259067 C18.4843276,3.61660808 18.5443882,3.59247515 18.5844287,3.57227836 L18.6572295,3.53555693 L18.7198576,3.48128471 L18.7824857,3.4270125 L18.8484444,3.34040775 C18.8847223,3.29277621 18.9175725,3.24574076 18.9214467,3.23588547 L18.9284889,3.21796675 L18.922364,3.27769581 C18.9189945,3.3105468 18.9114402,3.36430295 18.9055761,3.39715394 C18.8997132,3.43000492 18.8913059,3.49316841 18.8868942,3.53751724 L18.8788715,3.61815148 L19.1168877,3.61815148 L19.3549039,3.61815148 L19.3549039,3.53751724 L19.3549039,3.456883 L19.391166,3.15226478 C19.411111,2.98472475 19.4406038,2.7616367 19.4567061,2.65651355 C19.4728085,2.5513904 19.4976627,2.40087316 19.5119389,2.32203079 C19.5262139,2.24318843 19.5514964,2.10073461 19.5681205,2.00546676 C19.5847433,1.9101989 19.6147725,1.74355481 19.6348497,1.63514656 C19.654927,1.52673831 19.68706,1.35471861 19.7062552,1.25288055 C19.7254515,1.1510425 19.7552865,0.992461836 19.7725549,0.900479078 C19.7898244,0.80849632 19.8207636,0.647227848 19.841308,0.542104696 C19.8618536,0.436981544 19.8918657,0.289152111 19.9080008,0.213594845 C19.9241371,0.13803758 19.9373165,0.0721862871 19.9372885,0.0672586394 L19.9372886,0.0582992798 L19.6776105,0.0582992798 L19.4179324,0.0582992798 L19.4102629,0.132960609 C19.4060453,0.174024341 19.386167,0.309758638 19.3660873,0.434592381 C19.3460089,0.559426124 19.3132764,0.758323906 19.2933496,0.876587452 C19.2734228,0.994850998 19.2542119,1.109532 19.2506592,1.13143345 L19.2442006,1.17125601 L19.2237071,1.16267653 C19.2124364,1.15795674 19.1513431,1.14127321 19.0879458,1.12560031 L18.9726778,1.09710477 L18.8149427,1.08501083 L18.6572076,1.07291569 L18.5237395,1.08516015 L18.3902713,1.09740461 L18.2689366,1.12760004 L18.147602,1.15779547 L18.032334,1.21314639 L17.9170661,1.26849731 L17.8321318,1.33040529 L17.7471975,1.39231447 L17.6738471,1.46974245 C17.6335045,1.51232808 17.5752238,1.58276537 17.5443344,1.62626963 L17.488171,1.70537002 L17.4222183,1.84048553 C17.3859453,1.91479923 17.3418026,2.01323153 17.3241241,2.05922291 C17.3064456,2.10521429 17.2752675,2.20716464 17.2548384,2.28577884 L17.2176966,2.42871287 L17.1993969,2.61428869 L17.1810984,2.7998633 L17.1948396,2.94918596 L17.2085795,3.09850862 L17.224825,3.15226478 C17.2337589,3.18183067 17.2525985,3.23450692 17.2666891,3.26932419 L17.2923089,3.33262744 L17.3390179,3.39487707 L17.3857281,3.45712789 L17.4390608,3.5001364 L17.4923947,3.54314491 L17.5651955,3.57873388 C17.6052359,3.59830709 17.6724044,3.62360354 17.714459,3.63494729 C17.7565136,3.64629103 17.8247643,3.65990926 17.8661273,3.66521081 C17.9074903,3.67051236 17.9932036,3.67549377 18.056601,3.67628099 L18.0566228,3.67628099 Z M18.2635057,3.33735678 L18.1718907,3.34214706 L18.1100549,3.33118916 C18.0760448,3.3251625 18.0216226,3.30900698 17.989117,3.29528841 L17.9300149,3.27034555 L17.8802835,3.23022554 L17.830552,3.19010433 L17.7935947,3.12041485 L17.7566361,3.05072537 L17.7397949,2.97307759 L17.7229524,2.8954298 L17.7243805,2.74013424 L17.7258074,2.58483867 L17.7453666,2.44746183 L17.7649257,2.31008498 L17.7953249,2.21451848 C17.8120436,2.1619569 17.8258042,2.11236625 17.8259049,2.10431836 C17.8260262,2.09627046 17.8425132,2.05326554 17.8625892,2.00875185 C17.8826665,1.96423817 17.9162082,1.89556528 17.9371288,1.8561441 C17.9580481,1.81672291 17.9971506,1.75526768 18.0240226,1.71957718 C18.0508934,1.68388667 18.0987648,1.63013051 18.1304016,1.60011905 C18.1620384,1.57010758 18.2123656,1.53074374 18.2422382,1.51264345 L18.2965536,1.47973512 L18.3919567,1.44723295 L18.4873609,1.41473079 L18.6875631,1.41461133 L18.8877654,1.41461133 L19.0030333,1.44609571 C19.0664307,1.46341117 19.1337447,1.48349327 19.1526184,1.49072169 L19.1869367,1.50386327 L19.1802341,1.53665453 C19.176548,1.55468912 19.1621274,1.63395198 19.1481884,1.71279434 C19.1342495,1.79163671 19.1067842,1.94215395 19.0871522,2.0472771 C19.0675203,2.15240025 19.0373589,2.31098092 19.0201245,2.39967858 C19.0028914,2.48837624 18.9779292,2.60126417 18.9646527,2.65054064 C18.9513763,2.69981712 18.9326471,2.76806952 18.9230301,2.80221304 C18.9134143,2.83635657 18.890516,2.89548834 18.872146,2.93361698 C18.8537759,2.97174563 18.8216307,3.02713239 18.8007126,3.05669828 C18.7797957,3.08626416 18.7444145,3.12722038 18.7220889,3.14771103 C18.6997633,3.16820288 18.6514661,3.2046173 18.6147623,3.22863316 L18.5480283,3.2722975 L18.4515745,3.30243201 L18.3551207,3.33256771 L18.2635057,3.33735798 L18.2635057,3.33735678 Z M0.406035224,3.61815148 L0.700846957,3.61815148 L0.721999232,3.48973399 C0.733631588,3.41910437 0.756352721,3.28337007 0.772489021,3.18810222 C0.78862532,3.09283436 0.818658081,2.91543904 0.839229163,2.7938904 C0.859799032,2.67234175 0.890636242,2.49225862 0.907755352,2.39370567 C0.924874463,2.29515271 0.952074059,2.14227379 0.968198225,2.05397392 C0.984323604,1.96567525 1.00057639,1.89041663 1.00431713,1.88673254 L1.01111794,1.88003572 L1.80383747,1.88003572 L2.596557,1.88003572 L2.60535861,1.88869883 L2.61416145,1.89736193 L2.60041544,1.96634661 C2.59285507,2.0042877 2.57049188,2.12134114 2.55072039,2.22646429 C2.53094769,2.33158744 2.49770806,2.50898276 2.47685426,2.62067611 C2.45600047,2.73236946 2.42584638,2.89095012 2.40984597,2.97307759 C2.39384435,3.05520505 2.36146377,3.22722475 2.33788965,3.3553436 C2.31431432,3.48346244 2.29507549,3.59500646 2.29513616,3.60321921 L2.2952575,3.61815148 L2.59128136,3.61815148 L2.88730644,3.61815148 L2.90040452,3.54349015 C2.90760938,3.50242641 2.91920048,3.4285117 2.92616388,3.37923522 C2.93312606,3.32995874 2.9499115,3.22513424 2.96346337,3.14629187 C2.97701646,3.06744951 3.00409472,2.91155665 3.02363688,2.7998633 C3.04317905,2.68816995 3.07588966,2.4973356 3.09632728,2.37578695 C3.11676368,2.25423831 3.14708242,2.07684299 3.16370127,1.98157513 C3.18032,1.88630727 3.2099327,1.7250388 3.22950738,1.62320075 C3.24908194,1.52136269 3.28168651,1.34934299 3.30196202,1.24093474 C3.32223741,1.13252649 3.3526127,0.96857021 3.36946269,0.876587452 C3.3863128,0.784604694 3.41703596,0.617960606 3.43773662,0.506267257 C3.45843729,0.394573908 3.48457667,0.264215227 3.49582403,0.216581299 L3.5162739,0.129974156 L3.21654665,0.129974156 L2.91681989,0.129974156 L2.90866742,0.186716767 C2.9041841,0.217925202 2.88970402,0.305278958 2.87649067,0.380836224 C2.86327611,0.456393489 2.83924092,0.590783883 2.82307672,0.679481542 C2.80691251,0.768179202 2.77737358,0.937511097 2.75743465,1.05577464 C2.73749451,1.17403819 2.7120846,1.33059045 2.7009667,1.40366896 L2.68075113,1.53653985 L2.24076366,1.54530688 L1.80077498,1.55407391 L1.43224272,1.54546337 C1.22954949,1.54072805 1.0625869,1.53591269 1.06121339,1.53476231 C1.05983988,1.53361551 1.06674383,1.4871905 1.07655495,1.43160066 C1.08636486,1.37601082 1.10492543,1.27945999 1.11780025,1.21704312 C1.13067507,1.15462624 1.15508154,1.03098708 1.17203685,0.942289422 C1.18899095,0.853591763 1.20819702,0.74339164 1.21471511,0.697400261 C1.22123321,0.651408882 1.23489429,0.574806358 1.24507305,0.52717243 C1.25525061,0.479538501 1.27456709,0.379202037 1.28799762,0.304203835 C1.30142816,0.229204439 1.31573716,0.159321434 1.3197958,0.148908269 L1.32717538,0.129974156 L1.02986779,0.129974156 L0.732560203,0.129974156 L0.713517938,0.234500018 C0.703043115,0.291989241 0.689078706,0.373967381 0.682484166,0.416673662 C0.675889626,0.459379942 0.653744833,0.596458144 0.633273245,0.721291887 C0.612802871,0.84612563 0.582582041,1.03158437 0.566118138,1.13342243 C0.549653021,1.23526048 0.519668795,1.42071922 0.499487197,1.54555297 C0.479305599,1.67038671 0.446005295,1.86390887 0.4254876,1.97560222 C0.404969905,2.08729557 0.375264748,2.24587624 0.359476679,2.3280037 C0.343687397,2.41013116 0.313600035,2.56602402 0.292613988,2.67443227 C0.271629155,2.78284052 0.241013987,2.93604557 0.224581631,3.01488793 C0.208148062,3.0937303 0.189981833,3.18511576 0.184209942,3.21796675 C0.178439265,3.25081773 0.159657869,3.34556595 0.142475664,3.42851887 C0.125292247,3.51147178 0.111233197,3.58807431 0.111233197,3.5987467 L0.111233197,3.61815148 L0.40604493,3.61815148 L0.406035224,3.61815148 Z M3.6696828,3.61815148 L3.93066933,3.61815148 L3.93803423,3.59925559 C3.94208498,3.58886273 3.94539912,3.56160239 3.94539912,3.53867598 C3.94539912,3.51574958 3.96181061,3.39658174 3.98186905,3.27385882 C4.00192749,3.1511347 4.03506982,2.95127648 4.0555186,2.82972783 C4.07596737,2.70817919 4.10616636,2.53078387 4.12262747,2.43551601 C4.13908859,2.34024816 4.16836313,2.18166749 4.18768216,2.08311454 C4.20700119,1.98456158 4.23665805,1.83135654 4.2535863,1.74265888 C4.27051468,1.65396122 4.3038043,1.48521228 4.32756345,1.3676607 C4.3513226,1.25010912 4.37372499,1.14921121 4.37734671,1.14344138 L4.38393166,1.13295176 L4.1200058,1.13617355 L3.85607993,1.13939533 L3.83409918,1.2946909 C3.82200988,1.38010346 3.79557869,1.54943535 3.77536324,1.670984 C3.75514791,1.79253264 3.72457012,1.97799139 3.70741291,2.08311454 C3.69025558,2.18823769 3.66033444,2.35756959 3.64092138,2.45940764 C3.62150844,2.56124569 3.59175924,2.71713855 3.57481193,2.80583621 C3.55786476,2.89453387 3.52745513,3.05042672 3.50723495,3.15226478 C3.48701476,3.25410283 3.45988239,3.38849323 3.44694071,3.4509101 C3.43399891,3.51332697 3.42009966,3.57649045 3.41605327,3.5912734 L3.40869626,3.61815148 L3.6696828,3.61815148 Z M9.77371379,3.61815148 L10.0327662,3.61815148 L10.0405474,3.5102342 C10.0448257,3.45088023 10.0594866,3.33127278 10.0731246,3.24443986 C10.0867638,3.15760695 10.1146878,2.98442611 10.1351788,2.85959237 C10.155671,2.73475862 10.1937543,2.52697555 10.2198085,2.39785326 C10.2458627,2.26872977 10.2753155,2.14038396 10.2852589,2.11263742 C10.295201,2.08489208 10.3033365,2.05482685 10.3033365,2.04582568 C10.3033365,2.03682332 10.3228132,1.98777501 10.346619,1.9368285 C10.3704237,1.885882 10.4147873,1.80786868 10.4452047,1.76346729 L10.5005078,1.6827351 L10.5745377,1.61525798 L10.6485665,1.54777966 L10.7398538,1.50485597 L10.8311424,1.46193228 L10.9706773,1.46264903 L11.1102122,1.46336577 L11.1788136,1.48354942 C11.216545,1.49465186 11.2506704,1.50373426 11.2546478,1.50373426 C11.2586263,1.50373426 11.2618805,1.49103467 11.2618805,1.47551228 C11.2618805,1.45999108 11.2755307,1.38130521 11.2922142,1.30065544 C11.3088977,1.22000687 11.3225479,1.15061842 11.3225479,1.14646009 C11.3225479,1.14230175 11.2829624,1.12704814 11.2345802,1.11256384 C11.186198,1.09807954 11.1193123,1.08290836 11.0859452,1.07885156 L11.0252779,1.07147502 L10.9464103,1.08520913 C10.9030332,1.09276246 10.8385341,1.10943762 10.8030789,1.12226504 C10.7676249,1.13509245 10.7090846,1.16418528 10.6729899,1.18691816 C10.6368953,1.20964985 10.5807489,1.25394851 10.5482203,1.28535763 C10.5156916,1.31676676 10.4609794,1.3800951 10.4266368,1.42608648 C10.392293,1.47207786 10.356378,1.5204584 10.3468229,1.53359879 L10.3294514,1.55749042 L10.339999,1.50970717 C10.3458012,1.48342638 10.3619594,1.39741653 10.375908,1.31857416 C10.3898566,1.2397318 10.4041729,1.16581708 10.4077208,1.15431924 L10.4141733,1.13341406 L10.1828196,1.13341406 L9.95146594,1.13341406 L9.95146594,1.16220945 C9.95146594,1.1780472 9.93781118,1.27346438 9.92112208,1.37424762 C9.90443298,1.47503205 9.87691282,1.64350027 9.85996613,1.74862342 C9.84301943,1.85374657 9.8129425,2.03651751 9.79312843,2.15478105 C9.77331448,2.2730446 9.74322906,2.44237649 9.72627205,2.53107415 C9.70931504,2.61977181 9.67920475,2.77566467 9.65936022,2.87750272 C9.63951569,2.97934078 9.60656725,3.14598486 9.58614129,3.24782292 C9.56571544,3.34966097 9.54127633,3.46992783 9.53183225,3.515083 C9.52238804,3.56023818 9.51466108,3.6018992 9.51466108,3.60766305 L9.51466108,3.61815148 L9.77371379,3.61814311 L9.77371379,3.61815148 Z M15.9231926,3.61815148 L16.1880687,3.61815148 L16.1880687,3.53834508 L16.1880687,3.4585375 L16.2185916,3.26060494 C16.2353807,3.15174036 16.2630766,2.97934914 16.2801399,2.87751109 C16.2972031,2.77567303 16.3184719,2.64665825 16.3274021,2.59081158 C16.3363336,2.53496491 16.3600011,2.41401355 16.3799983,2.32203079 C16.3999955,2.23004804 16.4249722,2.13059914 16.4355041,2.10103326 C16.4460347,2.07146737 16.4547308,2.04044768 16.4548278,2.03210114 C16.4549492,2.0237546 16.4775041,1.97007848 16.5050034,1.9128222 L16.555003,1.80871922 L16.6209641,1.72243342 L16.6869253,1.63614762 L16.7591146,1.58271997 C16.7988189,1.55333566 16.862664,1.51433975 16.9009912,1.49606385 L16.9706774,1.46283419 L17.1223457,1.46386153 L17.2740141,1.46488886 L17.3337192,1.48376564 L17.3934244,1.50264122 L17.4034867,1.49651779 L17.413549,1.49039556 L17.4140586,1.45227648 C17.4143376,1.43131157 17.4273241,1.35330183 17.4429192,1.27892123 L17.4712752,1.14368388 L17.4393799,1.13139044 C17.4218386,1.12462911 17.3801856,1.1106334 17.3468185,1.10028833 L17.2861512,1.08147964 L17.17695,1.0817544 L17.0677488,1.08202915 L16.9787546,1.11285532 L16.8897605,1.1436803 L16.8229391,1.18334995 L16.7561176,1.22301961 L16.669242,1.3126132 L16.5823676,1.4022068 L16.5356913,1.47170873 C16.5100193,1.50993414 16.4874171,1.53950002 16.4854648,1.5374107 C16.4835113,1.53532018 16.4974648,1.45566431 16.5164719,1.36039645 C16.535479,1.2651286 16.5512658,1.17508703 16.5515534,1.16030409 L16.5520751,1.1334272 L16.327606,1.1334272 L16.1031368,1.1334272 L16.1031368,1.14103908 C16.1031368,1.14522489 16.0919461,1.22182741 16.0782681,1.31126691 C16.0645912,1.40070521 16.0371283,1.57333176 16.0172416,1.6948804 C15.9973536,1.81642905 15.9647218,2.01263902 15.9447271,2.13090257 C15.9247312,2.24916611 15.894588,2.41849801 15.8777419,2.50719567 C15.8608958,2.59589333 15.8309746,2.75178618 15.8112517,2.85362424 C15.7915287,2.95546229 15.7591214,3.11941857 15.7392359,3.21797153 C15.7193504,3.31652448 15.6930086,3.44688316 15.6806992,3.50765749 L15.6583178,3.61815625 L15.9231951,3.61815625 L15.9231926,3.61815148 Z M4.18287366,0.70311036 L4.25654638,0.703373168 L4.31510626,0.683728279 L4.37366602,0.664083389 L4.42549425,0.612324572 L4.47732236,0.56056456 L4.50462182,0.491606161 L4.53192127,0.422646568 L4.5328968,0.32110716 L4.53387233,0.219567752 L4.5096054,0.179918405 L4.48533846,0.140270252 L4.4430896,0.114516275 L4.40084074,0.0887622969 L4.30962145,0.0887622969 L4.21840216,0.0887611023 L4.15629991,0.116134932 L4.09419767,0.143508762 L4.05814865,0.181538257 L4.0220995,0.219567752 L3.99378945,0.285269722 L3.96547928,0.350971692 L3.96012782,0.453313859 L3.95477635,0.555656026 L3.98113328,0.606521296 L4.00749008,0.657385372 L4.05834557,0.680117059 L4.10920094,0.702848746 L4.18287366,0.703111554 L4.18287366,0.70311036 Z",
  id: "path2997"
})))), e2 = {
  amex: Yp,
  dinersclub: Jp,
  discover: Xp,
  hipercard: Qp,
  jcb: Zp,
  unionpay: Up,
  mastercard: Wp,
  placeholder: Gp,
  visa: Kp,
  troy: qp
};
function t2() {
  const { t } = He(), [e, n] = Te(!1), {
    setCardNumber: r,
    setExpiryMonth: a,
    setExpiryYear: i,
    setCvc: o,
    setFormInvalid: s,
    cardHolderName: l,
    setCardHolderName: d
  } = To(), { meta: u, getCardImageProps: p, getCardNumberProps: m, getExpiryDateProps: _, getCVCProps: y } = T0({
    errorMessages: {
      dateOutOfRange: t("public_pages_purchase.payment_inputs.date_out_of_range"),
      emptyCVC: t("public_pages_purchase.payment_inputs.empty_cvc"),
      invalidCVC: t("public_pages_purchase.payment_inputs.invalid_cvc"),
      emptyCardNumber: t("public_pages_purchase.payment_inputs.empty_card_number"),
      invalidCardNumber: t("public_pages_purchase.payment_inputs.invalid_card_number"),
      emptyExpiryDate: t("public_pages_purchase.payment_inputs.empty_expiry_date"),
      invalidExpiryDate: t("public_pages_purchase.payment_inputs.invalid_expiry_date"),
      monthOutOfRange: t("public_pages_purchase.payment_inputs.month_out_of_range"),
      yearOutOfRange: t("public_pages_purchase.payment_inputs.year_out_of_range")
    }
  }), f = l === "", g = e && f;
  Ve(() => {
    const h = l.match(/^[a-zA-Z]+ [a-zA-Z]+$/);
    s(!!u.error || f || !h);
  }, [l, g, f, u.error, s]);
  const b = (h) => {
    r(h.target.value.replace(/\s/g, ""));
  }, v = (h) => {
    const [P, F] = h.target.value.replace(/\s/g, "").split("/");
    P && F && P.length === 2 && F.length === 2 && (a(P), i(F));
  }, x = (h) => {
    o(h.target.value);
  }, {
    state: { primaryColor: S }
  } = qe();
  return /* @__PURE__ */ L("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ L("div", { className: "flex flex-wrap gap-3", children: [
      /* @__PURE__ */ c(
        ar,
        {
          ...m({ onChange: b }),
          addonBefore: /* @__PURE__ */ c("svg", { ...p({ images: e2 }) }),
          placeholder: t("public_pages_purchase.payment_inputs.card_number_placeholder"),
          inputClassName: "focus:!border-THEME-primary",
          error: u.touchedInputs.cardNumber ? u.erroredInputs.cardNumber : ""
        }
      ),
      /* @__PURE__ */ c(
        ar,
        {
          ..._({ onChange: v }),
          placeholder: t("public_pages_purchase.payment_inputs.expiry_data_placeholder"),
          error: u.touchedInputs.expiryDate ? u.erroredInputs.expiryDate : "",
          inputClassName: "focus:!border-THEME-primary",
          className: "w-24"
        }
      )
    ] }),
    /* @__PURE__ */ L("div", { className: "flex flex-wrap gap-3", children: [
      /* @__PURE__ */ c(
        ar,
        {
          addonBefore: /* @__PURE__ */ c(pl, { height: 14, width: 21, fill: S }),
          type: "text",
          autoComplete: "cc-name",
          id: "cardName",
          name: "cardName",
          spellCheck: "false",
          "aria-label": t("public_pages_purchase.payment_inputs.card_holder_placeholder"),
          value: l,
          inputClassName: "focus:!border-THEME-primary",
          onChange: (h) => d(h.target.value),
          placeholder: t("public_pages_purchase.payment_inputs.card_holder_placeholder"),
          onBlur: () => n(!0),
          error: g ? t("public_pages_purchase.payment_inputs.empty_card_holder") : ""
        }
      ),
      /* @__PURE__ */ c(
        ar,
        {
          ...y({ onChange: x }),
          placeholder: t("public_pages_purchase.payment_inputs.cvc_placeholder"),
          error: u.touchedInputs.cvc ? u.erroredInputs.cvc : "",
          inputClassName: "focus:!border-THEME-primary",
          className: "w-24"
        }
      )
    ] })
  ] });
}
const r2 = (t, e) => {
  switch (t) {
    case le.stripe_card:
      return /* @__PURE__ */ c(Dd, { ...e });
    case le.stripe_ideal:
      return /* @__PURE__ */ c(Fd, {});
    case le.mercadopago_ar_card:
    case le.mercadopago_br_card:
    case le.mercadopago_cl_card:
    case le.mercadopago_co_card:
    case le.mercadopago_mx_card:
      return /* @__PURE__ */ c(s0, {});
    case le.xendit_id_card:
    case le.xendit_ph_card:
      return /* @__PURE__ */ c(t2, {});
  }
};
function n2(t) {
  switch (t) {
    case Or.SPANISH:
      return "es-AR";
    case Or.PORTUGUESE:
      return "pt-BR";
    case Or.ENGLISH:
      return "en-US";
    default:
      return "en-US";
  }
}
function i5({
  children: t,
  publicKey: e,
  forceInitialization: n
}) {
  const { locale: r } = _e(), { paymentMethod: a } = tt(), { setInitialized: i } = Mo();
  return Ve(() => {
    !e || !(a === le.mercadopago_ar_card || a === le.mercadopago_br_card || a === le.mercadopago_br_pix || a === le.mercadopago_br_boleto || a === le.mercadopago_cl_card || a === le.mercadopago_co_card || a === le.mercadopago_mx_card || n) || (Yd(e, { locale: n2(r) }), i(!0));
  }, [a, n, e, r]), t;
}
const a2 = [
  Ne.CHILEAN_PESO,
  Ne.GUINEAN_FRANC,
  Ne.JAPANESE_YEN,
  Ne.RWANDAN_FRANC,
  Ne.UGANDAN_SHILLING,
  Ne.CENTRAL_AFRICAN_FRANC,
  Ne.WEST_AFRICAN_CFA_FRANC_BCEAO
];
function zn({ children: t, paymentMethodType: e }) {
  const { stripePromise: n } = Wu(), { locale: r } = _e(), { currency: a, finalAmount: i } = tt(), { state: o } = qe(), { primaryColor: s, textColorSecondary: l } = nn(o), d = i && i > 0 && e !== "ideal" ? "payment" : "setup", u = (() => {
    if (i && d === "payment" && a)
      return a2.includes(a) ? Me(i) : i;
  })(), p = {
    mode: d,
    amount: u,
    payment_method_types: [e],
    currency: a,
    paymentMethodCreation: "manual",
    locale: r,
    appearance: {
      variables: {
        colorPrimary: s
      },
      rules: {
        ".Label": {
          color: l
        }
      }
    }
  };
  return /* @__PURE__ */ c(
    Jo,
    {
      stripe: n,
      options: p,
      children: t
    },
    [p.mode, p.amount, p.payment_method_types].flat().filter(Boolean).join("-")
  );
}
const i2 = (t) => {
  switch (t) {
    case le.stripe_bancontact:
      return ({ children: e }) => /* @__PURE__ */ c(zn, { paymentMethodType: "bancontact", children: e });
    case le.stripe_applepay:
    case le.stripe_card:
      return ({ children: e }) => /* @__PURE__ */ c(zn, { paymentMethodType: "card", children: e });
    case le.stripe_ideal:
      return ({ children: e }) => /* @__PURE__ */ c(zn, { paymentMethodType: "ideal", children: e });
    default:
      return C.Fragment;
  }
}, As = (t) => {
  const { paymentMethod: e } = tt();
  return {
    PaymentProcessorProvider: tn(
      () => i2(e),
      [e]
    ),
    paymentProcessorDetails: r2(e, t),
    paymentProcessorPaymentButton: Ud(e, t)
  };
}, Ra = (t) => JSON.parse(JSON.stringify(t)), Aa = (t) => Object.values(t).some(
  (e) => Array.isArray(e) ? e.length > 0 : Aa(e)
), zs = (t, e) => {
  var o;
  const { common: n, ...r } = Ra(e), a = { ...r, ...((o = t.errors) == null ? void 0 : o.fields) || {} };
  return {
    common: t.errors.common ?? n,
    ...a
  };
};
/*! js-cookie v3.0.5 | MIT */
function Nr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      t[r] = n[r];
  }
  return t;
}
var o2 = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function oa(t, e) {
  function n(a, i, o) {
    if (!(typeof document > "u")) {
      o = Nr({}, e, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var l in o)
        o[l] && (s += "; " + l, o[l] !== !0 && (s += "=" + o[l].split(";")[0]));
      return document.cookie = a + "=" + t.write(i, a) + s;
    }
  }
  function r(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], o = {}, s = 0; s < i.length; s++) {
        var l = i[s].split("="), d = l.slice(1).join("=");
        try {
          var u = decodeURIComponent(l[0]);
          if (o[u] = t.read(d, u), a === u)
            break;
        } catch {
        }
      }
      return a ? o[a] : o;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(a, i) {
        n(
          a,
          "",
          Nr({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return oa(this.converter, Nr({}, this.attributes, a));
      },
      withConverter: function(a) {
        return oa(Nr({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var Ji = oa(o2, { path: "/" });
const Ds = ({
  pagePath: t,
  handlerError: e
}) => {
  const n = "error_message", r = Ji.get(n);
  Ve(() => {
    r && (e(r), Ji.remove(n, {
      path: t
    }));
  }, [r, t]);
}, Is = (t) => {
  switch (t) {
    case et.download:
      return ie.product_download_cover;
    case et.eCourse:
      return ie.e_course_cover;
    case et.physicalProduct:
      return ie.physical_product_cover;
  }
}, Xi = (t, e) => Object.keys(t).includes(e), js = (t, e) => {
  const n = [];
  return Object.values(Qe).forEach((r) => {
    const a = Xi(e, r), i = Xi(t, r);
    !a && i && n.push(...t[r]);
  }), n;
}, Fs = (t, e) => me(t.price * (e ?? 0) / 100), s2 = (t, e) => {
  const n = Fs(t, e);
  return me(n + t.price);
}, l2 = ({
  calculatePrice: t,
  productVariant: e,
  product: n,
  quantity: r
}) => t != null && t.netAmount ? t.netAmount : e != null && e.price ? me((e == null ? void 0 : e.price) * r) : me(n.price * r), c2 = ({ product: t, calculatePrice: e }) => {
  const { locale: n } = at(), { quantity: r, productVariant: a } = fr(), { t: i } = He();
  return t && t.name && /* @__PURE__ */ L(St, { children: [
    /* @__PURE__ */ L("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ L("div", { className: "flex gap-1 text-[14px]", children: [
        /* @__PURE__ */ c("span", { children: t.name }),
        /* @__PURE__ */ L("span", { className: "font-bold", children: [
          "x",
          r
        ] })
      ] }),
      /* @__PURE__ */ L("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ c(Ue, { currency: t.currency }),
        /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: Be(
          Me(
            l2({
              calculatePrice: e,
              productVariant: a,
              product: t,
              quantity: r
            })
          ),
          t.currency,
          n
        ) })
      ] })
    ] }),
    !!(e != null && e.tax) && e.tax.rate > 0 && /* @__PURE__ */ L("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ c("span", { className: "text-[14px]", children: i("public_pages_purchase.vat_percent", {
        percent: e.tax.rate
      }) }),
      /* @__PURE__ */ L("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ c(Ue, { currency: t.currency }),
        /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: Be(
          Me(e.tax.amount),
          t.currency,
          n
        ) })
      ] })
    ] })
  ] });
}, u2 = ({
  product: t,
  selectedShipping: e,
  calculatePrice: n
}) => {
  var o;
  const { locale: r } = at(), { t: a } = He(), i = Fs(e, (o = n == null ? void 0 : n.tax) == null ? void 0 : o.rate);
  return /* @__PURE__ */ L(St, { children: [
    /* @__PURE__ */ c("div", { className: "bg-text-secondary/30 h-[1px] w-full" }),
    /* @__PURE__ */ L("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ c("span", { className: "text-[14px]", children: a("public_pages_purchase.shipping_fee") }),
      /* @__PURE__ */ L("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ c(Ue, { currency: e.currency }),
        /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: Be(
          Me(e.price),
          t.currency,
          r
        ) })
      ] })
    ] }),
    i > 0 && /* @__PURE__ */ L("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ c("span", { className: "text-[14px]", children: a("public_pages_purchase.vat_percent", {
        percent: n == null ? void 0 : n.tax.rate
      }) }),
      /* @__PURE__ */ L("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ c(Ue, { currency: e.currency }),
        /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: Be(
          Me(i),
          e.currency,
          r
        ) })
      ] })
    ] })
  ] });
}, d2 = ({ product: t, calculatePrice: e, isLoading: n }) => {
  const { t: r } = He(), { locale: a } = at(), { selectedShipping: i } = fr(), { finalAmount: o } = tt(), s = !!i, l = !!(e != null && e.tax) && e.tax.rate > 0, d = s ? s2(i, (e == null ? void 0 : e.tax.rate) ?? 0) : 0, u = me(Math.ceil(o ?? 0) + d), p = () => r(!l && !s ? "public_pages_purchase.total" : l && !s ? "public_pages_purchase.total_amount_with_tax" : !l && s ? "public_pages_purchase.total_amount_with_shipping" : "public_pages_purchase.total_amount_with_tax_and_shipping");
  return /* @__PURE__ */ L("div", { className: De("flex flex-col gap-1", n && "animate-pulse"), children: [
    /* @__PURE__ */ c(dr, { label: r("public_pages_purchase.order_summary") }),
    /* @__PURE__ */ L("div", { className: "border-text-secondary/30 flex flex-col gap-5 rounded-lg border px-3.5 py-5", children: [
      /* @__PURE__ */ c(c2, { product: t, calculatePrice: e }),
      s && /* @__PURE__ */ c(
        u2,
        {
          product: t,
          selectedShipping: i,
          calculatePrice: e
        }
      ),
      u > 0 && /* @__PURE__ */ L(St, { children: [
        /* @__PURE__ */ c("div", { className: "bg-text-secondary/30 h-[1px] w-full" }),
        /* @__PURE__ */ L("div", { className: "flex w-full items-center justify-between", children: [
          /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: p() }),
          /* @__PURE__ */ L("div", { className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ c(Ue, { currency: t.currency }),
            /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: Be(
              Me(u),
              t.currency,
              a
            ) })
          ] })
        ] })
      ] })
    ] })
  ] });
}, sa = (t, e) => e != null && e.pricePlan ? e.pricePlan : t != null && t.pricePlan ? t.pricePlan : null, Vs = (t, e, n, r) => {
  const i = e.optionValueIds.map((o) => n.optionValues.map((l) => l.id).includes(o) ? r.id : o);
  return t.productVariants.find(
    (o) => JSON.stringify(o.optionValueIds) === JSON.stringify(i)
  );
}, p2 = (t, e, n, r) => !!Vs(t, e, n, r), m2 = ({ product: t, activeVariant: e, changeActiveVariant: n }) => {
  const r = (a, i) => {
    const o = Vs(t, e, a, i);
    o && n(o);
  };
  return /* @__PURE__ */ c("div", { className: "flex flex-col gap-2", children: t.options.map((a) => /* @__PURE__ */ L("div", { children: [
    /* @__PURE__ */ c("span", { children: a.name }),
    /* @__PURE__ */ c("div", { className: "flex flex-wrap gap-2", children: a.optionValues.map((i) => {
      const o = e.optionValueIds.includes(i.id);
      return /* @__PURE__ */ c(
        co,
        {
          type: "button",
          onClick: () => r(a, i),
          disabled: !p2(t, e, a, i),
          color: o ? "text-THEME-primary" : "text-THEME-text-secondary",
          hoverColor: `hover:${o ? "text-THEME-primary" : "text-THEME-text-secondary"}`,
          backgroundColor: o ? "bg-THEME-tertiary" : "bg-THEME-secondary",
          hoverBackgroundColor: o ? "hover:bg-THEME-tertiary" : "hover:bg-THEME-secondary",
          borderColor: o ? "border-THEME-tertiary" : "border-THEME-border-tertiary",
          children: i.value
        },
        i.id
      );
    }) })
  ] }, a.id)) });
}, Qi = "w-8 h-full main-transition-colors hover:bg-THEME-tertiary text-THEME-text-secondary hover:text-THEME-text-secondary", f2 = ({
  quantity: t,
  onIncrease: e,
  onDecrease: n,
  disabledIncreaseButton: r,
  disabledDecreaseButton: a
}) => {
  const { t: i } = He();
  return /* @__PURE__ */ L("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ c("span", { children: i("public_pages_purchase.quantity") }),
    /* @__PURE__ */ L(
      "div",
      {
        className: "border-THEME-border-tertiary flex h-8 items-center overflow-hidden rounded-md border text-[16px]",
        children: [
          /* @__PURE__ */ c(
            "button",
            {
              disabled: a,
              type: "button",
              onClick: n,
              className: Qi,
              children: "-"
            }
          ),
          /* @__PURE__ */ c("span", { className: "min-w-8 inline-block text-center text-[14px] font-semibold", children: t }),
          /* @__PURE__ */ c(
            "button",
            {
              disabled: r,
              type: "button",
              onClick: e,
              className: Qi,
              children: "+"
            }
          )
        ]
      }
    )
  ] });
};
function kt() {
  return kt = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, kt.apply(null, arguments);
}
function eo(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function z(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? eo(Object(n), !0).forEach(function(r) {
      re(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : eo(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function h2(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function _r(t, e) {
  if (e && (rt(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return h2(t);
}
function Jt() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Jt = function() {
    return !!t;
  })();
}
function nt(t) {
  return nt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, nt(t);
}
function la(t, e) {
  return la = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, la(t, e);
}
function Xt(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && la(t, e);
}
var g2 = {
  animating: !1,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: !1,
  edgeDragged: !1,
  initialized: !1,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: !1,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: !1,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: !1,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
function _2(t, e, n) {
  var r = n || {}, a = r.noTrailing, i = a === void 0 ? !1 : a, o = r.noLeading, s = o === void 0 ? !1 : o, l = r.debounceMode, d = l === void 0 ? void 0 : l, u, p = !1, m = 0;
  function _() {
    u && clearTimeout(u);
  }
  function y(g) {
    var b = g || {}, v = b.upcomingOnly, x = v === void 0 ? !1 : v;
    _(), p = !x;
  }
  function f() {
    for (var g = arguments.length, b = new Array(g), v = 0; v < g; v++)
      b[v] = arguments[v];
    var x = this, S = Date.now() - m;
    if (p)
      return;
    function h() {
      m = Date.now(), e.apply(x, b);
    }
    function P() {
      u = void 0;
    }
    !s && d && !u && h(), _(), d === void 0 && S > t ? s ? (m = Date.now(), i || (u = setTimeout(d ? P : h, t))) : h() : i !== !0 && (u = setTimeout(d ? P : h, d === void 0 ? t - S : t));
  }
  return f.cancel = y, f;
}
function y2(t, e, n) {
  var r = {}, a = r.atBegin, i = a === void 0 ? !1 : a;
  return _2(t, e, {
    debounceMode: i !== !1
  });
}
var Dn = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var to;
function v2() {
  return to || (to = 1, (function(t) {
    (function() {
      var e = {}.hasOwnProperty;
      function n() {
        for (var i = "", o = 0; o < arguments.length; o++) {
          var s = arguments[o];
          s && (i = a(i, r(s)));
        }
        return i;
      }
      function r(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var o = "";
        for (var s in i)
          e.call(i, s) && i[s] && (o = a(o, s));
        return o;
      }
      function a(i, o) {
        return o ? i ? i + " " + o : i + o : i;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  })(Dn)), Dn.exports;
}
var b2 = v2();
const Nt = /* @__PURE__ */ mr(b2);
var ca = {
  accessibility: !0,
  adaptiveHeight: !1,
  afterChange: null,
  appendDots: function(e) {
    return /* @__PURE__ */ C.createElement("ul", {
      style: {
        display: "block"
      }
    }, e);
  },
  arrows: !0,
  autoplay: !1,
  autoplaySpeed: 3e3,
  beforeChange: null,
  centerMode: !1,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function(e) {
    return /* @__PURE__ */ C.createElement("button", null, e + 1);
  },
  dots: !1,
  dotsClass: "slick-dots",
  draggable: !0,
  easing: "linear",
  edgeFriction: 0.35,
  fade: !1,
  focusOnSelect: !1,
  infinite: !0,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: !1,
  pauseOnFocus: !1,
  pauseOnHover: !0,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: !1,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: !0,
  swipeEvent: null,
  swipeToSlide: !1,
  touchMove: !0,
  touchThreshold: 5,
  useCSS: !0,
  useTransform: !0,
  variableWidth: !1,
  vertical: !1,
  waitForAnimate: !0,
  asNavFor: null
};
function ua(t, e, n) {
  return Math.max(e, Math.min(t, n));
}
var Bt = function(e) {
  var n = ["onTouchStart", "onTouchMove", "onWheel"];
  n.includes(e._reactName) || e.preventDefault();
}, Xr = function(e) {
  for (var n = [], r = Hs(e), a = $s(e), i = r; i < a; i++)
    e.lazyLoadedList.indexOf(i) < 0 && n.push(i);
  return n;
}, Hs = function(e) {
  return e.currentSlide - C2(e);
}, $s = function(e) {
  return e.currentSlide + w2(e);
}, C2 = function(e) {
  return e.centerMode ? Math.floor(e.slidesToShow / 2) + (parseInt(e.centerPadding) > 0 ? 1 : 0) : 0;
}, w2 = function(e) {
  return e.centerMode ? Math.floor((e.slidesToShow - 1) / 2) + 1 + (parseInt(e.centerPadding) > 0 ? 1 : 0) : e.slidesToShow;
}, da = function(e) {
  return e && e.offsetWidth || 0;
}, za = function(e) {
  return e && e.offsetHeight || 0;
}, Bs = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r, a, i, o;
  return r = e.startX - e.curX, a = e.startY - e.curY, i = Math.atan2(a, r), o = Math.round(i * 180 / Math.PI), o < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 || o <= 360 && o >= 315 ? "left" : o >= 135 && o <= 225 ? "right" : n === !0 ? o >= 35 && o <= 135 ? "up" : "down" : "vertical";
}, pn = function(e) {
  var n = !0;
  return e.infinite || (e.centerMode && e.currentSlide >= e.slideCount - 1 || e.slideCount <= e.slidesToShow || e.currentSlide >= e.slideCount - e.slidesToShow) && (n = !1), n;
}, In = function(e, n) {
  var r = {};
  return n.forEach(function(a) {
    return r[a] = e[a];
  }), r;
}, x2 = function(e) {
  var n = C.Children.count(e.children), r = e.listRef, a = Math.ceil(da(r)), i = e.trackRef && e.trackRef.node, o = Math.ceil(da(i)), s;
  if (e.vertical)
    s = a;
  else {
    var l = e.centerMode && parseInt(e.centerPadding) * 2;
    typeof e.centerPadding == "string" && e.centerPadding.slice(-1) === "%" && (l *= a / 100), s = Math.ceil((a - l) / e.slidesToShow);
  }
  var d = r && za(r.querySelector('[data-index="0"]')), u = d * e.slidesToShow, p = e.currentSlide === void 0 ? e.initialSlide : e.currentSlide;
  e.rtl && e.currentSlide === void 0 && (p = n - 1 - e.initialSlide);
  var m = e.lazyLoadedList || [], _ = Xr(z(z({}, e), {}, {
    currentSlide: p,
    lazyLoadedList: m
  }));
  m = m.concat(_);
  var y = {
    slideCount: n,
    slideWidth: s,
    listWidth: a,
    trackWidth: o,
    currentSlide: p,
    slideHeight: d,
    listHeight: u,
    lazyLoadedList: m
  };
  return e.autoplaying === null && e.autoplay && (y.autoplaying = "playing"), y;
}, k2 = function(e) {
  var n = e.waitForAnimate, r = e.animating, a = e.fade, i = e.infinite, o = e.index, s = e.slideCount, l = e.lazyLoad, d = e.currentSlide, u = e.centerMode, p = e.slidesToScroll, m = e.slidesToShow, _ = e.useCSS, y = e.lazyLoadedList;
  if (n && r) return {};
  var f = o, g, b, v, x = {}, S = {}, h = i ? o : ua(o, 0, s - 1);
  if (a) {
    if (!i && (o < 0 || o >= s)) return {};
    o < 0 ? f = o + s : o >= s && (f = o - s), l && y.indexOf(f) < 0 && (y = y.concat(f)), x = {
      animating: !0,
      currentSlide: f,
      lazyLoadedList: y,
      targetSlide: f
    }, S = {
      animating: !1,
      targetSlide: f
    };
  } else
    g = f, f < 0 ? (g = f + s, i ? s % p !== 0 && (g = s - s % p) : g = 0) : !pn(e) && f > d ? f = g = d : u && f >= s ? (f = i ? s : s - 1, g = i ? 0 : s - 1) : f >= s && (g = f - s, i ? s % p !== 0 && (g = 0) : g = s - m), !i && f + m >= s && (g = s - m), b = ur(z(z({}, e), {}, {
      slideIndex: f
    })), v = ur(z(z({}, e), {}, {
      slideIndex: g
    })), i || (b === v && (f = g), b = v), l && (y = y.concat(Xr(z(z({}, e), {}, {
      currentSlide: f
    })))), _ ? (x = {
      animating: !0,
      currentSlide: g,
      trackStyle: Ks(z(z({}, e), {}, {
        left: b
      })),
      lazyLoadedList: y,
      targetSlide: h
    }, S = {
      animating: !1,
      currentSlide: g,
      trackStyle: cr(z(z({}, e), {}, {
        left: v
      })),
      swipeLeft: null,
      targetSlide: h
    }) : x = {
      currentSlide: g,
      trackStyle: cr(z(z({}, e), {}, {
        left: v
      })),
      lazyLoadedList: y,
      targetSlide: h
    };
  return {
    state: x,
    nextState: S
  };
}, S2 = function(e, n) {
  var r, a, i, o, s, l = e.slidesToScroll, d = e.slidesToShow, u = e.slideCount, p = e.currentSlide, m = e.targetSlide, _ = e.lazyLoad, y = e.infinite;
  if (o = u % l !== 0, r = o ? 0 : (u - p) % l, n.message === "previous")
    i = r === 0 ? l : d - r, s = p - i, _ && !y && (a = p - i, s = a === -1 ? u - 1 : a), y || (s = m - l);
  else if (n.message === "next")
    i = r === 0 ? l : r, s = p + i, _ && !y && (s = (p + l) % u + r), y || (s = m + l);
  else if (n.message === "dots")
    s = n.index * n.slidesToScroll;
  else if (n.message === "children") {
    if (s = n.index, y) {
      var f = O2(z(z({}, e), {}, {
        targetSlide: s
      }));
      s > n.currentSlide && f === "left" ? s = s - u : s < n.currentSlide && f === "right" && (s = s + u);
    }
  } else n.message === "index" && (s = Number(n.index));
  return s;
}, P2 = function(e, n, r) {
  return e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !n ? "" : e.keyCode === 37 ? r ? "next" : "previous" : e.keyCode === 39 ? r ? "previous" : "next" : "";
}, E2 = function(e, n, r) {
  return e.target.tagName === "IMG" && Bt(e), !n || !r && e.type.indexOf("mouse") !== -1 ? "" : {
    dragging: !0,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
}, L2 = function(e, n) {
  var r = n.scrolling, a = n.animating, i = n.vertical, o = n.swipeToSlide, s = n.verticalSwiping, l = n.rtl, d = n.currentSlide, u = n.edgeFriction, p = n.edgeDragged, m = n.onEdge, _ = n.swiped, y = n.swiping, f = n.slideCount, g = n.slidesToScroll, b = n.infinite, v = n.touchObject, x = n.swipeEvent, S = n.listHeight, h = n.listWidth;
  if (!r) {
    if (a) return Bt(e);
    i && o && s && Bt(e);
    var P, F = {}, G = ur(n);
    v.curX = e.touches ? e.touches[0].pageX : e.clientX, v.curY = e.touches ? e.touches[0].pageY : e.clientY, v.swipeLength = Math.round(Math.sqrt(Math.pow(v.curX - v.startX, 2)));
    var W = Math.round(Math.sqrt(Math.pow(v.curY - v.startY, 2)));
    if (!s && !y && W > 10)
      return {
        scrolling: !0
      };
    s && (v.swipeLength = W);
    var H = (l ? -1 : 1) * (v.curX > v.startX ? 1 : -1);
    s && (H = v.curY > v.startY ? 1 : -1);
    var B = Math.ceil(f / g), U = Bs(n.touchObject, s), Y = v.swipeLength;
    return b || (d === 0 && (U === "right" || U === "down") || d + 1 >= B && (U === "left" || U === "up") || !pn(n) && (U === "left" || U === "up")) && (Y = v.swipeLength * u, p === !1 && m && (m(U), F.edgeDragged = !0)), !_ && x && (x(U), F.swiped = !0), i ? P = G + Y * (S / h) * H : l ? P = G - Y * H : P = G + Y * H, s && (P = G + Y * H), F = z(z({}, F), {}, {
      touchObject: v,
      swipeLeft: P,
      trackStyle: cr(z(z({}, n), {}, {
        left: P
      }))
    }), Math.abs(v.curX - v.startX) < Math.abs(v.curY - v.startY) * 0.8 || v.swipeLength > 10 && (F.swiping = !0, Bt(e)), F;
  }
}, T2 = function(e, n) {
  var r = n.dragging, a = n.swipe, i = n.touchObject, o = n.listWidth, s = n.touchThreshold, l = n.verticalSwiping, d = n.listHeight, u = n.swipeToSlide, p = n.scrolling, m = n.onSwipe, _ = n.targetSlide, y = n.currentSlide, f = n.infinite;
  if (!r)
    return a && Bt(e), {};
  var g = l ? d / s : o / s, b = Bs(i, l), v = {
    dragging: !1,
    edgeDragged: !1,
    scrolling: !1,
    swiping: !1,
    swiped: !1,
    swipeLeft: null,
    touchObject: {}
  };
  if (p || !i.swipeLength)
    return v;
  if (i.swipeLength > g) {
    Bt(e), m && m(b);
    var x, S, h = f ? y : _;
    switch (b) {
      case "left":
      case "up":
        S = h + no(n), x = u ? ro(n, S) : S, v.currentDirection = 0;
        break;
      case "right":
      case "down":
        S = h - no(n), x = u ? ro(n, S) : S, v.currentDirection = 1;
        break;
      default:
        x = h;
    }
    v.triggerSlideHandler = x;
  } else {
    var P = ur(n);
    v.trackStyle = Ks(z(z({}, n), {}, {
      left: P
    }));
  }
  return v;
}, N2 = function(e) {
  for (var n = e.infinite ? e.slideCount * 2 : e.slideCount, r = e.infinite ? e.slidesToShow * -1 : 0, a = e.infinite ? e.slidesToShow * -1 : 0, i = []; r < n; )
    i.push(r), r = a + e.slidesToScroll, a += Math.min(e.slidesToScroll, e.slidesToShow);
  return i;
}, ro = function(e, n) {
  var r = N2(e), a = 0;
  if (n > r[r.length - 1])
    n = r[r.length - 1];
  else
    for (var i in r) {
      if (n < r[i]) {
        n = a;
        break;
      }
      a = r[i];
    }
  return n;
}, no = function(e) {
  var n = e.centerMode ? e.slideWidth * Math.floor(e.slidesToShow / 2) : 0;
  if (e.swipeToSlide) {
    var r, a = e.listRef, i = a.querySelectorAll && a.querySelectorAll(".slick-slide") || [];
    if (Array.from(i).every(function(l) {
      if (e.vertical) {
        if (l.offsetTop + za(l) / 2 > e.swipeLeft * -1)
          return r = l, !1;
      } else if (l.offsetLeft - n + da(l) / 2 > e.swipeLeft * -1)
        return r = l, !1;
      return !0;
    }), !r)
      return 0;
    var o = e.rtl === !0 ? e.slideCount - e.currentSlide : e.currentSlide, s = Math.abs(r.dataset.index - o) || 1;
    return s;
  } else
    return e.slidesToScroll;
}, Da = function(e, n) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    n.reduce(function(r, a) {
      return r && e.hasOwnProperty(a);
    }, !0) ? null : console.error("Keys Missing:", e)
  );
}, cr = function(e) {
  Da(e, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var n, r;
  if (!e.vertical)
    n = M2(e) * e.slideWidth;
  else {
    var a = e.unslick ? e.slideCount : e.slideCount + 2 * e.slidesToShow;
    r = a * e.slideHeight;
  }
  var i = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (e.useTransform) {
    var o = e.vertical ? "translate3d(0px, " + e.left + "px, 0px)" : "translate3d(" + e.left + "px, 0px, 0px)", s = e.vertical ? "translate3d(0px, " + e.left + "px, 0px)" : "translate3d(" + e.left + "px, 0px, 0px)", l = e.vertical ? "translateY(" + e.left + "px)" : "translateX(" + e.left + "px)";
    i = z(z({}, i), {}, {
      WebkitTransform: o,
      transform: s,
      msTransform: l
    });
  } else
    e.vertical ? i.top = e.left : i.left = e.left;
  return e.fade && (i = {
    opacity: 1
  }), n && (i.width = n), r && (i.height = r), window && !window.addEventListener && window.attachEvent && (e.vertical ? i.marginTop = e.left + "px" : i.marginLeft = e.left + "px"), i;
}, Ks = function(e) {
  Da(e, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var n = cr(e);
  return e.useTransform ? (n.WebkitTransition = "-webkit-transform " + e.speed + "ms " + e.cssEase, n.transition = "transform " + e.speed + "ms " + e.cssEase) : e.vertical ? n.transition = "top " + e.speed + "ms " + e.cssEase : n.transition = "left " + e.speed + "ms " + e.cssEase, n;
}, ur = function(e) {
  if (e.unslick)
    return 0;
  Da(e, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var n = e.slideIndex, r = e.trackRef, a = e.infinite, i = e.centerMode, o = e.slideCount, s = e.slidesToShow, l = e.slidesToScroll, d = e.slideWidth, u = e.listWidth, p = e.variableWidth, m = e.slideHeight, _ = e.fade, y = e.vertical, f = 0, g, b, v = 0;
  if (_ || e.slideCount === 1)
    return 0;
  var x = 0;
  if (a ? (x = -yt(e), o % l !== 0 && n + l > o && (x = -(n > o ? s - (n - o) : o % l)), i && (x += parseInt(s / 2))) : (o % l !== 0 && n + l > o && (x = s - o % l), i && (x = parseInt(s / 2))), f = x * d, v = x * m, y ? g = n * m * -1 + v : g = n * d * -1 + f, p === !0) {
    var S, h = r && r.node;
    if (S = n + yt(e), b = h && h.childNodes[S], g = b ? b.offsetLeft * -1 : 0, i === !0) {
      S = a ? n + yt(e) : n, b = h && h.children[S], g = 0;
      for (var P = 0; P < S; P++)
        g -= h && h.children[P] && h.children[P].offsetWidth;
      g -= parseInt(e.centerPadding), g += b && (u - b.offsetWidth) / 2;
    }
  }
  return g;
}, yt = function(e) {
  return e.unslick || !e.infinite ? 0 : e.variableWidth ? e.slideCount : e.slidesToShow + (e.centerMode ? 1 : 0);
}, Vr = function(e) {
  return e.unslick || !e.infinite ? 0 : e.slideCount;
}, M2 = function(e) {
  return e.slideCount === 1 ? 1 : yt(e) + e.slideCount + Vr(e);
}, O2 = function(e) {
  return e.targetSlide > e.currentSlide ? e.targetSlide > e.currentSlide + R2(e) ? "left" : "right" : e.targetSlide < e.currentSlide - A2(e) ? "right" : "left";
}, R2 = function(e) {
  var n = e.slidesToShow, r = e.centerMode, a = e.rtl, i = e.centerPadding;
  if (r) {
    var o = (n - 1) / 2 + 1;
    return parseInt(i) > 0 && (o += 1), a && n % 2 === 0 && (o += 1), o;
  }
  return a ? 0 : n - 1;
}, A2 = function(e) {
  var n = e.slidesToShow, r = e.centerMode, a = e.rtl, i = e.centerPadding;
  if (r) {
    var o = (n - 1) / 2 + 1;
    return parseInt(i) > 0 && (o += 1), !a && n % 2 === 0 && (o += 1), o;
  }
  return a ? n - 1 : 0;
}, ao = function() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}, z2 = Object.keys(ca);
function D2(t) {
  return z2.reduce(function(e, n) {
    return t.hasOwnProperty(n) && (e[n] = t[n]), e;
  }, {});
}
function I2(t, e, n) {
  return e = nt(e), _r(t, Jt() ? Reflect.construct(e, n || [], nt(t).constructor) : e.apply(t, n));
}
var jn = function(e) {
  var n, r, a, i, o;
  e.rtl ? o = e.slideCount - 1 - e.index : o = e.index, a = o < 0 || o >= e.slideCount, e.centerMode ? (i = Math.floor(e.slidesToShow / 2), r = (o - e.currentSlide) % e.slideCount === 0, o > e.currentSlide - i - 1 && o <= e.currentSlide + i && (n = !0)) : n = e.currentSlide <= o && o < e.currentSlide + e.slidesToShow;
  var s;
  e.targetSlide < 0 ? s = e.targetSlide + e.slideCount : e.targetSlide >= e.slideCount ? s = e.targetSlide - e.slideCount : s = e.targetSlide;
  var l = o === s;
  return {
    "slick-slide": !0,
    "slick-active": n,
    "slick-center": r,
    "slick-cloned": a,
    "slick-current": l
    // dubious in case of RTL
  };
}, j2 = function(e) {
  var n = {};
  return (e.variableWidth === void 0 || e.variableWidth === !1) && (n.width = e.slideWidth), e.fade && (n.position = "relative", e.vertical && e.slideHeight ? n.top = -e.index * parseInt(e.slideHeight) : n.left = -e.index * parseInt(e.slideWidth), n.opacity = e.currentSlide === e.index ? 1 : 0, n.zIndex = e.currentSlide === e.index ? 999 : 998, e.useCSS && (n.transition = "opacity " + e.speed + "ms " + e.cssEase + ", visibility " + e.speed + "ms " + e.cssEase)), n;
}, Fn = function(e, n) {
  return e.key + "-" + n;
}, F2 = function(e) {
  var n, r = [], a = [], i = [], o = C.Children.count(e.children), s = Hs(e), l = $s(e);
  return C.Children.forEach(e.children, function(d, u) {
    var p, m = {
      message: "children",
      index: u,
      slidesToScroll: e.slidesToScroll,
      currentSlide: e.currentSlide
    };
    !e.lazyLoad || e.lazyLoad && e.lazyLoadedList.indexOf(u) >= 0 ? p = d : p = /* @__PURE__ */ C.createElement("div", null);
    var _ = j2(z(z({}, e), {}, {
      index: u
    })), y = p.props.className || "", f = jn(z(z({}, e), {}, {
      index: u
    }));
    if (r.push(/* @__PURE__ */ C.cloneElement(p, {
      key: "original" + Fn(p, u),
      "data-index": u,
      className: Nt(f, y),
      tabIndex: "-1",
      "aria-hidden": !f["slick-active"],
      style: z(z({
        outline: "none"
      }, p.props.style || {}), _),
      onClick: function(v) {
        p.props && p.props.onClick && p.props.onClick(v), e.focusOnSelect && e.focusOnSelect(m);
      }
    })), e.infinite && o > 1 && e.fade === !1 && !e.unslick) {
      var g = o - u;
      g <= yt(e) && (n = -g, n >= s && (p = d), f = jn(z(z({}, e), {}, {
        index: n
      })), a.push(/* @__PURE__ */ C.cloneElement(p, {
        key: "precloned" + Fn(p, n),
        "data-index": n,
        tabIndex: "-1",
        className: Nt(f, y),
        "aria-hidden": !f["slick-active"],
        style: z(z({}, p.props.style || {}), _),
        onClick: function(v) {
          p.props && p.props.onClick && p.props.onClick(v), e.focusOnSelect && e.focusOnSelect(m);
        }
      }))), n = o + u, n < l && (p = d), f = jn(z(z({}, e), {}, {
        index: n
      })), i.push(/* @__PURE__ */ C.cloneElement(p, {
        key: "postcloned" + Fn(p, n),
        "data-index": n,
        tabIndex: "-1",
        className: Nt(f, y),
        "aria-hidden": !f["slick-active"],
        style: z(z({}, p.props.style || {}), _),
        onClick: function(v) {
          p.props && p.props.onClick && p.props.onClick(v), e.focusOnSelect && e.focusOnSelect(m);
        }
      }));
    }
  }), e.rtl ? a.concat(r, i).reverse() : a.concat(r, i);
}, V2 = /* @__PURE__ */ (function(t) {
  function e() {
    var n;
    At(this, e);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return n = I2(this, e, [].concat(a)), re(n, "node", null), re(n, "handleRef", function(o) {
      n.node = o;
    }), n;
  }
  return Xt(e, t), zt(e, [{
    key: "render",
    value: function() {
      var r = F2(this.props), a = this.props, i = a.onMouseEnter, o = a.onMouseOver, s = a.onMouseLeave, l = {
        onMouseEnter: i,
        onMouseOver: o,
        onMouseLeave: s
      };
      return /* @__PURE__ */ C.createElement("div", kt({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, l), r);
    }
  }]);
})(C.PureComponent);
function H2(t, e, n) {
  return e = nt(e), _r(t, Jt() ? Reflect.construct(e, n || [], nt(t).constructor) : e.apply(t, n));
}
var $2 = function(e) {
  var n;
  return e.infinite ? n = Math.ceil(e.slideCount / e.slidesToScroll) : n = Math.ceil((e.slideCount - e.slidesToShow) / e.slidesToScroll) + 1, n;
}, B2 = /* @__PURE__ */ (function(t) {
  function e() {
    return At(this, e), H2(this, e, arguments);
  }
  return Xt(e, t), zt(e, [{
    key: "clickHandler",
    value: function(r, a) {
      a.preventDefault(), this.props.clickHandler(r);
    }
  }, {
    key: "render",
    value: function() {
      for (var r = this.props, a = r.onMouseEnter, i = r.onMouseOver, o = r.onMouseLeave, s = r.infinite, l = r.slidesToScroll, d = r.slidesToShow, u = r.slideCount, p = r.currentSlide, m = $2({
        slideCount: u,
        slidesToScroll: l,
        slidesToShow: d,
        infinite: s
      }), _ = {
        onMouseEnter: a,
        onMouseOver: i,
        onMouseLeave: o
      }, y = [], f = 0; f < m; f++) {
        var g = (f + 1) * l - 1, b = s ? g : ua(g, 0, u - 1), v = b - (l - 1), x = s ? v : ua(v, 0, u - 1), S = Nt({
          "slick-active": s ? p >= x && p <= b : p === x
        }), h = {
          message: "dots",
          index: f,
          slidesToScroll: l,
          currentSlide: p
        }, P = this.clickHandler.bind(this, h);
        y = y.concat(/* @__PURE__ */ C.createElement("li", {
          key: f,
          className: S
        }, /* @__PURE__ */ C.cloneElement(this.props.customPaging(f), {
          onClick: P
        })));
      }
      return /* @__PURE__ */ C.cloneElement(this.props.appendDots(y), z({
        className: this.props.dotsClass
      }, _));
    }
  }]);
})(C.PureComponent);
function Us(t, e, n) {
  return e = nt(e), _r(t, Jt() ? Reflect.construct(e, n || [], nt(t).constructor) : e.apply(t, n));
}
var K2 = /* @__PURE__ */ (function(t) {
  function e() {
    return At(this, e), Us(this, e, arguments);
  }
  return Xt(e, t), zt(e, [{
    key: "clickHandler",
    value: function(r, a) {
      a && a.preventDefault(), this.props.clickHandler(r, a);
    }
  }, {
    key: "render",
    value: function() {
      var r = {
        "slick-arrow": !0,
        "slick-prev": !0
      }, a = this.clickHandler.bind(this, {
        message: "previous"
      });
      !this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow) && (r["slick-disabled"] = !0, a = null);
      var i = {
        key: "0",
        "data-role": "none",
        className: Nt(r),
        style: {
          display: "block"
        },
        onClick: a
      }, o = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, s;
      return this.props.prevArrow ? s = /* @__PURE__ */ C.cloneElement(this.props.prevArrow, z(z({}, i), o)) : s = /* @__PURE__ */ C.createElement("button", kt({
        key: "0",
        type: "button"
      }, i), " ", "Previous"), s;
    }
  }]);
})(C.PureComponent), U2 = /* @__PURE__ */ (function(t) {
  function e() {
    return At(this, e), Us(this, e, arguments);
  }
  return Xt(e, t), zt(e, [{
    key: "clickHandler",
    value: function(r, a) {
      a && a.preventDefault(), this.props.clickHandler(r, a);
    }
  }, {
    key: "render",
    value: function() {
      var r = {
        "slick-arrow": !0,
        "slick-next": !0
      }, a = this.clickHandler.bind(this, {
        message: "next"
      });
      pn(this.props) || (r["slick-disabled"] = !0, a = null);
      var i = {
        key: "1",
        "data-role": "none",
        className: Nt(r),
        style: {
          display: "block"
        },
        onClick: a
      }, o = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, s;
      return this.props.nextArrow ? s = /* @__PURE__ */ C.cloneElement(this.props.nextArrow, z(z({}, i), o)) : s = /* @__PURE__ */ C.createElement("button", kt({
        key: "1",
        type: "button"
      }, i), " ", "Next"), s;
    }
  }]);
})(C.PureComponent), qs = (function() {
  if (typeof Map < "u")
    return Map;
  function t(e, n) {
    var r = -1;
    return e.some(function(a, i) {
      return a[0] === n ? (r = i, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    (function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(n) {
        var r = t(this.__entries__, n), a = this.__entries__[r];
        return a && a[1];
      }, e.prototype.set = function(n, r) {
        var a = t(this.__entries__, n);
        ~a ? this.__entries__[a][1] = r : this.__entries__.push([n, r]);
      }, e.prototype.delete = function(n) {
        var r = this.__entries__, a = t(r, n);
        ~a && r.splice(a, 1);
      }, e.prototype.has = function(n) {
        return !!~t(this.__entries__, n);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var a = 0, i = this.__entries__; a < i.length; a++) {
          var o = i[a];
          n.call(r, o[1], o[0]);
        }
      }, e;
    })()
  );
})(), pa = typeof window < "u" && typeof document < "u" && window.document === document, Qr = (function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
})(), q2 = (function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Qr) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
})(), G2 = 2;
function W2(t, e) {
  var n = !1, r = !1, a = 0;
  function i() {
    n && (n = !1, t()), r && s();
  }
  function o() {
    q2(i);
  }
  function s() {
    var l = Date.now();
    if (n) {
      if (l - a < G2)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(o, e);
    a = l;
  }
  return s;
}
var Z2 = 20, Y2 = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], J2 = typeof MutationObserver < "u", X2 = (
  /** @class */
  (function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = W2(this.refresh.bind(this), Z2);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var n = this.observers_, r = n.indexOf(e);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return e.forEach(function(n) {
        return n.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !pa || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), J2 ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !pa || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var n = e.propertyName, r = n === void 0 ? "" : n, a = Y2.some(function(i) {
        return !!~r.indexOf(i);
      });
      a && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  })()
), Gs = (function(t, e) {
  for (var n = 0, r = Object.keys(e); n < r.length; n++) {
    var a = r[n];
    Object.defineProperty(t, a, {
      value: e[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}), Gt = (function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || Qr;
}), Ws = mn(0, 0, 0, 0);
function en(t) {
  return parseFloat(t) || 0;
}
function io(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  return e.reduce(function(r, a) {
    var i = t["border-" + a + "-width"];
    return r + en(i);
  }, 0);
}
function Q2(t) {
  for (var e = ["top", "right", "bottom", "left"], n = {}, r = 0, a = e; r < a.length; r++) {
    var i = a[r], o = t["padding-" + i];
    n[i] = en(o);
  }
  return n;
}
function e3(t) {
  var e = t.getBBox();
  return mn(0, 0, e.width, e.height);
}
function t3(t) {
  var e = t.clientWidth, n = t.clientHeight;
  if (!e && !n)
    return Ws;
  var r = Gt(t).getComputedStyle(t), a = Q2(r), i = a.left + a.right, o = a.top + a.bottom, s = en(r.width), l = en(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + i) !== e && (s -= io(r, "left", "right") + i), Math.round(l + o) !== n && (l -= io(r, "top", "bottom") + o)), !n3(t)) {
    var d = Math.round(s + i) - e, u = Math.round(l + o) - n;
    Math.abs(d) !== 1 && (s -= d), Math.abs(u) !== 1 && (l -= u);
  }
  return mn(a.left, a.top, s, l);
}
var r3 = /* @__PURE__ */ (function() {
  return typeof SVGGraphicsElement < "u" ? function(t) {
    return t instanceof Gt(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof Gt(t).SVGElement && typeof t.getBBox == "function";
  };
})();
function n3(t) {
  return t === Gt(t).document.documentElement;
}
function a3(t) {
  return pa ? r3(t) ? e3(t) : t3(t) : Ws;
}
function i3(t) {
  var e = t.x, n = t.y, r = t.width, a = t.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, o = Object.create(i.prototype);
  return Gs(o, {
    x: e,
    y: n,
    width: r,
    height: a,
    top: n,
    right: e + r,
    bottom: a + n,
    left: e
  }), o;
}
function mn(t, e, n, r) {
  return { x: t, y: e, width: n, height: r };
}
var o3 = (
  /** @class */
  (function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = mn(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = a3(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  })()
), s3 = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e, n) {
      var r = i3(n);
      Gs(this, { target: e, contentRect: r });
    }
    return t;
  })()
), l3 = (
  /** @class */
  (function() {
    function t(e, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new qs(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = n, this.callbackCtx_ = r;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof Gt(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) || (n.set(e, new o3(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof Gt(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) && (n.delete(e), n.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && e.activeObservations_.push(n);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new s3(r.target, r.broadcastRect());
        });
        this.callback_.call(e, n, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  })()
), Zs = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new qs(), Ys = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = X2.getInstance(), r = new l3(e, n, this);
      Zs.set(this, r);
    }
    return t;
  })()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  Ys.prototype[t] = function() {
    var e;
    return (e = Zs.get(this))[t].apply(e, arguments);
  };
});
var c3 = (function() {
  return typeof Qr.ResizeObserver < "u" ? Qr.ResizeObserver : Ys;
})(), u3 = ["animating"];
function d3(t, e, n) {
  return e = nt(e), _r(t, Jt() ? Reflect.construct(e, n || [], nt(t).constructor) : e.apply(t, n));
}
var p3 = /* @__PURE__ */ (function(t) {
  function e(n) {
    var r;
    At(this, e), r = d3(this, e, [n]), re(r, "listRefHandler", function(i) {
      return r.list = i;
    }), re(r, "trackRefHandler", function(i) {
      return r.track = i;
    }), re(r, "adaptHeight", function() {
      if (r.props.adaptiveHeight && r.list) {
        var i = r.list.querySelector('[data-index="'.concat(r.state.currentSlide, '"]'));
        r.list.style.height = za(i) + "px";
      }
    }), re(r, "componentDidMount", function() {
      if (r.props.onInit && r.props.onInit(), r.props.lazyLoad) {
        var i = Xr(z(z({}, r.props), r.state));
        i.length > 0 && (r.setState(function(s) {
          return {
            lazyLoadedList: s.lazyLoadedList.concat(i)
          };
        }), r.props.onLazyLoad && r.props.onLazyLoad(i));
      }
      var o = z({
        listRef: r.list,
        trackRef: r.track
      }, r.props);
      r.updateState(o, !0, function() {
        r.adaptHeight(), r.props.autoplay && r.autoPlay("playing");
      }), r.props.lazyLoad === "progressive" && (r.lazyLoadTimer = setInterval(r.progressiveLazyLoad, 1e3)), r.ro = new c3(function() {
        r.state.animating ? (r.onWindowResized(!1), r.callbackTimers.push(setTimeout(function() {
          return r.onWindowResized();
        }, r.props.speed))) : r.onWindowResized();
      }), r.ro.observe(r.list), document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(s) {
        s.onfocus = r.props.pauseOnFocus ? r.onSlideFocus : null, s.onblur = r.props.pauseOnFocus ? r.onSlideBlur : null;
      }), window.addEventListener ? window.addEventListener("resize", r.onWindowResized) : window.attachEvent("onresize", r.onWindowResized);
    }), re(r, "componentWillUnmount", function() {
      r.animationEndCallback && clearTimeout(r.animationEndCallback), r.lazyLoadTimer && clearInterval(r.lazyLoadTimer), r.callbackTimers.length && (r.callbackTimers.forEach(function(i) {
        return clearTimeout(i);
      }), r.callbackTimers = []), window.addEventListener ? window.removeEventListener("resize", r.onWindowResized) : window.detachEvent("onresize", r.onWindowResized), r.autoplayTimer && clearInterval(r.autoplayTimer), r.ro.disconnect();
    }), re(r, "componentDidUpdate", function(i) {
      if (r.checkImagesLoad(), r.props.onReInit && r.props.onReInit(), r.props.lazyLoad) {
        var o = Xr(z(z({}, r.props), r.state));
        o.length > 0 && (r.setState(function(d) {
          return {
            lazyLoadedList: d.lazyLoadedList.concat(o)
          };
        }), r.props.onLazyLoad && r.props.onLazyLoad(o));
      }
      r.adaptHeight();
      var s = z(z({
        listRef: r.list,
        trackRef: r.track
      }, r.props), r.state), l = r.didPropsChange(i);
      l && r.updateState(s, l, function() {
        r.state.currentSlide >= C.Children.count(r.props.children) && r.changeSlide({
          message: "index",
          index: C.Children.count(r.props.children) - r.props.slidesToShow,
          currentSlide: r.state.currentSlide
        }), (i.autoplay !== r.props.autoplay || i.autoplaySpeed !== r.props.autoplaySpeed) && (!i.autoplay && r.props.autoplay ? r.autoPlay("playing") : r.props.autoplay ? r.autoPlay("update") : r.pause("paused"));
      });
    }), re(r, "onWindowResized", function(i) {
      r.debouncedResize && r.debouncedResize.cancel(), r.debouncedResize = y2(50, function() {
        return r.resizeWindow(i);
      }), r.debouncedResize();
    }), re(r, "resizeWindow", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, o = !!(r.track && r.track.node);
      if (o) {
        var s = z(z({
          listRef: r.list,
          trackRef: r.track
        }, r.props), r.state);
        r.updateState(s, i, function() {
          r.props.autoplay ? r.autoPlay("update") : r.pause("paused");
        }), r.setState({
          animating: !1
        }), clearTimeout(r.animationEndCallback), delete r.animationEndCallback;
      }
    }), re(r, "updateState", function(i, o, s) {
      var l = x2(i);
      i = z(z(z({}, i), l), {}, {
        slideIndex: l.currentSlide
      });
      var d = ur(i);
      i = z(z({}, i), {}, {
        left: d
      });
      var u = cr(i);
      (o || C.Children.count(r.props.children) !== C.Children.count(i.children)) && (l.trackStyle = u), r.setState(l, s);
    }), re(r, "ssrInit", function() {
      if (r.props.variableWidth) {
        var i = 0, o = 0, s = [], l = yt(z(z(z({}, r.props), r.state), {}, {
          slideCount: r.props.children.length
        })), d = Vr(z(z(z({}, r.props), r.state), {}, {
          slideCount: r.props.children.length
        }));
        r.props.children.forEach(function(P) {
          s.push(P.props.style.width), i += P.props.style.width;
        });
        for (var u = 0; u < l; u++)
          o += s[s.length - 1 - u], i += s[s.length - 1 - u];
        for (var p = 0; p < d; p++)
          i += s[p];
        for (var m = 0; m < r.state.currentSlide; m++)
          o += s[m];
        var _ = {
          width: i + "px",
          left: -o + "px"
        };
        if (r.props.centerMode) {
          var y = "".concat(s[r.state.currentSlide], "px");
          _.left = "calc(".concat(_.left, " + (100% - ").concat(y, ") / 2 ) ");
        }
        return {
          trackStyle: _
        };
      }
      var f = C.Children.count(r.props.children), g = z(z(z({}, r.props), r.state), {}, {
        slideCount: f
      }), b = yt(g) + Vr(g) + f, v = 100 / r.props.slidesToShow * b, x = 100 / b, S = -x * (yt(g) + r.state.currentSlide) * v / 100;
      r.props.centerMode && (S += (100 - x * v / 100) / 2);
      var h = {
        width: v + "%",
        left: S + "%"
      };
      return {
        slideWidth: x + "%",
        trackStyle: h
      };
    }), re(r, "checkImagesLoad", function() {
      var i = r.list && r.list.querySelectorAll && r.list.querySelectorAll(".slick-slide img") || [], o = i.length, s = 0;
      Array.prototype.forEach.call(i, function(l) {
        var d = function() {
          return ++s && s >= o && r.onWindowResized();
        };
        if (!l.onclick)
          l.onclick = function() {
            return l.parentNode.focus();
          };
        else {
          var u = l.onclick;
          l.onclick = function(p) {
            u(p), l.parentNode.focus();
          };
        }
        l.onload || (r.props.lazyLoad ? l.onload = function() {
          r.adaptHeight(), r.callbackTimers.push(setTimeout(r.onWindowResized, r.props.speed));
        } : (l.onload = d, l.onerror = function() {
          d(), r.props.onLazyLoadError && r.props.onLazyLoadError();
        }));
      });
    }), re(r, "progressiveLazyLoad", function() {
      for (var i = [], o = z(z({}, r.props), r.state), s = r.state.currentSlide; s < r.state.slideCount + Vr(o); s++)
        if (r.state.lazyLoadedList.indexOf(s) < 0) {
          i.push(s);
          break;
        }
      for (var l = r.state.currentSlide - 1; l >= -yt(o); l--)
        if (r.state.lazyLoadedList.indexOf(l) < 0) {
          i.push(l);
          break;
        }
      i.length > 0 ? (r.setState(function(d) {
        return {
          lazyLoadedList: d.lazyLoadedList.concat(i)
        };
      }), r.props.onLazyLoad && r.props.onLazyLoad(i)) : r.lazyLoadTimer && (clearInterval(r.lazyLoadTimer), delete r.lazyLoadTimer);
    }), re(r, "slideHandler", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = r.props, l = s.asNavFor, d = s.beforeChange, u = s.onLazyLoad, p = s.speed, m = s.afterChange, _ = r.state.currentSlide, y = k2(z(z(z({
        index: i
      }, r.props), r.state), {}, {
        trackRef: r.track,
        useCSS: r.props.useCSS && !o
      })), f = y.state, g = y.nextState;
      if (f) {
        d && d(_, f.currentSlide);
        var b = f.lazyLoadedList.filter(function(v) {
          return r.state.lazyLoadedList.indexOf(v) < 0;
        });
        u && b.length > 0 && u(b), !r.props.waitForAnimate && r.animationEndCallback && (clearTimeout(r.animationEndCallback), m && m(_), delete r.animationEndCallback), r.setState(f, function() {
          l && r.asNavForIndex !== i && (r.asNavForIndex = i, l.innerSlider.slideHandler(i)), g && (r.animationEndCallback = setTimeout(function() {
            var v = g.animating, x = ga(g, u3);
            r.setState(x, function() {
              r.callbackTimers.push(setTimeout(function() {
                return r.setState({
                  animating: v
                });
              }, 10)), m && m(f.currentSlide), delete r.animationEndCallback;
            });
          }, p));
        });
      }
    }), re(r, "changeSlide", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = z(z({}, r.props), r.state), l = S2(s, i);
      if (!(l !== 0 && !l) && (o === !0 ? r.slideHandler(l, o) : r.slideHandler(l), r.props.autoplay && r.autoPlay("update"), r.props.focusOnSelect)) {
        var d = r.list.querySelectorAll(".slick-current");
        d[0] && d[0].focus();
      }
    }), re(r, "clickHandler", function(i) {
      r.clickable === !1 && (i.stopPropagation(), i.preventDefault()), r.clickable = !0;
    }), re(r, "keyHandler", function(i) {
      var o = P2(i, r.props.accessibility, r.props.rtl);
      o !== "" && r.changeSlide({
        message: o
      });
    }), re(r, "selectHandler", function(i) {
      r.changeSlide(i);
    }), re(r, "disableBodyScroll", function() {
      var i = function(s) {
        s = s || window.event, s.preventDefault && s.preventDefault(), s.returnValue = !1;
      };
      window.ontouchmove = i;
    }), re(r, "enableBodyScroll", function() {
      window.ontouchmove = null;
    }), re(r, "swipeStart", function(i) {
      r.props.verticalSwiping && r.disableBodyScroll();
      var o = E2(i, r.props.swipe, r.props.draggable);
      o !== "" && r.setState(o);
    }), re(r, "swipeMove", function(i) {
      var o = L2(i, z(z(z({}, r.props), r.state), {}, {
        trackRef: r.track,
        listRef: r.list,
        slideIndex: r.state.currentSlide
      }));
      o && (o.swiping && (r.clickable = !1), r.setState(o));
    }), re(r, "swipeEnd", function(i) {
      var o = T2(i, z(z(z({}, r.props), r.state), {}, {
        trackRef: r.track,
        listRef: r.list,
        slideIndex: r.state.currentSlide
      }));
      if (o) {
        var s = o.triggerSlideHandler;
        delete o.triggerSlideHandler, r.setState(o), s !== void 0 && (r.slideHandler(s), r.props.verticalSwiping && r.enableBodyScroll());
      }
    }), re(r, "touchEnd", function(i) {
      r.swipeEnd(i), r.clickable = !0;
    }), re(r, "slickPrev", function() {
      r.callbackTimers.push(setTimeout(function() {
        return r.changeSlide({
          message: "previous"
        });
      }, 0));
    }), re(r, "slickNext", function() {
      r.callbackTimers.push(setTimeout(function() {
        return r.changeSlide({
          message: "next"
        });
      }, 0));
    }), re(r, "slickGoTo", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (i = Number(i), isNaN(i)) return "";
      r.callbackTimers.push(setTimeout(function() {
        return r.changeSlide({
          message: "index",
          index: i,
          currentSlide: r.state.currentSlide
        }, o);
      }, 0));
    }), re(r, "play", function() {
      var i;
      if (r.props.rtl)
        i = r.state.currentSlide - r.props.slidesToScroll;
      else if (pn(z(z({}, r.props), r.state)))
        i = r.state.currentSlide + r.props.slidesToScroll;
      else
        return !1;
      r.slideHandler(i);
    }), re(r, "autoPlay", function(i) {
      r.autoplayTimer && clearInterval(r.autoplayTimer);
      var o = r.state.autoplaying;
      if (i === "update") {
        if (o === "hovered" || o === "focused" || o === "paused")
          return;
      } else if (i === "leave") {
        if (o === "paused" || o === "focused")
          return;
      } else if (i === "blur" && (o === "paused" || o === "hovered"))
        return;
      r.autoplayTimer = setInterval(r.play, r.props.autoplaySpeed + 50), r.setState({
        autoplaying: "playing"
      });
    }), re(r, "pause", function(i) {
      r.autoplayTimer && (clearInterval(r.autoplayTimer), r.autoplayTimer = null);
      var o = r.state.autoplaying;
      i === "paused" ? r.setState({
        autoplaying: "paused"
      }) : i === "focused" ? (o === "hovered" || o === "playing") && r.setState({
        autoplaying: "focused"
      }) : o === "playing" && r.setState({
        autoplaying: "hovered"
      });
    }), re(r, "onDotsOver", function() {
      return r.props.autoplay && r.pause("hovered");
    }), re(r, "onDotsLeave", function() {
      return r.props.autoplay && r.state.autoplaying === "hovered" && r.autoPlay("leave");
    }), re(r, "onTrackOver", function() {
      return r.props.autoplay && r.pause("hovered");
    }), re(r, "onTrackLeave", function() {
      return r.props.autoplay && r.state.autoplaying === "hovered" && r.autoPlay("leave");
    }), re(r, "onSlideFocus", function() {
      return r.props.autoplay && r.pause("focused");
    }), re(r, "onSlideBlur", function() {
      return r.props.autoplay && r.state.autoplaying === "focused" && r.autoPlay("blur");
    }), re(r, "render", function() {
      var i = Nt("slick-slider", r.props.className, {
        "slick-vertical": r.props.vertical,
        "slick-initialized": !0
      }), o = z(z({}, r.props), r.state), s = In(o, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]), l = r.props.pauseOnHover;
      s = z(z({}, s), {}, {
        onMouseEnter: l ? r.onTrackOver : null,
        onMouseLeave: l ? r.onTrackLeave : null,
        onMouseOver: l ? r.onTrackOver : null,
        focusOnSelect: r.props.focusOnSelect && r.clickable ? r.selectHandler : null
      });
      var d;
      if (r.props.dots === !0 && r.state.slideCount >= r.props.slidesToShow) {
        var u = In(o, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]), p = r.props.pauseOnDotsHover;
        u = z(z({}, u), {}, {
          clickHandler: r.changeSlide,
          onMouseEnter: p ? r.onDotsLeave : null,
          onMouseOver: p ? r.onDotsOver : null,
          onMouseLeave: p ? r.onDotsLeave : null
        }), d = /* @__PURE__ */ C.createElement(B2, u);
      }
      var m, _, y = In(o, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      y.clickHandler = r.changeSlide, r.props.arrows && (m = /* @__PURE__ */ C.createElement(K2, y), _ = /* @__PURE__ */ C.createElement(U2, y));
      var f = null;
      r.props.vertical && (f = {
        height: r.state.listHeight
      });
      var g = null;
      r.props.vertical === !1 ? r.props.centerMode === !0 && (g = {
        padding: "0px " + r.props.centerPadding
      }) : r.props.centerMode === !0 && (g = {
        padding: r.props.centerPadding + " 0px"
      });
      var b = z(z({}, f), g), v = r.props.touchMove, x = {
        className: "slick-list",
        style: b,
        onClick: r.clickHandler,
        onMouseDown: v ? r.swipeStart : null,
        onMouseMove: r.state.dragging && v ? r.swipeMove : null,
        onMouseUp: v ? r.swipeEnd : null,
        onMouseLeave: r.state.dragging && v ? r.swipeEnd : null,
        onTouchStart: v ? r.swipeStart : null,
        onTouchMove: r.state.dragging && v ? r.swipeMove : null,
        onTouchEnd: v ? r.touchEnd : null,
        onTouchCancel: r.state.dragging && v ? r.swipeEnd : null,
        onKeyDown: r.props.accessibility ? r.keyHandler : null
      }, S = {
        className: i,
        dir: "ltr",
        style: r.props.style
      };
      return r.props.unslick && (x = {
        className: "slick-list"
      }, S = {
        className: i,
        style: r.props.style
      }), /* @__PURE__ */ C.createElement("div", S, r.props.unslick ? "" : m, /* @__PURE__ */ C.createElement("div", kt({
        ref: r.listRefHandler
      }, x), /* @__PURE__ */ C.createElement(V2, kt({
        ref: r.trackRefHandler
      }, s), r.props.children)), r.props.unslick ? "" : _, r.props.unslick ? "" : d);
    }), r.list = null, r.track = null, r.state = z(z({}, g2), {}, {
      currentSlide: r.props.initialSlide,
      targetSlide: r.props.initialSlide ? r.props.initialSlide : 0,
      slideCount: C.Children.count(r.props.children)
    }), r.callbackTimers = [], r.clickable = !0, r.debouncedResize = null;
    var a = r.ssrInit();
    return r.state = z(z({}, r.state), a), r;
  }
  return Xt(e, t), zt(e, [{
    key: "didPropsChange",
    value: function(r) {
      for (var a = !1, i = 0, o = Object.keys(this.props); i < o.length; i++) {
        var s = o[i];
        if (!r.hasOwnProperty(s)) {
          a = !0;
          break;
        }
        if (!(rt(r[s]) === "object" || typeof r[s] == "function" || isNaN(r[s])) && r[s] !== this.props[s]) {
          a = !0;
          break;
        }
      }
      return a || C.Children.count(this.props.children) !== C.Children.count(r.children);
    }
  }]);
})(C.Component), Vn, oo;
function m3() {
  if (oo) return Vn;
  oo = 1;
  var t = function(e) {
    return e.replace(/[A-Z]/g, function(n) {
      return "-" + n.toLowerCase();
    }).toLowerCase();
  };
  return Vn = t, Vn;
}
var Hn, so;
function f3() {
  if (so) return Hn;
  so = 1;
  var t = m3(), e = function(a) {
    var i = /[height|width]$/;
    return i.test(a);
  }, n = function(a) {
    var i = "", o = Object.keys(a);
    return o.forEach(function(s, l) {
      var d = a[s];
      s = t(s), e(s) && typeof d == "number" && (d = d + "px"), d === !0 ? i += s : d === !1 ? i += "not " + s : i += "(" + s + ": " + d + ")", l < o.length - 1 && (i += " and ");
    }), i;
  }, r = function(a) {
    var i = "";
    return typeof a == "string" ? a : a instanceof Array ? (a.forEach(function(o, s) {
      i += n(o), s < a.length - 1 && (i += ", ");
    }), i) : n(a);
  };
  return Hn = r, Hn;
}
var h3 = f3();
const $n = /* @__PURE__ */ mr(h3);
function g3(t, e, n) {
  return e = nt(e), _r(t, Jt() ? Reflect.construct(e, n || [], nt(t).constructor) : e.apply(t, n));
}
var _3 = /* @__PURE__ */ (function(t) {
  function e(n) {
    var r;
    return At(this, e), r = g3(this, e, [n]), re(r, "innerSliderRefHandler", function(a) {
      return r.innerSlider = a;
    }), re(r, "slickPrev", function() {
      return r.innerSlider.slickPrev();
    }), re(r, "slickNext", function() {
      return r.innerSlider.slickNext();
    }), re(r, "slickGoTo", function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      return r.innerSlider.slickGoTo(a, i);
    }), re(r, "slickPause", function() {
      return r.innerSlider.pause("paused");
    }), re(r, "slickPlay", function() {
      return r.innerSlider.autoPlay("play");
    }), r.state = {
      breakpoint: null
    }, r._responsiveMediaHandlers = [], r;
  }
  return Xt(e, t), zt(e, [{
    key: "media",
    value: function(r, a) {
      var i = window.matchMedia(r), o = function(l) {
        var d = l.matches;
        d && a();
      };
      i.addListener(o), o(i), this._responsiveMediaHandlers.push({
        mql: i,
        query: r,
        listener: o
      });
    }
    // handles responsive breakpoints
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this;
      if (this.props.responsive) {
        var a = this.props.responsive.map(function(o) {
          return o.breakpoint;
        });
        a.sort(function(o, s) {
          return o - s;
        }), a.forEach(function(o, s) {
          var l;
          s === 0 ? l = $n({
            minWidth: 0,
            maxWidth: o
          }) : l = $n({
            minWidth: a[s - 1] + 1,
            maxWidth: o
          }), ao() && r.media(l, function() {
            r.setState({
              breakpoint: o
            });
          });
        });
        var i = $n({
          minWidth: a.slice(-1)[0]
        });
        ao() && this.media(i, function() {
          r.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._responsiveMediaHandlers.forEach(function(r) {
        r.mql.removeListener(r.listener);
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this, a, i;
      this.state.breakpoint ? (i = this.props.responsive.filter(function(f) {
        return f.breakpoint === r.state.breakpoint;
      }), a = i[0].settings === "unslick" ? "unslick" : z(z(z({}, ca), this.props), i[0].settings)) : a = z(z({}, ca), this.props), a.centerMode && (a.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(a.slidesToScroll)), a.slidesToScroll = 1), a.fade && (a.slidesToShow > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(a.slidesToShow)), a.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(a.slidesToScroll)), a.slidesToShow = 1, a.slidesToScroll = 1);
      var o = C.Children.toArray(this.props.children);
      o = o.filter(function(f) {
        return typeof f == "string" ? !!f.trim() : !!f;
      }), a.variableWidth && (a.rows > 1 || a.slidesPerRow > 1) && (console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1"), a.variableWidth = !1);
      for (var s = [], l = null, d = 0; d < o.length; d += a.rows * a.slidesPerRow) {
        for (var u = [], p = d; p < d + a.rows * a.slidesPerRow; p += a.slidesPerRow) {
          for (var m = [], _ = p; _ < p + a.slidesPerRow && (a.variableWidth && o[_].props.style && (l = o[_].props.style.width), !(_ >= o.length)); _ += 1)
            m.push(/* @__PURE__ */ C.cloneElement(o[_], {
              key: 100 * d + 10 * p + _,
              tabIndex: -1,
              style: {
                width: "".concat(100 / a.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          u.push(/* @__PURE__ */ C.createElement("div", {
            key: 10 * d + p
          }, m));
        }
        a.variableWidth ? s.push(/* @__PURE__ */ C.createElement("div", {
          key: d,
          style: {
            width: l
          }
        }, u)) : s.push(/* @__PURE__ */ C.createElement("div", {
          key: d
        }, u));
      }
      if (a === "unslick") {
        var y = "regular slider " + (this.props.className || "");
        return /* @__PURE__ */ C.createElement("div", {
          className: y
        }, o);
      } else s.length <= a.slidesToShow && !a.infinite && (a.unslick = !0);
      return /* @__PURE__ */ C.createElement(p3, kt({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, D2(a)), s);
    }
  }]);
})(C.Component), ma = /* @__PURE__ */ ((t) => (t[t.left = 0] = "left", t[t.right = 1] = "right", t))(ma || {});
const lo = ({ className: t, onClick: e, variant: n }) => {
  const { isDefaultSioColor: r } = qe();
  return /* @__PURE__ */ c(
    "div",
    {
      className: De(
        t,
        n === 0 ? "!left-2" : "!right-2",
        "!z-20 !h-[24px] !w-[24px] before:!content-none"
      ),
      onClick: e,
      children: /* @__PURE__ */ c(
        ml,
        {
          className: De(
            "before:!display-none !flex !h-[24px] !w-[24px] justify-center",
            r ? "stroke-brand-primary" : "stroke-THEME-text-primary",
            n === 0 ? "rotate-90" : "-rotate-90"
          )
        }
      )
    }
  );
}, y3 = ({ goToSlide: t, index: e, slidesCount: n }) => {
  const r = Ot(null), [a, i] = Te(!1), { isDefaultSioColor: o } = qe();
  let s = "";
  return a ? s = o ? "!bg-brand-primary" : "!bg-THEME-primary" : s = o ? "bg-THEME-tertiary" : "bg-THEME-secondary", Ve(() => {
    if (!r.current) return;
    const l = r.current.parentElement;
    if (!l) return;
    l.style.width = `${100 / n}%`, i(l.classList.contains("slick-active"));
    const d = new MutationObserver((u) => {
      u.forEach((p) => {
        p.attributeName === "class" && i(l.classList.contains("slick-active"));
      });
    });
    return d.observe(l, { attributes: !0 }), () => d.disconnect();
  }, []), /* @__PURE__ */ c(
    "div",
    {
      onClick: () => t(e),
      className: fe("flex h-[4px] cursor-pointer rounded-[30px]", s),
      ref: r
    }
  );
}, Js = C.forwardRef(
  ({ images: t, goToSlide: e }, n) => {
    if (!t || t.length === 0) return null;
    const r = t.length > 1;
    return /* @__PURE__ */ c(
      _3,
      {
        ref: n,
        swipe: r,
        arrows: r,
        infinite: r,
        swipeToSlide: r,
        dots: r,
        prevArrow: /* @__PURE__ */ c(lo, { variant: ma.left }),
        nextArrow: /* @__PURE__ */ c(lo, { variant: ma.right }),
        customPaging: (a) => /* @__PURE__ */ c(y3, { slidesCount: t.length, index: a, goToSlide: e }),
        dotsClass: "relative bottom-5 !flex flex-row justify-center items-center gap-[9px] w-[calc(100%-90px)] max-w-[120px] mx-auto",
        children: t.map(({ path: a, id: i }) => /* @__PURE__ */ c("div", { className: "!flex items-center justify-center", children: /* @__PURE__ */ c("img", { src: a }) }, i))
      }
    );
  }
);
Js.displayName = "Slider";
const v3 = ({ product: t }) => {
  const { currency: e, productVariants: n, images: r = [], name: a, stock: i, limitStock: o } = t, [s, l] = Te([]), { setPricePlan: d, setFinalAmount: u } = tt(), { locale: p } = at(), { quantity: m, setQuantity: _, productVariant: y, setProductVariant: f } = fr(), { t: g } = He(), b = Ot(null), v = (B) => {
    var U;
    (U = b == null ? void 0 : b.current) == null || U.slickGoTo(B);
  }, x = (B, U) => {
    const Y = sa(B, U);
    Y && (d(Y), u(Y.amount));
  }, S = (B) => {
    var U;
    if (f(B), B.image) {
      const Y = [B.image, ...s.slice(1)];
      l(Y), (U = b.current) == null || U.slickGoTo(0);
    }
    x(t, B);
  };
  Fe(t, (B) => {
    if (!B)
      d(void 0), u(void 0);
    else {
      const U = [...r], Y = y ?? n[0];
      f(Y), Y != null && Y.image && U.unshift(Y.image), l(U), x(B, Y);
    }
  });
  const h = (y == null ? void 0 : y.stock) ?? i ?? 0, P = () => _(m + 1), F = () => _(m - 1), G = h > 0 && o ? h : void 0, W = !!G && m >= G, H = m <= 1;
  return /* @__PURE__ */ c("div", { className: "flex flex-col gap-3 sm:gap-5", children: /* @__PURE__ */ L("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ c(dr, { label: g("public_pages_purchase.product") }),
    /* @__PURE__ */ L(
      "div",
      {
        className: "border-text-secondary/30 flex flex-col gap-3.5 rounded-lg border px-3.5 py-5",
        children: [
          y && /* @__PURE__ */ c(
            m2,
            {
              product: t,
              activeVariant: y,
              changeActiveVariant: S
            }
          ),
          /* @__PURE__ */ c(
            f2,
            {
              quantity: m,
              onIncrease: P,
              onDecrease: F,
              disabledIncreaseButton: W,
              disabledDecreaseButton: H
            }
          ),
          /* @__PURE__ */ c(Js, { goToSlide: v, ref: b, images: s }),
          /* @__PURE__ */ L("div", { className: "items flex justify-between", children: [
            /* @__PURE__ */ c("h2", { className: "text-[14px] font-normal", children: a }),
            /* @__PURE__ */ L("div", { className: "flex items-center gap-2.5", children: [
              /* @__PURE__ */ c(Ue, { currency: e }),
              /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: Be(
                Me((y == null ? void 0 : y.price) ?? t.price),
                t.currency,
                p
              ) })
            ] })
          ] })
        ]
      }
    )
  ] }) });
}, b3 = (t, e) => e ? t.some(
  (n) => n.rules.some((r) => r.id !== e.ruleId ? !1 : e.conditionId ? r.shippingConditions.some((a) => a.id === e.conditionId) : !0)
) : !1, C3 = ({ service: t, rule: e, onChange: n, isSelected: r }) => {
  const { locale: a } = at(), i = Be(
    Me(e.price),
    e.currency,
    a
  );
  return /* @__PURE__ */ L("label", { className: "relative flex cursor-pointer items-center gap-2", children: [
    /* @__PURE__ */ c(
      "input",
      {
        className: fe(
          "border-fill-primary h-[20px] w-[20px] rounded-full border-2 outline-hidden",
          r ? "bg-background-secondary" : "bg-transparent",
          "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
        ),
        checked: r,
        value: e.id,
        onChange: () => {
          n({
            ruleId: e.id,
            currency: e.currency,
            price: e.price
          });
        },
        type: "radio"
      }
    ),
    /* @__PURE__ */ c(Ca, { className: De(!r && "fill-transparent") }),
    /* @__PURE__ */ c("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: /* @__PURE__ */ L(
      "div",
      {
        className: "main-transition-colors flex flex-col flex-wrap gap-2 text-left text-[16px]",
        children: [
          /* @__PURE__ */ L("div", { className: "flex flex-wrap gap-1", children: [
            /* @__PURE__ */ c("span", { className: "flex shrink-0", children: t.name }),
            /* @__PURE__ */ c("span", { className: "flex shrink-0", children: e.name })
          ] }),
          e.description
        ]
      }
    ) }),
    /* @__PURE__ */ L("div", { className: "ml-auto flex items-center gap-2.5", children: [
      /* @__PURE__ */ c(Ue, { currency: e.currency }),
      /* @__PURE__ */ c("span", { className: "main-transition-colors text-[14px] font-semibold", children: i })
    ] })
  ] });
};
var Je = /* @__PURE__ */ ((t) => (t.Inclusive = "inclusive", t.Exclusive = "exclusive", t))(Je || {}), Xe = /* @__PURE__ */ ((t) => (t.one_shot = "one_shot", t.subscription = "subscription", t.limited_subscription = "limited_subscription", t))(Xe || {}), Mt = /* @__PURE__ */ ((t) => (t.price = "price", t.quantity = "quantity", t.weight = "weight", t))(Mt || {});
const Hr = (t, e, n, r = "narrowSymbol") => {
  try {
    return new Intl.NumberFormat(n, {
      style: "currency",
      currency: e,
      currencyDisplay: r
    }).format(t);
  } catch (a) {
    if (a instanceof RangeError && r !== "symbol")
      return Hr(t, e, n, "symbol");
    throw a;
  }
}, w3 = (t, e, n, r) => {
  switch (e.type) {
    case Mt.price:
      return t.max ? n("public_pages_purchase.shipping.condition_label.price", {
        min: Hr(Me(t.min), e.currency, r),
        max: Hr(Me(t.max), e.currency, r),
        currency: ""
      }) : n("public_pages_purchase.shipping.condition_label.price_min", {
        min: Hr(Me(t.min), e.currency, r),
        currency: ""
      });
    case Mt.quantity:
      return t.max ? n("public_pages_purchase.shipping.condition_label.quantity", {
        min: t.min,
        max: t.max
      }) : n("public_pages_purchase.shipping.condition_label.quantity_min", {
        min: t.min
      });
    case Mt.weight:
      return t.max ? n("public_pages_purchase.shipping.condition_label.weight", {
        min: t.min,
        max: t.max
      }) : n("public_pages_purchase.shipping.condition_label.weight_min", {
        min: t.min
      });
    default:
      return "";
  }
}, x3 = ({
  onChange: t,
  service: e,
  rule: n,
  condition: r,
  isSelected: a
}) => {
  const { t: i } = He(), { locale: o } = at();
  return /* @__PURE__ */ L("label", { className: fe("relative flex cursor-pointer items-center gap-2"), children: [
    /* @__PURE__ */ c(
      "input",
      {
        className: fe(
          "border-fill-primary h-[20px] w-[20px] rounded-full border-2 outline-hidden",
          a ? "bg-background-secondary" : "bg-transparent",
          "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
        ),
        checked: a,
        value: n.id,
        onChange: () => {
          t({
            ruleId: n.id,
            currency: n.currency,
            conditionId: r.id,
            price: r.price
          });
        },
        type: "radio"
      }
    ),
    /* @__PURE__ */ c(Ca, { className: De(!a && "fill-transparent") }),
    /* @__PURE__ */ c("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: /* @__PURE__ */ L(
      "div",
      {
        className: "main-transition-colors flex max-w-full flex-col flex-wrap gap-2 text-left text-[16px] md:max-w-[70%]",
        children: [
          /* @__PURE__ */ L("div", { className: "flex flex-wrap gap-1", children: [
            /* @__PURE__ */ c("span", { className: "flex shrink-0", children: e.name }),
            /* @__PURE__ */ c("span", { className: "flex shrink-0", children: n.name })
          ] }),
          w3(r, n, i, o)
        ]
      }
    ) }),
    /* @__PURE__ */ L("div", { className: "ml-auto flex items-center gap-2.5", children: [
      /* @__PURE__ */ c(Ue, { currency: n.currency }),
      /* @__PURE__ */ c("span", { className: "main-transition-colors text-[14px] font-semibold", children: Be(Me(r.price), n.currency, o) })
    ] })
  ] });
}, k3 = ({ shipping: t, isLoading: e }) => {
  const { t: n } = He(), { setSelectedShipping: r, selectedShipping: a } = fr();
  Fe(a, (o) => {
    if (!(!t || !t.length) && !b3(t, o))
      if (t[0]) {
        const s = t[0].rules[0], l = s.shippingConditions[0];
        r(l ? {
          ruleId: s.id,
          currency: s.currency,
          conditionId: l.id,
          price: l.price
        } : {
          ruleId: s.id,
          currency: s.currency,
          price: s.price
        });
      } else
        r(null);
  });
  const i = (o) => {
    r(o);
  };
  return typeof t > "u" ? null : /* @__PURE__ */ L("div", { className: De("flex flex-col gap-1", e && "animate-pulse"), children: [
    /* @__PURE__ */ c(dr, { label: n("public_pages_purchase.shipping.shipping_method") }),
    /* @__PURE__ */ c("div", { className: "border-text-secondary/30 flex flex-col gap-4 rounded-lg border p-4", children: t.length ? t.map(
      (o, s) => o.rules.map(
        (l) => l.shippingConditions.length ? l.shippingConditions.map((d) => {
          const u = d.id === (a == null ? void 0 : a.conditionId) && l.id === (a == null ? void 0 : a.ruleId);
          return /* @__PURE__ */ c(
            x3,
            {
              isSelected: u,
              onChange: i,
              service: o,
              rule: l,
              condition: d
            },
            d.id
          );
        }) : /* @__PURE__ */ c(
          C3,
          {
            isSelected: l.id === (a == null ? void 0 : a.ruleId),
            onChange: i,
            service: o,
            rule: l
          },
          l.id
        )
      )
    ) : n("public_pages_purchase.shipping.not_available") })
  ] });
}, S3 = {
  id: 123,
  type: Xe.one_shot,
  currency: Ne.EURO,
  name: "Default Price plan",
  amount: me(1),
  taxBehavior: Je.Inclusive,
  innerName: "Default Price plan",
  statementDescriptor: "Default Price plan",
  removedAt: null
}, P3 = {
  id: 112651,
  name: "T-shirt",
  tax: Rr(20),
  createdAt: "2025-01-01T00:00:00.000Z",
  updatedAt: "2025-01-01T00:00:00.000Z",
  taxBehavior: Je.Inclusive,
  options: [
    {
      id: "01JTG214EFTGZQ486S90TTNZ9P",
      name: "Color",
      optionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        }
      ]
    },
    {
      id: "01JTG226Z40D4GP8P4X9MA49XS",
      name: "Size",
      optionValues: [
        {
          id: "01JTG226Z41H5Q9QPCG1VS57V8",
          value: "S"
        },
        {
          id: "01JTG22ANKHJZFR5G74R9K8P5T",
          value: "M"
        },
        {
          id: "01JTG22C024FRBMX3055G1AD45",
          value: "L"
        },
        {
          id: "01JTG22DJ2PM2CT42C3AXTGZTM",
          value: "XL"
        }
      ]
    }
  ],
  productVariants: [
    {
      id: "01JTG21EHKEMWGEBH704F0V5EX",
      sku: "WHI-737",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG226Z41H5Q9QPCG1VS57V8"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG226Z41H5Q9QPCG1VS57V8",
          value: "S"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: pt.Product,
        size: 1024,
        type: dt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: me(799),
      stock: null,
      pricePlan: {
        id: 123,
        type: Xe.one_shot,
        currency: Ne.EURO,
        name: "Default Price plan",
        amount: me(1),
        taxBehavior: Je.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG21HT1GC9S77WEJMY8H2KF",
      sku: "BLA-213",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG226Z41H5Q9QPCG1VS57V8"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG226Z41H5Q9QPCG1VS57V8",
          value: "S"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: pt.Product,
        size: 1024,
        type: dt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: me(699),
      stock: null,
      pricePlan: {
        id: 124,
        type: Xe.one_shot,
        currency: Ne.EURO,
        name: "Default Price plan",
        amount: me(699),
        taxBehavior: Je.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22C0H1PTYQGZ8Z576M09H",
      sku: "BLA-649",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG22ANKHJZFR5G74R9K8P5T"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG22ANKHJZFR5G74R9K8P5T",
          value: "M"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: pt.Product,
        size: 1024,
        type: dt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: me(799),
      stock: null,
      pricePlan: {
        id: 125,
        type: Xe.one_shot,
        currency: Ne.EURO,
        name: "Default Price plan",
        amount: me(799),
        taxBehavior: Je.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22C0HMC23MHK814V8CPA4",
      sku: "WHI-332",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG22ANKHJZFR5G74R9K8P5T"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG22ANKHJZFR5G74R9K8P5T",
          value: "M"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: pt.Product,
        size: 1024,
        type: dt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: me(799),
      stock: null,
      pricePlan: {
        id: 126,
        type: Xe.one_shot,
        currency: Ne.EURO,
        name: "Default Price plan",
        amount: me(799),
        taxBehavior: Je.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22DJH1CNT3RHRGC9TT0AQ",
      sku: "BLA-298",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG22C024FRBMX3055G1AD45"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG22C024FRBMX3055G1AD45",
          value: "L"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: pt.Product,
        size: 1024,
        type: dt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: me(899),
      stock: null,
      pricePlan: {
        id: 127,
        type: Xe.one_shot,
        currency: Ne.EURO,
        name: "Default Price plan",
        amount: me(899),
        taxBehavior: Je.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22DJHAM47QZGNW8B8A9AR",
      sku: "WHI-220",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG22C024FRBMX3055G1AD45"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG22C024FRBMX3055G1AD45",
          value: "L"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: pt.Product,
        size: 1024,
        type: dt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: me(899),
      stock: null,
      pricePlan: {
        id: 128,
        type: Xe.one_shot,
        currency: Ne.EURO,
        name: "Default Price plan",
        amount: me(899),
        taxBehavior: Je.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22ERSQSJ084P417PRG46W",
      sku: "BLA-217",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG22DJ2PM2CT42C3AXTGZTM"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG22DJ2PM2CT42C3AXTGZTM",
          value: "XL"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: pt.Product,
        size: 1024,
        type: dt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: me(899),
      stock: null,
      pricePlan: {
        id: 129,
        type: Xe.one_shot,
        currency: Ne.EURO,
        name: "Default Price plan",
        amount: me(899),
        taxBehavior: Je.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22ERSSH236MH8ZMQWRQRA",
      sku: "WHI-855",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG22DJ2PM2CT42C3AXTGZTM"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG22DJ2PM2CT42C3AXTGZTM",
          value: "XL"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: pt.Product,
        size: 1024,
        type: dt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: me(999),
      stock: null,
      pricePlan: {
        id: 130,
        type: Xe.one_shot,
        currency: Ne.EURO,
        name: "Default Price plan",
        amount: me(999),
        taxBehavior: Je.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    }
  ],
  sku: "T-S-887",
  images: [
    {
      id: 31121503,
      path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
      thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
      name: "White T-shirt",
      filename: "white-t-shirt.webp",
      source: pt.Product,
      size: 1024,
      type: dt.Image,
      createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
      id: 31121528,
      path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
      thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
      name: "Black T-shirt",
      filename: "black-t-shirt.jpg",
      source: pt.Product,
      size: 1024,
      type: dt.Image,
      createdAt: "2025-01-01T00:00:00.000Z"
    }
  ],
  currency: Ne.EURO,
  price: me(799),
  description: "T-shirt description",
  limitStock: !1,
  stock: null,
  weight: 250,
  shippingFeesDisabled: !1,
  pricePlan: S3
}, E3 = [
  {
    rules: [
      {
        id: 5056,
        name: "Rule",
        description: "Desc",
        price: me(1e3),
        shippingConditions: [
          {
            id: 7180,
            min: 1,
            max: 100,
            price: me(500)
          }
        ],
        currency: Ne.EURO,
        type: Mt.quantity
      }
    ],
    id: 1739821,
    name: "Custom"
  },
  {
    rules: [
      {
        id: 5075,
        name: "Fixed Rate",
        description: "Fixed price rate delivery",
        price: me(599),
        shippingConditions: [],
        currency: Ne.EURO,
        type: Mt.quantity
      }
    ],
    id: 1739887,
    name: "Fixed Delivery"
  },
  {
    rules: [
      {
        id: 5074,
        name: "Multizone",
        description: "Multizone Description",
        price: me(1100),
        shippingConditions: [
          {
            id: 7191,
            min: 1,
            max: 1e4,
            price: me(999)
          }
        ],
        currency: Ne.EURO,
        type: Mt.quantity
      }
    ],
    id: 1739886,
    name: "New Custom"
  }
], L3 = {
  pricePlan: 1,
  quantity: 1,
  originalAmount: me(999),
  netAmount: me(999),
  discountedNetAmount: me(999),
  tax: {
    amount: me(200),
    rate: Rr(20)
  },
  grossAmount: me(1199),
  discount: {
    amount: me(0),
    percent: Rr(0)
  },
  shippingFee: {
    amount: me(599),
    tax: {
      amount: me(119.8),
      rate: Rr(20)
    }
  },
  currencyCode: Ne.EURO
}, o5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  calculatePrice: L3,
  physicalProduct: P3,
  shippingRules: E3
}, Symbol.toStringTag, { value: "Module" })), s5 = (t) => {
  var E;
  const { title: e, description: n, buttonTitle: r, fields: a, cover: i, offerId: o, id: s } = t.checkoutPage, {
    currency: l,
    paymentMethods: d,
    thankYouPage: u,
    affiliateLink: p,
    displayAffiliateLink: m,
    productType: _,
    physicalProduct: y,
    shippingRules: f,
    calculatePrice: g,
    isLoadingShippingRules: b = !1,
    isLoadingCalculatePrice: v = !1,
    skipDisabledButton: x = !1
  } = t, { t: S } = He(), [h, P] = Te(!1), [F, G] = Te($e), { productVariant: W, quantity: H, selectedShipping: B } = fr();
  Ds({
    handlerError: (R) => G((q) => ({ ...q, common: [R] })),
    pagePath: t.checkoutPage.path
  });
  const {
    availablePaymentMethods: U,
    setAvailablePaymentMethods: Y,
    setPaymentMethod: ee,
    paymentMethod: Z,
    setCurrency: pe,
    setPricePlan: ne,
    setOfferId: te,
    setProductId: ce,
    finalAmount: A,
    setFinalAmount: D,
    contactFields: N,
    setContactFields: T
  } = tt();
  Fe(y == null ? void 0 : y.id, (R) => R && ce(R)), Fe(o, (R) => R && te(R)), Fe(d, (R) => R && Y(R)), Fe(l, (R) => R && pe(R)), Fe(a, (R) => R && T(Zr(R))), Fe(y, (R) => {
    if (!R)
      ne(void 0), D(void 0);
    else {
      const q = sa(R, W);
      q && (ne(q), D(q.amount));
    }
  });
  const M = () => {
    let R = !1;
    const q = Ra($e);
    return Object.values(N).forEach(({ slug: X, value: he, required: We }) => {
      We && (he == null || he === "") && (q.customer.fields[X] = [S("public_pages_purchase.required-field")], R = !0);
    }), Z || (q.paymentMethod = [S("public_pages_purchase.required-field")], R = !0), { errors: q, isFailed: R };
  }, V = !!A && !!Z && !!o && !!y && !!s, w = () => {
    if (!V) return;
    const R = sa(y, W);
    if (!R) return;
    const q = Object.values(N).reduce((We, Pe) => (We[Pe.slug] = Pe.value ?? "", We), {}), X = `${window.location.origin}${(u == null ? void 0 : u.path) ?? ""}`, he = window.location.href;
    return {
      page: s,
      customer: {
        fields: q
      },
      offer: o,
      digitalProduct: null,
      pricePlan: R.id,
      purchaseProductModel: {
        product: y.id,
        productVariant: (W == null ? void 0 : W.id) ?? null,
        quantity: H,
        shippingRule: (B == null ? void 0 : B.ruleId) ?? null,
        shippingCondition: (B == null ? void 0 : B.conditionId) ?? null
      },
      thankYouPageUrl: X,
      failedReturnUrl: he,
      paymentMethod: Z
    };
  }, $ = () => {
    const { errors: R, isFailed: q } = M();
    if (q) {
      G((X) => ({ ...X, ...R }));
      return;
    }
    return w();
  }, O = (R) => {
    const q = zs(R, $e), X = js(q.customer.fields, N);
    G({
      ...q,
      common: q.common.concat(X)
    });
  }, { paymentProcessorPaymentButton: J, paymentProcessorDetails: K, PaymentProcessorProvider: oe } = As({
    isFetching: h,
    setIsFetching: P,
    handleBadRequest: O,
    buttonTitle: r,
    buttonDisabled: !V && !x,
    preSubmit: $,
    setErrors: G,
    hasErrors: Aa(F)
  }), k = Object.values(U).filter((R) => R !== le.stripe_applepay).map((R) => ({
    id: R,
    caption: S(po(R)),
    content: K,
    additionalInfo: /* @__PURE__ */ c(Fo, { paymentMethod: R })
  })), ue = (R, q) => {
    T({
      ...N,
      [R.slug]: { ...R, value: q }
    });
  };
  return /* @__PURE__ */ c(va, { children: /* @__PURE__ */ L(jo, { children: [
    /* @__PURE__ */ L("form", { className: "flex flex-col gap-5 px-5 pt-5 sm:gap-10 sm:pb-5 ", children: [
      /* @__PURE__ */ c(
        Ge,
        {
          className: "h-full w-full shrink-0 rounded-lg",
          thumbnail: i,
          imageType: Is(_),
          alt: e
        }
      ),
      /* @__PURE__ */ c("h2", { className: "text-xl font-bold sm:text-3xl", children: e }),
      /* @__PURE__ */ L("div", { className: "flex flex-col gap-3 sm:gap-5", children: [
        /* @__PURE__ */ c(
          "div",
          {
            className: "ckeditor-default text-sm sm:text-base sm:leading-5",
            dangerouslySetInnerHTML: {
              __html: ho.sanitize(n)
            }
          }
        ),
        y && /* @__PURE__ */ c(v3, { product: y }),
        N[Qe.Country] && /* @__PURE__ */ c(k3, { shipping: f, isLoading: b }),
        y && /* @__PURE__ */ c(
          d2,
          {
            product: y,
            calculatePrice: g,
            isLoading: v
          }
        ),
        Object.values(N).map((R) => /* @__PURE__ */ c(
          wa,
          {
            contactFields: N,
            field: R,
            value: N[R.slug].value,
            error: F.customer.fields[R.slug],
            onChange: (q) => ue(R, q)
          },
          R.slug
        )),
        /* @__PURE__ */ L(oe, { children: [
          U.length > 0 && /* @__PURE__ */ c(
            Zn,
            {
              label: S("public_pages_purchase.Payment-method"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: k,
              selected: Z,
              onChange: (R) => ee(R),
              required: !0,
              error: (E = F.paymentMethod) == null ? void 0 : E.join(", ")
            }
          ),
          F.common && /* @__PURE__ */ c(
            ha,
            {
              error: F.common.join(", "),
              errorClassName: "flex justify-center"
            }
          ),
          J
        ] })
      ] })
    ] }),
    m && /* @__PURE__ */ c(on, { affiliateLink: p })
  ] }) });
}, T3 = ({ children: t }) => /* @__PURE__ */ c("span", { className: "font-semibold", children: t }), N3 = ({ type: t, amount: e, currency: n, recurringOptions: r }) => {
  if (t === Xe.one_shot)
    return /* @__PURE__ */ c(M3, { amount: e, currency: n });
  if (t === Xe.subscription)
    return /* @__PURE__ */ c(
      O3,
      {
        amount: e,
        currency: n,
        recurringOptions: r
      }
    );
  if (t === Xe.limited_subscription)
    return /* @__PURE__ */ c(
      R3,
      {
        amount: e,
        currency: n,
        recurringOptions: r
      }
    );
}, M3 = ({
  amount: t,
  currency: e
}) => {
  const { locale: n } = at(), r = Be(
    Me(t),
    e,
    n
  );
  return /* @__PURE__ */ L("div", { className: "flex items-center", children: [
    /* @__PURE__ */ c(Ue, { currency: e }),
    /* @__PURE__ */ c("div", { className: "ml-1 text-[14px] font-semibold", children: r })
  ] });
}, O3 = ({
  amount: t,
  currency: e,
  recurringOptions: n
}) => {
  const { locale: r } = at(), { t: a } = He(), i = Be(
    Me(t),
    e,
    r
  ), o = n.trialPeriod ? `${a("public_pages_purchase.components.offer_price.price_plans.trial_period_new", {
    trialPeriodPrice: a(
      "public_pages_purchase.components.offer_price.price_plans.trial_period_price"
    ),
    trialInterval: a(
      `public_pages_purchase.price_plan.trial_period.${n.trialInterval}`,
      {
        count: n.trialPeriod
      }
    )
  })} ` : void 0, s = /* @__PURE__ */ c(
    ko,
    {
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.unlimited_new",
      values: {
        amount: i,
        interval: a(`public_pages_purchase.price_plan.interval.${n.interval}`, {
          count: n.intervalCount
        })
      },
      components: {
        bold: /* @__PURE__ */ c(T3, {})
      }
    }
  );
  return /* @__PURE__ */ L("div", { className: "flex items-center", children: [
    /* @__PURE__ */ c(Ue, { currency: e }),
    /* @__PURE__ */ L("div", { className: "ml-3", children: [
      o && /* @__PURE__ */ c("div", { className: "text-[14px] font-semibold", children: o }),
      /* @__PURE__ */ c("div", { className: "text-[14px]", children: s })
    ] })
  ] });
}, R3 = ({
  amount: t,
  currency: e,
  recurringOptions: n
}) => {
  const { locale: r } = at(), { t: a } = He(), i = Be(
    Me(t),
    e,
    r
  ), o = n.trialPeriod ? `${a("public_pages_purchase.components.offer_price.price_plans.trial_period_new", {
    trialPeriodPrice: a(
      "public_pages_purchase.components.offer_price.price_plans.trial_period_price"
    ),
    trialInterval: a(
      `public_pages_purchase.price_plan.trial_period.${n.trialInterval}`,
      {
        count: n.trialPeriod
      }
    )
  })} ` : void 0, s = /* @__PURE__ */ c(
    ko,
    {
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.limited_with_limit_of_payments",
      values: {
        amount: i,
        count: n.limitOfPayments,
        interval: a(`public_pages_purchase.price_plan.interval.${n.interval}`, {
          count: n.intervalCount
        })
      }
    }
  );
  return /* @__PURE__ */ L("div", { className: "flex items-center", children: [
    /* @__PURE__ */ c(Ue, { currency: e }),
    /* @__PURE__ */ L("div", { className: "ml-3", children: [
      o && /* @__PURE__ */ c("div", { className: "text-[14px] font-semibold", children: o }),
      /* @__PURE__ */ c("div", { className: "text-[14px] font-semibold", children: s })
    ] })
  ] });
}, A3 = ({ calculatePrice: t, pricePlan: e }) => {
  const { locale: n } = at(), { t: r } = He();
  return /* @__PURE__ */ L(St, { children: [
    !!(t != null && t.netAmount) && /* @__PURE__ */ L("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ c("span", { className: "text-[14px]", children: r("public_pages_purchase.subtotal") }),
      /* @__PURE__ */ L("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ c(Ue, { currency: e.currency }),
        /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: Be(
          Me(t.netAmount),
          e.currency,
          n
        ) })
      ] })
    ] }),
    !!(t != null && t.tax) && t.tax.rate > 0 && /* @__PURE__ */ L("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ c("span", { className: "text-[14px]", children: r("public_pages_purchase.vat_percent", {
        percent: t.tax.rate
      }) }),
      /* @__PURE__ */ L("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ c(Ue, { currency: e.currency }),
        /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: Be(
          Me(t.tax.amount),
          e.currency,
          n
        ) })
      ] })
    ] })
  ] });
}, z3 = ({
  calculatePrice: t,
  isLoading: e,
  pricePlan: n
}) => {
  const { t: r } = He(), { locale: a } = at(), { finalAmount: i } = tt();
  return /* @__PURE__ */ L("div", { className: De("flex flex-col gap-1", e && "animate-pulse"), children: [
    /* @__PURE__ */ c(dr, { label: r("public_pages_purchase.order_summary") }),
    /* @__PURE__ */ L("div", { className: "border-text-secondary/30 flex flex-col gap-5 rounded-lg border px-3.5 py-5", children: [
      (n == null ? void 0 : n.taxBehavior) === Je.Exclusive && t && /* @__PURE__ */ L(St, { children: [
        /* @__PURE__ */ c(A3, { calculatePrice: t, pricePlan: n }),
        /* @__PURE__ */ c("div", { className: "bg-text-secondary/30 h-[1px] w-full" })
      ] }),
      i && i > 0 && /* @__PURE__ */ L("div", { className: "flex w-full items-center justify-between", children: [
        /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: r("public_pages_purchase.total") }),
        /* @__PURE__ */ L("div", { className: "flex flex-col items-center gap-1.5", children: [
          /* @__PURE__ */ L("div", { className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ c(Ue, { currency: n.currency }),
            /* @__PURE__ */ c("span", { className: "text-[14px] font-semibold", children: Be(
              Me(i),
              n.currency,
              a
            ) })
          ] }),
          (n == null ? void 0 : n.taxBehavior) === Je.Inclusive && t && t.tax.rate > 0 && /* @__PURE__ */ c("span", { className: "text-text-tertiary text-xs", children: r("public_pages_purchase.including_tax", {
            percent: t.tax.rate,
            amount: Be(
              Me(t.tax.amount),
              n.currency,
              a
            )
          }) })
        ] })
      ] })
    ] })
  ] });
}, l5 = (t) => {
  var oe, k, ue;
  const { title: e, description: n, buttonTitle: r, fields: a, cover: i, offerId: o, digitalProductId: s, id: l } = t.checkoutPage, {
    currency: d,
    paymentMethods: u,
    pricePlans: p,
    thankYouPage: m,
    affiliateLink: _,
    displayAffiliateLink: y,
    productType: f,
    calculatePrice: g,
    isLoadingCalculatePrice: b,
    skipDisabledButton: v = !1
  } = t, { t: x } = He(), [S, h] = Te(!1), [P, F] = Te($e);
  Ds({
    handlerError: (E) => F((R) => ({ ...R, common: [E] })),
    pagePath: t.checkoutPage.path
  });
  const {
    setAvailablePaymentMethods: G,
    setPaymentMethod: W,
    paymentMethod: H,
    availablePaymentMethods: B,
    setCurrency: U,
    setPricePlan: Y,
    pricePlan: ee,
    setOfferId: Z,
    setProductId: pe,
    finalAmount: ne,
    setFinalAmount: te,
    contactFields: ce,
    setContactFields: A
  } = tt();
  Fe(s, (E) => E && pe(E)), Fe(o, (E) => E && Z(E)), Fe(u, (E) => E && G(E)), Fe(d, (E) => E && U(E)), Fe(a, (E) => E && A(Zr(E))), Fe(p, (E) => {
    if (E) {
      if (E.length === 0)
        Y(void 0), te(void 0);
      else if (!ee) {
        const R = E[0];
        Y(R), te(R.amount);
      }
    }
  });
  const D = () => {
    let E = !1;
    const R = Ra($e);
    return Object.values(ce).forEach(({ slug: q, value: X, required: he }) => {
      he && (X == null || X === "") && (R.customer.fields[q] = [x("public_pages_purchase.required-field")], E = !0);
    }), H || (R.paymentMethod = [x("public_pages_purchase.required-field")], E = !0), ee || (R.pricePlan = [x("public_pages_purchase.required-field")], E = !0), { errors: R, isFailed: E };
  }, N = !!ne && !!H && !!o && !!s && !!ee && !!l, T = () => {
    if (!N) return;
    const E = Object.values(ce).reduce((X, he) => (X[he.slug] = he.value ?? "", X), {}), R = `${window.location.origin}${(m == null ? void 0 : m.path) ?? ""}`, q = window.location.href;
    return {
      page: l,
      customer: {
        fields: E
      },
      offer: o,
      digitalProduct: s,
      purchaseProductModel: null,
      pricePlan: ee.id,
      thankYouPageUrl: R,
      failedReturnUrl: q,
      paymentMethod: H
    };
  }, M = () => {
    const { errors: E, isFailed: R } = D();
    if (R) {
      F((q) => ({ ...q, ...E }));
      return;
    }
    return T();
  }, V = (E) => {
    const R = zs(E, $e), q = js(R.customer.fields, ce);
    F({
      ...R,
      common: R.common.concat(q)
    });
  }, { paymentProcessorPaymentButton: w, paymentProcessorDetails: $, PaymentProcessorProvider: O } = As({
    isFetching: S,
    setIsFetching: h,
    handleBadRequest: V,
    buttonTitle: r,
    buttonDisabled: !N && !v,
    preSubmit: M,
    setErrors: F,
    hasErrors: Aa(P)
  }), J = Object.values(B).filter((E) => E !== le.stripe_applepay).filter((E) => E !== le.cash_on_delivery).map((E) => ({
    id: E,
    caption: x(po(E)),
    content: $,
    additionalInfo: /* @__PURE__ */ c(Fo, { paymentMethod: E })
  })), K = p == null ? void 0 : p.map((E) => ({
    id: String(E.id),
    caption: E.name,
    additionalInfo: /* @__PURE__ */ c(N3, { ...E })
  }));
  return /* @__PURE__ */ c(va, { children: /* @__PURE__ */ L(jo, { children: [
    /* @__PURE__ */ c(O, { children: /* @__PURE__ */ L("form", { className: "flex flex-col gap-5 px-5 pt-5 sm:gap-10 sm:pb-5", children: [
      /* @__PURE__ */ c(
        Ge,
        {
          className: "h-full w-full shrink-0 rounded-lg",
          thumbnail: i,
          imageType: Is(f),
          alt: e
        }
      ),
      /* @__PURE__ */ L("div", { className: "flex flex-col gap-5 sm:gap-10", children: [
        /* @__PURE__ */ c("div", { className: "flex flex-col gap-3 sm:gap-5", children: /* @__PURE__ */ c("h2", { className: "text-xl font-bold sm:text-3xl", children: e }) }),
        /* @__PURE__ */ L("div", { className: "flex flex-col gap-3 sm:gap-5", children: [
          /* @__PURE__ */ c(
            "div",
            {
              className: "ckeditor-default text-sm sm:text-base sm:leading-5",
              dangerouslySetInnerHTML: {
                __html: ho.sanitize(n)
              }
            }
          ),
          Object.values(ce).map((E) => {
            const R = (q) => A({
              ...ce,
              [E.slug]: { ...E, value: q }
            });
            return /* @__PURE__ */ c(
              wa,
              {
                contactFields: ce,
                field: E,
                value: ce[E.slug].value,
                error: P.customer.fields[E.slug],
                onChange: R
              },
              E.slug
            );
          }),
          p && (p == null ? void 0 : p.length) > 0 && /* @__PURE__ */ c(
            Zn,
            {
              label: x("public_pages_purchase.payment.price_plan"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: K,
              selected: String(ee == null ? void 0 : ee.id),
              onChange: (E) => {
                const R = Number(E), q = p.find((X) => X.id === R);
                q && (Y(q), te(q.amount));
              },
              required: !0,
              error: (oe = P.pricePlan) == null ? void 0 : oe.join(", ")
            }
          ),
          ee && /* @__PURE__ */ c(
            z3,
            {
              calculatePrice: g,
              isLoading: b ?? !1,
              pricePlan: ee
            }
          ),
          B && (B == null ? void 0 : B.length) > 0 && /* @__PURE__ */ c(
            Zn,
            {
              label: x("public_pages_purchase.Payment-method"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: J,
              selected: H,
              onChange: (E) => W(E),
              required: !0,
              error: (k = P.paymentMethod) == null ? void 0 : k.join(", ")
            }
          ),
          P.common && /* @__PURE__ */ c(
            ha,
            {
              error: (ue = P.common) == null ? void 0 : ue.join(", "),
              errorClassName: "flex justify-center"
            }
          )
        ] }),
        w
      ] })
    ] }) }),
    y && /* @__PURE__ */ c(on, { affiliateLink: _ })
  ] }) });
};
export {
  $1 as CENTERED_LAYOUT_BASE_CLASSNAME,
  an as CardWrapper,
  Y3 as CenteredLayout,
  Ue as CurrencyBadge,
  zo as DesignContext,
  Z3 as DesignProvider,
  l5 as DigitalCheckout,
  U3 as DigitalStoreI18Provider,
  Gn as FontRootNamesEnum,
  r5 as Home,
  Do as LAYOUT_BASE_CLASSNAME,
  va as Layout,
  Oo as LocaleContext,
  G3 as LocaleProvider,
  i5 as MercadoPagoProvider,
  s5 as PhysicalCheckout,
  et as ProductTypeEnum,
  Fu as Profile,
  li as ROOT_DESIGN_ID,
  ci as ROOT_FONT_ID,
  Zn as RadioGroupAccordion,
  Ro as S3_BUCKET_URL,
  ya as S3_SHARED_BUCKET_URL,
  Ee as SocialLinksEnum,
  je as StoreFontEnum,
  Ge as StoreImage,
  ie as StoreImageEnum,
  ht as StoreItemEnum,
  B1 as StoreItemStyleEnum,
  q3 as StoreProvider,
  de as StoreThemeEnum,
  a5 as StripeProvider,
  Ca as SuccessIcon,
  n5 as ThankYou,
  it as ThemeButton,
  Lt as ThemeRootNamesEnum,
  H1 as applyDesign,
  Eo as createStore,
  qn as defaultDesignValues,
  e5 as defaultECourseValues,
  ot as defaultFontValues,
  J3 as defaultLinkValues,
  X3 as defaultOptinValues,
  t5 as defaultPhysicalProductValues,
  Q3 as defaultProductDownloadValues,
  Be as getAmountWithCurrencySymbol,
  nn as getColors,
  du as getCommonItem,
  Zr as getDefaultFieldValues,
  I1 as getFontCss,
  v1 as getI18nInstance,
  sa as getPhysicalProductPricePlan,
  V1 as getRootDesignCss,
  di as getSingleFontCssString,
  W3 as getSingleFontPreviewCssString,
  ct as getSocialLinkIcon,
  tu as getStoreImageHeight,
  eu as getStoreImageWidth,
  Kt as httpClient,
  o5 as mocks,
  qe as useDesignContext,
  at as useLocaleContext,
  Mo as useMercadoPagoStore,
  tt as useOfferStore,
  As as usePaymentProcessors,
  fr as usePhysicalProductStore,
  D1 as usePublicKeysStore,
  _e as useStore,
  No as useVisitorInfoStore,
  To as useXenditStore
};
